export const translateFn = (translate: (eng: string, fin: string, ...val: string[]) => string) => ({

  A00L: (en: string, ...val: string[]) => translate(en,
    'Asiakasnumero',
    ...val),

  A00M: (en: string, ...val: string[]) => translate(en,
    'jota muutos koskee',
    ...val),

  A00N: (en: string, ...val: string[]) => translate(en,
    'Asiakasnumero löytyy viimeisimmältä laskulta. Jos yrityksellä on useampi asiakasnumero, voit ilmoittaa niistä minkä tahansa.',
    ...val),

  A00O: (en: string, ...val: string[]) => translate(en,
    'Valitse kyllä, jos olet esimerkiksi yrityksen kirjanpitäjä tai asunto-osakeyhtiön isännöitsijä.',
    ...val),

  A00P: (en: string, ...val: string[]) => translate(en,
    'Valitettavasti muutos usealle yritykselle samanaikaisesti ei ole vielä mahdollista palvelussamme. Voit kuitenkin tehdä muutoslomakkeen jokaiselle yritykselle erikseen.',
    ...val),

  A00Q: (en: string, ...val: string[]) => translate(en,
    'Asiakasnumero sisältää vähintään kolme (3) ja enintään yhdeksän (9) numeroa',
    ...val),

  A00R: (en: string, ...val: string[]) => translate(en,
    'Sinulta vaaditaan tunnistautumista',
    ...val),

  A00T: (en: string, ...val: string[]) => translate(en,
    'Lähetä uusi koodi',
    ...val),

  A00U: (en: string, ...val: string[]) => translate(en,
    'Etkö saanut tekstiviestiä? Varmista yrityksenne pääkäyttäjältä, että puhelinnumerosi on varmasti oikein. ',
    ...val),

  A00V: (en: string, ...val: string[]) => translate(en,
    'Tunnistaudu',
    ...val),

  A00W: (en: string, ...val: string[]) => translate(en,
    'Koodi on väärin',
    ...val),

  A00X: (en: string, ...val: string[]) => translate(en,
    'Palvelun tietoturvallisen käytön takaamiseksi lähetimme sinulle varmistuskoodin tekstiviestillä numeroon {}. Täytä varmistuskoodi alla oleviin kenttiin.',
    ...val),

  A00Y: (en: string, ...val: string[]) => translate(en,
    'Odottamaton virhe',
    ...val),

  A04W: (en: string, ...val: string[]) => translate(en,
    'Voit valita itsellesi uuden numeron tai siirtää nykyisen liittymäsi numeron. Kun vaihdat toiselta operaattorilta Elisalle, me hoidamme liittymän siirron puolestasi.',
    ...val),

  A06G: (en: string, ...val: string[]) => translate(en,
    'Voit tarkistaa PUK-koodin ',
    ...val),

  A0OH: (en: string, ...val: string[]) => translate(en,
    'Valitse yritys, johon haluat lisätä uuden laitelistan.',
    ...val),

  A0OI: (en: string, ...val: string[]) => translate(en,
    'Valitse yritys, johon haluat lisätä uuden käyttäjän.',
    ...val),

  A0OJ: (en: string, ...val: string[]) => translate(en,
    'alv. {} %',
    ...val),

  A0OK: (en: string, ...val: string[]) => translate(en,
    'Ilmoitatko toisen yrityksen tai asunto-osakeyhtiön puolesta',
    ...val),

  A145: (en: string, ...val: string[]) => translate(en,
    'Valitulla yrityksellä ei ole vastaavaa Elisa Palvelupäätelaite -sopimusta, joten laitetta ei voida siirtää',
    ...val),

  A1Q5: (en: string, ...val: string[]) => translate(en,
    'Yritystiedot ja asetukset',
    ...val),

  A239: (en: string, ...val: string[]) => translate(en,
    'Aloita vianmääritys valitsemalla liittymä',
    ...val),

  A2WA: (en: string, ...val: string[]) => translate(en,
    'Käyttäjää ei voi muuttaa toiseksi henkilöksi',
    ...val),

  A2WB: (en: string, ...val: string[]) => translate(en,
    'Olet muuttamassa henkilön etu- ja sukunimeä. Mikäli henkilö on vaihtumassa toiseksi, poistathan nykyisen käyttäjän ja ',
    ...val),

  A2WC: (en: string, ...val: string[]) => translate(en,
    'luo uusi käyttäjä',
    ...val),

  A2WD: (en: string, ...val: string[]) => translate(en,
    'Mikäli henkilön molemmat nimet ovat virheelliset, mutta kyseessä on sama henkilö ota yhteyttä ',
    ...val),

  A30I: (en: string, ...val: string[]) => translate(en,
    'Kun aktivoit kaksivaiheisen tunnistautumisen, se tulee käyttöön kaikilla palvelusopimukseen kuuluvilla yrityksillä',
    ...val),

  A31U: (en: string, ...val: string[]) => translate(en,
    'Kutsun lähetys työntekijöille onnistui.',
    ...val),

  A37D: (en: string, ...val: string[]) => translate(en,
    'Ei',
    ...val),

  A3GB: (en: string, ...val: string[]) => translate(en,
    'Sisältyy',
    ...val),

  A48T: (en: string, ...val: string[]) => translate(en,
    'Pyydä käyttäjää tekemään numeronsiirtotilaus hyvissä ajoin ettei hän menetä numeroaan. Liittymä irtisanotaan automaattisesti ilmoittamanasi päivänä mikäli henkilö ei ole ottanut numeroa omaan käyttöönsä.',
    ...val),

  A4V5: (en: string, ...val: string[]) => translate(en,
    'Muut laitteet',
    ...val),

  A504: (en: string, ...val: string[]) => translate(en,
    '5G+ -liittymät käyttävät aina parasta saatavilla olevaa yhteyttä ja vaihtavat sujuvasti myös 4G-verkkoon, jos liikut alueella, jolla 5G-yhteyttä ei ole saatavilla. 5G+-liittymän myötä netin viive voi jopa puolittua nykyisestä. Uusi 5G+ kuluttaa myös vähemmän puhelimesi akkua ja on siten entistä energiatehokkaampi vaihtoehto.',
    ...val),

  A564: (en: string, ...val: string[]) => translate(en,
    '/reissunetti',
    ...val),

  A575: (en: string, ...val: string[]) => translate(en,
    'Mobiililaajakaista Netti Lite -liittymät',
    ...val),

  A5B3: (en: string, ...val: string[]) => translate(en,
    'Alle',
    ...val),

  A5G1: (en: string, ...val: string[]) => translate(en,
    'Huollata laite',
    ...val),

  A5G4: (en: string, ...val: string[]) => translate(en,
    'Liittymän operaattori',
    ...val),

  A6M3: (en: string, ...val: string[]) => translate(en,
    'Kohde',
    ...val),

  A77Z: (en: string, ...val: string[]) => translate(en,
    'Siirry',
    ...val),

  A7CA: (en: string, ...val: string[]) => translate(en,
    'Laitenetti',
    ...val),

  A7CB: (en: string, ...val: string[]) => translate(en,
    'Laitenetti sopii esimerkiksi yrityksesi valvontakameroihin, hälytysjärjestelmään tai lämmityslaitteisiin.',
    ...val),

  A7CC: (en: string, ...val: string[]) => translate(en,
    'Kuvien lähettäminen, SMS/puheohjattavat laitteet, kiinteistöjen hälyttimet, ilmalämpöpumput',
    ...val),

  A7CD: (en: string, ...val: string[]) => translate(en,
    'Valvonta- ja riistakamerat (kuva & video), hälytyslaitteet, GPS-paikantimet, olosuhdesensorit',
    ...val),

  A7CE: (en: string, ...val: string[]) => translate(en,
    'Valvonta- ja riistakamerat (live-video), mobiilireitittimet ja verkkolaitteet, hälytyslaitteet',
    ...val),

  A7CF: (en: string, ...val: string[]) => translate(en,
    'SIM-kortin koko',
    ...val),

  A7CG: (en: string, ...val: string[]) => translate(en,
    'Laitenetin päivitys',
    ...val),

  A7CH: (en: string, ...val: string[]) => translate(en,
    'Uusi Laitenetti',
    ...val),

  A7CI: (en: string, ...val: string[]) => translate(en,
    'EU-data {} Gt',
    ...val),

  A7CJ: (en: string, ...val: string[]) => translate(en,
    'Tilaa uusi (Mini + Micro)',
    ...val),

  A7CK: (en: string, ...val: string[]) => translate(en,
    'Tilaa uusi (Nano)',
    ...val),

  A7CL: (en: string, ...val: string[]) => translate(en,
    'Tarkastathan, mikä SIM-kortti koko sopii laitteeseesi. Valittavissa on yhdistelmäkortti Mini (2FF) + Micro (3FF) tai Nano (4FF).',
    ...val),

  A7DR: (en: string, ...val: string[]) => translate(en,
    'Laskun kieli',
    ...val),

  A86X: (en: string, ...val: string[]) => translate(en,
    'Laite palautetaan Elisalle',
    ...val),

  A8DZ: (en: string, ...val: string[]) => translate(en,
    'Elisa YritysWifi Lite - laajempi WiFi-verkko toimipisteeseesi',
    ...val),

  A8V9: (en: string, ...val: string[]) => translate(en,
    'https://elisa.fi/asiakaspalvelu/laskutus-maksaminen/e-laskuopas/',
    ...val),

  A8VA: (en: string, ...val: string[]) => translate(en,
    'Valitse kaikki',
    ...val),

  A8Y9: (en: string, ...val: string[]) => translate(en,
    'eIP Exchange O365 -lisäpalvelu vaatii käyttäjän Office 365-sähköpostin toimiakseen. Tämä sähköposti tulee olemaan jatkossa myös käyttäjän Ring-käyttäjätunnus.',
    ...val),

  A90Y: (en: string, ...val: string[]) => translate(en,
    'Tämä nimi ei ole sallittu.',
    ...val),

  A9V3: (en: string, ...val: string[]) => translate(en,
    'Työaikaketjun voimassaoloaika',
    ...val),

  A9VQ: (en: string, ...val: string[]) => translate(en,
    'Yrityksen toimipiste',
    ...val),

  AAAN: (en: string, ...val: string[]) => translate(en,
    'Voinko palauttaa useamman laitteen kerrallaan?',
    ...val),

  AANC: (en: string, ...val: string[]) => translate(en,
    'Kutsun lähetys epäonnistui.',
    ...val),

  AAOV: (en: string, ...val: string[]) => translate(en,
    'Ohjeet e-laskun käyttöönottoon',
    ...val),

  AAX0: (en: string, ...val: string[]) => translate(en,
    'Päivämäärään',
    ...val),

  ABI6: (en: string, ...val: string[]) => translate(en,
    'Korvaavaa laitetta ei lähetetä automaattisesti.',
    ...val),

  ABRO: (en: string, ...val: string[]) => translate(en,
    'Jos laskun viitenumero on 80-alkuinen vakioviitteellinen lasku, maksut kohdistuvat aina vanhimpaan avoimeen laskuun.',
    ...val),

  ABTG: (en: string, ...val: string[]) => translate(en,
    'Tervetuloa Työntekijän OmaElisaan!',
    ...val),

  ABTI: (en: string, ...val: string[]) => translate(en,
    'Lunastushinta sisältää mahdolliset jäljellä olevat kuukausimaksut ja erillisen lunastusmaksun.',
    ...val),

  ABTK: (en: string, ...val: string[]) => translate(en,
    'Lunastushinta nyt {}',
    ...val),

  ABTL: (en: string, ...val: string[]) => translate(en,
    'Sopimuksen päätyttyä {}',
    ...val),

  ABUM: (en: string, ...val: string[]) => translate(en,
    'Siirry muokkaamaan tietoja',
    ...val),

  ACGC: (en: string, ...val: string[]) => translate(en,
    'Työntekijälle',
    ...val),

  ACH1: (en: string, ...val: string[]) => translate(en,
    'laitteen',
    ...val),

  AD92: (en: string, ...val: string[]) => translate(en,
    'Muutoksen tekijä',
    ...val),

  ADCR: (en: string, ...val: string[]) => translate(en,
    '{0} = Erittäin tyytyväinen',
    ...val),

  AE4T: (en: string, ...val: string[]) => translate(en,
    'Hallitse laitteisiin liittyviä toimenpiteitä valitun laitteen sivulla. Voit tehdä esim. laitteen huolto- tai lunastuspyynnön.',
    ...val),

  AE6V: (en: string, ...val: string[]) => translate(en,
    'Yritys on liitetty Elisa Tunnukseesi',
    ...val),

  AEOA: (en: string, ...val: string[]) => translate(en,
    'Valitse vaihtoehto, joka kuvaa parhaiten laitteesi nykyistä kuntoa',
    ...val),

  AEPM: (en: string, ...val: string[]) => translate(en,
    '{0} = Täysin eri mieltä',
    ...val),

  AFJM: (en: string, ...val: string[]) => translate(en,
    'Ylläpito laitteelle',
    ...val),

  AFW3: (en: string, ...val: string[]) => translate(en,
    'SM-DP+ -osoite',
    ...val),

  AFXP: (en: string, ...val: string[]) => translate(en,
    'Olemme sinuun yhteydessä mahdollisimman pian.',
    ...val),

  AG7I: (en: string, ...val: string[]) => translate(en,
    'Jos laite vioittuu, saat välittömästi uuden tilalle.',
    ...val),

  AGIJ: (en: string, ...val: string[]) => translate(en,
    'Puhelinnumero',
    ...val),

  AGIK: (en: string, ...val: string[]) => translate(en,
    'Työpuhelinnumero',
    ...val),

  AGM7: (en: string, ...val: string[]) => translate(en,
    'Näytettävä numero tekstiviestille',
    ...val),

  AHB4: (en: string, ...val: string[]) => translate(en,
    'Laitevalikoima',
    ...val),

  AHL9: (en: string, ...val: string[]) => translate(en,
    'Tilaamalla OmaLasku Palvelunumerot -ominaisuuden, vastaat itse seuraavien palveluiden käytöstä aiheutuvista kuluista:',
    ...val),

  AHN6: (en: string, ...val: string[]) => translate(en,
    '{} hinta muutoksen jälkeen',
    ...val),

  AHN7: (en: string, ...val: string[]) => translate(en,
    'Emme pysty yhdistämään yhteystietojasi yritykseen',
    ...val),

  AHWD: (en: string, ...val: string[]) => translate(en,
    'Voimassa {} asti',
    ...val),

  AIK7: (en: string, ...val: string[]) => translate(en,
    'Etunimi',
    ...val),

  AIUJ: (en: string, ...val: string[]) => translate(en,
    'Huomioithan, että muutoksen jälkeen laskutus näkyy kahdella eri laskulla vielä seuraavassa laskussa. Mahdolliset lisäpalvelut siirtyvät päätuotteen mukana.',
    ...val),

  AJ93: (en: string, ...val: string[]) => translate(en,
    'Yrityksen nimi',
    ...val),

  AJAM: (en: string, ...val: string[]) => translate(en,
    '8K-leffat ja -sarjat ilman katkoksia',
    ...val),

  AJVW: (en: string, ...val: string[]) => translate(en,
    'että laite tulee tyhjentää ja palauttaa tehdasasetuksille ennen kuin otan sen henkilökohtaiseen käyttööni, sekä en palauta laitteeseen yrityksen tietoja ilman erillistä työnantajan lupaa. Jos tarvitset tukea tyhjennyksen suorittamisessa, ota yhteyttä Elisan yritysasiakaspalveluun.',
    ...val),

  AK55: (en: string, ...val: string[]) => translate(en,
    'Valitse toimitusosoite',
    ...val),

  AKD6: (en: string, ...val: string[]) => translate(en,
    'Tuotteiden toimitus',
    ...val),

  AKW8: (en: string, ...val: string[]) => translate(en,
    'Contact customer service',
    ...val),

  AL0L: (en: string, ...val: string[]) => translate(en,
    'Tilausta Käsitellään',
    ...val),

  ALD4: (en: string, ...val: string[]) => translate(en,
    'Ring-palvelun asetukset',
    ...val),

  ALQT: (en: string, ...val: string[]) => translate(en,
    'PIN-koodi',
    ...val),

  AM3R: (en: string, ...val: string[]) => translate(en,
    'Kysy laskusta',
    ...val),

  AMMX: (en: string, ...val: string[]) => translate(en,
    'Luo yritystili',
    ...val),

  AMRD: (en: string, ...val: string[]) => translate(en,
    'Laskutussopimuksen tiedot',
    ...val),

  AMXZ: (en: string, ...val: string[]) => translate(en,
    'Valitse yritykset, joille haluat kopioida laitelistan. Muista viimeistellä ja julkaista laitelista erikseen.',
    ...val),

  AN17: (en: string, ...val: string[]) => translate(en,
    'Numeroasetukset',
    ...val),

  ANG6: (en: string, ...val: string[]) => translate(en,
    'Lähetä kutsulinkki',
    ...val),

  ANXA: (en: string, ...val: string[]) => translate(en,
    'Yritysasiakkaat',
    ...val),

  AO0M: (en: string, ...val: string[]) => translate(en,
    'Tietolähde: Tieke verkkolaskutusosoitteisto. Tiedonvälittäjä: Alma Media Finland Oy.',
    ...val),

  AOIV: (en: string, ...val: string[]) => translate(en,
    'Käyttäjätiedot päivitetty tuotteelle.',
    ...val),

  AOQB: (en: string, ...val: string[]) => translate(en,
    'Aika',
    ...val),

  AP5F: (en: string, ...val: string[]) => translate(en,
    'Elisan asiakaspalveluun',
    ...val),

  AQA9: (en: string, ...val: string[]) => translate(en,
    'Liittymän/palvelun viitteet',
    ...val),

  AQOL: (en: string, ...val: string[]) => translate(en,
    'Tilaa',
    ...val),

  AQOM: (en: string, ...val: string[]) => translate(en,
    'Tilaa asiantuntijalta',
    ...val),

  AQON: (en: string, ...val: string[]) => translate(en,
    'Elisa Kuka Soittaa tarjoushintaan nyt 2,99 €/kk alv. 0 %',
    ...val),

  AQOO: (en: string, ...val: string[]) => translate(en,
    'Elisa Kuka Soittaa -palvelulla näet, kuka sinulle soittaa. Palvelu näyttää puhelimessasi automaattisesti soittajan nimitiedon ilman erikseen ladattavia sovelluksia. Elisa Kuka Soittaa nyt toistaiseksi tutustumishintaan 2,99 € / kk / liittymä alv. 0 % (norm. 3,99 € / kk / liittymä alv. 0 %).',
    ...val),

  AQOP: (en: string, ...val: string[]) => translate(en,
    'Lue lisää Elisa Kuka Soittaa -palvelusta',
    ...val),

  AQOQ: (en: string, ...val: string[]) => translate(en,
    'Tilaa Elisa Kuka Soittaa -palvelu',
    ...val),

  AQPA: (en: string, ...val: string[]) => translate(en,
    'Elisa Matkapuhelinvastaajalla saat liittymääsi vastaajan, lomavastaajan sekä ilmoituksen vastaamattomista puheluista. Tekstiviesti tuo tiedon vastaamattomista puheluista.',
    ...val),

  AQPB: (en: string, ...val: string[]) => translate(en,
    'Elisan Mobiiliturva parantaa mobiililiittymän selainturvallisuutta. Se tunnistaa haitalliset sivut ja ilmoittaa niistä käyttäjille.\nSaat turvaa yleisintä tietoturvauhkaa eli tietojen kalastelua (phishing) vastaan, kun käytät nettiä 4G- tai 5G-verkossa.',
    ...val),

  AQPC: (en: string, ...val: string[]) => translate(en,
    'Elisa Kuka Soittaa -palvelu näyttää puhelimessa soittajan nimitiedon, vaikka numeroa ei olisi tallennettuna puhelimen osoitekirjaan. Soittajan nimitieto näkyy saapuvan puhelun yhteydessä sekä puheluhistoriassa.',
    ...val),

  AQPD: (en: string, ...val: string[]) => translate(en,
    'Julkinen IP-osoite mahdollistaa laitteidesi etähallinnan internetin kautta.\nSe sopii erinomaisesti esimerkiksi valvontakameroiden ja älylaitteiden käyttöön, kun haluat käyttää niitä suoraan ja luotettavasti myös kodin tai toimiston ulkopuolelta.',
    ...val),

  AR0B: (en: string, ...val: string[]) => translate(en,
    'Puhelinliittymät',
    ...val),

  AR17: (en: string, ...val: string[]) => translate(en,
    'Onko tämä etsimäsi käyttäjä? Valitse löytynyt käyttäjä tai luo uusi.',
    ...val),

  ARD5: (en: string, ...val: string[]) => translate(en,
    'Hyväksyjä',
    ...val),

  ARDH: (en: string, ...val: string[]) => translate(en,
    'Jotain meni pieleen QR-koodin luomisessa. Ole hyvä ja ota yhteyttä asiakaspalveluumme.',
    ...val),

  ARE0: (en: string, ...val: string[]) => translate(en,
    'Puhelinliittymät yrityksille',
    ...val),

  ARE2: (en: string, ...val: string[]) => translate(en,
    'Elisan liittymä on oiva valinta sinulle, kun haluat suosia suomalaista – Elisa on myös ainoa operaattori, jonka mobiili- ja kiinteän verkon liittymille on myönnetty Avainlippu suomalaisen palvelun merkiksi.',
    ...val),

  ARE3: (en: string, ...val: string[]) => translate(en,
    'Elisan Aito 5G -verkko tekee työnteosta sujuvaa',
    ...val),

  ARE5: (en: string, ...val: string[]) => translate(en,
    'tutkitusti kattava',
    ...val),

  ARE6: (en: string, ...val: string[]) => translate(en,
    'Tee töitä vaikka mökin laiturilla ja nauti toimintavarmasta yhteydestä!',
    ...val),

  ARE7: (en: string, ...val: string[]) => translate(en,
    'Katso alueesi 5G-kuuluvuus kuuluvuuskartasta.',
    ...val),

  ARE8: (en: string, ...val: string[]) => translate(en,
    'Tarkista alueesi kuuluvuus.',
    ...val),

  ARE9: (en: string, ...val: string[]) => translate(en,
    'Usein kysytyt kysymykset yritysliittymistä',
    ...val),

  AREA: (en: string, ...val: string[]) => translate(en,
    'Yritysten OmaElisassa',
    ...val),

  AREB: (en: string, ...val: string[]) => translate(en,
    ' Yritysten OmaElisaan',
    ...val),

  AREC: (en: string, ...val: string[]) => translate(en,
    'Kirjaudu Yritysten OmaElisaan',
    ...val),

  ARED: (en: string, ...val: string[]) => translate(en,
    'Työntekijän OmaElisasta',
    ...val),

  AREE: (en: string, ...val: string[]) => translate(en,
    'Toimivatko 5G+ ja 5G-liittymät 4G-verkossa?',
    ...val),

  AREF: (en: string, ...val: string[]) => translate(en,
    'Liittymät toimivat myös 4G-verkossa. Kun menet Elisa Yritysliittymä 5G+ tai 5G -liittymällä 5G-alueen ulkopuolelle, käytössäsi on 4G-verkko.',
    ...val),

  AREG: (en: string, ...val: string[]) => translate(en,
    'Jos puhelimesi tukee vain 4G-verkkoa, käyttää liittymäsi myös silloin 4G-verkkoa.',
    ...val),

  AREH: (en: string, ...val: string[]) => translate(en,
    'Kuka voi tilata yritysliittymän?',
    ...val),

  AREI: (en: string, ...val: string[]) => translate(en,
    'Voit tilata Elisan yritysliittymän, kun sinulla on yrityksesi ',
    ...val),

  AREJ: (en: string, ...val: string[]) => translate(en,
    'nimenkirjoitusoikeus',
    ...val),

  AREK: (en: string, ...val: string[]) => translate(en,
    '',
    ...val),

  AREL: (en: string, ...val: string[]) => translate(en,
    'Tilaamiseen tarvitset Yritysten OmaElisa -tunnukset. Jos sinulla ei ole vielä tunnuksia, ',
    ...val),

  AREM: (en: string, ...val: string[]) => translate(en,
    'luo itsellesi uudet tunnukset',
    ...val),

  AREN: (en: string, ...val: string[]) => translate(en,
    'Miten yritysliittymä tilataan?',
    ...val),

  AREO: (en: string, ...val: string[]) => translate(en,
    'Uuden yritysliittymän tilaaminen: ',
    ...val),

  AREP: (en: string, ...val: string[]) => translate(en,
    'Tilaa uusi puhelinliittymä yrityksellesi tältä sivulta tai ',
    ...val),

  AREQ: (en: string, ...val: string[]) => translate(en,
    '. Voit tilata liittymän uudella numerolla tai siirtää vanhan numerosi uudelle liittymälle.',
    ...val),

  ARER: (en: string, ...val: string[]) => translate(en,
    'Nykyisen liittymän päivittäminen toiseen liittymäpakettiin:',
    ...val),

  ARES: (en: string, ...val: string[]) => translate(en,
    ', jossa pääset päivittämään nykyisen Elisan puhelinliittymäsi.',
    ...val),

  ARET: (en: string, ...val: string[]) => translate(en,
    'Kuinka paljon saan käyttää dataa ulkomailla?',
    ...val),

  AREU: (en: string, ...val: string[]) => translate(en,
    'Elisan Yritysliittymät sisältävät rajattoman datan Ruotsissa, Norjassa, Tanskassa, Virossa, Latviassa ja Liettuassa.',
    ...val),

  AREV: (en: string, ...val: string[]) => translate(en,
    'Lisäksi jokaiseen liittymäpakettiin kuuluu reilusti dataa EU- ja ETA-maihin.',
    ...val),

  AREW: (en: string, ...val: string[]) => translate(en,
    'Pääkäyttäjä voi tarkistaa liittymän EU- ja ETA-datamäärän ',
    ...val),

  AREX: (en: string, ...val: string[]) => translate(en,
    ' ja työntekijä näkee sen ',
    ...val),

  AREY: (en: string, ...val: string[]) => translate(en,
    'Muissa maissa hinta vaihtelee kohdemaan mukaan. Lisäksi voit hankkia edullisen Reissaaja-datapaketin kaukomaille.',
    ...val),

  AREZ: (en: string, ...val: string[]) => translate(en,
    'Lue puhelimen käytöstä ulkomailla',
    ...val),

  ARF0: (en: string, ...val: string[]) => translate(en,
    'Voinko pitää nykyisen numeroni, jos siirrän liittymäni Elisalle?',
    ...val),

  ARF1: (en: string, ...val: string[]) => translate(en,
    'Saat säilytettyä nykyisen numerosi, kun vaihdat kännykkäliittymäsi Elisalle. Tilausvaiheessa valitse vain ',
    ...val),

  ARF2: (en: string, ...val: string[]) => translate(en,
    '"Säilytä numerosi"',
    ...val),

  ARF3: (en: string, ...val: string[]) => translate(en,
    'Pitääkö minun itse irtisanoa vanha liittymäni?',
    ...val),

  ARF4: (en: string, ...val: string[]) => translate(en,
    'Kun vaihdat toiselta operaattorilta liittymäsi, sinun ei tarvitse olla yhteydessä vanhaan operaattoriisi. Me hoidamme liittymän siirron Elisalle puolestasi.',
    ...val),

  ARF5: (en: string, ...val: string[]) => translate(en,
    'Miten liittymän omistussuhde muutetaan?',
    ...val),

  ARF6: (en: string, ...val: string[]) => translate(en,
    'Lue ohjeet ',
    ...val),

  ARF7: (en: string, ...val: string[]) => translate(en,
    'liittymän omistussuhteen muutoksesta',
    ...val),

  ARF8: (en: string, ...val: string[]) => translate(en,
    'Miten saan puhelinliittymän käyttöön?',
    ...val),

  ARF9: (en: string, ...val: string[]) => translate(en,
    'Tilauksen jälkeen saat tilauksesta tilausvahvistuksen.',
    ...val),

  ARFA: (en: string, ...val: string[]) => translate(en,
    'Toimitamme SIM-kortin etukäteen ja lähetämme käyttäjän puhelimeen ',
    ...val),

  ARFB: (en: string, ...val: string[]) => translate(en,
    'tarkan siirtoajan',
    ...val),

  ARFC: (en: string, ...val: string[]) => translate(en,
    ', milloin uusi liittymä on toiminnassa ja SIM-kortin voi vaihtaa puhelimeen.',
    ...val),

  ARFD: (en: string, ...val: string[]) => translate(en,
    'Jos olet vaihtanut liittymän toiselta operaattorilta Elisalle, sinun ei tarvitse olla yhteydessä vanhaan operaattoriisi. Me hoidamme liittymän siirron puolestasi.',
    ...val),

  ARFE: (en: string, ...val: string[]) => translate(en,
    'Lue ohjeet liittymän käyttöönottoon',
    ...val),

  ARFF: (en: string, ...val: string[]) => translate(en,
    'Jos sinulla on kysyttävää, voit kysyä apua myös ',
    ...val),

  ARFG: (en: string, ...val: string[]) => translate(en,
    'asiakaspalvelustamme',
    ...val),

  ARFH: (en: string, ...val: string[]) => translate(en,
    'Mistä löydän PIN- ja PUK-koodin?',
    ...val),

  ARFI: (en: string, ...val: string[]) => translate(en,
    'Oletus PIN-koodi Elisan yritysliittymissä on 1234.',
    ...val),

  ARFJ: (en: string, ...val: string[]) => translate(en,
    'Puhelimen asetuksissa voit vaihtaa PIN-koodin toiseen.',
    ...val),

  ARFK: (en: string, ...val: string[]) => translate(en,
    'Kun olet työntekijä, löydät PUK-koodisi ',
    ...val),

  ARFL: (en: string, ...val: string[]) => translate(en,
    'Kun olet yrittäjä tai yrityksesi nimenkirjoitusoikeudellinen henkilö, löydät PUK-koodin ',
    ...val),

  ARFM: (en: string, ...val: string[]) => translate(en,
    'Lue ohjeet PIN- ja PUK-koodista',
    ...val),

  ARFN: (en: string, ...val: string[]) => translate(en,
    'Miten tilaan uusia SIM-kortteja ja aktivoin ne?',
    ...val),

  ARFO: (en: string, ...val: string[]) => translate(en,
    'Voit tilata ',
    ...val),

  ARFP: (en: string, ...val: string[]) => translate(en,
    'uusia SIM-kortteja verkosta',
    ...val),

  ARFQ: (en: string, ...val: string[]) => translate(en,
    'tai',
    ...val),

  ARFR: (en: string, ...val: string[]) => translate(en,
    ' Lue tarkemmat ohjeet, ',
    ...val),

  ARFS: (en: string, ...val: string[]) => translate(en,
    'miten SIM-kortin tilaus tapahtuu',
    ...val),

  ARFT: (en: string, ...val: string[]) => translate(en,
    'SIM-kortin voi aktivoida yrityksen pääkäyttäjä tai työntekijä.',
    ...val),

  ARFV: (en: string, ...val: string[]) => translate(en,
    'Uusi numero',
    ...val),

  ARFW: (en: string, ...val: string[]) => translate(en,
    'Säilytä numerosi',
    ...val),

  ARFX: (en: string, ...val: string[]) => translate(en,
    '– valitse tämä, kun haluat uuden numeron liittymääsi.',
    ...val),

  ARFY: (en: string, ...val: string[]) => translate(en,
    '– valitse tämä, kun haluat siirtää nykyisen numerosi toiselta operaattorilta Elisalle.',
    ...val),

  AS63: (en: string, ...val: string[]) => translate(en,
    'henkilöasiakkaan OmaElisassa',
    ...val),

  AS6H: (en: string, ...val: string[]) => translate(en,
    'Henkilön tiedot',
    ...val),

  AS6N: (en: string, ...val: string[]) => translate(en,
    'Sinulla on käytössä Elisa Ring -tunnus.',
    ...val),

  ASEI: (en: string, ...val: string[]) => translate(en,
    'Kertamaksu',
    ...val),

  ASJ1: (en: string, ...val: string[]) => translate(en,
    'Tunnistaudu helposti pankkitunnuksilla tai mobiilivarmenteella. Luo itsellesi käyttäjätunnukset ja viimeistele tilauksesi.',
    ...val),

  ASOX: (en: string, ...val: string[]) => translate(en,
    'Ongelma kamerassa',
    ...val),

  ASQT: (en: string, ...val: string[]) => translate(en,
    'Tila',
    ...val),

  AT96: (en: string, ...val: string[]) => translate(en,
    'Virheellinen postinumero',
    ...val),

  ATD5: (en: string, ...val: string[]) => translate(en,
    'Lisätietoja:',
    ...val),

  ATDL: (en: string, ...val: string[]) => translate(en,
    'Salasana on pakollinen',
    ...val),

  AUA3: (en: string, ...val: string[]) => translate(en,
    'Tilaukseni',
    ...val),

  AUI3: (en: string, ...val: string[]) => translate(en,
    'Voit tarkastella ja maksaa laskusi',
    ...val),

  AUI8: (en: string, ...val: string[]) => translate(en,
    'Laskutus',
    ...val),

  AURX: (en: string, ...val: string[]) => translate(en,
    'Palaamme asiaan niin pian kuin mahdollista.',
    ...val),

  AV0P: (en: string, ...val: string[]) => translate(en,
    'Yritystietoturva',
    ...val),

  AWAM: (en: string, ...val: string[]) => translate(en,
    'Mihin yhteyttä käytetään',
    ...val),

  AWEN: (en: string, ...val: string[]) => translate(en,
    'Peruskausi',
    ...val),

  AWNU: (en: string, ...val: string[]) => translate(en,
    'Laitteiden sopimuskaudet',
    ...val),

  AWTH: (en: string, ...val: string[]) => translate(en,
    'EPP lunastuspyyntö',
    ...val),

  AX7R: (en: string, ...val: string[]) => translate(en,
    'Laite vaatii laturin, jonka latausteho on vähintään {} W. Laitteen suurimman latausnopeuden saavuttamiseksi on laturin lataustehon oltava vähintään {} W. Laite tukee USB PD -pikalatausta.',
    ...val),

  AX9O: (en: string, ...val: string[]) => translate(en,
    'Liikasuoritus',
    ...val),

  AXSD: (en: string, ...val: string[]) => translate(en,
    'Alla näet ajastetut muutokset, jotka julkaistaan {}. Voit poistaa muutospyynnön tai ajastaa sen uudelleen. Jos haluat muokata näitä muutoksia, poista ajastettu muutos ja luo kokonaan uusi muutospyyntö.',
    ...val),

  AY02: (en: string, ...val: string[]) => translate(en,
    'Elisa Kuka Soittaa -numeropalvelu',
    ...val),

  AYKR: (en: string, ...val: string[]) => translate(en,
    'Ota yhteyttä asiakaspalveluun',
    ...val),

  AYSW: (en: string, ...val: string[]) => translate(en,
    'Elisa Yritystietoturva',
    ...val),

  AZKN: (en: string, ...val: string[]) => translate(en,
    'Haluatko varmasti peruuttaa?',
    ...val),

  B0D9: (en: string, ...val: string[]) => translate(en,
    'Asiakaspalvelun yhteystiedot',
    ...val),

  B0GP: (en: string, ...val: string[]) => translate(en,
    'Laitelistan avulla voit määrittää yrityksesi laitevalikoiman. Laitelistoja voi olla useampi ja voit valita listalle yhden tai useamman laitteen. Tilaukselle ei voi valita tuotteita eri katalogeista, joten huomioithan tämän luodessasi uusia katalogeja. Voit myös asettaa listalle hintarajan, jonka yritys maksaa laitteesta kuukaudessa. OmaLasku -palvelun ollessa käytössä, työntekijä voi valita myös hintarajan ylittävän laitteen, jolloin hän maksaa erotuksen itse.',
    ...val),

  B0M1: (en: string, ...val: string[]) => translate(en,
    'Luo salasana',
    ...val),

  B0MA: (en: string, ...val: string[]) => translate(en,
    'Tarkenna hakua tai siirry katsomaan kaikki hakutulokset alla olevan napin kautta.',
    ...val),

  B0MB: (en: string, ...val: string[]) => translate(en,
    'Lue lisätietoja hinnoista ja liittymän käytöstä ulkomailla',
    ...val),

  B100: (en: string, ...val: string[]) => translate(en,
    'Vai oletko kuluttaja?',
    ...val),

  B101: (en: string, ...val: string[]) => translate(en,
    'Katso Laitenetin vaihtoehdot kuluttajalle',
    ...val),

  B104: (en: string, ...val: string[]) => translate(en,
    'Laitenettiliittymien tarkemmat ominaisuudet',
    ...val),

  B105: (en: string, ...val: string[]) => translate(en,
    'Puhelut ja tekstarit',
    ...val),

  B106: (en: string, ...val: string[]) => translate(en,
    'Puhelut normaalihintaisiin kotimaan lanka- ja matkapuhelinliittymiin {} €/min',
    ...val),

  B107: (en: string, ...val: string[]) => translate(en,
    'Liittymän kk-hintaan sisältyy {} kpl SMS/MMS-viestejä',
    ...val),

  B108: (en: string, ...val: string[]) => translate(en,
    'Ylimenevät tekstiviestit {} €/kpl',
    ...val),

  B109: (en: string, ...val: string[]) => translate(en,
    'Ylimenevät multimediaviestit {} €/kpl',
    ...val),

  B10A: (en: string, ...val: string[]) => translate(en,
    'Puhelu-, tekstiviesti- ja mobiilimaksuestoista hyötyesto (P1) on oletuksena käytössä.',
    ...val),

  B10B: (en: string, ...val: string[]) => translate(en,
    'Nettiyhteys',
    ...val),

  B10C: (en: string, ...val: string[]) => translate(en,
    'Rajaton netti kotimaassa',
    ...val),

  B10D: (en: string, ...val: string[]) => translate(en,
    'Toimii 2G- ja 4G-verkoissa, Laitenetti 5G toimii myös 5G-verkossa ',
    ...val),

  B10E: (en: string, ...val: string[]) => translate(en,
    'Elisa Laitenetti -liittymät on tarkoitettu vain tilapäisiin, korkeintaan {} kuukautta kestäviin verkkovierailuihin ulkomailla. Elisalla on oikeus seurata liittymien käyttöä ja tarvittaessa estää pysyvä käyttö ulkomailla. ',
    ...val),

  B10F: (en: string, ...val: string[]) => translate(en,
    'Ehdot',
    ...val),

  B10G: (en: string, ...val: string[]) => translate(en,
    'Ei määräaikaisuutta',
    ...val),

  B10H: (en: string, ...val: string[]) => translate(en,
    'Voit irtisanoa liittymän milloin vain',
    ...val),

  B152: (en: string, ...val: string[]) => translate(en,
    'Sisäiset ja ulkoiset puhelut',
    ...val),

  B1Q0: (en: string, ...val: string[]) => translate(en,
    'Poista valitut',
    ...val),

  B2B9: (en: string, ...val: string[]) => translate(en,
    'Arkisto',
    ...val),

  B2V1: (en: string, ...val: string[]) => translate(en,
    'Peruuta',
    ...val),

  B3IH: (en: string, ...val: string[]) => translate(en,
    'Liittymäni-näkymästä voit tarkastaa liittymiesi PUK-koodit koska tahansa. Klikkaamalla liittymää näet myös PUK2-koodin.',
    ...val),

  B3MG: (en: string, ...val: string[]) => translate(en,
    'kpl',
    ...val),

  B4DW: (en: string, ...val: string[]) => translate(en,
    'Vastaa kysymyksiin laitteesi kunnosta',
    ...val),

  B4NE: (en: string, ...val: string[]) => translate(en,
    'Toiminto epäonnistui',
    ...val),

  B4ZV: (en: string, ...val: string[]) => translate(en,
    'Tuotteen tiedot',
    ...val),

  B5AC: (en: string, ...val: string[]) => translate(en,
    'ReCAPTCHA-varmennus on pakollinen',
    ...val),

  B5J1: (en: string, ...val: string[]) => translate(en,
    'Lisää ostoskoriin',
    ...val),

  B5VB: (en: string, ...val: string[]) => translate(en,
    'Kotiosoite rivi 1',
    ...val),

  B63L: (en: string, ...val: string[]) => translate(en,
    'Auttaaksesi meitä ymmärtämään tarpeitasi paremmin, arvostamme palautettasi. Jos haluat muutoksia tarjoukseen, kerrothan niistä. Myyntitiimimme laatii mielellään tarpeitasi vastaavan päivitetyn tarjouksen. ',
    ...val),

  B69Q: (en: string, ...val: string[]) => translate(en,
    '{} kbit/s',
    ...val),

  B75I: (en: string, ...val: string[]) => translate(en,
    'Mobiilivarmenne on maksuton Elisa yritysliittymien käyttäjille.',
    ...val),

  B7E8: (en: string, ...val: string[]) => translate(en,
    'Sopii sinulle, jos teet toisinaan etätöitä esim. mökillä. Reitittimeen, mobiilireitittimeen tai tablettiin sopiva SIM-kortti on helposti siirrettävissä laitteesta toiseen.',
    ...val),

  B7GD: (en: string, ...val: string[]) => translate(en,
    'tarkastaa ulkomaan puheluiden ja datan käyttörajat',
    ...val),

  B7P0: (en: string, ...val: string[]) => translate(en,
    'Toimitus yrityksen päätoimipisteeseen',
    ...val),

  B8KE: (en: string, ...val: string[]) => translate(en,
    'Sinulla on käytössäsi Elisa Yritystietoturva -tilaus, joka mahdollistaa tietojen palauttamisen, jos laitteesi tai tiedostot ovat vaurioituneet. Luethan linkistä löytyvät ohjeet huolellisesti.',
    ...val),

  B951: (en: string, ...val: string[]) => translate(en,
    'Lunastuspyyntö',
    ...val),

  B9A9: (en: string, ...val: string[]) => translate(en,
    'Valikoimastamme poistuneet tuotteet',
    ...val),

  B9EG: (en: string, ...val: string[]) => translate(en,
    'Laitteen lunastaminen',
    ...val),

  B9GC: (en: string, ...val: string[]) => translate(en,
    'Tietue poistettu',
    ...val),

  B9LR: (en: string, ...val: string[]) => translate(en,
    'Palautettava laite',
    ...val),

  BA64: (en: string, ...val: string[]) => translate(en,
    'Sinulla ei ole liittymiä.',
    ...val),

  BBJW: (en: string, ...val: string[]) => translate(en,
    'Pääset muokkaamaan Elisa Tunnuksen henkilökohtaisia tietoja navigaation oikeasta yläkulmasta.',
    ...val),

  BBNI: (en: string, ...val: string[]) => translate(en,
    'täältä',
    ...val),

  BBPX: (en: string, ...val: string[]) => translate(en,
    'Ohjelmistoversio',
    ...val),

  BC0X: (en: string, ...val: string[]) => translate(en,
    'Ei saatavuustietoa',
    ...val),

  BC3P: (en: string, ...val: string[]) => translate(en,
    'Sinulla ei ole eSIMiä tilattuna tälle liittymälle.',
    ...val),

  BCAG: (en: string, ...val: string[]) => translate(en,
    'Tekstiviestipaketti 5000',
    ...val),

  BCB6: (en: string, ...val: string[]) => translate(en,
    'Olemme pyytäneet lisätietoa tukipyynnön avanneelta käyttäjältä sähköpostitse. Vastaattehan mahdollisimman pian, niin pääsemme jatkamaan asianne käsittelyä.',
    ...val),

  BCFF: (en: string, ...val: string[]) => translate(en,
    'Sinulla on käytössä useampi käyttäjätunnus OmaElisaan. Valitse tunnus jota haluat käyttää kirjautuessasi OmaElisaan. Tietoturvasyistä, suosittelemme, että valitset sähköpostimuotoisen tunnuksen.',
    ...val),

  BCPB: (en: string, ...val: string[]) => translate(en,
    'Sopimusehdot',
    ...val),

  BCWX: (en: string, ...val: string[]) => translate(en,
    'Elisa Päätelaitepalvelu, {} kk sopimus',
    ...val),

  BDBD: (en: string, ...val: string[]) => translate(en,
    '{} kpl',
    ...val),

  BDCT: (en: string, ...val: string[]) => translate(en,
    'Sallitut tiedostomuodot: {}',
    ...val),

  BDQD: (en: string, ...val: string[]) => translate(en,
    'Työntekijöiden pääsy yritysten OmaElisaan on estetty. Mikäli olet työsuhdeliittymääsi tai muita palveluitasi hallinnoimassa, voit tehdä sen',
    ...val),

  BE0G: (en: string, ...val: string[]) => translate(en,
    'Ohjeita laskutuskysymyksiin',
    ...val),

  BE4A: (en: string, ...val: string[]) => translate(en,
    'Käyttäjät',
    ...val),

  BE8Q: (en: string, ...val: string[]) => translate(en,
    'Ostoskori',
    ...val),

  BEKE: (en: string, ...val: string[]) => translate(en,
    'Huomioitavaa',
    ...val),

  BF36: (en: string, ...val: string[]) => translate(en,
    'Maksu keskeytetty',
    ...val),

  BFBA: (en: string, ...val: string[]) => translate(en,
    'Täytä tiedot, niin saat alustavan hinta-arvion kierrätettävälle laitteellesi. Otamme sinuun yhteyttä arkipäivisin 24 tunnin sisällä ja viimeistelemme Vaihtoetusi.',
    ...val),

  BFQ0: (en: string, ...val: string[]) => translate(en,
    'Tehtyjä muutoksia ei tallenneta.',
    ...val),

  BFV5: (en: string, ...val: string[]) => translate(en,
    'Kutsun lähetys työntekijälle onnistui.',
    ...val),

  BG4W: (en: string, ...val: string[]) => translate(en,
    'Muokkaa lisäpalveluita',
    ...val),

  BGVG: (en: string, ...val: string[]) => translate(en,
    'Vanha puhelinnumero',
    ...val),

  BH8T: (en: string, ...val: string[]) => translate(en,
    'Palauta alkuperäiset tiedot?',
    ...val),

  BHMU: (en: string, ...val: string[]) => translate(en,
    'Arkipäivisin ennen klo 12 tehdyt tilaukset ehtivät pääsääntöisesti seuraavan arkipaivan toimitukseen.',
    ...val),

  BHWT: (en: string, ...val: string[]) => translate(en,
    'Huomioithan, että tulet saamaan loppulaskun irtisanotusta liittymästä, mikäli käyttö- tai kuukausimaksuja on vielä laskuttamatta.',
    ...val),

  BID9: (en: string, ...val: string[]) => translate(en,
    'Voit halutessasi asettaa liittymälle palvelu- ja soitonestoja, joilla voit rajoittaa lisämaksullisten palveluiden käyttöä kotimaassa ja ulkomailla.',
    ...val),

  BIIR: (en: string, ...val: string[]) => translate(en,
    'Järjestys',
    ...val),

  BIRR: (en: string, ...val: string[]) => translate(en,
    'Uusi viite',
    ...val),

  BIS7: (en: string, ...val: string[]) => translate(en,
    'Tuotteet tilauksella',
    ...val),

  BJ25: (en: string, ...val: string[]) => translate(en,
    '1,60 €/kk/käyttäjä (alv. 0 %)',
    ...val),

  BJ43: (en: string, ...val: string[]) => translate(en,
    'Lähetimme vahvistuslinkin sähköpostiosoitteeseesi {} otsikolla "Tervetuloa Työntekijän OmaElisaan". Tarkista myös mahdollinen roskapostisi. \nKlikkaa "Vahvista linkkiä" vahvistaaksesi sähköpostiosoitteesi. Tämän jälkeen voit käyttää Työntekijän Oma Elisaa.',
    ...val),

  BJ8A: (en: string, ...val: string[]) => translate(en,
    'Muut asiointikanavat',
    ...val),

  BJRZ: (en: string, ...val: string[]) => translate(en,
    'Asiakkaan pääkäyttäjä luo aliasprofiilin KME Admin Portaalissa ja toimittaa sen tilauksen yhteydessä jälleenmyyjälle. Alias on aina jälleenmyyjäkohtainen, samaa aliasnimeä ei voi käyttää eri jälleenmyyjillä',
    ...val),

  BJVQ: (en: string, ...val: string[]) => translate(en,
    'Tilaa uutta',
    ...val),

  BKNH: (en: string, ...val: string[]) => translate(en,
    'Maksuerien määrä',
    ...val),

  BKPE: (en: string, ...val: string[]) => translate(en,
    'Muuttuvan sopimuksen numero',
    ...val),

  BLLL: (en: string, ...val: string[]) => translate(en,
    'Vain ulkopuheluilla',
    ...val),

  BLQP: (en: string, ...val: string[]) => translate(en,
    'Elisa Ring tuo matkapuhelimet luontevasti osaksi yrityksen puhelinjärjestelmää.',
    ...val),

  BM5E: (en: string, ...val: string[]) => translate(en,
    'Lähetämme erikseen vahvistusviestin jokaiselle liittymälle, kun palvelu on kytketty päälle 1-2 työpäivän kuluessa. Tämän jälkeen palvelu näkyy Yritysten OmaElisassa liittymän lisäpalveluiden näkymässä.',
    ...val),

  BMK4: (en: string, ...val: string[]) => translate(en,
    'Pääkäyttäjän puhelinnumero',
    ...val),

  BN1I: (en: string, ...val: string[]) => translate(en,
    'Jos virhe toistuu, ota yhteyttä asiakaspalveluun',
    ...val),

  BNAZ: (en: string, ...val: string[]) => translate(en,
    'Maksupäivän siirto veloitetaan',
    ...val),

  BO8J: (en: string, ...val: string[]) => translate(en,
    'Vahvista tilauksen hyväksyminen',
    ...val),

  BOIN: (en: string, ...val: string[]) => translate(en,
    'Ei laskutukseen liittyviä kirjeitä',
    ...val),

  BON5: (en: string, ...val: string[]) => translate(en,
    'Luo uusi salasana',
    ...val),

  BOZA: (en: string, ...val: string[]) => translate(en,
    'Vakaampi yhteys',
    ...val),

  BPM8: (en: string, ...val: string[]) => translate(en,
    'Suosituimmat lisätarvikkeet',
    ...val),

  BPVB: (en: string, ...val: string[]) => translate(en,
    'Suojaa yrityksesi laitteet F-Securen tietoturvalla',
    ...val),

  BPVG: (en: string, ...val: string[]) => translate(en,
    'Laskusi toimitetaan sähköpostilla. Löydät laskukopion henkilöasiakkaiden Oma Elisasta, jonka kautta voit halutessasi myös maksaa laskun.',
    ...val),

  BQ9Y: (en: string, ...val: string[]) => translate(en,
    'Katso tarkemmat tiedot',
    ...val),

  BQK6: (en: string, ...val: string[]) => translate(en,
    'Oletko soittanut palvelunumeroihin?',
    ...val),

  BQMC: (en: string, ...val: string[]) => translate(en,
    'Julkaisemattomia muutoksia',
    ...val),

  BQO3: (en: string, ...val: string[]) => translate(en,
    'Tarkista, että luot uuden henkilökontaktin sen yrityksen alle, jossa henkilö työskentelee. Yritysvalinta määritetään Yritysten OmaElisan etusivun oikeasta yläkulmasta.',
    ...val),

  BQS1: (en: string, ...val: string[]) => translate(en,
    'Elisalta löydät luotettavat nettiyhteydet myös isompiin tiloihin ja vaativampiin tarpeisiin.',
    ...val),

  BR9A: (en: string, ...val: string[]) => translate(en,
    'Valitse ensin yritys',
    ...val),

  BRFX: (en: string, ...val: string[]) => translate(en,
    'Laskunumero',
    ...val),

  BRHY: (en: string, ...val: string[]) => translate(en,
    'Tee uusi tilaus vasta kuin avoin tilaus on valmis. ',
    ...val),

  BRWO: (en: string, ...val: string[]) => translate(en,
    'Valitse toivomasi siirron ajankohta',
    ...val),

  BSE3: (en: string, ...val: string[]) => translate(en,
    'Toimitus',
    ...val),

  BSHJ: (en: string, ...val: string[]) => translate(en,
    'Pyydä uusi vahvistuskoodi',
    ...val),

  BTEU: (en: string, ...val: string[]) => translate(en,
    'Oma myyjäsi',
    ...val),

  BTJ9: (en: string, ...val: string[]) => translate(en,
    'tukipyynnön',
    ...val),

  BTMU: (en: string, ...val: string[]) => translate(en,
    'Ei asetettu',
    ...val),

  BTOF: (en: string, ...val: string[]) => translate(en,
    'Valitse kuljetustapa',
    ...val),

  BTQA: (en: string, ...val: string[]) => translate(en,
    'Katalogin julkaisu onnistui',
    ...val),

  BTTL: (en: string, ...val: string[]) => translate(en,
    'Työntekijä voi nähdä liittymän perustiedot ja käyttää laajakaistakorjainta vian määrittämiseen.',
    ...val),

  BU57: (en: string, ...val: string[]) => translate(en,
    'Kaikki yrityspalvelut',
    ...val),

  BUMO: (en: string, ...val: string[]) => translate(en,
    'rajaton',
    ...val),

  BV5F: (en: string, ...val: string[]) => translate(en,
    'toimitusehdot',
    ...val),

  BVO5: (en: string, ...val: string[]) => translate(en,
    'Laskutuskausi',
    ...val),

  BW68: (en: string, ...val: string[]) => translate(en,
    'Portti',
    ...val),

  BWTQ: (en: string, ...val: string[]) => translate(en,
    'Vapaa',
    ...val),

  BX0B: (en: string, ...val: string[]) => translate(en,
    'Syötä 5 numeroinen postinumero',
    ...val),

  BXJC: (en: string, ...val: string[]) => translate(en,
    'Palvelussa näkyvät tiedot palautetaan numeropalvelusta saataviin luettelotietoihin. Voit  muokata luettelotietoja ja niiden näkyvyyttä ',
    ...val),

  BXJD: (en: string, ...val: string[]) => translate(en,
    'liittymän tiedoissa',
    ...val),

  BXJH: (en: string, ...val: string[]) => translate(en,
    'Numerosi siirretään uudelle omistajalle.',
    ...val),

  BYFY: (en: string, ...val: string[]) => translate(en,
    'Vaaditaan jatkamista varten!',
    ...val),

  BZGP: (en: string, ...val: string[]) => translate(en,
    'Kauppa',
    ...val),

  BZHH: (en: string, ...val: string[]) => translate(en,
    'Valitse menneisyydessä oleva päivämäärä, jonka mukaan haluat raportin tiedot. Raportti on saatavilla takautuvasti 17.12.2025 alkaen, enintään vuoden ajalta.',
    ...val),

  BZWY: (en: string, ...val: string[]) => translate(en,
    'Huomioithan, että jos olet lisännyt uuden laskutussopimuksen se on käytettävissä heti.',
    ...val),

  BZYZ: (en: string, ...val: string[]) => translate(en,
    'Verkkokauppa',
    ...val),

  C001: (en: string, ...val: string[]) => translate(en,
    'Tilaus',
    ...val),

  C02I: (en: string, ...val: string[]) => translate(en,
    'Elisa Palvelupäätelaitteiden elinkaari',
    ...val),

  C0L4: (en: string, ...val: string[]) => translate(en,
    'Jos haluat lisätietoja Netti Litestä, ota yhteyttä myyntiimme:',
    ...val),

  C0OX: (en: string, ...val: string[]) => translate(en,
    'Muokkaa laskutussopimusten tietoja',
    ...val),

  C0QM: (en: string, ...val: string[]) => translate(en,
    'Lähetä irtisanomispyyntö',
    ...val),

  C0WF: (en: string, ...val: string[]) => translate(en,
    'Saat digiturvaa yleisintä tietoturvauhkaa eli tietojen kalastelua (phishing) vastaan käyttäessäsi nettiä 4G- tai 5G-mobiiliverkossa.',
    ...val),

  C2KQ: (en: string, ...val: string[]) => translate(en,
    'Vähennä',
    ...val),

  C2SK: (en: string, ...val: string[]) => translate(en,
    'Vahvista omistajanvaihto',
    ...val),

  C3XX: (en: string, ...val: string[]) => translate(en,
    'Voit aina olla yhteydessä asiakaspalveluumme',
    ...val),

  C499: (en: string, ...val: string[]) => translate(en,
    'Ole hyvä ja valitse toimitusmuoto.',
    ...val),

  C4FQ: (en: string, ...val: string[]) => translate(en,
    'Numeron julkisuutta ei voi vaihtaa samanaikaisesti laskutussopimuksen kanssa. Voit muuttaa numeron julkisuutta kun laskutussopimus on muutettu.',
    ...val),

  C4YQ: (en: string, ...val: string[]) => translate(en,
    'Gt',
    ...val),

  C5T9: (en: string, ...val: string[]) => translate(en,
    'Unohtuiko Elisa Tunnuksen salasana?',
    ...val),

  C6WY: (en: string, ...val: string[]) => translate(en,
    'Muu',
    ...val),

  C6Z0: (en: string, ...val: string[]) => translate(en,
    'Eikö liittymäsi näy listassa?',
    ...val),

  C7AE: (en: string, ...val: string[]) => translate(en,
    'Tyhjennä valinnat',
    ...val),

  C7PN: (en: string, ...val: string[]) => translate(en,
    'Tee-tukipyyntö',
    ...val),

  C7R5: (en: string, ...val: string[]) => translate(en,
    'OK, JATKA',
    ...val),

  C84H: (en: string, ...val: string[]) => translate(en,
    'Tuote',
    ...val),

  C8BR: (en: string, ...val: string[]) => translate(en,
    'Linkki on vanhentunut tai se on virheellinen.',
    ...val),

  C8DA: (en: string, ...val: string[]) => translate(en,
    'PopUp -viesti työntekijälle',
    ...val),

  C8I6: (en: string, ...val: string[]) => translate(en,
    'Sopimus',
    ...val),

  C8M7: (en: string, ...val: string[]) => translate(en,
    'Muutoksen tilaaja',
    ...val),

  C98K: (en: string, ...val: string[]) => translate(en,
    'Ohjeet Applen tukisivulla',
    ...val),

  C9DH: (en: string, ...val: string[]) => translate(en,
    'Käyttäjällä ei ole laitteita.',
    ...val),

  C9M1: (en: string, ...val: string[]) => translate(en,
    'Perustiedot',
    ...val),

  C9OV: (en: string, ...val: string[]) => translate(en,
    'Muuta KelloSIM-palvelun laskun maksajaa',
    ...val),

  C9XG: (en: string, ...val: string[]) => translate(en,
    'Odota hetki...',
    ...val),

  CAA9: (en: string, ...val: string[]) => translate(en,
    'Sopimuksen kesto',
    ...val),

  CACI: (en: string, ...val: string[]) => translate(en,
    'Edellinen',
    ...val),

  CACT: (en: string, ...val: string[]) => translate(en,
    'Tuleeko muutos heti voimaan',
    ...val),

  CAQ7: (en: string, ...val: string[]) => translate(en,
    'QR-koodi',
    ...val),

  CATY: (en: string, ...val: string[]) => translate(en,
    'https://elisa.fi/yhtiotieto/',
    ...val),

  CAW1: (en: string, ...val: string[]) => translate(en,
    'Tarvittaessa useampi laitelista voi käyttää samaa laitevalikoimaa. Laitelista asetuksineen on yrityskohtainen, mutta laitevalikoima voidaan jakaa muiden organisaatiorakenteen yritysten kanssa.',
    ...val),

  CAW5: (en: string, ...val: string[]) => translate(en,
    'Käyttäjän vaihto',
    ...val),

  CB08: (en: string, ...val: string[]) => translate(en,
    'Kun tilaat palvelun, liittymä ja laite toimitetaan sinulle helposti ja nopeasti toimintavalmiina pakettina',
    ...val),

  CB50: (en: string, ...val: string[]) => translate(en,
    'Lähetetään...',
    ...val),

  CBBN: (en: string, ...val: string[]) => translate(en,
    'Valitse maksutapa',
    ...val),

  CBCC: (en: string, ...val: string[]) => translate(en,
    'Kiitos viestistä',
    ...val),

  CC7C: (en: string, ...val: string[]) => translate(en,
    'Voit seurata tilausta ',
    ...val),

  CCB1: (en: string, ...val: string[]) => translate(en,
    'Numero',
    ...val),

  CCR4: (en: string, ...val: string[]) => translate(en,
    'Liittymä ei ole yhteensopiva Vakio-ratkaisun kanssa.',
    ...val),

  CCRE: (en: string, ...val: string[]) => translate(en,
    'Kaikkiin Netti Lite 4G/5G-liittymiin kuuluu oletuksena tietoturvallinen, ei-julkinen IP-osoite. Jos tarvitset julkisen IP-osoitteen, saat tilattua sen lisäpalveluna.',
    ...val),

  CCTC: (en: string, ...val: string[]) => translate(en,
    'Asentaja voi soittaa asennuksen aikana tarvittaessa (esimerkiksi pääsyn, ohjeiden tai lisätietojen vuoksi).',
    ...val),

  CD0S: (en: string, ...val: string[]) => translate(en,
    'Ei laitteita',
    ...val),

  CD11: (en: string, ...val: string[]) => translate(en,
    'Ei laskun viitetietoja',
    ...val),

  CDCD: (en: string, ...val: string[]) => translate(en,
    'Henkilöasiakkaat',
    ...val),

  CDME: (en: string, ...val: string[]) => translate(en,
    'Palvelu',
    ...val),

  CEHN: (en: string, ...val: string[]) => translate(en,
    'Ota yhteyttä yrityksesi pääkäyttäjään.',
    ...val),

  CEQ2: (en: string, ...val: string[]) => translate(en,
    'Yhteensä',
    ...val),

  CF93: (en: string, ...val: string[]) => translate(en,
    '{} kk sopimus',
    ...val),

  CFBG: (en: string, ...val: string[]) => translate(en,
    'Päivitä yhteyshenkilön tietoja',
    ...val),

  CFX9: (en: string, ...val: string[]) => translate(en,
    'Latausnopeus max. {0}M, lähetysnopeus max. {1}M',
    ...val),

  CG4F: (en: string, ...val: string[]) => translate(en,
    'Omat palvelut',
    ...val),

  CGVI: (en: string, ...val: string[]) => translate(en,
    'Jos sinulla on yrityksen nimenkirjoitusoikeus, voit jatkaa tunnistautumalla.',
    ...val),

  CGXR: (en: string, ...val: string[]) => translate(en,
    'katso muutospyynnön tiedot',
    ...val),

  CH87: (en: string, ...val: string[]) => translate(en,
    'Palvelunumerot',
    ...val),

  CHUM: (en: string, ...val: string[]) => translate(en,
    'Voit nyt kirjautua Yritysten OmaElisaan uudella salasanallasi.',
    ...val),

  CHWD: (en: string, ...val: string[]) => translate(en,
    'Muu aihe',
    ...val),

  CI5R: (en: string, ...val: string[]) => translate(en,
    'Pääkäyttäjän sähköpostiosoite',
    ...val),

  CI6O: (en: string, ...val: string[]) => translate(en,
    'Pää-Tiva',
    ...val),

  CI7R: (en: string, ...val: string[]) => translate(en,
    'Kutsulinkin avulla työntekijä pääsee kirjautumaan laitekauppaan sekä valitsemaan itsellensä laitteen.',
    ...val),

  CJGP: (en: string, ...val: string[]) => translate(en,
    'Laite, jota muutos koskee',
    ...val),

  CJOF: (en: string, ...val: string[]) => translate(en,
    'eSIMiä ei voi tilata tälle liittymälle.',
    ...val),

  CJT5: (en: string, ...val: string[]) => translate(en,
    'Luo tunnukset ja kirjaudu',
    ...val),

  CKF5: (en: string, ...val: string[]) => translate(en,
    'Rekisteröidy Yritysten OmaElisaan',
    ...val),

  CL0O: (en: string, ...val: string[]) => translate(en,
    'Laitteen {} tiedot',
    ...val),

  CL9N: (en: string, ...val: string[]) => translate(en,
    'Sopimus päättynyt',
    ...val),

  CL9O: (en: string, ...val: string[]) => translate(en,
    'Liittymän kuukausimaksut tilauksen jälkeen {0}/kk',
    ...val),

  CLAY: (en: string, ...val: string[]) => translate(en,
    ' että vahvistettuasi tilauksen, et voi enää muuttaa mieltäsi ja lunastaa vanhaa laitettasi.',
    ...val),

  CLD7: (en: string, ...val: string[]) => translate(en,
    'Yhdistelmä SIM-kortissa samaan korttipohjaan on yhdistetty kolme SIM-korttikokoa: Mini, Macro ja Nano. SIM-korttien PIN-koodi oletuksena 1234. Muistathan kuitenkin vaihtaa sen, kun otat liittymän käyttöön.',
    ...val),

  CLP6: (en: string, ...val: string[]) => translate(en,
    'Tarkista käyttäjätunnus ja salasana.',
    ...val),

  CMFZ: (en: string, ...val: string[]) => translate(en,
    'Muutoksen hinta',
    ...val),

  CMMT: (en: string, ...val: string[]) => translate(en,
    'Tunnistautumaan',
    ...val),

  CNNS: (en: string, ...val: string[]) => translate(en,
    'Vertaile ominaisuuksia',
    ...val),

  CNY8: (en: string, ...val: string[]) => translate(en,
    'Laitteella on käytössä Elisa Oma Laitelasku',
    ...val),

  CO7W: (en: string, ...val: string[]) => translate(en,
    'Estä kaikki datasiirto',
    ...val),

  COBB: (en: string, ...val: string[]) => translate(en,
    'Laitelistat',
    ...val),

  COPO: (en: string, ...val: string[]) => translate(en,
    'Maksu ei sisällä laitteen lunastushintaa, mikäli haluat lunastaa laitteen itsellesi sopimuskauden päätyttyä.',
    ...val),

  COTT: (en: string, ...val: string[]) => translate(en,
    'Siirry aktivoimaan',
    ...val),

  CPDO: (en: string, ...val: string[]) => translate(en,
    'Olet vaihtamassa sopijayritystä. Laskutussopimus ja käyttäjä on päivitettävä myös uuden sopijayrityksen mukaan. Mikäli haluat siirtää käyttäjän toiseen yritykseen, voit tehdä sen [Käyttäjät]-sivulta.',
    ...val),

  CPDQ: (en: string, ...val: string[]) => translate(en,
    'Yritysten määrä: {}',
    ...val),

  CPRM: (en: string, ...val: string[]) => translate(en,
    'Maksusi päivittyy meille 3 arkipäivän kuluessa. Sinun ei tarvitse ilmoittaa meille maksusta erikseen.',
    ...val),

  CPUS: (en: string, ...val: string[]) => translate(en,
    'Pystyt räätälöimään liittymääsi monipuolisilla liittymien lisäpalveluilla.',
    ...val),

  CQCX: (en: string, ...val: string[]) => translate(en,
    'Huijauspuheluiden esto',
    ...val),

  CQQ7: (en: string, ...val: string[]) => translate(en,
    'Lähetysnopeus',
    ...val),

  CQYP: (en: string, ...val: string[]) => translate(en,
    'Päivitä liittymäsi seuraavalle tasolle',
    ...val),

  CRIM: (en: string, ...val: string[]) => translate(en,
    'Olemme ratkaisseet ja sulkeneet tukipyynnön.',
    ...val),

  CRW1: (en: string, ...val: string[]) => translate(en,
    'Hyväksy OmaLasku -palvelun {}',
    ...val),

  CSI7: (en: string, ...val: string[]) => translate(en,
    'Uusi salasana',
    ...val),

  CSOC: (en: string, ...val: string[]) => translate(en,
    'Huomaa, että jos yritykselläsi on Samsung KME-laiterekisteriohjelmassa useampi alias, jokaiselle aliakselle täytyy luoda oma laitelista.',
    ...val),

  CSTF: (en: string, ...val: string[]) => translate(en,
    'Lisää kontakti',
    ...val),

  CTBU: (en: string, ...val: string[]) => translate(en,
    'Laskutussopimuksen vaihto onnistui',
    ...val),

  CTMX: (en: string, ...val: string[]) => translate(en,
    'Luo tunnus',
    ...val),

  CU8T: (en: string, ...val: string[]) => translate(en,
    'Palvelumaksu',
    ...val),

  CU9Z: (en: string, ...val: string[]) => translate(en,
    'Dataestot',
    ...val),

  CUDY: (en: string, ...val: string[]) => translate(en,
    'Kohde soittaessa alanumeroon',
    ...val),

  CUE7: (en: string, ...val: string[]) => translate(en,
    'Muutoshistoria',
    ...val),

  CUJ5: (en: string, ...val: string[]) => translate(en,
    'Laite on jatkokaudella',
    ...val),

  CUJO: (en: string, ...val: string[]) => translate(en,
    'Oletko poistanut Etsi -toiminnon käytöstä?',
    ...val),

  CUQU: (en: string, ...val: string[]) => translate(en,
    'Näytä erittely',
    ...val),

  CUS1: (en: string, ...val: string[]) => translate(en,
    'Lasku toimitetaan ilmoittamaasi sähköpostiin.',
    ...val),

  CV0S: (en: string, ...val: string[]) => translate(en,
    'Katso PUK-koodit',
    ...val),

  CV2A: (en: string, ...val: string[]) => translate(en,
    'Mobiilireititin',
    ...val),

  CV5H: (en: string, ...val: string[]) => translate(en,
    'Kategoria',
    ...val),

  CVAH: (en: string, ...val: string[]) => translate(en,
    'Hinta käyttäjälle',
    ...val),

  CVJF: (en: string, ...val: string[]) => translate(en,
    'Löysimme käyttäjän, jolla on samoja yhteystietoja',
    ...val),

  CVJM: (en: string, ...val: string[]) => translate(en,
    'PUK-koodit',
    ...val),

  CVON: (en: string, ...val: string[]) => translate(en,
    'Tilaa SIM',
    ...val),

  CVSQ: (en: string, ...val: string[]) => translate(en,
    'Suurten tiedostojen nopea siirto, live-striimaus ja vaativa etätyö',
    ...val),

  CW9X: (en: string, ...val: string[]) => translate(en,
    'Laitteen lunastaminen vaatii työnantajasi hyväksynnän. Lähetämme lunastuspyynnön työnantajallesi automaattisesti. Hyväksynnän jälkeen saat laskun sähköpostiisi.',
    ...val),

  CWR5: (en: string, ...val: string[]) => translate(en,
    'Viite- tai lisätieto',
    ...val),

  CXWM: (en: string, ...val: string[]) => translate(en,
    'Tällä liittymällä on ajastettu muutospyyntö',
    ...val),

  CYRE: (en: string, ...val: string[]) => translate(en,
    'Sallitut merkit: kirjaimet, numerot ja - & ( ) . ,',
    ...val),

  CYTU: (en: string, ...val: string[]) => translate(en,
    'Kertamaksulliset laitteet',
    ...val),

  CYUU: (en: string, ...val: string[]) => translate(en,
    'Valitse mitä laskutussopimuksia tilauksen hyväksyjä voi tilauksella käyttää.',
    ...val),

  CYVE: (en: string, ...val: string[]) => translate(en,
    'Rajaton netin käyttö kotimaassa',
    ...val),

  CYXH: (en: string, ...val: string[]) => translate(en,
    'Vanhat palvelut',
    ...val),

  CYY2: (en: string, ...val: string[]) => translate(en,
    'Ruotsi',
    ...val),

  CYZV: (en: string, ...val: string[]) => translate(en,
    'Ostoskorissa 1 tuote',
    ...val),

  CZ63: (en: string, ...val: string[]) => translate(en,
    'Laskutus- ja käyttäjätiedot',
    ...val),

  CZ6R: (en: string, ...val: string[]) => translate(en,
    'Puhelinnumeron vaihto',
    ...val),

  CZ7M: (en: string, ...val: string[]) => translate(en,
    'Voit tilausvaiheessa lisätä lisäpalveluita liittymääsi. Pääset myös OmaElisassa helposti hallinnoimaan ja aktivoimaan liittymäsi lisäpalveluita.',
    ...val),

  CZ89: (en: string, ...val: string[]) => translate(en,
    'Saatavuus',
    ...val),

  CZNY: (en: string, ...val: string[]) => translate(en,
    'Luo uusi viesti tai tukipyyntö',
    ...val),

  CZS5: (en: string, ...val: string[]) => translate(en,
    'Apple laiterekisteröintiohjelma',
    ...val),

  D002: (en: string, ...val: string[]) => translate(en,
    'Ostotavat',
    ...val),

  D00E: (en: string, ...val: string[]) => translate(en,
    'Jos olet jo ottanut Elisa Tunnuksen käyttöön Yritysten OmaElisassa, jatka kirjautumista sillä.',
    ...val),

  D030: (en: string, ...val: string[]) => translate(en,
    'Jätä yhteydenottopyyntö',
    ...val),

  D14J: (en: string, ...val: string[]) => translate(en,
    'Vastaajat työajan ulkopuolella',
    ...val),

  D1E9: (en: string, ...val: string[]) => translate(en,
    'Takaisin',
    ...val),

  D1GD: (en: string, ...val: string[]) => translate(en,
    'Lisää uusi yritys',
    ...val),

  D1HY: (en: string, ...val: string[]) => translate(en,
    'Hallitse yrityksesi liittymien soittajatietoja, jotka näytetään puhelun vastaanottajalle. Voit muokata tietoja tai palauttaa ne luettelutietojen mukaisiksi.',
    ...val),

  D1IS: (en: string, ...val: string[]) => translate(en,
    'Päätä sopimus',
    ...val),

  D1RH: (en: string, ...val: string[]) => translate(en,
    'Ei laitelistoja. Ota yhteyttä työnantajasi pääkäyttäjään.',
    ...val),

  D1YH: (en: string, ...val: string[]) => translate(en,
    'henkilöasiakaspuolella',
    ...val),

  D205: (en: string, ...val: string[]) => translate(en,
    'Liittymän päivitys epäonnistui',
    ...val),

  D259: (en: string, ...val: string[]) => translate(en,
    'Liittymässä on määräaikainen sopimus {} saakka. Sopimuksen irtisanominen ei ole mahdollista ilman loppulaskua, jossa veloitetaan laskuttamatta jääneet kuukausiveloitukset.',
    ...val),

  D2O8: (en: string, ...val: string[]) => translate(en,
    'Power Book -ominaisuus',
    ...val),

  D2PS: (en: string, ...val: string[]) => translate(en,
    'Viestiestot',
    ...val),

  D2UO: (en: string, ...val: string[]) => translate(en,
    'liittymän',
    ...val),

  D2W8: (en: string, ...val: string[]) => translate(en,
    'Varaa aika',
    ...val),

  D2W9: (en: string, ...val: string[]) => translate(en,
    'Etätapaaminen yritysmyyjän kanssa',
    ...val),

  D30R: (en: string, ...val: string[]) => translate(en,
    'Palaa liittymäsivulle',
    ...val),

  D3MU: (en: string, ...val: string[]) => translate(en,
    'Liittymällä on käytössä lisäpalvelu ({}), joka estää palvelun käyttöönoton.',
    ...val),

  D4FU: (en: string, ...val: string[]) => translate(en,
    'Toimitus kotiosoitteeseen',
    ...val),

  D4L5: (en: string, ...val: string[]) => translate(en,
    'Yritysnumeron ajastetulla työajalla käytössä',
    ...val),

  D4Y7: (en: string, ...val: string[]) => translate(en,
    'Tunnistaudu henkilökohtaisilla verkkopankkitunnuksilla tai Mobiilivarmenteella vahvistaaksesi liittymänumeron',
    ...val),

  D55A: (en: string, ...val: string[]) => translate(en,
    'Mikäli toivottu asennuspäivä jätetään täyttämättä, niin liittymä toimitetaan mahdollisimman pian. Toimitusaika vahvistetaan toimitusvahvistuksessa.',
    ...val),

  D55M: (en: string, ...val: string[]) => translate(en,
    'Sopimuskausi',
    ...val),

  D689: (en: string, ...val: string[]) => translate(en,
    'Anna osoite, johon lähetämme laskun. Saat ensimmäisen laskun postitse. Suosittelemme tekemään e-laskusopimuksen, jolloin saat laskut suoraan verkkopankkiisi.',
    ...val),

  D6IE: (en: string, ...val: string[]) => translate(en,
    'Voit hallinnoida palvelua henkilöasiakkaiden OmaElisassa.',
    ...val),

  D6Q4: (en: string, ...val: string[]) => translate(en,
    'Liittymä on väliaikaisesti suljettu',
    ...val),

  D6YG: (en: string, ...val: string[]) => translate(en,
    'Monimuotokuitu',
    ...val),

  D7L8: (en: string, ...val: string[]) => translate(en,
    'Käsittelemme tukipyyntöä.',
    ...val),

  D7Y7: (en: string, ...val: string[]) => translate(en,
    'Laitteelle on tehty muutospyyntö, jonka käsittely on vielä kesken. Uusia muutoksia on mahdollista tehdä vasta, kun edellinen muutospyyntö on käsitelty. Huomaathan myös, että käsittelyssä oleva muutos tulee näkyviin vasta, kun muutospyyntö on käsitelty.',
    ...val),

  D8IX: (en: string, ...val: string[]) => translate(en,
    'Ohjeita käyttäjähallintaan',
    ...val),

  D8WR: (en: string, ...val: string[]) => translate(en,
    'Muutospyynnön lähetys onnistui. Muutoksen päivittyminen voi kestää noin vuorokauden.',
    ...val),

  D99O: (en: string, ...val: string[]) => translate(en,
    'Arkipäivisin ennen klo 12 tehdyt tilaukset ehtivät pääsääntöisesti seuraavan arkipäivän toimitukseen.',
    ...val),

  D9LE: (en: string, ...val: string[]) => translate(en,
    'Irtisano palvelu',
    ...val),

  D9LX: (en: string, ...val: string[]) => translate(en,
    'Tee vianselvitys liittymän tiedoissa',
    ...val),

  D9NS: (en: string, ...val: string[]) => translate(en,
    'Voit lunastaa laitteen yritykselle tai tehdä lunastuspyynnön työntekijän puolesta, mikäli työntekijä on ottanut Omalaitelaskun käyttöönsä. Lunastushinta lasketaan reaaliaikaisesti. Laitteen lunastuksen työntekijä voi tehdä myös itse Työntekijän OmaElisasta yrityksille.elisa.fi/työntekijä.',
    ...val),

  D9PT: (en: string, ...val: string[]) => translate(en,
    'Kustannuspaikkalasku',
    ...val),

  D9Q4: (en: string, ...val: string[]) => translate(en,
    'Maksu',
    ...val),

  D9TG: (en: string, ...val: string[]) => translate(en,
    'Yritysnumero',
    ...val),

  DA7N: (en: string, ...val: string[]) => translate(en,
    'Tarjoa työntekijöille vahva sähköinen tunnistusväline',
    ...val),

  DB2P: (en: string, ...val: string[]) => translate(en,
    'Yritysten OmaElisassa pystyt lähettämään liitteitä tukipyynnön mukana sekä seuraamaan tukipyyntöjen etenemistä.',
    ...val),

  DB9E: (en: string, ...val: string[]) => translate(en,
    '33 W pikalataus',
    ...val),

  DBD3: (en: string, ...val: string[]) => translate(en,
    'Sisältää pelkän liittymän. Päätelaite myydään erikseen. ',
    ...val),

  DBJG: (en: string, ...val: string[]) => translate(en,
    'Yritykselläsi ei ole enää yritysnumeroita vapaana. Voit tilata lisää numeroita',
    ...val),

  DBQJ: (en: string, ...val: string[]) => translate(en,
    'Liittymänumero',
    ...val),

  DC0T: (en: string, ...val: string[]) => translate(en,
    'Käyttäjällä on tuotteita, joiden tilausta ei ole vielä käsitelty',
    ...val),

  DCA8: (en: string, ...val: string[]) => translate(en,
    'Jatka kirjautumatta',
    ...val),

  DCMM: (en: string, ...val: string[]) => translate(en,
    'Poissaoloketjuun vaaditaan ensimmäinen kohdenumero kun aikaohjaus on valittuna',
    ...val),

  DD38: (en: string, ...val: string[]) => translate(en,
    'Katuosoite',
    ...val),

  DD3Q: (en: string, ...val: string[]) => translate(en,
    'Tilaa eSIM',
    ...val),

  DDHX: (en: string, ...val: string[]) => translate(en,
    'Näytä vähemmän',
    ...val),

  DDRB: (en: string, ...val: string[]) => translate(en,
    'Liittymän kuukausimaksu sisältää myös reitittimen.',
    ...val),

  DDU5: (en: string, ...val: string[]) => translate(en,
    'Rekisteröityminen epäonnistui',
    ...val),

  DED6: (en: string, ...val: string[]) => translate(en,
    ', niin pääset hallinnoimaan ja aktivoimaan liittymiäsi ja lisäpalveluita.',
    ...val),

  DEPW: (en: string, ...val: string[]) => translate(en,
    'Ostolaitteiden laskutustiedot',
    ...val),

  DFUR: (en: string, ...val: string[]) => translate(en,
    'Mahdollisimman pian',
    ...val),

  DHD6: (en: string, ...val: string[]) => translate(en,
    'Mitä 5G+ eli Aito 5G tarkoittaa?',
    ...val),

  DHEY: (en: string, ...val: string[]) => translate(en,
    'Jos haluat lisätä vain hyväksyjä-roolin, sinun täytyy ensin lähettää kutsu Työntekijän OmaElisaan',
    ...val),

  DHQ9: (en: string, ...val: string[]) => translate(en,
    'Kustannuspaikka voi olla enintään 40 merkkiä pitkä',
    ...val),

  DI4V: (en: string, ...val: string[]) => translate(en,
    'Asennusosoite',
    ...val),

  DIBP: (en: string, ...val: string[]) => translate(en,
    'Roaming Datavartija',
    ...val),

  DIEL: (en: string, ...val: string[]) => translate(en,
    'Tilaa Elisa Kuka Soittaa -palvelu vaivattomasti yhteen tai useampaan yritysliittymään Yritysten OmaElisassa.',
    ...val),

  DILB: (en: string, ...val: string[]) => translate(en,
    'Tekstiviesti- ja mobiilimaksuestot',
    ...val),

  DIPB: (en: string, ...val: string[]) => translate(en,
    'Supernopea netti päivittäiseen työntekoon ja vapaa-ajan viihteeseen',
    ...val),

  DIRC: (en: string, ...val: string[]) => translate(en,
    'Puhelinnumero (työ)',
    ...val),

  DJO2: (en: string, ...val: string[]) => translate(en,
    'Valittu lista',
    ...val),

  DKUZ: (en: string, ...val: string[]) => translate(en,
    'Kuuluvuus, häiriöt ja viat',
    ...val),

  DKXU: (en: string, ...val: string[]) => translate(en,
    'Takaisin ostoskoriin',
    ...val),

  DLRT: (en: string, ...val: string[]) => translate(en,
    'Lomakkeen lähetyksessä tapahtui virhe. Ole hyvä ja yritä uudelleen tai ota yhteyttä yritysasiakaspalveluumme.',
    ...val),

  DLV8: (en: string, ...val: string[]) => translate(en,
    'Uusi laitevalikoima',
    ...val),

  DMD6: (en: string, ...val: string[]) => translate(en,
    'Estää tekstiviesti- ja mobiilimaksamisen esim. pizza- ja matkalipputilauksissa. Estää myös osallistumisen puhelinlahjoituksiin sekä numerotiedustelujen ja tilauspalveluiden käytön (esim. juoma- tai elintarvikeautomaatit). Sisältää eston viihde- ja ajanvietenumeroihin.',
    ...val),

  DMJV: (en: string, ...val: string[]) => translate(en,
    'Luo uusi tietue',
    ...val),

  DMM5: (en: string, ...val: string[]) => translate(en,
    'Verkkolaitteet',
    ...val),

  DN45: (en: string, ...val: string[]) => translate(en,
    'Muut liittymätyypit',
    ...val),

  DNM5: (en: string, ...val: string[]) => translate(en,
    'Viankuvaus',
    ...val),

  DNMO: (en: string, ...val: string[]) => translate(en,
    'Kiitos! eSIMin tilaus onnistui.',
    ...val),

  DODI: (en: string, ...val: string[]) => translate(en,
    'Täytä alennuskoodi',
    ...val),

  DOV9: (en: string, ...val: string[]) => translate(en,
    'Ongelma latauksessa',
    ...val),

  DP44: (en: string, ...val: string[]) => translate(en,
    'Liittymän numero',
    ...val),

  DQ1Z: (en: string, ...val: string[]) => translate(en,
    'Vakio-ratkaisu liittymälle',
    ...val),

  DQDK: (en: string, ...val: string[]) => translate(en,
    'Jälkitoimituksena tilattavat tuotteet toimitetaan sitä mukaan, kun tuotteita on saatavilla varastossa. Toimitusmaksu veloitetaan vain kerran.',
    ...val),

  DQQ1: (en: string, ...val: string[]) => translate(en,
    'Sopimustyyppi',
    ...val),

  DR5T: (en: string, ...val: string[]) => translate(en,
    'Ladataan lomaketta',
    ...val),

  DREM: (en: string, ...val: string[]) => translate(en,
    'Tila kertoo onko laskutussopimus aktiivinen eli käytössä vai passiivinen eli päättynyt.',
    ...val),

  DRG7: (en: string, ...val: string[]) => translate(en,
    'Mobiilireitittimen pakkauksen sisältö',
    ...val),

  DRKV: (en: string, ...val: string[]) => translate(en,
    'Henkilöasiakkaan käyttäjätunnus on sähköpostiosoite. Jos olet Elisan kuluttajaliittymien yritysasiakas (entinen Saunalahden yritysasiakas), tunnus on usein puhelinnumerosi, mutta se voi olla myös yhdistelmä kirjaimia ja numeroita.',
    ...val),

  DRLC: (en: string, ...val: string[]) => translate(en,
    'Estoluokitukset liittymiin',
    ...val),

  DRSH: (en: string, ...val: string[]) => translate(en,
    'Sopimuskausi päättymässä',
    ...val),

  DRXL: (en: string, ...val: string[]) => translate(en,
    'Asennusosoite puuttuu',
    ...val),

  DRYH: (en: string, ...val: string[]) => translate(en,
    'Laskulle tulostuva maksajan postiosoite.',
    ...val),

  DS9O: (en: string, ...val: string[]) => translate(en,
    'Palvelu sisältää WIFI Mesh-laitteiden ({}) asennuksen optimaalisesti sijoiteltuna, jotta WIFI-verkko kattaa koko kodin/toimiston',
    ...val),

  DT3P: (en: string, ...val: string[]) => translate(en,
    'Siirtyminen portaaliin epäonnistui',
    ...val),

  DTLM: (en: string, ...val: string[]) => translate(en,
    'Sisältää 500kpl viestiä Pohjolassa ja Baltiassa, ylimenevät viestit 0,079 €/kpl',
    ...val),

  DTQ6: (en: string, ...val: string[]) => translate(en,
    'EU/ETA-maiden ulkopuolella',
    ...val),

  DTYT: (en: string, ...val: string[]) => translate(en,
    'Hälytysaika',
    ...val),

  DU8X: (en: string, ...val: string[]) => translate(en,
    'Tarjouksen voimassaolo',
    ...val),

  DUFL: (en: string, ...val: string[]) => translate(en,
    'Laitteesi palvelupyyntö lähetettiin onnistuneesti',
    ...val),

  DUPA: (en: string, ...val: string[]) => translate(en,
    'Kentän arvo on virheellinen',
    ...val),

  DV41: (en: string, ...val: string[]) => translate(en,
    'Etkö löydä laitettasi täältä?',
    ...val),

  DVAW: (en: string, ...val: string[]) => translate(en,
    'Odottaa...',
    ...val),

  DVM1: (en: string, ...val: string[]) => translate(en,
    'Paikallista käyttöä ei löytynyt!',
    ...val),

  DVRM: (en: string, ...val: string[]) => translate(en,
    'Vahvistuskoodia ei voi lähettää heti uudelleen. Yritä hetken kuluttua uudelleen.',
    ...val),

  DVXR: (en: string, ...val: string[]) => translate(en,
    'Valitse alta laitelistat, joihin haluat kopioida tämän laitelistan tuotevalikoiman. Huomioithan, että tuotevalikoiman kopiointi korvaa kaikki valituissa laitelistoissa olevat tuotteet. Tämä ei vaikuta laitelistan asetuksiin.',
    ...val),

  DVYV: (en: string, ...val: string[]) => translate(en,
    'Elisa Oma Laitelasku sopimusehdot',
    ...val),

  DW0G: (en: string, ...val: string[]) => translate(en,
    'Tyhjennä kenttä',
    ...val),

  DW3T: (en: string, ...val: string[]) => translate(en,
    'Yksityisille',
    ...val),

  DWS8: (en: string, ...val: string[]) => translate(en,
    'Kaipaatko apua sopivan laitteen valinnassa?',
    ...val),

  DXK6: (en: string, ...val: string[]) => translate(en,
    'Piilota kuukausikohtainen erittely',
    ...val),

  DYKC: (en: string, ...val: string[]) => translate(en,
    'Avaajan sähköposti',
    ...val),

  DYMN: (en: string, ...val: string[]) => translate(en,
    'Tuote on poistunut valikoimastamme.',
    ...val),

  DZA1: (en: string, ...val: string[]) => translate(en,
    'Työaikaketjun voimassaoloajat vaaditaan, kun aikaohjaus on käytössä.',
    ...val),

  DZMK: (en: string, ...val: string[]) => translate(en,
    'Siirry OmaElisa Classiciin',
    ...val),

  DZQF: (en: string, ...val: string[]) => translate(en,
    'Kirjautuminen uudistuu',
    ...val),

  E0FK: (en: string, ...val: string[]) => translate(en,
    'https://elisa.fi/tietosuoja/',
    ...val),

  E0K4: (en: string, ...val: string[]) => translate(en,
    'Kk-maksut yhteensä, alv. 0 %',
    ...val),

  E0KX: (en: string, ...val: string[]) => translate(en,
    'Oletko työntekijä?',
    ...val),

  E0RW: (en: string, ...val: string[]) => translate(en,
    'Lisäturva laitteelle',
    ...val),

  E0TK: (en: string, ...val: string[]) => translate(en,
    'Kopioi laitelistan tuotevalikoima muihin kertamaksullisiin listoihin',
    ...val),

  E112: (en: string, ...val: string[]) => translate(en,
    'Pääkäyttäjä',
    ...val),

  E12Y: (en: string, ...val: string[]) => translate(en,
    'Työnantaja kustantaa tämän laitteen kokonaan',
    ...val),

  E1IS: (en: string, ...val: string[]) => translate(en,
    'Sulje keskustelukutsu',
    ...val),

  E1N1: (en: string, ...val: string[]) => translate(en,
    'Hyväksy vielä ehdot.',
    ...val),

  E23N: (en: string, ...val: string[]) => translate(en,
    'Työaikana käytössä',
    ...val),

  E2HY: (en: string, ...val: string[]) => translate(en,
    'Nettiliittymän ja langattoman MESH-verkon asennus',
    ...val),

  E35R: (en: string, ...val: string[]) => translate(en,
    'Toimii myös ulkomailla',
    ...val),

  E3AN: (en: string, ...val: string[]) => translate(en,
    'Tilaukselle on lisätty nollahintainen kerta- tai kuukausiveloitus. Ole hyvä ja valitse käyttökategoria sekä perusteet miksi tilauksella olevasta tuotteesta ei tulisi veloittaa kerta- tai kuukausimaksuja. Kerro myös keneltä olet tähän saanut luvan. Tarkemmat tiedot käyttökategorioista löydät',
    ...val),

  E45A: (en: string, ...val: string[]) => translate(en,
    'Liittymätietojen näyttäminen Työntekijän OmaElisassa',
    ...val),

  E4TT: (en: string, ...val: string[]) => translate(en,
    '(alv. {} %)',
    ...val),

  E51E: (en: string, ...val: string[]) => translate(en,
    'Lue lisää ja ota käyttöön',
    ...val),

  E54X: (en: string, ...val: string[]) => translate(en,
    'Lunastuksesta lähetetään lasku käyttäjälle.',
    ...val),

  E68G: (en: string, ...val: string[]) => translate(en,
    'Yrityskäytössä Aito 5G:n hyödyt näkyvät parempana suorituskykynä, pienempinä viiveinä ja vähäisempänä yhteyksien katkeiluna esimerkiksi etätyössä, videopalavereissa ja pilvipalveluiden käytössä.',
    ...val),

  E6CG: (en: string, ...val: string[]) => translate(en,
    'Puhelussa näkyvä tieto',
    ...val),

  E6DY: (en: string, ...val: string[]) => translate(en,
    'Posti Express aamu',
    ...val),

  E6LF: (en: string, ...val: string[]) => translate(en,
    'Laitteen voi vaihtaa uuteen kaksi viikkoa ennen peruskauden päättymistä. Mikäli laitevaihtoa ei tehdä tai sopimusta päätetä, laite siirtyy automaattisesti 6kk jatkokaudelle.',
    ...val),

  E6PL: (en: string, ...val: string[]) => translate(en,
    'Poista tuotteita',
    ...val),

  E74C: (en: string, ...val: string[]) => translate(en,
    'Gt aktivoituu automaattisesti kohdemaissa ja mahdollistaa mobiilipäätelaitteella tai kannettavalla tietokoneella käytettävän nopean tiedonsiirtoyhteyden edulliseen hintaan EU/ETA-alueen ulkopuolisissa maissa. Palvelussa ei ole kuukausimaksua, vaan hinnoittelu aktivoituu käytön mukaan 26,90 € / 14 vrk.',
    ...val),

  E7S2: (en: string, ...val: string[]) => translate(en,
    'Vahinko- tai huoltoilmoitus',
    ...val),

  E82U: (en: string, ...val: string[]) => translate(en,
    'Suosittelemme seuraavia vaihtoehtoja:',
    ...val),

  E83U: (en: string, ...val: string[]) => translate(en,
    'Suosittelemme myös',
    ...val),

  E83V: (en: string, ...val: string[]) => translate(en,
    'Yhteensopivat lisätarvikkeet',
    ...val),

  E83W: (en: string, ...val: string[]) => translate(en,
    'Tilaaja ja avainkäyttäjä saavat linkin F-Secure-portaaliin. Lisenssit on määritettävä manuaalisesti ennen käyttöä.',
    ...val),

  E86B: (en: string, ...val: string[]) => translate(en,
    'Ei määräaikaa',
    ...val),

  E8T5: (en: string, ...val: string[]) => translate(en,
    'Muutoksen lähetys onnistui',
    ...val),

  E90X: (en: string, ...val: string[]) => translate(en,
    'Voit palauttaa käyttäjätunnuksesi',
    ...val),

  E99N: (en: string, ...val: string[]) => translate(en,
    'Keskeneräiset tilaukset',
    ...val),

  E9BD: (en: string, ...val: string[]) => translate(en,
    'Muutoksen tiedot',
    ...val),

  E9GS: (en: string, ...val: string[]) => translate(en,
    'Alkamisaika ei voi olla suurempi kuin päättymisaika',
    ...val),

  E9I4: (en: string, ...val: string[]) => translate(en,
    'Lähetetty',
    ...val),

  E9IF: (en: string, ...val: string[]) => translate(en,
    'Puhelimet',
    ...val),

  E9LB: (en: string, ...val: string[]) => translate(en,
    'Hanki entistä toimivampi netti työntekoon Elisa YritysWIFI Lite -palvelulla. Sen sisältämien wifi-vahvistinten avulla netti toimii kaikissa huoneissa ja kerroksissa.',
    ...val),

  E9XD: (en: string, ...val: string[]) => translate(en,
    'Hinta-arvio laitteestasi',
    ...val),

  EAA8: (en: string, ...val: string[]) => translate(en,
    'Laitteen sopimuskausi on päättymässä. Laitekaupasta voit tilata uuden laitteen ja halutessasi myös lunastaa tämän vanhan laitteen. Mikäli laitevaihtoa ei tehdä tai sopimusta päätetä, laite siirtyy automaattisesti 6 kk jatkokaudelle.',
    ...val),

  EAAJ: (en: string, ...val: string[]) => translate(en,
    'Liittymän tiedot',
    ...val),

  EADV: (en: string, ...val: string[]) => translate(en,
    'Lähetä kaikki tuotteet yhdessä',
    ...val),

  EAFO: (en: string, ...val: string[]) => translate(en,
    'Unohtuiko salasana?',
    ...val),

  EAJM: (en: string, ...val: string[]) => translate(en,
    'Ilmoittaudu',
    ...val),

  EAPO: (en: string, ...val: string[]) => translate(en,
    'Näytä vain luomani tilaukset',
    ...val),

  EAVJ: (en: string, ...val: string[]) => translate(en,
    'Kirjaamme sinut ulos tunnistautumista varten',
    ...val),

  EBAT: (en: string, ...val: string[]) => translate(en,
    'Arkisin',
    ...val),

  EBJW: (en: string, ...val: string[]) => translate(en,
    'Laskutussopimuksen lisääminen epäonnistui. Yritä myöhemmin uudelleen.',
    ...val),

  EBNB: (en: string, ...val: string[]) => translate(en,
    'Hylkäämisen lisätiedot työntekijälle',
    ...val),

  EBUW: (en: string, ...val: string[]) => translate(en,
    'Laite on peruskaudella',
    ...val),

  EBX4: (en: string, ...val: string[]) => translate(en,
    'Tämän laitteen osalta summa on ',
    ...val),

  EC1N: (en: string, ...val: string[]) => translate(en,
    'omista tiedoistasi',
    ...val),

  ECIT: (en: string, ...val: string[]) => translate(en,
    'Voit seurata tilaustasi myös',
    ...val),

  ECMJ: (en: string, ...val: string[]) => translate(en,
    'Laitteen malli',
    ...val),

  EDWL: (en: string, ...val: string[]) => translate(en,
    'Kiitoksena hyvästä asiakkuudestasi tarjoamme sinulle liittymääsi päivitysedun:',
    ...val),

  EE4N: (en: string, ...val: string[]) => translate(en,
    'Maksutiedot',
    ...val),

  EE7J: (en: string, ...val: string[]) => translate(en,
    'Tilauksesi sisältää tuotteita, joita ei juuri nyt ole saatavilla.',
    ...val),

  EEE3: (en: string, ...val: string[]) => translate(en,
    'Huom!',
    ...val),

  EER5: (en: string, ...val: string[]) => translate(en,
    'Tilaa Elisa Kuka Soittaa -palvelu',
    ...val),

  EEYF: (en: string, ...val: string[]) => translate(en,
    'Siirrä liittymä toiseen laskutussopimukseen',
    ...val),

  EFC1: (en: string, ...val: string[]) => translate(en,
    'Muutos astuu voimaan valitsemanasi päivänä. Tukipyynnön tila ja ratkaisu on nähtävillä viestikeskuksessa. Ilmoitus muutetuista sopimuksista lähetetään viestikeskuksen lisäksi myös yhteyshenkilön sähköpostiin.',
    ...val),

  EFXH: (en: string, ...val: string[]) => translate(en,
    'Sopimuksen irtisanominen',
    ...val),

  EG02: (en: string, ...val: string[]) => translate(en,
    'Verkkolaite',
    ...val),

  EG5X: (en: string, ...val: string[]) => translate(en,
    'Valitut laskutussopimukset',
    ...val),

  EG6F: (en: string, ...val: string[]) => translate(en,
    'Omat tilaukset',
    ...val),

  EGFA: (en: string, ...val: string[]) => translate(en,
    'Valitettavasti emme voi käsitellä pyyntöäsi, koska järjestelmästämme löytyy mahdollinen samanlainen yhteyshenkilö. Ole ystävällinen ja ota yhteyttä Elisan asiakaspalveluun.',
    ...val),

  EGPN: (en: string, ...val: string[]) => translate(en,
    'Suosikit',
    ...val),

  EGQX: (en: string, ...val: string[]) => translate(en,
    'Puhelimen paikannus',
    ...val),

  EGRR: (en: string, ...val: string[]) => translate(en,
    'Siirrä seuraavaan numeroon ketjussa',
    ...val),

  EH0U: (en: string, ...val: string[]) => translate(en,
    'Elisa Mobiiliturva Yrityksille',
    ...val),

  EH18: (en: string, ...val: string[]) => translate(en,
    'Matkahuolto Lähellä-paketti',
    ...val),

  EHOL: (en: string, ...val: string[]) => translate(en,
    'Yrityksen tiedot',
    ...val),

  EI6P: (en: string, ...val: string[]) => translate(en,
    'Tekstiviestipaketti 500',
    ...val),

  EIC5: (en: string, ...val: string[]) => translate(en,
    'Tukipyyntö avattu',
    ...val),

  EITS: (en: string, ...val: string[]) => translate(en,
    'Aktivoi',
    ...val),

  EIYK: (en: string, ...val: string[]) => translate(en,
    'Ei lisäpalveluita',
    ...val),

  EJQF: (en: string, ...val: string[]) => translate(en,
    'Asetukset',
    ...val),

  EJTJ: (en: string, ...val: string[]) => translate(en,
    'Reportin luonti on jo käynnissä',
    ...val),

  EK6O: (en: string, ...val: string[]) => translate(en,
    'Numero ei ole siirrettävissä.',
    ...val),

  EK6P: (en: string, ...val: string[]) => translate(en,
    'Suojakuoret',
    ...val),

  EKAI: (en: string, ...val: string[]) => translate(en,
    'Palvelun irtisanominen onnistui',
    ...val),

  EKAR: (en: string, ...val: string[]) => translate(en,
    'Muista myös muut hyödylliset palvelut yrittäjän tai suuremman yrityksen tarpeisiin',
    ...val),

  EKG9: (en: string, ...val: string[]) => translate(en,
    'Tukipyyntö',
    ...val),

  EKK1: (en: string, ...val: string[]) => translate(en,
    'Palvelu käytössä',
    ...val),

  EKYF: (en: string, ...val: string[]) => translate(en,
    'Vahvista, että olet tarkistanut pääkäyttäjien tiedot',
    ...val),

  EL7L: (en: string, ...val: string[]) => translate(en,
    'Syötä työyhteystietosi',
    ...val),

  EL7N: (en: string, ...val: string[]) => translate(en,
    'Virheellinen kokonaisluku',
    ...val),

  EL9W: (en: string, ...val: string[]) => translate(en,
    'Linkki lähetetty.',
    ...val),

  ELB0: (en: string, ...val: string[]) => translate(en,
    'Toimii itsenäisessä 5G+ -verkossa',
    ...val),

  ELJA: (en: string, ...val: string[]) => translate(en,
    'Olen uusi asiakas',
    ...val),

  ELJB: (en: string, ...val: string[]) => translate(en,
    'Oletko jo Elisan asiakas?',
    ...val),

  ELMO: (en: string, ...val: string[]) => translate(en,
    'Elisa Mobiilivarmenne',
    ...val),

  ELQI: (en: string, ...val: string[]) => translate(en,
    'Valitse tiedosto',
    ...val),

  EM2Q: (en: string, ...val: string[]) => translate(en,
    'Maksuaika',
    ...val),

  EMCQ: (en: string, ...val: string[]) => translate(en,
    'Anna salasana',
    ...val),

  EMSP: (en: string, ...val: string[]) => translate(en,
    'Toimeksiantosi Elisa Kuka Soittaa -palvelun tilauksesta on otettu käsittelyyn.',
    ...val),

  EMYQ: (en: string, ...val: string[]) => translate(en,
    'Lisää tuotteelle käyttäjä tai käyttötarkoitus',
    ...val),

  EMZV: (en: string, ...val: string[]) => translate(en,
    'Kopioi laitelistan tuotevalikoima',
    ...val),

  EN2Q: (en: string, ...val: string[]) => translate(en,
    'Ei datapakettia',
    ...val),

  ENOC: (en: string, ...val: string[]) => translate(en,
    'Ei tiedossa',
    ...val),

  ENVW: (en: string, ...val: string[]) => translate(en,
    'Olemme vastaanottaneet tukipyynnön ja aloitamme sen käsittelyn mahdollisimman pian.',
    ...val),

  EO6B: (en: string, ...val: string[]) => translate(en,
    'Elisan tietosuojaperiaatteet',
    ...val),

  EO7W: (en: string, ...val: string[]) => translate(en,
    'Muilla kuin puhelimilla toimi laiteohjeiden mukaisesti eSIM käyttöönotossa.',
    ...val),

  EPDD: (en: string, ...val: string[]) => translate(en,
    'Tarjouksen päivitys epäonnistui',
    ...val),

  EPHQ: (en: string, ...val: string[]) => translate(en,
    'Tarkista ja korjaa seuraava kohta:',
    ...val),

  EPSL: (en: string, ...val: string[]) => translate(en,
    'Entistä tasalaatuisemmat yhteydet.',
    ...val),

  EPUZ: (en: string, ...val: string[]) => translate(en,
    'Ring-liittymän poistaminen',
    ...val),

  EQ10: (en: string, ...val: string[]) => translate(en,
    'Asennuspäivä on vahvistettu',
    ...val),

  EQI1: (en: string, ...val: string[]) => translate(en,
    'Viallisen laitteen kuntoluokka',
    ...val),

  EQID: (en: string, ...val: string[]) => translate(en,
    'Mikäli yksi tai useampi lasku on ulkoisessa perinnässä, maksusopimusta ei voi tehdä itsepalvelussa.',
    ...val),

  EQK0: (en: string, ...val: string[]) => translate(en,
    'Osa yhteyshenkilön tiedoista puuttuu',
    ...val),

  EQKJ: (en: string, ...val: string[]) => translate(en,
    'Mobiililaajakaista',
    ...val),

  ER2E: (en: string, ...val: string[]) => translate(en,
    'Käyttäjätiedot lisätty tuotteelle.',
    ...val),

  ERA0: (en: string, ...val: string[]) => translate(en,
    'https://support.apple.com/fi-fi/guide/icloud/mmfc0eeddd/icloud',
    ...val),

  ERCX: (en: string, ...val: string[]) => translate(en,
    'Postita laite meille saamiesi ohjeiden mukaisesti.',
    ...val),

  ERXV: (en: string, ...val: string[]) => translate(en,
    'Siirry hallintaportaaliin',
    ...val),

  ES15: (en: string, ...val: string[]) => translate(en,
    'Luotettava yhteys sujuvaan työskentelyyn ja korkealaatuisiin livelähetyksiin',
    ...val),

  ES5D: (en: string, ...val: string[]) => translate(en,
    'Verkkotunnus',
    ...val),

  ES7M: (en: string, ...val: string[]) => translate(en,
    'Lomakkeen käyttämässä tuotedatassa on virhe tai tuotedata puuttuu. Ota yhteyttä Salesforcen tukipyynnöllä backofficeen asian korjaamiseksi.',
    ...val),

  ESF8: (en: string, ...val: string[]) => translate(en,
    'Sinut kirjataan ulos automaattisesti käyttäjätunnuksen valinnan jälkeen.',
    ...val),

  ESQW: (en: string, ...val: string[]) => translate(en,
    'Voimmeko yhdistää selailutietoja asiakastietoihisi?',
    ...val),

  ESVA: (en: string, ...val: string[]) => translate(en,
    'Alanumerosarja',
    ...val),

  ETR5: (en: string, ...val: string[]) => translate(en,
    'Elisa Kuka Soittaa nyt tarjoushintaan 2,99 €/kk alv. 0 %',
    ...val),

  ETV2: (en: string, ...val: string[]) => translate(en,
    'Vaihda vastaanottaja',
    ...val),

  EUOO: (en: string, ...val: string[]) => translate(en,
    'Laitelistalla määrität työntekijöiden tilauksissa saatavilla olevan laitevalikoiman.',
    ...val),

  EV5V: (en: string, ...val: string[]) => translate(en,
    'Lisätarvikeet',
    ...val),

  EW6G: (en: string, ...val: string[]) => translate(en,
    'Uusien yritysten tiedot päivittyvät rekisteriimme automaattisesti parin päivän kuluessa. Jos sinun pitää päästä hoitamaan asiasi heti, ota yhteyttä ',
    ...val),

  EWI0: (en: string, ...val: string[]) => translate(en,
    'Yritykselläsi ei ole aktiivista Ring-ratkaisua.',
    ...val),

  EX8C: (en: string, ...val: string[]) => translate(en,
    'Aktiiviseen surffailuun, videopalavereihin ja sarjojen katseluun.',
    ...val),

  EXDT: (en: string, ...val: string[]) => translate(en,
    'Vanha laitteesi kierrätetään aina luotettavasti ja tietoturvallisesti',
    ...val),

  EXXX: (en: string, ...val: string[]) => translate(en,
    'Suomi',
    ...val),

  EY5B: (en: string, ...val: string[]) => translate(en,
    'Toimitamme postitse osoitteeseen sopivan langattoman laajakaistareitittimen.',
    ...val),

  EY5Q: (en: string, ...val: string[]) => translate(en,
    'Laskutuksen yhteyshenkilö',
    ...val),

  EY68: (en: string, ...val: string[]) => translate(en,
    ' -osion painikkeilla. Jokainen liittymä pitää lisätä erikseen. Jos liittymän lisääminen ei onnistu, tarkista ',
    ...val),

  EY6A: (en: string, ...val: string[]) => translate(en,
    'Kaikki',
    ...val),

  EY7T: (en: string, ...val: string[]) => translate(en,
    'Laskutustiedot ja vahvistaminen',
    ...val),

  EYPA: (en: string, ...val: string[]) => translate(en,
    'Oletuslaskutussopimus',
    ...val),

  EYS6: (en: string, ...val: string[]) => translate(en,
    'Työnantajasi ei kustanna tätä laitetta kokonaan. Voit kuitenkin tilata laitteen osallistumalla itse kustannuksiin.',
    ...val),

  EYZM: (en: string, ...val: string[]) => translate(en,
    'Numerosi ja yhteystietosi voidaan julkaista numeropalveluissa.',
    ...val),

  EZ2Q: (en: string, ...val: string[]) => translate(en,
    'Yhteystietojen päivitys onnistui',
    ...val),

  EZYP: (en: string, ...val: string[]) => translate(en,
    'uudelleen. Tunnuksesi on voinut vanhentua.',
    ...val),

  F09D: (en: string, ...val: string[]) => translate(en,
    'Näytä salasana',
    ...val),

  F0CY: (en: string, ...val: string[]) => translate(en,
    'Muut lisätarvikkeet',
    ...val),

  F0MY: (en: string, ...val: string[]) => translate(en,
    'Seuraava',
    ...val),

  F0OO: (en: string, ...val: string[]) => translate(en,
    'Tilausnumero',
    ...val),

  F12I: (en: string, ...val: string[]) => translate(en,
    'Puhelut ulkomaille',
    ...val),

  F16P: (en: string, ...val: string[]) => translate(en,
    'Vahvistuskoodi',
    ...val),

  F1G3: (en: string, ...val: string[]) => translate(en,
    'Ei laitelistoja joihin kopioida',
    ...val),

  F1JW: (en: string, ...val: string[]) => translate(en,
    'Toistaiseksi voimassa',
    ...val),

  F1NC: (en: string, ...val: string[]) => translate(en,
    'Tilauspäivämäärä',
    ...val),

  F1YQ: (en: string, ...val: string[]) => translate(en,
    'Osaa laitteistasi voit hallita',
    ...val),

  F223: (en: string, ...val: string[]) => translate(en,
    'Istuntosi on vanhentumassa ja sinut kirjataan automaattisesti ulos viiden minuutin kuluttua.',
    ...val),

  F25D: (en: string, ...val: string[]) => translate(en,
    'Käyttäjällä on päättymässä oleva Elisa palvelupäätelaite sopimus',
    ...val),

  F2BF: (en: string, ...val: string[]) => translate(en,
    'Rivit',
    ...val),

  F2S0: (en: string, ...val: string[]) => translate(en,
    'Ota Elisa Tunnus käyttöön',
    ...val),

  F30X: (en: string, ...val: string[]) => translate(en,
    ', numerosi on salainen ja sen tiedot eivät löydy numeropalveluista',
    ...val),

  F3KA: (en: string, ...val: string[]) => translate(en,
    'Kutsujen lähetys onnistui.',
    ...val),

  F3LL: (en: string, ...val: string[]) => translate(en,
    'Laturit',
    ...val),

  F3W3: (en: string, ...val: string[]) => translate(en,
    'Aito 5G on teknologisesti edistynein verkkovaihtoehto. Aito 5G -verkossa liikenne kulkee pelkästään 5G:n kautta ilman 4G-riippuvuutta. Tämä tekee yhteydestä vakaamman ja tasaisemman, koska laite ei vaihda jatkuvasti verkkojen välillä.',
    ...val),

  F3ZQ: (en: string, ...val: string[]) => translate(en,
    'Hups… sinulla ei ole oikeuksia tähän toimintoon',
    ...val),

  F43F: (en: string, ...val: string[]) => translate(en,
    'ja',
    ...val),

  F514: (en: string, ...val: string[]) => translate(en,
    'Ladataan laskutustietoja',
    ...val),

  F54R: (en: string, ...val: string[]) => translate(en,
    'Otamme Yritysten OmaElisassa käyttöön uuden henkilökohtaisen Elisa Tunnuksen.',
    ...val),

  F56Z: (en: string, ...val: string[]) => translate(en,
    'Jotta saat Aito 5G -liittymästäsi parhaan hyödyn irti, tarvitset ',
    ...val),

  F5BJ: (en: string, ...val: string[]) => translate(en,
    'Tekniikka',
    ...val),

  F5M7: (en: string, ...val: string[]) => translate(en,
    'Yhteydenotto myyntiin',
    ...val),

  F5YW: (en: string, ...val: string[]) => translate(en,
    'Muutosten julkaiseminen:',
    ...val),

  F64J: (en: string, ...val: string[]) => translate(en,
    'Rekisteröidy yrityksesi nimellä tai Y-tunnuksella.',
    ...val),

  F6BI: (en: string, ...val: string[]) => translate(en,
    'Jos vaihdat päätelaitetta, sinun tulee tilata uusi eSIM SIM-kortinvaihdon avulla ja asentaa se uuteen laitteeseen. Vanha QR-koodi ei toimi uudessa laitteessa.',
    ...val),

  F6H1: (en: string, ...val: string[]) => translate(en,
    'Lähetä tukipyyntö',
    ...val),

  F6OD: (en: string, ...val: string[]) => translate(en,
    'Aktiivinen versio',
    ...val),

  F7YS: (en: string, ...val: string[]) => translate(en,
    'Valitse yritys, johon haluat kutsua työntekijöitä',
    ...val),

  F8DF: (en: string, ...val: string[]) => translate(en,
    'Estopalveluiden muuttamisessa tapahtui odottamaton virhe.',
    ...val),

  F8VB: (en: string, ...val: string[]) => translate(en,
    'Elisan kuluttajaliittymien yritysasiakas',
    ...val),

  F8Y3: (en: string, ...val: string[]) => translate(en,
    'Tarkista kuuluvuus alueellasi',
    ...val),

  F97B: (en: string, ...val: string[]) => translate(en,
    'Haluatko varmasti poistaa viimeisen tuotteen ostoskorista?',
    ...val),

  F9G1: (en: string, ...val: string[]) => translate(en,
    'Tyyppi',
    ...val),

  F9HL: (en: string, ...val: string[]) => translate(en,
    'Yrityksen vaihtaminen päivittää ostoskorin',
    ...val),

  FA5L: (en: string, ...val: string[]) => translate(en,
    'Laitelistat ja tuotevalikoima',
    ...val),

  FAKM: (en: string, ...val: string[]) => translate(en,
    'Elisa Kuka soittaa -palvelu puhelimessa',
    ...val),

  FAOI: (en: string, ...val: string[]) => translate(en,
    'Valitse, mitä laitteita ja lisävarusteita työntekijät voivat tilata laitelistoilta, jotka käyttävät tätä laitevalikoimaa.',
    ...val),

  FBDO: (en: string, ...val: string[]) => translate(en,
    'Käyttäjällä on pääkäyttäjäoikeudet',
    ...val),

  FBMB: (en: string, ...val: string[]) => translate(en,
    'Ei laiterekisteröintiohjelmaa',
    ...val),

  FBQT: (en: string, ...val: string[]) => translate(en,
    'Käyttäjät-sivulla',
    ...val),

  FCH5: (en: string, ...val: string[]) => translate(en,
    'Hyvityslasku',
    ...val),

  FD6H: (en: string, ...val: string[]) => translate(en,
    'Lisää pääkäyttäjäoikeuksia muihin yrityksiin',
    ...val),

  FD7W: (en: string, ...val: string[]) => translate(en,
    'Käyttäjällä ei ole palveluita',
    ...val),

  FDE2: (en: string, ...val: string[]) => translate(en,
    'Maksajan nimi ja Y-tunnus',
    ...val),

  FDK6: (en: string, ...val: string[]) => translate(en,
    'Lue lisää tietosuojastamme',
    ...val),

  FDQN: (en: string, ...val: string[]) => translate(en,
    'IMEI-koodi tai sarjanumero',
    ...val),

  FDSO: (en: string, ...val: string[]) => translate(en,
    'Tilauksesi on siirretty käsittelyyn',
    ...val),

  FDUX: (en: string, ...val: string[]) => translate(en,
    'Elisa DNS -hallinta vaatii kaksivaiheisen tunnistautumisen. Saat aktivoitua kaksivaiheisen tunnistautumisen käyttöön Yrityksen tiedot ja asetukset sivulla.',
    ...val),

  FEPO: (en: string, ...val: string[]) => translate(en,
    'Jos asiakkaalla on olemassa oleva liittymä, se on irtisanottava ennen toimituspäivää.',
    ...val),

  FF2X: (en: string, ...val: string[]) => translate(en,
    'Säännölliseen työntekoon ja vapaa-aikaan',
    ...val),

  FF9Q: (en: string, ...val: string[]) => translate(en,
    'Liittymän tilapäinen sulku',
    ...val),

  FFJ2: (en: string, ...val: string[]) => translate(en,
    'Muutokset tallennettiin onnistuneesti',
    ...val),

  FFQZ: (en: string, ...val: string[]) => translate(en,
    'Näytä PopUp -viesti työntekijälle.',
    ...val),

  FG7T: (en: string, ...val: string[]) => translate(en,
    'Toimitus toiseen yrityksen toimipisteeseen ',
    ...val),

  FGE3: (en: string, ...val: string[]) => translate(en,
    'Sinun maksettava osuus kuukausimaksusta',
    ...val),

  FGVX: (en: string, ...val: string[]) => translate(en,
    'Laitelistan tuotevalikoiman kopiointi onnistui',
    ...val),

  FHAL: (en: string, ...val: string[]) => translate(en,
    'Voit valita, maksaako palvelun työntekijä itse, tarjoaako yritys palvelun työntekijälle tai estää palvelun käytön työntekijöiltä kokonaan. Työntekijä ottaa KelloSIM-palvelun käyttöön Työntekijän OmaElisassa Apple Watchin Watch-sovelluksen kautta. [Lisätietoja käyttöönotosta.]',
    ...val),

  FHD7: (en: string, ...val: string[]) => translate(en,
    'Saat työntekijän laitesopimuksesta vahvistuksen, joka sinun tulee tarkastaa ja hyväksyä.',
    ...val),

  FHGI: (en: string, ...val: string[]) => translate(en,
    'Yrityksellä voi olla useita laitelistoja eri asetuksilla ja laitevalikoimilla. Huomioi, että eri laitelistojen tuotteita ei voi tilata samassa tilauksessa. Tästä syystä esimerkiksi puhelinten laitevalikoimaan kannattaa lisätä myös puhelimiin liittyvät lisävarusteet, jotta ne voidaan tilata samassa tilauksessa.',
    ...val),

  FHIZ: (en: string, ...val: string[]) => translate(en,
    'Maksulliset viestit',
    ...val),

  FHKH: (en: string, ...val: string[]) => translate(en,
    'Lataa tilausvahvistus',
    ...val),

  FHL4: (en: string, ...val: string[]) => translate(en,
    ' kautta.',
    ...val),

  FI1N: (en: string, ...val: string[]) => translate(en,
    'Tarkista antamasi vahvistuskoodi',
    ...val),

  FI29: (en: string, ...val: string[]) => translate(en,
    'Huomioithan, että laskutussopimus on voimassa 21 päivää. Jos laskutussopimukselle ei tilata tuotteita tai palveluita tämän ajanjakson aikana, poistuu se automaattisesti käytöstä.',
    ...val),

  FIAV: (en: string, ...val: string[]) => translate(en,
    'Lisää puhelinliittymä',
    ...val),

  FINQ: (en: string, ...val: string[]) => translate(en,
    'Laite on tuhoutunut',
    ...val),

  FIRO: (en: string, ...val: string[]) => translate(en,
    'Hyväksyn sopimusehdot',
    ...val),

  FIS5: (en: string, ...val: string[]) => translate(en,
    'Valitut alanumeroavaruudet',
    ...val),

  FJ23: (en: string, ...val: string[]) => translate(en,
    'Et voi poistaa laitevalikoimaa {0}, koska se on käytössä laitelistoilla. Vaihda {0} toiseen laitevalikoimaan ennen poistamista.',
    ...val),

  FJLH: (en: string, ...val: string[]) => translate(en,
    'Viesti',
    ...val),

  FJOL: (en: string, ...val: string[]) => translate(en,
    'OmaLasku -palvelut',
    ...val),

  FJW1: (en: string, ...val: string[]) => translate(en,
    'Tarkista tilauksen tiedot',
    ...val),

  FK2F: (en: string, ...val: string[]) => translate(en,
    'Tilauksen lisäpalvelut',
    ...val),

  FK90: (en: string, ...val: string[]) => translate(en,
    'Voit käyttää nettiä Euroopassa kotimaan hinnoin liittymäsi kohtuukäytön rajaan asti.',
    ...val),

  FKAE: (en: string, ...val: string[]) => translate(en,
    'Kertaluonteiset maksut',
    ...val),

  FKO8: (en: string, ...val: string[]) => translate(en,
    '(esim. henkilönumero)',
    ...val),

  FKUE: (en: string, ...val: string[]) => translate(en,
    'Ajastus on mahdollista tehdä enintään yhden kuukauden päähän.',
    ...val),

  FKVB: (en: string, ...val: string[]) => translate(en,
    '6,37 €/kk (alv. 0%)',
    ...val),

  FL34: (en: string, ...val: string[]) => translate(en,
    'Näytettävä numero',
    ...val),

  FLKQ: (en: string, ...val: string[]) => translate(en,
    'Haetaan sisältöä...',
    ...val),

  FLLT: (en: string, ...val: string[]) => translate(en,
    'Vahinkopalvelu korjaa omavastuumaksua vastaan Käyttäjän itse aiheuttamat, takuun ulkopuoliset viat. Vahinkopalvelu ei kata laitteen varkaus- tai katoamistapauksia. Omavastuut ovat kategoriassa Business Pro 30 € / vahinko ja kategoriassa Business Premium 50 € / vahinko. Vaurioituneen laitteen Käyttäjälle toimitetaan kuntoluokitusta vastaava laite.',
    ...val),

  FM7B: (en: string, ...val: string[]) => translate(en,
    'Elisa Oyj',
    ...val),

  FMUV: (en: string, ...val: string[]) => translate(en,
    'Elisa KelloSIM-palvelu',
    ...val),

  FNBG: (en: string, ...val: string[]) => translate(en,
    'Puhe kuulostaa luonnolliselta ja sisältää vähemmän taustan häiritsevää kohinaa',
    ...val),

  FO3J: (en: string, ...val: string[]) => translate(en,
    'Kyllä voit. Tee kuitenkin jokaisesta laitteesta oma hinta-arviolomake, jolloin jokaiselle laitteelle muodostuu oma Vaihtoetutilaus ja lähetyspaketti.\nMe laskemme lopuksi hyvitykset yhteen ja siirrämme koko summan yrityksesi laskutussopimukselle.',
    ...val),

  FO5U: (en: string, ...val: string[]) => translate(en,
    'Käytössä olevat tuotteet ja palvelut',
    ...val),

  FOKG: (en: string, ...val: string[]) => translate(en,
    'avoimia',
    ...val),

  FPAP: (en: string, ...val: string[]) => translate(en,
    'Tilauksesi sisältää tuotteita, jotka eivät tarvitse toimitusta.',
    ...val),

  FPE7: (en: string, ...val: string[]) => translate(en,
    'Emme löytäneet tiedoistasi uusia lisättäviä yrityksiä. Elisa Tunnukseesi liitetyt yritykset löytyvät Yritysten OmaElisasta.',
    ...val),

  FPH3: (en: string, ...val: string[]) => translate(en,
    'Voit tarkastella liittymien lisäpalveluita yksittäisen liittymän sivulta. Löydät kaikki liittymäsi Tuotteet ja palvelut sivulta.',
    ...val),

  FPYG: (en: string, ...val: string[]) => translate(en,
    'Lisäpalveluita koskeva muutos',
    ...val),

  FR97: (en: string, ...val: string[]) => translate(en,
    'Jotta liittymän tiedot näkyvät työntekijän OmaElisassa tarkista, että liittymän käyttäjänä on henkilö ja että käyttäjätiedoissa on työntekijän sähköpostiosoite ja puhelinnumero.',
    ...val),

  FRYN: (en: string, ...val: string[]) => translate(en,
    'Matkapuhelinnumero',
    ...val),

  FSWU: (en: string, ...val: string[]) => translate(en,
    'Lähetä',
    ...val),

  FT2S: (en: string, ...val: string[]) => translate(en,
    'Supernopea netti päivittäiseen työntekoon ja pienelle toimistolle',
    ...val),

  FT2U: (en: string, ...val: string[]) => translate(en,
    'Tai tunnistaudu',
    ...val),

  FT4V: (en: string, ...val: string[]) => translate(en,
    'Valittu kieli',
    ...val),

  FTAF: (en: string, ...val: string[]) => translate(en,
    'Kutsua ei voida lähettää',
    ...val),

  FTM8: (en: string, ...val: string[]) => translate(en,
    'Alla näet nykyisen version. Ajastettu muutos julkaistaan {}.',
    ...val),

  FTZT: (en: string, ...val: string[]) => translate(en,
    'Siirry avoimiin laskuihin',
    ...val),

  FUAJ: (en: string, ...val: string[]) => translate(en,
    'Lataa tästä csv-pohja sähköpostiosoitteille.',
    ...val),

  FUDM: (en: string, ...val: string[]) => translate(en,
    'Nykyisen salasanan ja uuden salasanan ei pitäisi olla samat',
    ...val),

  FUTC: (en: string, ...val: string[]) => translate(en,
    'Liittymän avaus onnistui.',
    ...val),

  FV4B: (en: string, ...val: string[]) => translate(en,
    'Nettiliittymä',
    ...val),

  FV55: (en: string, ...val: string[]) => translate(en,
    'Yhteystietosi',
    ...val),

  FV8F: (en: string, ...val: string[]) => translate(en,
    'Poista ja palaa kauppaan',
    ...val),

  FVC8: (en: string, ...val: string[]) => translate(en,
    'Vanha käyttäjä',
    ...val),

  FVI5: (en: string, ...val: string[]) => translate(en,
    'Kallein ensin',
    ...val),

  FVJ4: (en: string, ...val: string[]) => translate(en,
    'Sisältää vähintään kaksi numeroa tai erikoismerkkiä',
    ...val),

  FVU9: (en: string, ...val: string[]) => translate(en,
    'Katso estetyt numerot',
    ...val),

  FW1W: (en: string, ...val: string[]) => translate(en,
    'Tilattavien lisenssien (käyttäjien) määrä',
    ...val),

  FWV1: (en: string, ...val: string[]) => translate(en,
    'Laajakaistan tekniikka',
    ...val),

  FX59: (en: string, ...val: string[]) => translate(en,
    'Tuotteiden toimitus yhdessä ei ole mahdollista, koska tilaus sisältää tuotteita jotka toimitetaan suoraan toimittajan varastolta.',
    ...val),

  FXBN: (en: string, ...val: string[]) => translate(en,
    'Palvelusopimuksen muutos',
    ...val),

  FXG6: (en: string, ...val: string[]) => translate(en,
    'Elisa-tunnuksen',
    ...val),

  FXJQ: (en: string, ...val: string[]) => translate(en,
    'Elisa on ollut yrittäjän kotimainen kumppani yli 25 vuotta – katso rahanarvoiset edut Suomen Yrittäjien jäsenille!',
    ...val),

  FXKU: (en: string, ...val: string[]) => translate(en,
    'löytyi',
    ...val),

  FXKW: (en: string, ...val: string[]) => translate(en,
    ' ei löytynyt yhtään hakutulosta.',
    ...val),

  FY9Z: (en: string, ...val: string[]) => translate(en,
    'Tilinumero',
    ...val),

  FYJ7: (en: string, ...val: string[]) => translate(en,
    'KelloSIM mahdollistaa Apple Watch -älykellon käytön puheluihin, viesteihin, mobiilidataan ja ilmoituksiin myös silloin, kun iPhone ei ole mukana.',
    ...val),

  FYWX: (en: string, ...val: string[]) => translate(en,
    'Tilaa puhelimet ja muut laitteet helposti netistä!',
    ...val),

  FZ4O: (en: string, ...val: string[]) => translate(en,
    'Oletko jo asiakkaamme? Kirjaudu ',
    ...val),

  FZAU: (en: string, ...val: string[]) => translate(en,
    'Saat F-Securelta sähköpostitse uudet kirjautumistunnukset, joilla voit kirjautua takaisin sisään.',
    ...val),

  FZNW: (en: string, ...val: string[]) => translate(en,
    'Palvelun asennus ei ole mahdollista',
    ...val),

  FZU3: (en: string, ...val: string[]) => translate(en,
    'Etkö näe tilaustasi täällä?',
    ...val),

  G013: (en: string, ...val: string[]) => translate(en,
    'Käyttääksesi lisenssien hallintaportaalia, täydennä seuraavat tiedot',
    ...val),

  G07Y: (en: string, ...val: string[]) => translate(en,
    'ADSL',
    ...val),

  G089: (en: string, ...val: string[]) => translate(en,
    'Katso kaikki tukipyynnöt',
    ...val),

  G090: (en: string, ...val: string[]) => translate(en,
    'Katso kaikki',
    ...val),

  G09Z: (en: string, ...val: string[]) => translate(en,
    'Laitteen lunastaminen',
    ...val),

  G0EZ: (en: string, ...val: string[]) => translate(en,
    'Mobiililaajakaistat',
    ...val),

  G0NE: (en: string, ...val: string[]) => translate(en,
    'Tunniste',
    ...val),

  G0QN: (en: string, ...val: string[]) => translate(en,
    'Toimitustapa',
    ...val),

  G0UE: (en: string, ...val: string[]) => translate(en,
    'Alennuskoodi ei voimassa sopimushinnoittelun vuoksi',
    ...val),

  G0XR: (en: string, ...val: string[]) => translate(en,
    'Elisa Palvelupäätelaitteiden vuokravastuut',
    ...val),

  G16D: (en: string, ...val: string[]) => translate(en,
    'Mikä on Työntekijän OmaElisa?',
    ...val),

  G188: (en: string, ...val: string[]) => translate(en,
    'Lisää rajaus',
    ...val),

  G18X: (en: string, ...val: string[]) => translate(en,
    'Lisää laskutussopimus',
    ...val),

  G24H: (en: string, ...val: string[]) => translate(en,
    'Etusivulle',
    ...val),

  G2SA: (en: string, ...val: string[]) => translate(en,
    '{0} = Erittäin tyytymätön',
    ...val),

  G2WE: (en: string, ...val: string[]) => translate(en,
    'Valikoimasta poistuneita tuotteita',
    ...val),

  G304: (en: string, ...val: string[]) => translate(en,
    'Salasanan on oltava vähintään 8 merkkiä pitkä ja siinä on oltava vähintään yksi pieni kirjain, yksi iso kirjain sekä vähintään kaksi numeroa tai erikoismerkkiä.',
    ...val),

  G39I: (en: string, ...val: string[]) => translate(en,
    'Sähköpostiosoite tarvitaan',
    ...val),

  G3YU: (en: string, ...val: string[]) => translate(en,
    'Avausmaksut yhteensä',
    ...val),

  G42E: (en: string, ...val: string[]) => translate(en,
    'Haluan irroittaa Ring- ja matkapuhelinliittymät toisistaan.',
    ...val),

  G4ZD: (en: string, ...val: string[]) => translate(en,
    'Lopetuspyyntösi lähetettiin onnistuneesti',
    ...val),

  G5EQ: (en: string, ...val: string[]) => translate(en,
    'Näytä kuukausikohtainen erittely',
    ...val),

  G5HB: (en: string, ...val: string[]) => translate(en,
    'Mobiilivarmenne -palvelu ei ole yhteensopiva eSIM:in kanssa.',
    ...val),

  G5NF: (en: string, ...val: string[]) => translate(en,
    'Voit kirjautua samoilla tunnuksilla Oma Elisaan.',
    ...val),

  G664: (en: string, ...val: string[]) => translate(en,
    'Yrityksen osuus',
    ...val),

  G6IO: (en: string, ...val: string[]) => translate(en,
    'Elisan yleiset sopimusehdot',
    ...val),

  G7RQ: (en: string, ...val: string[]) => translate(en,
    'valinnainen',
    ...val),

  G83G: (en: string, ...val: string[]) => translate(en,
    'Siirry rekisteröintisivulle',
    ...val),

  G85J: (en: string, ...val: string[]) => translate(en,
    'Apua laskutuskysymyksiin',
    ...val),

  G87R: (en: string, ...val: string[]) => translate(en,
    'Käytetty',
    ...val),

  G8FE: (en: string, ...val: string[]) => translate(en,
    'Yhteistoiminne',
    ...val),

  G91V: (en: string, ...val: string[]) => translate(en,
    'Sopimuksesta on jo tehty irtisanomispyyntö',
    ...val),

  G9H2: (en: string, ...val: string[]) => translate(en,
    'Lomake',
    ...val),

  G9OG: (en: string, ...val: string[]) => translate(en,
    'Windows Autopilot laiterekisteröintiohjelma',
    ...val),

  G9OH: (en: string, ...val: string[]) => translate(en,
    'Tiedonsiirtonopeus vaihtelee päätelaitteen ominaisuuksien, sijainnin ja verkon kuormituksen mukaan.',
    ...val),

  G9QF: (en: string, ...val: string[]) => translate(en,
    'Kirjaudu palveluihin',
    ...val),

  G9UR: (en: string, ...val: string[]) => translate(en,
    'Haluatko poistaa ajastetun muutoksen?',
    ...val),

  G9X4: (en: string, ...val: string[]) => translate(en,
    'Reskontran saldo',
    ...val),

  G9X8: (en: string, ...val: string[]) => translate(en,
    'Jos sinulla ei ole nimenkirjoitusoikeutta voi yrityksesi OmaElisa-pääkäyttäjä palauttaa tunnuksesi OmaElisa-palvelussa.',
    ...val),

  GAGZ: (en: string, ...val: string[]) => translate(en,
    'Kiitos tarjouksen hyväksymisestä {0} ({1}). Sopimus on aktiivinen.',
    ...val),

  GAJ8: (en: string, ...val: string[]) => translate(en,
    'Säännölliseen etätyöhön ja aktiiviseen vapaa-ajan surffailuun',
    ...val),

  GAML: (en: string, ...val: string[]) => translate(en,
    'Tarkista ja korjaa seuraavat {} kohtaa:',
    ...val),

  GAPN: (en: string, ...val: string[]) => translate(en,
    'Toimitus 1-3 arkipäivässä valitsemaasi pakettiautomaattiin tai noutopisteeseen.',
    ...val),

  GBCS: (en: string, ...val: string[]) => translate(en,
    'Ei vielä tilauksia',
    ...val),

  GBFN: (en: string, ...val: string[]) => translate(en,
    '{} asti',
    ...val),

  GCDV: (en: string, ...val: string[]) => translate(en,
    'Valitettavasti tilausta ei voida käsitellä. Otathan yhteyttä yrityksesi yhteyshenkilöön.',
    ...val),

  GCJB: (en: string, ...val: string[]) => translate(en,
    'Etsitkö sittenkin Työntekijän OmaElisaa?',
    ...val),

  GCMD: (en: string, ...val: string[]) => translate(en,
    'Miten voimme auttaa?',
    ...val),

  GCO3: (en: string, ...val: string[]) => translate(en,
    'Tilaushistoria',
    ...val),

  GDBJ: (en: string, ...val: string[]) => translate(en,
    'Koodi on voimassa',
    ...val),

  GDFF: (en: string, ...val: string[]) => translate(en,
    'Ota yhteyttä Elisan asiakaspalveluun.',
    ...val),

  GDH2: (en: string, ...val: string[]) => translate(en,
    ', sopimus on voimassa toistaiseksi.',
    ...val),

  GE17: (en: string, ...val: string[]) => translate(en,
    'Unohtunut salasana',
    ...val),

  GEPH: (en: string, ...val: string[]) => translate(en,
    'Valitettavasti järjestelmässämme tapahtui virhe. Yritä hetken kuluttua uudelleen. Pahoittelemme häiriötä.',
    ...val),

  GF1O: (en: string, ...val: string[]) => translate(en,
    'Hyvä perusliittymä työntekoon ja vapaa-ajan surffailuun',
    ...val),

  GFN5: (en: string, ...val: string[]) => translate(en,
    '+ Luo uusi',
    ...val),

  GFYJ: (en: string, ...val: string[]) => translate(en,
    'Uusia tunnuksia varten tarvitset yrityksesi nimenkirjoitusoikeuden. Rekisteröidy yrityksesi nimellä tai Y-tunnuksella. Voit tunnistautua pankkitunnuksilla tai mobiilivarmenteella.',
    ...val),

  GGLB: (en: string, ...val: string[]) => translate(en,
    'Etsi...',
    ...val),

  GGVK: (en: string, ...val: string[]) => translate(en,
    'Käytössä laitelistoilla',
    ...val),

  GHDJ: (en: string, ...val: string[]) => translate(en,
    'Yritysliittymä',
    ...val),

  GHE2: (en: string, ...val: string[]) => translate(en,
    'sopimushinta',
    ...val),

  GIRL: (en: string, ...val: string[]) => translate(en,
    'Sis. 0,5 Gt datan käyttöä kotimaassa. Paketin ylimenevä datankäyttö 1,50 € / alkava 0,5 Gt.',
    ...val),

  GIWH: (en: string, ...val: string[]) => translate(en,
    'Hallinnoi käyttäjiä',
    ...val),

  GJ02: (en: string, ...val: string[]) => translate(en,
    'Valitse yksi liittymään sisältyvä lisäominaisuus',
    ...val),

  GJ0P: (en: string, ...val: string[]) => translate(en,
    'Laitteen lunastaminen työntekijän puolesta ei ole mahdollista. Tämä voi johtua siitä, että yrityksellä ei ole käytössä Työntekijän OmaElisaa tai työntekijä ei ole ottanut käyttöönsä. Elisa Oma Laskua. Työntekijä voi tehdä laitteen lunastamisen myös itse Työntekijän OmaElisasta.',
    ...val),

  GJJF: (en: string, ...val: string[]) => translate(en,
    'Lue lisää',
    ...val),

  GJLT: (en: string, ...val: string[]) => translate(en,
    'Estää puhelut aikuisviihdepalveluihin.',
    ...val),

  GJS9: (en: string, ...val: string[]) => translate(en,
    'Yhteystiedot',
    ...val),

  GK6I: (en: string, ...val: string[]) => translate(en,
    'Sisltyvt palvelut',
    ...val),

  GKQW: (en: string, ...val: string[]) => translate(en,
    'Arvioitu toimitusaika',
    ...val),

  GKWF: (en: string, ...val: string[]) => translate(en,
    'Liittymä on jo liitetty Vakio-ratkaisuun.',
    ...val),

  GL4B: (en: string, ...val: string[]) => translate(en,
    'Valikoimasta poistuneet tuotteet',
    ...val),

  GL4R: (en: string, ...val: string[]) => translate(en,
    'Katuosoite, esim. Ritarikatu 42 C 6',
    ...val),

  GL5D: (en: string, ...val: string[]) => translate(en,
    'Varavastaaja',
    ...val),

  GLO4: (en: string, ...val: string[]) => translate(en,
    'Toimitusajankohta',
    ...val),

  GMAP: (en: string, ...val: string[]) => translate(en,
    'Avoimet',
    ...val),

  GMD4: (en: string, ...val: string[]) => translate(en,
    'Laskutussopimus on valittava',
    ...val),

  GMMI: (en: string, ...val: string[]) => translate(en,
    'Muuttuuko maksajan nimi tai postiosoite',
    ...val),

  GMNB: (en: string, ...val: string[]) => translate(en,
    'Vahvista poisto',
    ...val),

  GNFK: (en: string, ...val: string[]) => translate(en,
    'Uutuus',
    ...val),

  GNM7: (en: string, ...val: string[]) => translate(en,
    'Mitä haluat tehdä?',
    ...val),

  GO7L: (en: string, ...val: string[]) => translate(en,
    'Suuret tiedonsiirrot ja 8K-leffat',
    ...val),

  GOBY: (en: string, ...val: string[]) => translate(en,
    'Kertamaksut',
    ...val),

  GOH2: (en: string, ...val: string[]) => translate(en,
    'Alennuskoodi',
    ...val),

  GOK4: (en: string, ...val: string[]) => translate(en,
    'Tilaa Elisa Kuka Soittaa -palvelu Yritysten OmaElisasta tai asiantuntijamme kautta.',
    ...val),

  GOPL: (en: string, ...val: string[]) => translate(en,
    'https://elisa.fi/asiakaspalvelu/aihe/sopimusehdot/ohje/sopimusehdot/',
    ...val),

  GOZ7: (en: string, ...val: string[]) => translate(en,
    'Valittu hyväksyjä',
    ...val),

  GPDS: (en: string, ...val: string[]) => translate(en,
    'Suosituin',
    ...val),

  GPJ3: (en: string, ...val: string[]) => translate(en,
    'Valitse vaihtoehto, joka kuvaa parhaiten laitteesi vikaa.',
    ...val),

  GPPB: (en: string, ...val: string[]) => translate(en,
    'Tietoja toimituksesta',
    ...val),

  GPPO: (en: string, ...val: string[]) => translate(en,
    'Yritysten OmaElisan kirjautuminen uudistuu. Jatkossa sekä OmaElisa Classic että Yritysten OmaElisa käyttävät henkilökohtaista Elisa Tunnusta. Kaikki kirjautuminen tapahtuu samalta sivulta, jonka ulkoasu uudistuu vaiheittain.',
    ...val),

  GQAX: (en: string, ...val: string[]) => translate(en,
    'Estoluokka',
    ...val),

  GQBC: (en: string, ...val: string[]) => translate(en,
    'Vahvistamalla hyväksyt ',
    ...val),

  GQLC: (en: string, ...val: string[]) => translate(en,
    'Voit olla yhteydessä liittymän nopeuden vaihdosta myyntipalveluumme',
    ...val),

  GQLW: (en: string, ...val: string[]) => translate(en,
    'Laskutussopimuksen numero',
    ...val),

  GR5R: (en: string, ...val: string[]) => translate(en,
    'Oletko tarkistanut ja tehnyt ohjeistetut toimet?',
    ...val),

  GR8T: (en: string, ...val: string[]) => translate(en,
    'Lisätietoa laskun poikkeavasta loppusummasta',
    ...val),

  GRAL: (en: string, ...val: string[]) => translate(en,
    'Sähköposti-, verkko- tai paperilasku',
    ...val),

  GRFB: (en: string, ...val: string[]) => translate(en,
    'Uudet palvelut',
    ...val),

  GSAD: (en: string, ...val: string[]) => translate(en,
    'Y-tunnus tai yrityksen nimi',
    ...val),

  GSYE: (en: string, ...val: string[]) => translate(en,
    'Luotu',
    ...val),

  GT6R: (en: string, ...val: string[]) => translate(en,
    'Vaihda asiointiroolia',
    ...val),

  GUAE: (en: string, ...val: string[]) => translate(en,
    '{} kustannuspaikka ja viitenumero',
    ...val),

  GUFJ: (en: string, ...val: string[]) => translate(en,
    'Matkapuhelinnumerolla on käytössä kaksi ketjua (työajalla ja työajan ulkopuolella), joihin voit molempiin lisätä kaksi vastaanottajaa. Puhelin soi aina ensimmäisenä käyttäjän matkapuhelinnumerossa ja vasta sitten siirtyy varavastaajille',
    ...val),

  GUWX: (en: string, ...val: string[]) => translate(en,
    'Käyttäjätiedot kopioitu kaikkiin tuotteisiin',
    ...val),

  GUWY: (en: string, ...val: string[]) => translate(en,
    'Käyttäjätiedot kopioitu tuotteelle',
    ...val),

  GUWZ: (en: string, ...val: string[]) => translate(en,
    'Kopioi käyttäjätiedot kaikkiin tuotteisiin',
    ...val),

  GV78: (en: string, ...val: string[]) => translate(en,
    'Merkki',
    ...val),

  GVGJ: (en: string, ...val: string[]) => translate(en,
    'Haluatko irtisanoa Ring-liittymän vai vain irroittaa Ring- ja matkapuhelinliittymät toisistaan?',
    ...val),

  GVIF: (en: string, ...val: string[]) => translate(en,
    'Mikäli tarvitset oikeudet hallinnoidaksesi yrityksesi Elisa Palvelupäätelaite -asioita, ota yhteyttä',
    ...val),

  GVMV: (en: string, ...val: string[]) => translate(en,
    'Avoinna {0}.',
    ...val),

  GVZV: (en: string, ...val: string[]) => translate(en,
    'Lähetä kutsu työntekijöille',
    ...val),

  GW69: (en: string, ...val: string[]) => translate(en,
    'Onko yrityksesi uusi?',
    ...val),

  GWCA: (en: string, ...val: string[]) => translate(en,
    'Mobiilinumerot',
    ...val),

  GWH6: (en: string, ...val: string[]) => translate(en,
    'Lähetä yhteydenottopyyntö',
    ...val),

  GWJI: (en: string, ...val: string[]) => translate(en,
    'Domain eli verkkotunnus',
    ...val),

  GWZ6: (en: string, ...val: string[]) => translate(en,
    'Osoite',
    ...val),

  GX72: (en: string, ...val: string[]) => translate(en,
    'Netin käyttö',
    ...val),

  GXAQ: (en: string, ...val: string[]) => translate(en,
    'Ei tuotteita',
    ...val),

  GXHR: (en: string, ...val: string[]) => translate(en,
    'Kontaktin luonti epäonnistui',
    ...val),

  GY5T: (en: string, ...val: string[]) => translate(en,
    'asioit',
    ...val),

  GY75: (en: string, ...val: string[]) => translate(en,
    'Estää mobiilidatan ja multimediaviestien käytön EU- ja ETA-maiden ulkopuolella. Estolla varmistat, ettet käytä vahingossa mobiilidataa.',
    ...val),

  GYOL: (en: string, ...val: string[]) => translate(en,
    'Kun vaihdat yritystä, ostoskori päivittyy. Ostoskorissa olevien tuotteiden hinnat voivat muuttua.',
    ...val),

  GZ5O: (en: string, ...val: string[]) => translate(en,
    'Liittymäsi ei ole liitetty tietoihisi Työntekijän OmaElisassa',
    ...val),

  GZ8L: (en: string, ...val: string[]) => translate(en,
    'Muutosten tallentaminen epäonnistui',
    ...val),

  GZUK: (en: string, ...val: string[]) => translate(en,
    'Lisätiedot',
    ...val),

  GZUL: (en: string, ...val: string[]) => translate(en,
    'Annan Elisalle luvan olla minuun yhteydessä sähköpostitse ja puhelimitse sekä yhdistää verkosta saatavia tietoja, kuten päätelaite- ja sijaintitietoa asiakastietojeni kanssa. Elisa voi hyödyntää tietoja viestinnän ja markkinoinnin kohdentamisessa.',
    ...val),

  GZUM: (en: string, ...val: string[]) => translate(en,
    'Lisätietoja viestinnästä ja markkinoinnista saat ',
    ...val),

  GZUN: (en: string, ...val: string[]) => translate(en,
    'Elisan tietosuojaperiaatteesta',
    ...val),

  GZUO: (en: string, ...val: string[]) => translate(en,
    '. Voit muuttaa valintojasi tai kieltää markkinoinnin OmaElisassa tai asiakaspalvelussamme.',
    ...val),

  H041: (en: string, ...val: string[]) => translate(en,
    'Säilytä valittujen listojen tila ennallaan',
    ...val),

  H094: (en: string, ...val: string[]) => translate(en,
    'Yritysnumeroavaruus',
    ...val),

  H0EZ: (en: string, ...val: string[]) => translate(en,
    'Laite ei kuulu Elisan palvelupäätelaite-valikoimaan. Ole hyvä ja valitse toinen laite.',
    ...val),

  H0K6: (en: string, ...val: string[]) => translate(en,
    'Ulkomaan käyttö',
    ...val),

  H0N7: (en: string, ...val: string[]) => translate(en,
    'Huomioithan, että kampanjatilaus "{}" on määräaikainen, eikä sitä voi irtisanoa kesken sopimuskauden.',
    ...val),

  H0UY: (en: string, ...val: string[]) => translate(en,
    'Rooli',
    ...val),

  H0XT: (en: string, ...val: string[]) => translate(en,
    'Muutospyynnön käsittely on kesken',
    ...val),

  H103: (en: string, ...val: string[]) => translate(en,
    'Maksusopimusvahvistus',
    ...val),

  H131: (en: string, ...val: string[]) => translate(en,
    'Kiitos mielenkiinnostasi Elisaa kohtaan',
    ...val),

  H272: (en: string, ...val: string[]) => translate(en,
    'Laskun toimitustapa',
    ...val),

  H2ZI: (en: string, ...val: string[]) => translate(en,
    'Luo kopio laitelistasta',
    ...val),

  H32M: (en: string, ...val: string[]) => translate(en,
    'Annoin väärän puhelinnumeron',
    ...val),

  H37G: (en: string, ...val: string[]) => translate(en,
    '€/kk',
    ...val),

  H3AZ: (en: string, ...val: string[]) => translate(en,
    'Ring-käyttäjätunnus',
    ...val),

  H3IT: (en: string, ...val: string[]) => translate(en,
    'Ota tarvittaessa yhteyttä työnantajasi yhteyshenkilöön ja pyydä lähettämään sinulle kutsu Työntekijän OmaElisaan.',
    ...val),

  H3KG: (en: string, ...val: string[]) => translate(en,
    'siirry tunnistautumaan',
    ...val),

  H3T3: (en: string, ...val: string[]) => translate(en,
    'Et voi tehdä muutoksia liittymälle, jos sen tila on "Muutostilaus kesken" tai "Toimituksessa".',
    ...val),

  H3ZA: (en: string, ...val: string[]) => translate(en,
    'Uusi omistaja',
    ...val),

  H41V: (en: string, ...val: string[]) => translate(en,
    'Laskutussopimuksen vaihtaminen',
    ...val),

  H45W: (en: string, ...val: string[]) => translate(en,
    'Vanha arvo',
    ...val),

  H4F0: (en: string, ...val: string[]) => translate(en,
    'Tukipyynnöt',
    ...val),

  H4JG: (en: string, ...val: string[]) => translate(en,
    'Irtisanomispäivä',
    ...val),

  H4LW: (en: string, ...val: string[]) => translate(en,
    'Luo tukipyyntö laskusta',
    ...val),

  H4WT: (en: string, ...val: string[]) => translate(en,
    'Vanhan järjestelmän tilaukset',
    ...val),

  H4ZY: (en: string, ...val: string[]) => translate(en,
    '4K-videopuhelut ja pilvipalvelut',
    ...val),

  H51P: (en: string, ...val: string[]) => translate(en,
    'Kotiosoite rivi 2',
    ...val),

  H56I: (en: string, ...val: string[]) => translate(en,
    'Vahvista puhelinnumerosi',
    ...val),

  H5I1: (en: string, ...val: string[]) => translate(en,
    'Muutoksen voimaantulopäivän täytyy olla tulevaisuudessa eikä se saa osua viikonlopulle',
    ...val),

  H5KU: (en: string, ...val: string[]) => translate(en,
    'Emme löytäneet yhtään yritystä',
    ...val),

  H61T: (en: string, ...val: string[]) => translate(en,
    'Matkapuhelinnumeron työajan mukaan (ajastettu)',
    ...val),

  H6AD: (en: string, ...val: string[]) => translate(en,
    'Ruuhkankestävämmät yhteydet – Aito 5G-liittymä toimii parhaiten kaikissa tilanteissa, myös esimeriksi massatapahtumissa, kun verkossa on ruuhkaa',
    ...val),

  H6JV: (en: string, ...val: string[]) => translate(en,
    'OmaElisa työntekijälle',
    ...val),

  H6OA: (en: string, ...val: string[]) => translate(en,
    'Näytä lisää',
    ...val),

  H6X9: (en: string, ...val: string[]) => translate(en,
    'Omaelisa tabletilla',
    ...val),

  H7VQ: (en: string, ...val: string[]) => translate(en,
    'Hylkäyksen syy / muutospyyntö',
    ...val),

  H7ZS: (en: string, ...val: string[]) => translate(en,
    'Laitelista on linkitetty laitevalikoimaan.',
    ...val),

  H8Q4: (en: string, ...val: string[]) => translate(en,
    'Yrityksen maksuosuus laitteen kuukausimaksusta',
    ...val),

  H92N: (en: string, ...val: string[]) => translate(en,
    'Liittymäpäivitystilauksesi on käsittelyssä. Pääset seuraamaan päivityksen tilaa ',
    ...val),

  H9EI: (en: string, ...val: string[]) => translate(en,
    'Uuden SIM-kortin numero',
    ...val),

  H9TQ: (en: string, ...val: string[]) => translate(en,
    'Ryhmän',
    ...val),

  HA0A: (en: string, ...val: string[]) => translate(en,
    'Lisätietoa vastaanotettu',
    ...val),

  HA3D: (en: string, ...val: string[]) => translate(en,
    'Lasku maksettu onnistuneesti.',
    ...val),

  HAA2: (en: string, ...val: string[]) => translate(en,
    'Myymälät kartalla',
    ...val),

  HAN0: (en: string, ...val: string[]) => translate(en,
    'Tietojen yhdistämisen perusteella tarjoamme Elisan verkkosivuilla juuri sinulle soveltuvaa sisältöä ja tarjouksia. Voit milloin tahansa muuttaa valintaasi.',
    ...val),

  HAWX: (en: string, ...val: string[]) => translate(en,
    'Estä kaikki käyttö ulkomailla',
    ...val),

  HBBD: (en: string, ...val: string[]) => translate(en,
    'Viite ei päivity automaattisesti käyttäjän palveluille. Tarkastathan viitteen tuotteen tai palvelun tiedoista.',
    ...val),

  HBFB: (en: string, ...val: string[]) => translate(en,
    'Pakettiin kuuluvat puhelut',
    ...val),

  HBS2: (en: string, ...val: string[]) => translate(en,
    'Uusi maksupäivä ei näy Yritysten OmaElisassa, mutta saat vahvistuksen sähköpostiisi käsiteltyämme maksusopimuspyynnön. Mikäli et ole saanut vahvistusviestiä sähköpostiisi 5 arkipäivän jälkeen, olethan yhteydessä Yritysasiakaspalveluumme.',
    ...val),

  HBW3: (en: string, ...val: string[]) => translate(en,
    'Kuvaus',
    ...val),

  HC1K: (en: string, ...val: string[]) => translate(en,
    'Peruskaudella olevat',
    ...val),

  HC61: (en: string, ...val: string[]) => translate(en,
    'Valitettavasti tilausta ei voida käsitellä. Työnantajasi asettama sallittujen puhelimien määrän raja on ylitetty. Otathan tarvittaessa yhteyttä yrityksesi yhteyshenkilöön.',
    ...val),

  HCCZ: (en: string, ...val: string[]) => translate(en,
    'Salasana',
    ...val),

  HCIE: (en: string, ...val: string[]) => translate(en,
    'Sopijayritys',
    ...val),

  HCVM: (en: string, ...val: string[]) => translate(en,
    'Yleisin uusissa rakennuksissa. Kytt yht valon aallonpituutta pitkn matkan tiedonsiirtoon.',
    ...val),

  HD01: (en: string, ...val: string[]) => translate(en,
    'Antamasi koodi on virheellinen tai se ei ole enää voimassa. Tarkista sähköpostisi tai tilaa uusi vahvistusviesti.',
    ...val),

  HD6M: (en: string, ...val: string[]) => translate(en,
    'Hakutuloksia on liikaa.',
    ...val),

  HDQI: (en: string, ...val: string[]) => translate(en,
    'DNS-tietueen päivittäminen epäonnistui!',
    ...val),

  HE3T: (en: string, ...val: string[]) => translate(en,
    'Haluatko palauttaa useamman laitteen kerralla?',
    ...val),

  HEGD: (en: string, ...val: string[]) => translate(en,
    'Alla näet ajastetun muutoksen tiedot, jotka julkaistaan {}. Jos haluat muokata tietoja, poista ensin ajastettu muutos.',
    ...val),

  HEKO: (en: string, ...val: string[]) => translate(en,
    'Mobiilivarmenteen rekisteröinti yritysliittymiin on maksuton eikä sisällä kuukausikuluja.',
    ...val),

  HEKT: (en: string, ...val: string[]) => translate(en,
    'Laskumallin nimi, määrittää laskun ulkoasun ja erittelytason.',
    ...val),

  HF21: (en: string, ...val: string[]) => translate(en,
    'Rajaton kotimaassa',
    ...val),

  HFD9: (en: string, ...val: string[]) => translate(en,
    'Kutsut',
    ...val),

  HFUO: (en: string, ...val: string[]) => translate(en,
    'Tämä henkilö löytyy jo yrityksen käyttäjälistalta.',
    ...val),

  HFZQ: (en: string, ...val: string[]) => translate(en,
    'Valitse toivottu asennuspäivä',
    ...val),

  HG0J: (en: string, ...val: string[]) => translate(en,
    'Tarkastele liittymiäsi',
    ...val),

  HGEL: (en: string, ...val: string[]) => translate(en,
    'Tilapäisesti loppu, toimitetaan jälkitoimituksena',
    ...val),

  HGNO: (en: string, ...val: string[]) => translate(en,
    'Valitse matkapuhelinnumeron aktviivinen tila työajalla, työajan ulkopuolella tai ajastettu. Ajastetulla tilalla voit määrittää työajan voimassaoloajan, jolloin käytetään työajan vastaajia. Muina aikoina käytetään työajan ulkopuolisia vastaajia. Jos haluat käyttää työajan ulkopuolisia vastaajia koko viikonlopulle, aseta ajaksi 00:00 - 00:00.',
    ...val),

  HH00: (en: string, ...val: string[]) => translate(en,
    'Tyhjennä',
    ...val),

  HHCQ: (en: string, ...val: string[]) => translate(en,
    'Voit siirtää käyttäjän vain niiden yritysten välillä, joihin sinulla on käyttöoikeus. Myös käyttäjän sopimukset siirtyvät. Pyydä tarvittaessa käyttöoikeus toisen yrityksen pääkäyttäjältä.',
    ...val),

  HHDQ: (en: string, ...val: string[]) => translate(en,
    'Anna saamasi vahvistuskoodi',
    ...val),

  HHOH: (en: string, ...val: string[]) => translate(en,
    'Kerro, mitä muutoksia tarvitset?',
    ...val),

  HHRE: (en: string, ...val: string[]) => translate(en,
    'Määrittelee työaikaketjun voimassaoloajan. Muina aikoina käytössä on poissaoloketju. Jos haluat poissaoloketjun koko viikonlopulle, aseta ajaksi 00.00 - 00.00.',
    ...val),

  HIM5: (en: string, ...val: string[]) => translate(en,
    'tarkastaa liittymäsi PUK-koodin',
    ...val),

  HIOW: (en: string, ...val: string[]) => translate(en,
    'Tilaa tarvittaessa uusi laite tai ohjeista työntekijää tilaamaan se Työntekijän OmaElisasta.',
    ...val),

  HJ9V: (en: string, ...val: string[]) => translate(en,
    'Yritystilin voi luoda vain henkilö, jolla on yrityksen nimenkirjoitusoikeus.',
    ...val),

  HJJ3: (en: string, ...val: string[]) => translate(en,
    'Sopijayrityksen vaihtaminen ei ole mahdollista',
    ...val),

  HKFZ: (en: string, ...val: string[]) => translate(en,
    'Muuta laskutusosoitetta',
    ...val),

  HKO6: (en: string, ...val: string[]) => translate(en,
    'Lue lisää tavoitettavuudesta matkapuhelinnumerolla',
    ...val),

  HM82: (en: string, ...val: string[]) => translate(en,
    'Liittymän käyttäjä',
    ...val),

  HMZZ: (en: string, ...val: string[]) => translate(en,
    'Sopimushinta yritykselle, alv. 0 %',
    ...val),

  HNN2: (en: string, ...val: string[]) => translate(en,
    ' mukaisen maksun.',
    ...val),

  HOPN: (en: string, ...val: string[]) => translate(en,
    'Ylläpitäjän sähköposti',
    ...val),

  HP5L: (en: string, ...val: string[]) => translate(en,
    'Käyttäjällä on oltava nimi, puhelinnumero ja sähköposti, jotta käyttöoikeuksia voidaan lisätä.',
    ...val),

  HP5R: (en: string, ...val: string[]) => translate(en,
    'Valitut tiedostot',
    ...val),

  HPH9: (en: string, ...val: string[]) => translate(en,
    'Koulutukseen ilmoittautumisen yhteydessä, sen järjestämisessä ja toteuttamisessa käsitellään henkilötietoja Elisan tietosuojaperiaatteiden mukaisesti. Elisa on käsiteltävien henkilötietojen osalta tietosuojalainsäädännössä tarkoitettu henkilötietojen rekisterinpitäjä. Elisalla on oikeus käyttää palveluiden tuottamisessa ja henkilötietojen käsittelyssä myös alihankkijoita.',
    ...val),

  HPMO: (en: string, ...val: string[]) => translate(en,
    'Sis. {} Gt datan käyttöä Pohjola & Baltia sekä muun EU:n alueella. Paketin ylimenevä datankäyttö 1,50 € / alkava 0,5 Gt.',
    ...val),

  HPSA: (en: string, ...val: string[]) => translate(en,
    'Kirjaudu Yritysten OmaElisan käyttäjätunnuksella',
    ...val),

  HPSN: (en: string, ...val: string[]) => translate(en,
    'Toimitamme sinulle palautuspussin nykyistä laitetta varten uuden laitteen mukana. Tilauksen yhteydessä voit halutessasi myös lunastaa nykyisen laitteen omaksesi hintaan {}.',
    ...val),

  HPT9: (en: string, ...val: string[]) => translate(en,
    'Muuta hyllyliittymäksi',
    ...val),

  HPTO: (en: string, ...val: string[]) => translate(en,
    'Liian monta tiedostoa ({}/{})',
    ...val),

  HQ3V: (en: string, ...val: string[]) => translate(en,
    'Yritysten OmaElisan käyttö vaatii Elisa Tunnuksen.',
    ...val),

  HQ41: (en: string, ...val: string[]) => translate(en,
    'Avattu',
    ...val),

  HQ5P: (en: string, ...val: string[]) => translate(en,
    'Liittymä kannattaa päivittää hyllyliittymäksi silloin, jos liittymää ei tarvita pidempään aikaan mutta sen numerosta ei haluta luopua.',
    ...val),

  HQ7C: (en: string, ...val: string[]) => translate(en,
    'tietoihin',
    ...val),

  HQC3: (en: string, ...val: string[]) => translate(en,
    'Kuukausimaksu sinulle',
    ...val),

  HQTV: (en: string, ...val: string[]) => translate(en,
    'Max. 1000 merkkiä. Ei html -tageja.',
    ...val),

  HQWU: (en: string, ...val: string[]) => translate(en,
    'Ma-Pe 8:00-16:30',
    ...val),

  HQWV: (en: string, ...val: string[]) => translate(en,
    'arkisin klo 8:00-16:30',
    ...val),

  HQWW: (en: string, ...val: string[]) => translate(en,
    'mpm/pvm',
    ...val),

  HQWX: (en: string, ...val: string[]) => translate(en,
    'Käytä toista sähköpostiosoitetta tunnuksen luomiseen tai ota yhteyttä asiakaspalveluun {0} ({1}). Yritysten OmaElisaan pääset kirjautumaan ',
    ...val),

  HR7X: (en: string, ...val: string[]) => translate(en,
    'Valikoimasta poistuneet tuotteet eivät ole enää myynnissä, eikä niitä näytetä työntekijöiden laitelistoilla. Tuotteet näkyvät sinulle, kunnes poistat ne tältä sivulta tai Lisää tai poista laitteita -sivulta. ',
    ...val),

  HRG7: (en: string, ...val: string[]) => translate(en,
    'Huomioithan,',
    ...val),

  HRWW: (en: string, ...val: string[]) => translate(en,
    'Laskunumero:',
    ...val),

  HS3T: (en: string, ...val: string[]) => translate(en,
    'Tilaajan tiedot',
    ...val),

  HS6F: (en: string, ...val: string[]) => translate(en,
    'Yhdistä numeroon',
    ...val),

  HSBQ: (en: string, ...val: string[]) => translate(en,
    'Odottaa vahvistusta',
    ...val),

  HSC5: (en: string, ...val: string[]) => translate(en,
    'Päivämäärästä alkaen',
    ...val),

  HSJ0: (en: string, ...val: string[]) => translate(en,
    'Skannaa QR-koodi',
    ...val),

  HSJH: (en: string, ...val: string[]) => translate(en,
    'Uusi arvo',
    ...val),

  HSM8: (en: string, ...val: string[]) => translate(en,
    'Tilaa puhelinliittymä',
    ...val),

  HSVK: (en: string, ...val: string[]) => translate(en,
    'Laitekauppaan',
    ...val),

  HT1M: (en: string, ...val: string[]) => translate(en,
    'ja sen, että Elisa tarkistaa luottotietoni laskutustietoja varten',
    ...val),

  HTQL: (en: string, ...val: string[]) => translate(en,
    'Ostoskorissa on nyt yksi tuote',
    ...val),

  HUJX: (en: string, ...val: string[]) => translate(en,
    'Maksupäivän siirto lähetetty käsittelyyn',
    ...val),

  HUN9: (en: string, ...val: string[]) => translate(en,
    'Yhteyspuhelinnumero',
    ...val),

  HUVS: (en: string, ...val: string[]) => translate(en,
    'Vastaavia tuotteita ei löytynyt',
    ...val),

  HV0T: (en: string, ...val: string[]) => translate(en,
    'Yritysten OmaElisa-tunnus on henkilökohtainen.',
    ...val),

  HV3R: (en: string, ...val: string[]) => translate(en,
    'Yritysliittymät',
    ...val),

  HVG8: (en: string, ...val: string[]) => translate(en,
    'Näytössä ja rungossa naarmuja tai kulumaa',
    ...val),

  HVK9: (en: string, ...val: string[]) => translate(en,
    'Lisää jokainen sähköpostiosoite omalle rivilleen',
    ...val),

  HVS2: (en: string, ...val: string[]) => translate(en,
    'Valittu laskutussopimus',
    ...val),

  HVWH: (en: string, ...val: string[]) => translate(en,
    'Lähetä uusi',
    ...val),

  HW60: (en: string, ...val: string[]) => translate(en,
    'Löydät laskutussopimuksen numeron viimeisimmältä laskulta, oikeasta yläkulmasta. Jos laskutussopimusnumeroa ei löydy laskulta, ilmoita laskulla näkyvä asiakasnumero.\n\nLisätäksesi laskutussopimuksia, paina "Ilmoita laskutussopimus" painiketta. Voit lisätä enintään 10 sopimusta.',
    ...val),

  HW70: (en: string, ...val: string[]) => translate(en,
    'täällä',
    ...val),

  HWDL: (en: string, ...val: string[]) => translate(en,
    'Salasana ei täsmää toisen salasanan kanssa.',
    ...val),

  HWDR: (en: string, ...val: string[]) => translate(en,
    'Avausmaksu',
    ...val),

  HWDT: (en: string, ...val: string[]) => translate(en,
    'Säästä',
    ...val),

  HWDU: (en: string, ...val: string[]) => translate(en,
    'Avausmaksu {0}',
    ...val),

  HWDV: (en: string, ...val: string[]) => translate(en,
    'Avausmaksu {0}/kpl',
    ...val),

  HWMI: (en: string, ...val: string[]) => translate(en,
    'Cable modem Netti Lite offers',
    ...val),

  HWV3: (en: string, ...val: string[]) => translate(en,
    'Jatka tallentamatta tietoja',
    ...val),

  HWZF: (en: string, ...val: string[]) => translate(en,
    'Voit antaa pääkäyttäjäoikeuksia myös muihin yrityksiin, joihin sinulla on käyttöoikeus.',
    ...val),

  HXOW: (en: string, ...val: string[]) => translate(en,
    'ollessa varattu',
    ...val),

  HY0C: (en: string, ...val: string[]) => translate(en,
    'Tilaa Yritysten OmaElisasta',
    ...val),

  HYGU: (en: string, ...val: string[]) => translate(en,
    'Kentässä voi olla enintään {} sähköpostiosoitetta.',
    ...val),

  HYV2: (en: string, ...val: string[]) => translate(en,
    'Kirjaudu sisään',
    ...val),

  HYX0: (en: string, ...val: string[]) => translate(en,
    '2,4 tuuman LCD-kosketusnäyttö',
    ...val),

  HZ90: (en: string, ...val: string[]) => translate(en,
    'Vahingon sattuessa, ota yhteyttä SquareTraden asiakaspalveluun. Puh 0800 915 801, ma-pe klo 9-19, la klo 10-16:30. Voit tehdä vahinkoilmoituksen myös internet-sivuilla',
    ...val),

  I00R: (en: string, ...val: string[]) => translate(en,
    'Sisältää mobiilireitittimen',
    ...val),

  I053: (en: string, ...val: string[]) => translate(en,
    'Tarkasta datasaldo',
    ...val),

  I0G5: (en: string, ...val: string[]) => translate(en,
    'Oletko varma, että haluat valita yhteyshenkilön toisesta yrityksestä?',
    ...val),

  I0YR: (en: string, ...val: string[]) => translate(en,
    'Käytä ostolaitteille eri laskutussopimusta',
    ...val),

  I1LH: (en: string, ...val: string[]) => translate(en,
    'Tarjoukset',
    ...val),

  I23L: (en: string, ...val: string[]) => translate(en,
    'Korissa on 1 tuote',
    ...val),

  I281: (en: string, ...val: string[]) => translate(en,
    'Kiitos, vahvistaminen onnistui!',
    ...val),

  I2EO: (en: string, ...val: string[]) => translate(en,
    'Kertamaksullisten tuotteiden tietojen muokkaus ei ole mahdollista.',
    ...val),

  I2OG: (en: string, ...val: string[]) => translate(en,
    'Siirry Tuotteet ja palvelut sivulle',
    ...val),

  I2P0: (en: string, ...val: string[]) => translate(en,
    'Kaapelit',
    ...val),

  I2YS: (en: string, ...val: string[]) => translate(en,
    'Tärkeää tietoa',
    ...val),

  I3A5: (en: string, ...val: string[]) => translate(en,
    'Valitettavasti kirjautumisessa tapahtui virhe. Auttaisiko jokin alla olevista?',
    ...val),

  I3DO: (en: string, ...val: string[]) => translate(en,
    'Vahvista irtisanominen',
    ...val),

  I4F9: (en: string, ...val: string[]) => translate(en,
    'Ohjelmistolisenssi toimitetaan osoitteeseen {}',
    ...val),

  I4ME: (en: string, ...val: string[]) => translate(en,
    'Laskutussopimuksella',
    ...val),

  I4X2: (en: string, ...val: string[]) => translate(en,
    'Sulje ikkuna',
    ...val),

  I62A: (en: string, ...val: string[]) => translate(en,
    'Jatka',
    ...val),

  I6FA: (en: string, ...val: string[]) => translate(en,
    'Huomioithan, että muutosten aktivoinnissa saattaa kestää useita minuutteja.',
    ...val),

  I6X5: (en: string, ...val: string[]) => translate(en,
    'Elisa Kuka Soittaa -palvelulla näet, kuka sinulle soittaa. Palvelu näyttää puhelimessasi automaattisesti soittajan nimitiedon ilman erikseen ladattavia sovelluksia.',
    ...val),

  I86M: (en: string, ...val: string[]) => translate(en,
    'Tilausvahvistukset',
    ...val),

  I8GJ: (en: string, ...val: string[]) => translate(en,
    'Käynnistä laitteesi kortin aktivoinnin jälkeen uudelleen. Uuden SIM-kortin PIN-koodi on aluksi 1234. Vanha korttisi lakkaa toimimasta aktivoinnin jälkeen.',
    ...val),

  I9BN: (en: string, ...val: string[]) => translate(en,
    'Varattu yritysnumeroavaruus',
    ...val),

  I9C0: (en: string, ...val: string[]) => translate(en,
    'Tilaukset',
    ...val),

  I9DB: (en: string, ...val: string[]) => translate(en,
    'Uusia muutoksia on mahdollista tehdä vasta, kun edellinen muutostilaus on käsitelty.',
    ...val),

  I9G8: (en: string, ...val: string[]) => translate(en,
    'Tervetuloa Työntekijän OmaElisaan',
    ...val),

  I9KT: (en: string, ...val: string[]) => translate(en,
    'Muutostilaus kesken',
    ...val),

  I9NH: (en: string, ...val: string[]) => translate(en,
    'Muuta tiedot ja yritä käyttäjän siirtoa uudelleen. Voit myös jättää',
    ...val),

  I9QZ: (en: string, ...val: string[]) => translate(en,
    'Sähköpostiosoiteella löytyi jo tunnus',
    ...val),

  I9RX: (en: string, ...val: string[]) => translate(en,
    'Laitelistat kopioitu. Viimeistele ja julkaise listat yritysten omalla laitelista-sivulla.',
    ...val),

  IAGQ: (en: string, ...val: string[]) => translate(en,
    'Salasanaasi hallinnoidaan erillisellä salasananhallintasivulla.',
    ...val),

  IATD: (en: string, ...val: string[]) => translate(en,
    'Sulje väliaikaisesti',
    ...val),

  IB0X: (en: string, ...val: string[]) => translate(en,
    'Lataa takuukuitti',
    ...val),

  IBNP: (en: string, ...val: string[]) => translate(en,
    'Kevyt perusliittymä työntekoon ja vapaa-ajan surffailuun',
    ...val),

  IBOB: (en: string, ...val: string[]) => translate(en,
    'Ymmärrän ja hyväksyn ehdon,',
    ...val),

  IBVP: (en: string, ...val: string[]) => translate(en,
    'Laiterekisteröinnin alias',
    ...val),

  IBZN: (en: string, ...val: string[]) => translate(en,
    'Mobiililaajakaistan päivitys',
    ...val),

  ICAD: (en: string, ...val: string[]) => translate(en,
    'Sinulla on vain lukuoikeus tietueisiin. Jos oikeuksiasi tulisi laajentaa, ota yhteyttä',
    ...val),

  ICJX: (en: string, ...val: string[]) => translate(en,
    'Yrityksellä ei ole vielä tuotteita ja palveluita',
    ...val),

  IDBW: (en: string, ...val: string[]) => translate(en,
    'SIM-kortti toimitetaan kirjepostina. Voit aktivoida SIM-kortin täällä OmaElisassa heti saatuasi sen. Nykyinen SIM-kortti lakkaa toimimasta, kun aktivoit uuden kortin käyttöön. ',
    ...val),

  IDD3: (en: string, ...val: string[]) => translate(en,
    'Postin kuljetus toimitusosoitteeseen aamuksi',
    ...val),

  IDU1: (en: string, ...val: string[]) => translate(en,
    'Aito 5G toimii täysin omassa, itsenäisessä 5G-verkossaan. Itsenäinen 5G-verkko (5G Standalone) on 5G:n seuraava teknologinen kehitysaskel, jonka avulla nykyisen 5G-verkon potentiaali kasvaa entistä täysimääräisemmin hyötykäyttöön.',
    ...val),

  IEC8: (en: string, ...val: string[]) => translate(en,
    'Valitettavasti seuraava puhelinnumero tai -numerot eivät ole enää vapaana',
    ...val),

  IEFA: (en: string, ...val: string[]) => translate(en,
    'Supernopea netti vaativaan työntekoon ja pilvipalveluihin',
    ...val),

  IFIJ: (en: string, ...val: string[]) => translate(en,
    'Ei kohdetta',
    ...val),

  IFKT: (en: string, ...val: string[]) => translate(en,
    'Laskutussopimuksen yhteystiedot',
    ...val),

  IFQ5: (en: string, ...val: string[]) => translate(en,
    'Usein kysyttyjä kysymyksiä',
    ...val),

  IFT9: (en: string, ...val: string[]) => translate(en,
    'Laskutussopimus',
    ...val),

  IG52: (en: string, ...val: string[]) => translate(en,
    'tai kopioi aktivointikoodi. Nykyinen SIM-korttisi lakkaa toimimasta, kun saat toimitusvahvistuksen uudesta liittymästä.',
    ...val),

  IGKK: (en: string, ...val: string[]) => translate(en,
    'Siirrytään yrityksen',
    ...val),

  IGOI: (en: string, ...val: string[]) => translate(en,
    'Sähköpostit ja kevyt surffaaminen',
    ...val),

  IGS3: (en: string, ...val: string[]) => translate(en,
    'Osoitteeseen sopivat nettiyhteydet',
    ...val),

  IGY8: (en: string, ...val: string[]) => translate(en,
    'Lähetimme sähköpostiosoitteeseen ',
    ...val),

  IH0Z: (en: string, ...val: string[]) => translate(en,
    'Muutos astuu voimaan valitsemanasi päivänä. Saat sähköpostiisi ilmoituksen muutetuista sopimuksista.',
    ...val),

  IH2K: (en: string, ...val: string[]) => translate(en,
    'Estää tekstiviestit ja mobiilimaksut aikuisviihdepalveluihin.',
    ...val),

  IH3X: (en: string, ...val: string[]) => translate(en,
    'Kassa',
    ...val),

  IHET: (en: string, ...val: string[]) => translate(en,
    'Yksityisasiakkaat',
    ...val),

  IHO6: (en: string, ...val: string[]) => translate(en,
    'Toimitusosoite',
    ...val),

  IHRV: (en: string, ...val: string[]) => translate(en,
    'Laskutusyhteyshenkilön tiedot',
    ...val),

  IHS4: (en: string, ...val: string[]) => translate(en,
    'Tietokone',
    ...val),

  IHW3: (en: string, ...val: string[]) => translate(en,
    'Toistaiseksi voimassa oleva',
    ...val),

  IIBS: (en: string, ...val: string[]) => translate(en,
    'kk + 6 kk jatkokausi',
    ...val),

  IJ5P: (en: string, ...val: string[]) => translate(en,
    'EU-data {0} Gt/kk',
    ...val),

  IJNQ: (en: string, ...val: string[]) => translate(en,
    'EU- JA ETA-maat',
    ...val),

  IJNS: (en: string, ...val: string[]) => translate(en,
    '{} Mbit/s',
    ...val),

  IJNT: (en: string, ...val: string[]) => translate(en,
    'maks. {} Mbit/s',
    ...val),

  IK1D: (en: string, ...val: string[]) => translate(en,
    'Verkkolasku',
    ...val),

  IKH4: (en: string, ...val: string[]) => translate(en,
    'Huom. voit hakea osoitteita myös ID:llä',
    ...val),

  IKLM: (en: string, ...val: string[]) => translate(en,
    'Huomioithan, että liittymän kausimaksut veloitetaan normaalisti sinä aikana, kun liittymän käyttö on estettynä.',
    ...val),

  IKPV: (en: string, ...val: string[]) => translate(en,
    'Voit myös jatkaa kirjautumatta',
    ...val),

  IKVP: (en: string, ...val: string[]) => translate(en,
    'Liittymätyypin muutosmaksu {}',
    ...val),

  IL1L: (en: string, ...val: string[]) => translate(en,
    'Asiointikieli',
    ...val),

  IL9T: (en: string, ...val: string[]) => translate(en,
    'Ei puhelinliittymiä',
    ...val),

  ILA7: (en: string, ...val: string[]) => translate(en,
    'Vahvista, että olet tarkastanut tilaus- ja laskutustiedot',
    ...val),

  ILJ6: (en: string, ...val: string[]) => translate(en,
    'Pääkäyttäjän nimi',
    ...val),

  ILLN: (en: string, ...val: string[]) => translate(en,
    ' tilalle.',
    ...val),

  IM77: (en: string, ...val: string[]) => translate(en,
    'Liittymän Vakio-asetukset',
    ...val),

  IMA5: (en: string, ...val: string[]) => translate(en,
    '{} tuotetta lisättiin ostoskoriin',
    ...val),

  IMN8: (en: string, ...val: string[]) => translate(en,
    ' kautta, jotta voit myöntää tilauksen hyväksyjän roolin.',
    ...val),

  IN3U: (en: string, ...val: string[]) => translate(en,
    'Jos syötät tiedot käsin',
    ...val),

  INV3: (en: string, ...val: string[]) => translate(en,
    'Avoimet laskut',
    ...val),

  IP2H: (en: string, ...val: string[]) => translate(en,
    'Verkkotunnuksen tarkistuksessa tapahtui virhe. Yritä myöhemmin uudelleen.',
    ...val),

  IPFH: (en: string, ...val: string[]) => translate(en,
    'Mistä löydän SIM-kortin numeron',
    ...val),

  IQAF: (en: string, ...val: string[]) => translate(en,
    'Alennuskoodia ei löytynyt.',
    ...val),

  IR4H: (en: string, ...val: string[]) => translate(en,
    'Liittymälläsi on Elisa Lankanumero -palvelu, joka estää palvelun käyttöönoton.',
    ...val),

  IRQS: (en: string, ...val: string[]) => translate(en,
    'Yrityksen laskutustiedot',
    ...val),

  IRUO: (en: string, ...val: string[]) => translate(en,
    'Voit olla yhteydessä Netti Liten nopeuden vaihdosta myyntipalveluumme',
    ...val),

  IRZJ: (en: string, ...val: string[]) => translate(en,
    'Lataa',
    ...val),

  ISHZ: (en: string, ...val: string[]) => translate(en,
    'Sinua palveli: {}',
    ...val),

  ISND: (en: string, ...val: string[]) => translate(en,
    'Tietokoneiden lisätarvikkeet',
    ...val),

  ISNF: (en: string, ...val: string[]) => translate(en,
    'Yritys on valittava',
    ...val),

  IT7Q: (en: string, ...val: string[]) => translate(en,
    'Tilaus vahvistettu onnistuneesti. Mikäli yrityksesi on sallinut tilausvahvistusten vastaanottamisen, saat vahvistuksen sähköpostiisi {}, kun tilaus on hyväksytty.',
    ...val),

  ITD0: (en: string, ...val: string[]) => translate(en,
    'Ei raportteja',
    ...val),

  ITOF: (en: string, ...val: string[]) => translate(en,
    'Muutospyynnön lähetys onnistui.',
    ...val),

  ITR5: (en: string, ...val: string[]) => translate(en,
    'Valitse yritys, jonka lisenssejä haluat hallinnoida.',
    ...val),

  IU66: (en: string, ...val: string[]) => translate(en,
    'Elisa Reissunetti 2 Gt aktivoituu automaattisesti kohdemaissa. Reissunetti mahdollistaa nopean tiedonsiirron mobiilipäätelaitteella tai kannettavalla tietokoneella edulliseen hintaan EU/ETA-alueen ulkopuolisissa maissa. Palvelussa ei ole kuukausimaksua, vaan se hinnoitellaan käytön mukaan: 26,90 € / 14 vrk.',
    ...val),

  IU7C: (en: string, ...val: string[]) => translate(en,
    'Kutsut Työntekijän OmaElisaan',
    ...val),

  IUX3: (en: string, ...val: string[]) => translate(en,
    'Poista valinta',
    ...val),

  IVHU: (en: string, ...val: string[]) => translate(en,
    'Palvelunumerot -ominaisuuden poistaminen',
    ...val),

  IVJB: (en: string, ...val: string[]) => translate(en,
    'Laitelistan nimi',
    ...val),

  IVJT: (en: string, ...val: string[]) => translate(en,
    'Näytönsuojat',
    ...val),

  IVJX: (en: string, ...val: string[]) => translate(en,
    'Estää mobiilidatan käytön. Puhelut ja tekstiviestit toimivat normaalisti.',
    ...val),

  IVLR: (en: string, ...val: string[]) => translate(en,
    'Elisa Reissunetti 1-1,5 Gt aktivoituu automaattisesti kohdemaissa. Reissunetti mahdollistaa nopean tiedonsiirron mobiilipäätelaitteella tai kannettavalla tietokoneella edulliseen hintaan EU/ETA-alueen ulkopuolisissa maissa. Palvelussa ei ole kuukausimaksua, vaan se hinnoitellaan käytön mukaan: 21,90 € / 14 vrk.',
    ...val),

  IVYK: (en: string, ...val: string[]) => translate(en,
    'Valittu',
    ...val),

  IVZR: (en: string, ...val: string[]) => translate(en,
    'Sopimus irtisanotaan muutamassa minuutissa päättämisen jälkeen ja liittymä poistuu käytöstä.',
    ...val),

  IW1J: (en: string, ...val: string[]) => translate(en,
    'Oma valinta',
    ...val),

  IW51: (en: string, ...val: string[]) => translate(en,
    'Elisa ID -ristiriita',
    ...val),

  IWD6: (en: string, ...val: string[]) => translate(en,
    'kuuluvuuskartta',
    ...val),

  IWHO: (en: string, ...val: string[]) => translate(en,
    'Liittymä on määräaikainen {} asti, jonka aikana sitä ei voi irtisanoa.',
    ...val),

  IWHR: (en: string, ...val: string[]) => translate(en,
    '{}kk määräaikainen sopimus',
    ...val),

  IWSZ: (en: string, ...val: string[]) => translate(en,
    'Päivitä vastaanottajan tietoja',
    ...val),

  IWVK: (en: string, ...val: string[]) => translate(en,
    'Tyhjennä rajaus',
    ...val),

  IX1T: (en: string, ...val: string[]) => translate(en,
    'Määräaikaista liittymää ei voi irtisanoa.',
    ...val),

  IXED: (en: string, ...val: string[]) => translate(en,
    'Laitelistan laskutustiedot',
    ...val),

  IY1W: (en: string, ...val: string[]) => translate(en,
    '50 € saldoraja datakäytölle ulkomailla',
    ...val),

  IY4Z: (en: string, ...val: string[]) => translate(en,
    'Tuotteet',
    ...val),

  IY5V: (en: string, ...val: string[]) => translate(en,
    'Tilaaja',
    ...val),

  IYBA: (en: string, ...val: string[]) => translate(en,
    'Seuraa tukipyynnön etenemistä',
    ...val),

  IYN3: (en: string, ...val: string[]) => translate(en,
    'Minulle tuli tunne, että Elisa välittää minusta asiakkaana',
    ...val),

  IZD7: (en: string, ...val: string[]) => translate(en,
    'Siirrytään takaisin laskutussopimuksen tietoihin',
    ...val),

  J07S: (en: string, ...val: string[]) => translate(en,
    'Voit tehdä muutoksia, kun liittymä on avattu.',
    ...val),

  J083: (en: string, ...val: string[]) => translate(en,
    'Huom.',
    ...val),

  J0U1: (en: string, ...val: string[]) => translate(en,
    'Automaattiset päivitykset tekevät palvelun käytöstä turvallista ja huoletonta',
    ...val),

  J0YE: (en: string, ...val: string[]) => translate(en,
    'Kaupunki',
    ...val),

  J1EZ: (en: string, ...val: string[]) => translate(en,
    'Lisäpalvelut arkea helpottamaan',
    ...val),

  J1F7: (en: string, ...val: string[]) => translate(en,
    'Mobiililaajakaista yrityksille',
    ...val),

  J1JB: (en: string, ...val: string[]) => translate(en,
    '{}G-liittymät',
    ...val),

  J1SK: (en: string, ...val: string[]) => translate(en,
    'Tuoteseloste',
    ...val),

  J1ZO: (en: string, ...val: string[]) => translate(en,
    'Toimitamme korvaavan laitteen rikkoutuneen tilalle. Valitse toimitusosoite, johon laite toimitetaan. Saat korvaavan laitteen mukana ohjeet vanhan laitteen palauttamista varten.',
    ...val),

  J23G: (en: string, ...val: string[]) => translate(en,
    'Käyttäjätunnus',
    ...val),

  J378: (en: string, ...val: string[]) => translate(en,
    'Ota käyttöön OmaElisa',
    ...val),

  J3XJ: (en: string, ...val: string[]) => translate(en,
    'Tulet saamaan loppulaskun irtisanotusta palvelusta, mikäli käyttö- tai kuukausimaksuja on vielä laskuttamatta.',
    ...val),

  J3YS: (en: string, ...val: string[]) => translate(en,
    'Käyttäjä lunastaa',
    ...val),

  J4EE: (en: string, ...val: string[]) => translate(en,
    'Käyttäjän mahdolliset Yritysten OmaElisan käyttöoikeudet sekä Elisa Ring- ja Puheratkaisu Vakio -palveluiden oikeudet poistuvat. Käyttöoikeudet ja lisäpalvelut voi aktivoida uudelleen siirron jälkeen.',
    ...val),

  J4WW: (en: string, ...val: string[]) => translate(en,
    'Kausimaksut',
    ...val),

  J5SL: (en: string, ...val: string[]) => translate(en,
    'Varattusoittoääni',
    ...val),

  J5VG: (en: string, ...val: string[]) => translate(en,
    'Palvelun muokkaaminen ei ole mahdollista OmaElisassa. Tarvittaessa ota yhteyttä asiakaspalveluun.',
    ...val),

  J63R: (en: string, ...val: string[]) => translate(en,
    'Tarjoukset',
    ...val),

  J6KQ: (en: string, ...val: string[]) => translate(en,
    'Palvelu ei ole saatavilla liittymällesi',
    ...val),

  J6P7: (en: string, ...val: string[]) => translate(en,
    'Syötä koko osoite mukaan lukien rapun numero',
    ...val),

  J7FZ: (en: string, ...val: string[]) => translate(en,
    'Palvelusopimus',
    ...val),

  J7JN: (en: string, ...val: string[]) => translate(en,
    'Luo uusi viesti ',
    ...val),

  J8VE: (en: string, ...val: string[]) => translate(en,
    'Poistaaksesi eston, sinun tulee sallia',
    ...val),

  J923: (en: string, ...val: string[]) => translate(en,
    'Uusi tilaus ja tarjouspyyntö',
    ...val),

  J954: (en: string, ...val: string[]) => translate(en,
    'Lisätarvikkeet',
    ...val),

  J9AR: (en: string, ...val: string[]) => translate(en,
    'Laskun viitetiedot',
    ...val),

  J9DM: (en: string, ...val: string[]) => translate(en,
    'Tuotteita',
    ...val),

  J9LT: (en: string, ...val: string[]) => translate(en,
    'Irroita ensin laitteen näytön päällä mahdollisesti oleva suojalasi ja/tai suojamuovi, tarkista onko näyttö rikki myös sen alla tai jatkuuko kosketusongelmat.',
    ...val),

  J9TT: (en: string, ...val: string[]) => translate(en,
    'Tunnistautuminen epäonnistui.',
    ...val),

  JAQQ: (en: string, ...val: string[]) => translate(en,
    'seurata liittymäsi viimeaikaista käyttöä ja katsoa erittelyn soitetuista puheluista sekä lähetetyistä tekstiviesteistä',
    ...val),

  JB8R: (en: string, ...val: string[]) => translate(en,
    'Estää tekstiviestit ja mobiilimaksut esim. erilaisiin TV-chatteihin ja -visailuihin sekä sovelluskaupasta puhelinlaskulle tehtävät ostot Android- ja Windows-laitteilla. Estää myös osallistumisen puhelinäänestyksiin ja markkinointikampanjoihin. Sisältää eston viihdenumeroihin.',
    ...val),

  JBEE: (en: string, ...val: string[]) => translate(en,
    'Täyttämäsi tiedot häviävät, jos poistut sivulta.',
    ...val),

  JBEM: (en: string, ...val: string[]) => translate(en,
    'Kustannuspaikka ja viite',
    ...val),

  JBMJ: (en: string, ...val: string[]) => translate(en,
    'Tilauksen hyväksymisen jälkeen ostotapahtumaa ei voi enää peruuttaa.',
    ...val),

  JC06: (en: string, ...val: string[]) => translate(en,
    'Julkaise',
    ...val),

  JC42: (en: string, ...val: string[]) => translate(en,
    'Ostolaitteet',
    ...val),

  JCEA: (en: string, ...val: string[]) => translate(en,
    'Kirje',
    ...val),

  JCJF: (en: string, ...val: string[]) => translate(en,
    'Vakion ohjaustietojen tallennuksessa tapahtui virhe, yritä jonkin ajan kuluttua uudestaan.',
    ...val),

  JCSR: (en: string, ...val: string[]) => translate(en,
    'Tukipyyntö on siirretty jatkokäsittelyyn. Olemme lähettäneet kuittauksen tukipyynnön avanneen käyttäjän sähköpostiin.',
    ...val),

  JCT8: (en: string, ...val: string[]) => translate(en,
    'Ennen vahinkoilmoituksen tekemistä, tarkista ja tee seuraavat asiat:',
    ...val),

  JCUQ: (en: string, ...val: string[]) => translate(en,
    'Tunnista saapuva puhelu',
    ...val),

  JD6A: (en: string, ...val: string[]) => translate(en,
    'Vanha viite',
    ...val),

  JDSQ: (en: string, ...val: string[]) => translate(en,
    'Lähetimme sinulle vahvistuskoodin tekstiviestillä numeroon ',
    ...val),

  JDTO: (en: string, ...val: string[]) => translate(en,
    'Jokin meni pieleen. Ole hyvä ja yritä uudelleen.',
    ...val),

  JE74: (en: string, ...val: string[]) => translate(en,
    'Muista tarkistaa yhteystietosi',
    ...val),

  JE8S: (en: string, ...val: string[]) => translate(en,
    'Virheellinen Kustannuspaikka. Syötä 4-numeroinen kustannuspaikka.',
    ...val),

  JE92: (en: string, ...val: string[]) => translate(en,
    'Puhelut ja viestit ajanvietepalvelunumeroihin, esim. keskustelulinjoille, äänestyksiin, peleihin ja markkinointikampanjoihin',
    ...val),

  JEHN: (en: string, ...val: string[]) => translate(en,
    'Kiinteä netti - mobiililaajakaista',
    ...val),

  JF65: (en: string, ...val: string[]) => translate(en,
    'Lasku',
    ...val),

  JFNL: (en: string, ...val: string[]) => translate(en,
    'Maksettava osuutesi uuden laitteen kuukausimaksusta',
    ...val),

  JFOS: (en: string, ...val: string[]) => translate(en,
    'Lisää koriin',
    ...val),

  JG2T: (en: string, ...val: string[]) => translate(en,
    'Muokkaa henkilötietoja',
    ...val),

  JGDD: (en: string, ...val: string[]) => translate(en,
    'Vahvista päivitys alla olevalla painikkeella.',
    ...val),

  JGP6: (en: string, ...val: string[]) => translate(en,
    'Hae uudestaan',
    ...val),

  JGSK: (en: string, ...val: string[]) => translate(en,
    'Vanhan SIM-kortin numero',
    ...val),

  JGSO: (en: string, ...val: string[]) => translate(en,
    'Laitekaupan 0,00€-hintaiset tuotteet ovat kokonaan työnantajasi kustantamia. Voit valita kalliimman laitteen osallistumalla itse kustannuksiin. Sopimuskauden pituus vaikuttaa laitteesta itse maksamaasi kokonaishintaan, kuukausimaksun suuruuteen sekä puhelimen vaihtoväliin.',
    ...val),

  JGV8: (en: string, ...val: string[]) => translate(en,
    'Kopioi SM-DP+ -osoite',
    ...val),

  JHAG: (en: string, ...val: string[]) => translate(en,
    'Muutos astuu voimaan',
    ...val),

  JHFF: (en: string, ...val: string[]) => translate(en,
    '-sivulla. Pyrimme vastaamaan arkisin 24h kuluessa.',
    ...val),

  JHXQ: (en: string, ...val: string[]) => translate(en,
    'Määritä laitelistan asetukset työntekijöiden tilauksille ja valitse listalla käytettävä laitevalikoima.',
    ...val),

  JHZY: (en: string, ...val: string[]) => translate(en,
    'Valitulle päivälle ei ole saatavilla asennusaikoja',
    ...val),

  JIID: (en: string, ...val: string[]) => translate(en,
    'Ostolaitteen hinta',
    ...val),

  JIP2: (en: string, ...val: string[]) => translate(en,
    'Valitse sopimuskausi',
    ...val),

  JIXE: (en: string, ...val: string[]) => translate(en,
    'Liittymä on suljettu luotonhallinnan toimesta. Ota tarvittaessa yhteyttä asiakaspalveluun {0} ({1})',
    ...val),

  JJM2: (en: string, ...val: string[]) => translate(en,
    'Elisa Palvelupäätelaite',
    ...val),

  JJRJ: (en: string, ...val: string[]) => translate(en,
    'Laskulle tulostuva maksajan postiosoite. Osoitteeseen lähetetään laskutukseen liittyvät kirjeet, esimerkiksi maksukehoitukset.',
    ...val),

  JJTM: (en: string, ...val: string[]) => translate(en,
    'Laitteet',
    ...val),

  JJTN: (en: string, ...val: string[]) => translate(en,
    'Verkko- ja tietoturvapalvelut',
    ...val),

  JJTO: (en: string, ...val: string[]) => translate(en,
    'IT-palvelut',
    ...val),

  JJTP: (en: string, ...val: string[]) => translate(en,
    'Asiakaspalveluratkaisut',
    ...val),

  JJTQ: (en: string, ...val: string[]) => translate(en,
    'Asiantuntijapalvelut / koulutus',
    ...val),

  JJTS: (en: string, ...val: string[]) => translate(en,
    'Aihe',
    ...val),

  JJWP: (en: string, ...val: string[]) => translate(en,
    'Tiedotteet',
    ...val),

  JK3C: (en: string, ...val: string[]) => translate(en,
    'Ladataan kalenterivapaita',
    ...val),

  JKG2: (en: string, ...val: string[]) => translate(en,
    'Tietueen arvoa muokattu',
    ...val),

  JKJJ: (en: string, ...val: string[]) => translate(en,
    'Pakollinen laskutussopimukselle annettu nimitieto. Ei tulostu laskulle.',
    ...val),

  JKJY: (en: string, ...val: string[]) => translate(en,
    'Maksusopimuksella voit siirtää maksupäivää maksimissaan 30 päivän päähän laskun alkuperäisestä eräpäivästä.',
    ...val),

  JL3U: (en: string, ...val: string[]) => translate(en,
    'Ota yhteyttä työnantajasi tilaajayhteyshenkilöön.',
    ...val),

  JLB0: (en: string, ...val: string[]) => translate(en,
    'Palautetaan Elisalle',
    ...val),

  JM9A: (en: string, ...val: string[]) => translate(en,
    'Valitse liiittymät joiden soittajan näyttönimiä haluat muokata.',
    ...val),

  JMGK: (en: string, ...val: string[]) => translate(en,
    'Kyllä saat. Laitteen lopullinen hyvitysarvo määräytyy sen kunnon mukaan. Mitä paremmassa kunnossa laite on, sitä suurempi on myös siitä saatava hyvitys, mutta myös kulunut ja viallinen laite voi saada arvon.',
    ...val),

  JN25: (en: string, ...val: string[]) => translate(en,
    'Julkaistu',
    ...val),

  JN29: (en: string, ...val: string[]) => translate(en,
    'Vanha laite',
    ...val),

  JNCH: (en: string, ...val: string[]) => translate(en,
    'Lomaketta lähetetään',
    ...val),

  JNNJ: (en: string, ...val: string[]) => translate(en,
    'Muutokset asetukseen tulee tehdä Elisan asiakaspalvelun kautta. Jätä viesti asiakaspalvelulle.',
    ...val),

  JNQG: (en: string, ...val: string[]) => translate(en,
    'Aloita tilaaminen valitsemalla laitelista, jolta haluat tilata tuotteita. Voit tehdä tilauksen vain yhdeltä laitelistalta kerrallaan. Jos et tiedä miltä listalta tuotteita valitset, kysy neuvoa esihenkilöltäsi tai työnantajasi OmaElisa-pääkäyttäjältä.',
    ...val),

  JNTB: (en: string, ...val: string[]) => translate(en,
    'Lue OmaLasku -palvelun sopimusehdot',
    ...val),

  JO8H: (en: string, ...val: string[]) => translate(en,
    'Työnantajayritys',
    ...val),

  JOM3: (en: string, ...val: string[]) => translate(en,
    'Kirjaudu OmaElisaan',
    ...val),

  JP9Z: (en: string, ...val: string[]) => translate(en,
    'Lisää osoitetiedot',
    ...val),

  JPFF: (en: string, ...val: string[]) => translate(en,
    'Elisan intranetistä',
    ...val),

  JPKP: (en: string, ...val: string[]) => translate(en,
    'Sopimushinta',
    ...val),

  JPRH: (en: string, ...val: string[]) => translate(en,
    'Liittymät',
    ...val),

  JQ1V: (en: string, ...val: string[]) => translate(en,
    'Tyhjennä lomake',
    ...val),

  JQD9: (en: string, ...val: string[]) => translate(en,
    'Korkealaatuisen live-videon lähetys, mahdollisuus hyötyä uusista teknologisista innovaatioista sekä laitteista, IoT-sovelluksista ja -ohjelmistoista.',
    ...val),

  JQDG: (en: string, ...val: string[]) => translate(en,
    'Laitekategoria',
    ...val),

  JR2G: (en: string, ...val: string[]) => translate(en,
    'Aina käytössä',
    ...val),

  JR9F: (en: string, ...val: string[]) => translate(en,
    'Käyttäjä on laskun yhteyshenkilönä ja/tai vastaanottajana',
    ...val),

  JRBO: (en: string, ...val: string[]) => translate(en,
    'Tämä Elisa ID on jo siirretty ja liitetty toiseen yrityksen käyttäjätiliin. Kirjaudu uudelleen sisään Elisa ID:lläsi.',
    ...val),

  JS1B: (en: string, ...val: string[]) => translate(en,
    'Tarkista toimitusosoite',
    ...val),

  JS80: (en: string, ...val: string[]) => translate(en,
    'OmaElisa Classic -palvelussa',
    ...val),

  JSLD: (en: string, ...val: string[]) => translate(en,
    'Viimeistele käyttöönotto kirjautumalla sisään henkilökohtaisella Elisa Tunnuksella tai luomalla Elisa Tunnus.',
    ...val),

  JSP4: (en: string, ...val: string[]) => translate(en,
    'Viesti ei voi olla tyhjä.',
    ...val),

  JT5W: (en: string, ...val: string[]) => translate(en,
    'Katso puheratkaisu Vakion ohjeet ja vinkit täältä',
    ...val),

  JTDS: (en: string, ...val: string[]) => translate(en,
    'Hoida laite- ja liittymäasiasi joustavasti silloin kun sinulle sopii.',
    ...val),

  JTEX: (en: string, ...val: string[]) => translate(en,
    'Virhe siirrossa. Yritä uudelleen tai kirjaudu ulos.',
    ...val),

  JTM7: (en: string, ...val: string[]) => translate(en,
    'Salasanat eivät täsmää',
    ...val),

  JTXG: (en: string, ...val: string[]) => translate(en,
    'Kopioi aktivointikoodi',
    ...val),

  JTZL: (en: string, ...val: string[]) => translate(en,
    'Palvelu samalla laskulla kuin varsinainen liittymä.',
    ...val),

  JU94: (en: string, ...val: string[]) => translate(en,
    'Ring-lisäpalvelut',
    ...val),

  JUCA: (en: string, ...val: string[]) => translate(en,
    'Kiitos viestistäsi',
    ...val),

  JUY2: (en: string, ...val: string[]) => translate(en,
    'Yritys, johon olet tilaamassa',
    ...val),

  JVCB: (en: string, ...val: string[]) => translate(en,
    'Kirjaudu mobiilivarmenteella',
    ...val),

  JVHX: (en: string, ...val: string[]) => translate(en,
    'Sisltyvt laitteet',
    ...val),

  JVNS: (en: string, ...val: string[]) => translate(en,
    'Jälkitoimitus',
    ...val),

  JW6Y: (en: string, ...val: string[]) => translate(en,
    'Jos olet työntekijä, voit hallinnoida työsuhdeliittymääsi',
    ...val),

  JWJO: (en: string, ...val: string[]) => translate(en,
    'Haluan säilyttää Ring-liittymän',
    ...val),

  JWLU: (en: string, ...val: string[]) => translate(en,
    'Ominaisuudet',
    ...val),

  JWO2: (en: string, ...val: string[]) => translate(en,
    'Tulosta QR-koodi',
    ...val),

  JWWE: (en: string, ...val: string[]) => translate(en,
    'Jos laitteesi on vahingoittunut, toimitamme korvaavan laitteen rikkoutuneen tilalle. Saat korvaavan laitteen mukana ohjeet vanhaan laitteen palauttamista varten.',
    ...val),

  JWZQ: (en: string, ...val: string[]) => translate(en,
    'Kaikille netin käyttäjille',
    ...val),

  JX0H: (en: string, ...val: string[]) => translate(en,
    'Yli',
    ...val),

  JXNJ: (en: string, ...val: string[]) => translate(en,
    'Tilaus käsitellään, kun se on hyväksytty. Arkipäivisin ennen klo 12 hyväksytyt tilaukset ehtivät pääsääntöisesti seuraavan arkipäivän toimitukseen.',
    ...val),

  JXQZ: (en: string, ...val: string[]) => translate(en,
    'Myyntipalvelu',
    ...val),

  JXVW: (en: string, ...val: string[]) => translate(en,
    'Työnantajasi on valinnut laitelistojen tuotevalikoiman yrityksenne käytäntöjen mukaan, esimerkiksi tiettyjen mallien tai hintaluokkien perusteella.',
    ...val),

  JXYZ: (en: string, ...val: string[]) => translate(en,
    'Muutospyynnön lähetys epäonnistui.',
    ...val),

  JYLX: (en: string, ...val: string[]) => translate(en,
    'Jokin meni pieleen, ole hyvä ja yritä kirjautumista uudelleen. Jos ongelma toistuu soita asiakaspalveluumme {0} ({1}). Asiakaspalvelumme on avoinna {2}.',
    ...val),

  JYZO: (en: string, ...val: string[]) => translate(en,
    'Sähköposti (työ)',
    ...val),

  JZ8R: (en: string, ...val: string[]) => translate(en,
    '(alv. 0 %)',
    ...val),

  JZH3: (en: string, ...val: string[]) => translate(en,
    'Muut laitteet',
    ...val),

  JZHA: (en: string, ...val: string[]) => translate(en,
    'Saat laskun lunastuksesta sähköpostiisi {} kun lunastuspyyntö on hyväksytty.',
    ...val),

  JZHE: (en: string, ...val: string[]) => translate(en,
    'Tyhjennä selaimen evästeet ja välimuisti ja yritä uudelleen.',
    ...val),

  JZYE: (en: string, ...val: string[]) => translate(en,
    'Valitsemasi sopimuskausi ei ole saatavilla. Valitse toinen sopimuskausi.',
    ...val),

  K0AG: (en: string, ...val: string[]) => translate(en,
    'Jos maksettava osuutesi uuden laitteen kuukausimaksusta jää alle 5 €/kk, saat laskun, kun maksettavaa on vähintään 5 € tai 3 kk välein. Voit muuttaa laskun myöhemmin e-laskuksi verkkopankissasi.',
    ...val),

  K1BD: (en: string, ...val: string[]) => translate(en,
    'Seuraa laitteen antamia ohjeita',
    ...val),

  K1J3: (en: string, ...val: string[]) => translate(en,
    'ja odota hetki, että eSIM-tiedot latautuvat laitteellesi.',
    ...val),

  K1TA: (en: string, ...val: string[]) => translate(en,
    'Vaihdathan tarvittaessa liittymän käyttäjätiedot sekä numeron julkisuustiedon tämän muutoksen jälkeen.',
    ...val),

  K2D6: (en: string, ...val: string[]) => translate(en,
    'Ole hyvä ja valitse toimitustapa.',
    ...val),

  K2PG: (en: string, ...val: string[]) => translate(en,
    'Muut tuotteet',
    ...val),

  K2SS: (en: string, ...val: string[]) => translate(en,
    ' Aito 5G toimii automaattisesti yhteensopivalla laitteella ja siirtyy tarvittaessa 4G-verkkoon siellä, missä 5G-yhteys ei ole saatavilla.',
    ...val),

  K31E: (en: string, ...val: string[]) => translate(en,
    'Liittymäni',
    ...val),

  K3GT: (en: string, ...val: string[]) => translate(en,
    'Uusi sopimus',
    ...val),

  K3GX: (en: string, ...val: string[]) => translate(en,
    'Alla näet nykyisen version. Ajastettu muutos julkaistaan',
    ...val),

  K3VK: (en: string, ...val: string[]) => translate(en,
    'Tiedostotyyppi {} ei sallittu',
    ...val),

  K3VL: (en: string, ...val: string[]) => translate(en,
    'Word-dokumentti',
    ...val),

  K3VM: (en: string, ...val: string[]) => translate(en,
    'PDF-dokumentti',
    ...val),

  K3VN: (en: string, ...val: string[]) => translate(en,
    'Tekstidokumentti',
    ...val),

  K3VO: (en: string, ...val: string[]) => translate(en,
    'Excel-dokumentti',
    ...val),

  K3VP: (en: string, ...val: string[]) => translate(en,
    'Kuva',
    ...val),

  K3VQ: (en: string, ...val: string[]) => translate(en,
    'Tiedosto',
    ...val),

  K4NE: (en: string, ...val: string[]) => translate(en,
    'Lisenssien jako',
    ...val),

  K5E2: (en: string, ...val: string[]) => translate(en,
    'Lisää arvo',
    ...val),

  K5TL: (en: string, ...val: string[]) => translate(en,
    'PUK-koodi',
    ...val),

  K6HI: (en: string, ...val: string[]) => translate(en,
    'Postitusosoite',
    ...val),

  K6IL: (en: string, ...val: string[]) => translate(en,
    'Aito 5G tarjoaa paremman ruuhkankeston. Lisäksi akunkesto paranee, koska laite käyttää vain yhtä verkkoa kahden sijaan – akunkesto on jopa 20 % parempi perinteiseen 4G- tai 5G-liittymään verrattuna.',
    ...val),

  K6XH: (en: string, ...val: string[]) => translate(en,
    'Voit tallentaa listan myös luonnoksena ja julkaista sen myöhemmin.',
    ...val),

  K70R: (en: string, ...val: string[]) => translate(en,
    'Valitse henkilö, joka on tavoitettavissa asennuspaikalla ja johon asentaja voi ottaa yhteyttä asennuksen aikana tarvittaessa (esim. pääsyn järjestämiseksi tai lisätietojen ja ohjeiden saamiseksi).',
    ...val),

  K755: (en: string, ...val: string[]) => translate(en,
    'Kuukausimaksullinen',
    ...val),

  K7TH: (en: string, ...val: string[]) => translate(en,
    'Ajanviete-esto',
    ...val),

  K84B: (en: string, ...val: string[]) => translate(en,
    'Lunastuspyynnön tunnistenumero',
    ...val),

  K8DS: (en: string, ...val: string[]) => translate(en,
    'Tilaustyyppi',
    ...val),

  K8YJ: (en: string, ...val: string[]) => translate(en,
    'Hyväksytty',
    ...val),

  KA37: (en: string, ...val: string[]) => translate(en,
    'https://elisa.fi/attachment/content/Elisan_yleiset_sopimusehdot_kuluttaja-asiakkaille.pdf_',
    ...val),

  KB1F: (en: string, ...val: string[]) => translate(en,
    'Valitse itsellesi parhaiten sopivat välineet työntekoon. OmaLaskulla saat parhaan mahdollisen laitteen.',
    ...val),

  KB2E: (en: string, ...val: string[]) => translate(en,
    'liittymän käyttäjälle lähetetään välittömästi tekstiviesti. Käyttäjän on tehtävä numeronsiirtotilaus minimissään viikkoa ennen valitsemaasi irtisanomispäivää.',
    ...val),

  KB82: (en: string, ...val: string[]) => translate(en,
    'Lisätään',
    ...val),

  KBLX: (en: string, ...val: string[]) => translate(en,
    'Yrityksille',
    ...val),

  KC2R: (en: string, ...val: string[]) => translate(en,
    'Numeroa käytetään esimerkiksi tilauksiisi liittyvissä asioissa ja salasanasi palauttamisessa.',
    ...val),

  KC4V: (en: string, ...val: string[]) => translate(en,
    'Oletko varma, että haluat jatkaa?',
    ...val),

  KC80: (en: string, ...val: string[]) => translate(en,
    'Ei luetteloon',
    ...val),

  KCZ6: (en: string, ...val: string[]) => translate(en,
    'Vahvista Hyväksy lunastuspyyntö',
    ...val),

  KD2L: (en: string, ...val: string[]) => translate(en,
    'Annan luvan siirtää numeron, vaikka siinä olisi määräaikainen sopimus kesken',
    ...val),

  KD2N: (en: string, ...val: string[]) => translate(en,
    'Ilmoitetut hinnat alv.',
    ...val),

  KD5A: (en: string, ...val: string[]) => translate(en,
    'Tilaa laite',
    ...val),

  KDIV: (en: string, ...val: string[]) => translate(en,
    'Tilauksen tiedot',
    ...val),

  KDZD: (en: string, ...val: string[]) => translate(en,
    'Olet kirjautuneena OmaElisa tunnuksilla. Kirjaudu ulos ja luo itsellesi Elisa Tunnus (jos sinulla ei vielä ole sitä). Elisa Tunnus toimii jatkossa myös OmaElisaan kirjautuessa etkä tarvitse kirjautua aina erikseen eri palveluihin.',
    ...val),

  KES0: (en: string, ...val: string[]) => translate(en,
    'Aktivoi eSIM',
    ...val),

  KF0J: (en: string, ...val: string[]) => translate(en,
    'Elisa KelloSIM',
    ...val),

  KFGF: (en: string, ...val: string[]) => translate(en,
    'Laite on kadonnut',
    ...val),

  KFRW: (en: string, ...val: string[]) => translate(en,
    'Kaipaatko apua?',
    ...val),

  KFUH: (en: string, ...val: string[]) => translate(en,
    'Sinut on kutsuttu Yritysten OmaElisaan.',
    ...val),

  KFUI: (en: string, ...val: string[]) => translate(en,
    'Sinut on kutsuttu Työntekijän OmaElisaan.',
    ...val),

  KG04: (en: string, ...val: string[]) => translate(en,
    'Tämä matkapuhelinnumero kuuluu toiselle organisaatiolle',
    ...val),

  KG30: (en: string, ...val: string[]) => translate(en,
    'Uusi tietue luotu',
    ...val),

  KGKV: (en: string, ...val: string[]) => translate(en,
    'Liittymälle ei voi lisätä enempää laitteita.',
    ...val),

  KHWC: (en: string, ...val: string[]) => translate(en,
    'Voit hyödyntää hyvityksen esimerkiksi liittymien ja palveluiden kuukausimaksuihin tai uusien laitteiden hankintaan. Hyvitys maksetaan yrityksesi laskutussopimukselle, eikä sitä makseta rahana.',
    ...val),

  KIB1: (en: string, ...val: string[]) => translate(en,
    'Mitä hyötyä Aito 5G:stä on yrityksen liittymissä?',
    ...val),

  KIEG: (en: string, ...val: string[]) => translate(en,
    'Sopimuksen pituus',
    ...val),

  KIRR: (en: string, ...val: string[]) => translate(en,
    'TARKISTA',
    ...val),

  KJ47: (en: string, ...val: string[]) => translate(en,
    'Sopimuksen tiedot',
    ...val),

  KJAE: (en: string, ...val: string[]) => translate(en,
    'Vahvistamisen jälkeen, et pysty enään näkemään vanhan työnantajasi aikaisia liittymä- tai käyttötietoja.\nLinkitys on tällöin tehtävä uudestaan.',
    ...val),

  KJP5: (en: string, ...val: string[]) => translate(en,
    'Uusia muutoksia on mahdollista tehdä vasta, kun edellinen muutospyyntö on käsitelty. Huomaathan myös, että käsittelyssä oleva muutos tulee näkyviin vasta, kun muutospyyntö on käsitelty.',
    ...val),

  KJTS: (en: string, ...val: string[]) => translate(en,
    'Yritys',
    ...val),

  KLNT: (en: string, ...val: string[]) => translate(en,
    'Vahvista sopimuksen irtisanominen',
    ...val),

  KM32: (en: string, ...val: string[]) => translate(en,
    'PIN-koodilla',
    ...val),

  KMG2: (en: string, ...val: string[]) => translate(en,
    'Arvioitu asennusaika',
    ...val),

  KMOP: (en: string, ...val: string[]) => translate(en,
    'Elisan yritysasiakkaana saat ohjattua hyvityksen esimerkiksi liittymien ja palveluiden kuukausimaksuihin',
    ...val),

  KMSU: (en: string, ...val: string[]) => translate(en,
    'Valmis!',
    ...val),

  KMZY: (en: string, ...val: string[]) => translate(en,
    'Nopea tiedonsiirto, 4K-videot ja pilvipalvelut',
    ...val),

  KN84: (en: string, ...val: string[]) => translate(en,
    'Varmista aluksi, että laitteesi on yhteydessä nettiin',
    ...val),

  KNBW: (en: string, ...val: string[]) => translate(en,
    'Poistunut valikoimasta',
    ...val),

  KNM4: (en: string, ...val: string[]) => translate(en,
    'Uusi asiakas?',
    ...val),

  KNS9: (en: string, ...val: string[]) => translate(en,
    'Lunastuspyynnön lähetys onnistui',
    ...val),

  KNX3: (en: string, ...val: string[]) => translate(en,
    'Vahinko- ja huoltoilmoitus',
    ...val),

  KOL4: (en: string, ...val: string[]) => translate(en,
    'Mikäli et halua vastaanottaa enää muistutuksia maksamattomista laskuista, voit estää SMS-muistutuksen. Esto koskee kaikkia yrityksen laskutussopimuksia.',
    ...val),

  KOO8: (en: string, ...val: string[]) => translate(en,
    'Jos haluat siirtää käyttäjän toiseen yritykseen, voit tehdä sen [Käyttäjät]-sivulla.',
    ...val),

  KP7E: (en: string, ...val: string[]) => translate(en,
    'Asiakastili',
    ...val),

  KQE6: (en: string, ...val: string[]) => translate(en,
    'Omat palvelut ja vianmääritys',
    ...val),

  KQOD: (en: string, ...val: string[]) => translate(en,
    'Vahvistettu',
    ...val),

  KQZ3: (en: string, ...val: string[]) => translate(en,
    'Tämä on asiakkaan oma laite, joten Elisa ei toimita sitä.',
    ...val),

  KRDZ: (en: string, ...val: string[]) => translate(en,
    'Lauantai',
    ...val),

  KRTP: (en: string, ...val: string[]) => translate(en,
    'Estää soittamisen ulkomaille sekä ulkomaan numerotiedusteluihin ja yhdistämispalvelunumeroihin.',
    ...val),

  KRYR: (en: string, ...val: string[]) => translate(en,
    'Palvelu laskuttuu kuukauden loppuun asti.',
    ...val),

  KSRZ: (en: string, ...val: string[]) => translate(en,
    'Sähköpostiosoite tai matkapuhelinnumero',
    ...val),

  KSXW: (en: string, ...val: string[]) => translate(en,
    'Käyttäjän vaihto vaikuttaa {} laskutustietoihin',
    ...val),

  KTY1: (en: string, ...val: string[]) => translate(en,
    'Liittymän {} tiedot',
    ...val),

  KU6Y: (en: string, ...val: string[]) => translate(en,
    'Muokkaa tietoja',
    ...val),

  KUKS: (en: string, ...val: string[]) => translate(en,
    'Lähetimme sinulle kertakäyttösalasanan. Kirjaudu sillä palveluun.',
    ...val),

  KUTS: (en: string, ...val: string[]) => translate(en,
    'Laskutussopimuksen nimen lisäosa',
    ...val),

  KUXE: (en: string, ...val: string[]) => translate(en,
    'Kauppaan',
    ...val),

  KUZQ: (en: string, ...val: string[]) => translate(en,
    'Raportti sisältää Elisa Palvelupäätelaitteiden Vuokravastuulaskennan. Laskennassa huomioidaan peruskaudella olevien laitteiden Yrityksen osuus sekä mahdollisen Vahinkopalvelun kuukausiveloitukset. Laskenta suoritetaan valitun raportointipäivän perusteella.',
    ...val),

  KV4P: (en: string, ...val: string[]) => translate(en,
    'Käyttäjätunnus',
    ...val),

  KVG8: (en: string, ...val: string[]) => translate(en,
    'Videopuhelut, pilvipalveluiden käyttö ja kevyt etätyöskentely',
    ...val),

  KVG9: (en: string, ...val: string[]) => translate(en,
    'Kevyt netinkäyttö ja sähköpostien lukeminen sekä lähetys',
    ...val),

  KVWE: (en: string, ...val: string[]) => translate(en,
    'Valittu päivä ei ole saatavilla asennukseen',
    ...val),

  KW12: (en: string, ...val: string[]) => translate(en,
    'Ladataan',
    ...val),

  KWE5: (en: string, ...val: string[]) => translate(en,
    'Voit irtisanoa liittymän lähettämällä yhteydenottopyynnön asiakaspalveluumme. Jätä puhelinnumerosi, niin asiakaspalvelustamme otetaan yhteyttä.',
    ...val),

  KXDH: (en: string, ...val: string[]) => translate(en,
    'Sähköpostilaskun vastaanottaja',
    ...val),

  KXYE: (en: string, ...val: string[]) => translate(en,
    'Kirjaudu sisään henkilökohtaisella Elisa Tunnuksella tai tunnistaudu. Mikäli sinulla ei vielä ole henkilökohtaista Elisa Tunnusta pääset luomaan sen tunnistautumisen jälkeen.',
    ...val),

  KXZI: (en: string, ...val: string[]) => translate(en,
    'Huomioithan, että yksi tilaus saattaa sisältää monia eri tuotteita.',
    ...val),

  KYYF: (en: string, ...val: string[]) => translate(en,
    'Jotta pääset tekemään tilauksen, sinulla pitää olla OmaElisa-tunnukset. Tarvitset tunnuksia varten yrityksesi nimenkirjoitusoikeuden.',
    ...val),

  KZ4H: (en: string, ...val: string[]) => translate(en,
    'Mitä Työntekijän OmaElisassa voi tehdä?',
    ...val),

  KZ5L: (en: string, ...val: string[]) => translate(en,
    'Liittymään on liitetty Mobiilivarmenne, joka lakkaa toimimasta muutoksen myötä. Liittymän käyttäjän on henkilökohtaisesti aktivoitava mobiilivarmenne uudelleen.',
    ...val),

  KZ5M: (en: string, ...val: string[]) => translate(en,
    'Elisa Palvelupäätelaitteet',
    ...val),

  KZ6N: (en: string, ...val: string[]) => translate(en,
    'Salainen numero',
    ...val),

  KZ77: (en: string, ...val: string[]) => translate(en,
    'Uusi käyttötarkoitus',
    ...val),

  KZ8Y: (en: string, ...val: string[]) => translate(en,
    'Sisällön haku epäonnistui...',
    ...val),

  KZJT: (en: string, ...val: string[]) => translate(en,
    'Tyhjennä lomakkeet',
    ...val),

  L07L: (en: string, ...val: string[]) => translate(en,
    'Estä datasiirto ulkomailla',
    ...val),

  L0B1: (en: string, ...val: string[]) => translate(en,
    'Tarkoititko:',
    ...val),

  L0FO: (en: string, ...val: string[]) => translate(en,
    'Olemme vastaanottaneet tukipyynnölle lisätietoa. Jatkamme käsittelyä mahdollisimman pian. ',
    ...val),

  L0X1: (en: string, ...val: string[]) => translate(en,
    'Katalogin poistaminen epäonnistui',
    ...val),

  L11M: (en: string, ...val: string[]) => translate(en,
    'Tarkista kaapelin ja virtalähteen toimivuus.',
    ...val),

  L1HT: (en: string, ...val: string[]) => translate(en,
    'Valitse laite',
    ...val),

  L1QB: (en: string, ...val: string[]) => translate(en,
    'Tiedostoa ei pystytty lukemaan tai se on tyhjä.',
    ...val),

  L1YX: (en: string, ...val: string[]) => translate(en,
    'Varmistetaan KelloSIM:n saatavuus',
    ...val),

  L2MX: (en: string, ...val: string[]) => translate(en,
    'Tekniset tiedot',
    ...val),

  L2OG: (en: string, ...val: string[]) => translate(en,
    'Kustannuspaikka',
    ...val),

  L35W: (en: string, ...val: string[]) => translate(en,
    'Kuulokkeet',
    ...val),

  L3C5: (en: string, ...val: string[]) => translate(en,
    'Kieli',
    ...val),

  L3TD: (en: string, ...val: string[]) => translate(en,
    'Esto käytössä',
    ...val),

  L6G9: (en: string, ...val: string[]) => translate(en,
    'Vastaajat työajalla',
    ...val),

  L6NC: (en: string, ...val: string[]) => translate(en,
    'Soita yritysasiakaspalveluun',
    ...val),

  L75K: (en: string, ...val: string[]) => translate(en,
    'Valmis',
    ...val),

  L78N: (en: string, ...val: string[]) => translate(en,
    'Linkin avulla työntekijä pääsee kirjautumaan laitekauppaan sekä valitsemaan itsellensä laitteen.',
    ...val),

  L7BV: (en: string, ...val: string[]) => translate(en,
    'Tietojen päivitys epäonnistui, kokeile hetken kuluttua uudestaan.',
    ...val),

  L7CX: (en: string, ...val: string[]) => translate(en,
    'Hakutuloksia on liikaa. Tarkenna hakua.',
    ...val),

  L7CZ: (en: string, ...val: string[]) => translate(en,
    'Ei hakutuloksia',
    ...val),

  L7DX: (en: string, ...val: string[]) => translate(en,
    'Voit hakea useammalla hakusanalla erottelemalla sanat välilyönnillä.',
    ...val),

  L7HY: (en: string, ...val: string[]) => translate(en,
    'Kuinka saan lisää maksuaikaa',
    ...val),

  L7ML: (en: string, ...val: string[]) => translate(en,
    'Odottaa käsittelyä',
    ...val),

  L7QB: (en: string, ...val: string[]) => translate(en,
    'Yritystiedot',
    ...val),

  L7VP: (en: string, ...val: string[]) => translate(en,
    'Näytä ostolaitteen hinta työntekijöille',
    ...val),

  L80Q: (en: string, ...val: string[]) => translate(en,
    'Toimi nopeasti, tuotetta jäljellä enää rajoitettu erä',
    ...val),

  L866: (en: string, ...val: string[]) => translate(en,
    'Lisenssien hallintaportaali',
    ...val),

  L88I: (en: string, ...val: string[]) => translate(en,
    'Elisan kuluttajaliittymien yritysasiakkaana (entinen Saunalahden yritysasiakas) ',
    ...val),

  L8A5: (en: string, ...val: string[]) => translate(en,
    'Ei julkaistu',
    ...val),

  L8XT: (en: string, ...val: string[]) => translate(en,
    'Numeron julkisuus',
    ...val),

  L9E5: (en: string, ...val: string[]) => translate(en,
    'Sopijayritystä ei voi vaihtaa, koska laitteen käyttäjällä on aktiivinen Elisa Oma Laitelasku.',
    ...val),

  L9HF: (en: string, ...val: string[]) => translate(en,
    'Tuote ei ole saatavilla',
    ...val),

  L9OE: (en: string, ...val: string[]) => translate(en,
    'Ota yhteyttä asiakaspalveluumme 010 80 8088 niin saat asian hoidettua. Asiakaspalvelumme auttaa arkisin klo 8.00-16.30). Pahoittelemme häiriötä.',
    ...val),

  L9TJ: (en: string, ...val: string[]) => translate(en,
    'Vaihtoedun hyödyntäminen kannattaa',
    ...val),

  LA93: (en: string, ...val: string[]) => translate(en,
    'Eräpäivä',
    ...val),

  LAC9: (en: string, ...val: string[]) => translate(en,
    '10000 mAh akku',
    ...val),

  LBBW: (en: string, ...val: string[]) => translate(en,
    'lähettää vahinko- tai huoltoilmoituksen laitteestasi',
    ...val),

  LBWF: (en: string, ...val: string[]) => translate(en,
    'Liittymän käyttäjän tai käyttötarkoituksen vaihtaminen ei onnistu, koska liittymällä on käytössä Ring-palvelu.',
    ...val),

  LC00: (en: string, ...val: string[]) => translate(en,
    '{0} = Erittäin vaikeaa',
    ...val),

  LC1S: (en: string, ...val: string[]) => translate(en,
    'Matkapuhelinnumeron ajastettu työaika',
    ...val),

  LC2W: (en: string, ...val: string[]) => translate(en,
    'Haluatko varmasti muuttaa KelloSIM-palvelun laskun maksajan? Muutos vaikuttaa kaikkiin uusiin KelloSIM-liittymiin.',
    ...val),

  LCCX: (en: string, ...val: string[]) => translate(en,
    'Sis. {} Gt datan käyttöä Pohjola & Baltia sekä muun EU:n alueella. Paketin ylimenevä datankäyttö 6,50 € / alkava 10 Gt.',
    ...val),

  LDM3: (en: string, ...val: string[]) => translate(en,
    'Mikäli sinulla on vain yksi eSIM-profiili, on se heti käytössäsi. Löydät ohjeet ja QR-koodin jatkossa liittymäsi tiedoista. Voit käyttää QR-koodia samalla laitteella rajattomasti. Huomioithan, että eSIM toimii vain laitteella, johon se on ensimmäisellä kerralla ladattu.',
    ...val),

  LDN7: (en: string, ...val: string[]) => translate(en,
    'Muistathan tehdä erillisen myyntikirjauksen Salesforceen',
    ...val),

  LDWQ: (en: string, ...val: string[]) => translate(en,
    'Kutsua lähetetään...',
    ...val),

  LDYA: (en: string, ...val: string[]) => translate(en,
    'Valitse toimitilasi koko:',
    ...val),

  LEDQ: (en: string, ...val: string[]) => translate(en,
    '. Vahvista puhelinnumerosi täyttämällä koodi alla olevaan kenttään.',
    ...val),

  LEO9: (en: string, ...val: string[]) => translate(en,
    'Tilaa uusi laite ja lisätarvikkeet',
    ...val),

  LFBC: (en: string, ...val: string[]) => translate(en,
    'Etsitkö nettiä isommalle toimistolle?',
    ...val),

  LFZM: (en: string, ...val: string[]) => translate(en,
    'Irtisano Elisa Mobiilivarmenne Työntekijälle -palvelu',
    ...val),

  LG1W: (en: string, ...val: string[]) => translate(en,
    'Puheratkaisu Vakio alueellisella numerolla, Elisa matkapuhelinvastaaja, Elisa WiFi-puhelu, Elisa Lankanumero, Puhelun edelleenyhdistäminen, Kaikkien lähtevien ulkomaanpuheluiden esto (BOIC),Kaikkien lähtevien puheluiden esto (BAOC), Lähtevien ulkomaan puheluiden esto sallittu vain Suomeen (BOIH), Kaikkien saapuvien puheluiden esto (BAIC), Kaikkien saapuvien puheluiden esto ulkomaisessa verkossa (BIRO), Sopimusasiointi, Vakio käyttöhinnat, Puheratkaisu Vakio valtakunnallisella yritysnumerolla, Yritysnumerotekstiviesti',
    ...val),

  LG3K: (en: string, ...val: string[]) => translate(en,
    'Laitelistat kopioitu luonnoksina. Valitse kunkin listan laskutussopimukset yritysten omalla laitelista-sivulla ja julkaise listat sen jälkeen.',
    ...val),

  LG3L: (en: string, ...val: string[]) => translate(en,
    'VDSL',
    ...val),

  LG40: (en: string, ...val: string[]) => translate(en,
    'Tarkista pääkäyttäjien tiedot',
    ...val),

  LG80: (en: string, ...val: string[]) => translate(en,
    'Tiva',
    ...val),

  LGDG: (en: string, ...val: string[]) => translate(en,
    'Vain numeroita',
    ...val),

  LGO7: (en: string, ...val: string[]) => translate(en,
    'Yritysten OmaElisaan kirjautuminen uudistuu. Elisa Tunnuksen hyötyjä',
    ...val),

  LGO8: (en: string, ...val: string[]) => translate(en,
    'Yritysten OmaElisaan kirjautuminen uudistuu. Elisa Tunnus on henkilökohtainen käyttäjätili, jolla pääset Elisan palveluihin.',
    ...val),

  LGOM: (en: string, ...val: string[]) => translate(en,
    'Yksimuotokuitu',
    ...val),

  LGPO: (en: string, ...val: string[]) => translate(en,
    'Poista käytöstä',
    ...val),

  LH4H: (en: string, ...val: string[]) => translate(en,
    'Arkipäivisin ennen klo 12 tehdyt tilaukset ehtivät pääsääntöisesti seuraavan työpäivän toimitukseen. SIM-kortti toimitetaan kirjekuoressa valittuun osoitteeseen.',
    ...val),

  LHCF: (en: string, ...val: string[]) => translate(en,
    'Siirry laitekauppaan',
    ...val),

  LHJ4: (en: string, ...val: string[]) => translate(en,
    'Sopimuksen päättymispäivä',
    ...val),

  LHU3: (en: string, ...val: string[]) => translate(en,
    'Vanha laskutussopimus',
    ...val),

  LIB5: (en: string, ...val: string[]) => translate(en,
    'Laskutussopimuksen lisäasetukset',
    ...val),

  LIQB: (en: string, ...val: string[]) => translate(en,
    'Ohjeita Elisa Mobiilivarmenteesta',
    ...val),

  LIU7: (en: string, ...val: string[]) => translate(en,
    'Viestit',
    ...val),

  LIUF: (en: string, ...val: string[]) => translate(en,
    'Päätä sopimus ja palauta laite',
    ...val),

  LJ10: (en: string, ...val: string[]) => translate(en,
    'Tutustu palvelun käyttöön liittyviin ',
    ...val),

  LJ4Y: (en: string, ...val: string[]) => translate(en,
    'Myyntipalvelumme tavoitat arkisin 8-16:00.',
    ...val),

  LJQ3: (en: string, ...val: string[]) => translate(en,
    'Numeroavaruudet',
    ...val),

  LJTY: (en: string, ...val: string[]) => translate(en,
    'Rekisteröidy',
    ...val),

  LK2D: (en: string, ...val: string[]) => translate(en,
    'Tarkemmat tiedot jäljellä olevista maksueristä löydät laskulta.',
    ...val),

  LK4J: (en: string, ...val: string[]) => translate(en,
    'Henkilökohtainen käyttäjätili',
    ...val),

  LK73: (en: string, ...val: string[]) => translate(en,
    'Maksa',
    ...val),

  LK7B: (en: string, ...val: string[]) => translate(en,
    'Osoite tai numero',
    ...val),

  LKBV: (en: string, ...val: string[]) => translate(en,
    'Laite lunastetaan',
    ...val),

  LKVJ: (en: string, ...val: string[]) => translate(en,
    'Tilaa myös mobiililaajakaistaliittymä - jopa 67% alennuksella',
    ...val),

  LLAF: (en: string, ...val: string[]) => translate(en,
    'Numeroasi ei julkaista luetteloissa, mutta sen voi saada numeropalvelusta kysymällä.',
    ...val),

  LLHD: (en: string, ...val: string[]) => translate(en,
    'Estä kaikki käyttö EU:n ja ETA:n ulkopuolella',
    ...val),

  LLQR: (en: string, ...val: string[]) => translate(en,
    'Kuljetus toimitusosoitteeseen. Perillä seuraavana työpäivänä klo 16 mennessä',
    ...val),

  LLYE: (en: string, ...val: string[]) => translate(en,
    'Näyttö ja/tai takalasi rikki',
    ...val),

  LM60: (en: string, ...val: string[]) => translate(en,
    'Olet kirjautuneena Työntekijän OmaElisaan. Voit hoitaa omia työliittymä- ja laiteasioitasi',
    ...val),

  LMKE: (en: string, ...val: string[]) => translate(en,
    'Kun kaikki tuotteet on saatavilla',
    ...val),

  LMRW: (en: string, ...val: string[]) => translate(en,
    'Laskutussopimuksen vaihto',
    ...val),

  LN3T: (en: string, ...val: string[]) => translate(en,
    'Sopijayrityksen vaihtamista ei voi ajastaa.',
    ...val),

  LN7R: (en: string, ...val: string[]) => translate(en,
    'Käyttäjä on lähettänyt lunastuspyynnön laitteesta',
    ...val),

  LNHO: (en: string, ...val: string[]) => translate(en,
    '{0} viite- sekä kustannuspaikka tiedot päivittyvät automaattisesti uuden henkilön tietojen mukaan. Tarkastathan {1} laskutustiedot tarvittaessa.',
    ...val),

  LNZ8: (en: string, ...val: string[]) => translate(en,
    'Ymmärrän, että viestit näkyvät kaikille yritykseni OmaElisa-käyttäjille.',
    ...val),

  LO5I: (en: string, ...val: string[]) => translate(en,
    'Liittymä ei ole liitetty yrityksesi Ring-ratkaisuun',
    ...val),

  LO9Y: (en: string, ...val: string[]) => translate(en,
    'Keskustele kanssamme',
    ...val),

  LOUS: (en: string, ...val: string[]) => translate(en,
    'Yritysten OmaElisa',
    ...val),

  LOV4: (en: string, ...val: string[]) => translate(en,
    'Virhe ladattaessa: {}',
    ...val),

  LQ3X: (en: string, ...val: string[]) => translate(en,
    'Kirjaudu ulos',
    ...val),

  LQ5X: (en: string, ...val: string[]) => translate(en,
    'Tuotetyypit',
    ...val),

  LQ6I: (en: string, ...val: string[]) => translate(en,
    'Päättyy',
    ...val),

  LR7P: (en: string, ...val: string[]) => translate(en,
    'Otettu uudelleen käsittelyyn',
    ...val),

  LRAQ: (en: string, ...val: string[]) => translate(en,
    'norm.',
    ...val),

  LROP: (en: string, ...val: string[]) => translate(en,
    'Liittymän tila',
    ...val),

  LRZV: (en: string, ...val: string[]) => translate(en,
    'Sisältää laitteen',
    ...val),

  LSQ3: (en: string, ...val: string[]) => translate(en,
    'Tällä laskutusopimuksella on ajastettu muutospyyntö',
    ...val),

  LSWI: (en: string, ...val: string[]) => translate(en,
    'Nettiliittymä pieneen toimistoon tai etätyöhön',
    ...val),

  LSWJ: (en: string, ...val: string[]) => translate(en,
    'Helppo ja turvallinen nettiratkaisu',
    ...val),

  LSZS: (en: string, ...val: string[]) => translate(en,
    'Kutsun lähetys onnistui.',
    ...val),

  LT6X: (en: string, ...val: string[]) => translate(en,
    'Kirjoita kommenttisi tähän..',
    ...val),

  LTEZ: (en: string, ...val: string[]) => translate(en,
    'Ota yhteyttä tilaajayhteyshenkilöön',
    ...val),

  LTQW: (en: string, ...val: string[]) => translate(en,
    'Yksi tai useampi vaadituista yhteyshenkilöistä on passiivinen. Valitse aktiivinen yhteyshenkilö(t) jatkaaksesi.',
    ...val),

  LUAI: (en: string, ...val: string[]) => translate(en,
    'Liian suuri tiedostokoko {} MB',
    ...val),

  LUCJ: (en: string, ...val: string[]) => translate(en,
    'Asennuspalvelu',
    ...val),

  LUFX: (en: string, ...val: string[]) => translate(en,
    'Liittymän aktivointi kesken',
    ...val),

  LUOE: (en: string, ...val: string[]) => translate(en,
    'Haluatko lunastaa vai palauttaa vanhan laitteesi?',
    ...val),

  LUZM: (en: string, ...val: string[]) => translate(en,
    'Käyttäjä',
    ...val),

  LVJT: (en: string, ...val: string[]) => translate(en,
    'Kun puhelinnumero luovutetaan liittymän käyttäjälle, on ensimmäinen mahdollinen irtisanomispäivä viikon kuluttua nykyhetkestä',
    ...val),

  LVRN: (en: string, ...val: string[]) => translate(en,
    'Viite',
    ...val),

  LVRQ: (en: string, ...val: string[]) => translate(en,
    'Valitse alta toimitusosoite johon toimitamme palautuspussin. Tuhoutunut laite tulee palauttaa Elisalle viikon kuluessa.',
    ...val),

  LW2K: (en: string, ...val: string[]) => translate(en,
    'Hups… järjestelmässä tapahtui virhe',
    ...val),

  LW7P: (en: string, ...val: string[]) => translate(en,
    'Voit vaihtaa salasanasi avaamalla salasanan hallintasivun alla olevasta painikkeesta.',
    ...val),

  LXFL: (en: string, ...val: string[]) => translate(en,
    'Yritys, johon käyttäjä siirretään',
    ...val),

  LXSR: (en: string, ...val: string[]) => translate(en,
    'Lisäpalvelut',
    ...val),

  LYDG: (en: string, ...val: string[]) => translate(en,
    'Käyttäjän siirto toiseen yritykseen epäonnistui',
    ...val),

  LYF6: (en: string, ...val: string[]) => translate(en,
    'Työntekijän osuus',
    ...val),

  LYSP: (en: string, ...val: string[]) => translate(en,
    'Palvelumuutokset',
    ...val),

  LYW5: (en: string, ...val: string[]) => translate(en,
    'Liittymän väliaikainen sulku',
    ...val),

  LYWB: (en: string, ...val: string[]) => translate(en,
    '(*Pakolliset tiedot)',
    ...val),

  LZMG: (en: string, ...val: string[]) => translate(en,
    'Muuta laskutustapaa',
    ...val),

  LZT3: (en: string, ...val: string[]) => translate(en,
    'Liittymän aktivointi on kesken, jonka aikana et voi tehdä muita muutoksia liittymälle.',
    ...val),

  M03S: (en: string, ...val: string[]) => translate(en,
    'Kyllä',
    ...val),

  M09Z: (en: string, ...val: string[]) => translate(en,
    '{} Gt',
    ...val),

  M0RI: (en: string, ...val: string[]) => translate(en,
    'Lisenssien hallintaportaalissa voit hallinnoida yrityksesi M365, Dynamics 365, Elisa 365 Varmistuspalvelun ja Turvapostin tilauksia.',
    ...val),

  M0TS: (en: string, ...val: string[]) => translate(en,
    'Liitä vakioon',
    ...val),

  M0U2: (en: string, ...val: string[]) => translate(en,
    'Kutsu vanhentunut',
    ...val),

  M0W7: (en: string, ...val: string[]) => translate(en,
    'Määrä',
    ...val),

  M16N: (en: string, ...val: string[]) => translate(en,
    'Kutsu lähetettiin onnistuneesti',
    ...val),

  M16R: (en: string, ...val: string[]) => translate(en,
    'Olet vaihtamassa sopijayritystä. Laskutussopimus on päivitettävä uuden sopijayrityksen mukaan.',
    ...val),

  M1E7: (en: string, ...val: string[]) => translate(en,
    'Aktivoi SIM-kortti',
    ...val),

  M1N1: (en: string, ...val: string[]) => translate(en,
    'Oma Laitelasku',
    ...val),

  M1RK: (en: string, ...val: string[]) => translate(en,
    'Jos käyttäjällä on Oma Elisa Classicissa hallittavia tuotteita, kyseiset tuotteet on siirrettävä erikseen',
    ...val),

  M1TW: (en: string, ...val: string[]) => translate(en,
    'Irtisano liittymä',
    ...val),

  M248: (en: string, ...val: string[]) => translate(en,
    'Voit antaa useamman sähköpostisoitteen kerralla tai liittää esim. sähköpostiosoitteet (max.500) sisältävän',
    ...val),

  M2FC: (en: string, ...val: string[]) => translate(en,
    'Käyttäjän poistaminen epäonnistui',
    ...val),

  M39B: (en: string, ...val: string[]) => translate(en,
    'Aito 5G kuluttaa laitteesi akkua jopa 20 % vähemmän tavalliseen 4G- tai 5G-liittymään verrattuna',
    ...val),

  M3GT: (en: string, ...val: string[]) => translate(en,
    'Yritysliittymiimme on saatavilla myös monia yrityksen arkea sujuvoittavia palveluita:',
    ...val),

  M3ZW: (en: string, ...val: string[]) => translate(en,
    'Antamaasi puhelinnumeroa tai sähköpostia ei voida päivittää',
    ...val),

  M41V: (en: string, ...val: string[]) => translate(en,
    'Jatkokausi',
    ...val),

  M4JY: (en: string, ...val: string[]) => translate(en,
    'Rajaton netti kotimaassa, Pohjolassa ja Baltiassa',
    ...val),

  M4P9: (en: string, ...val: string[]) => translate(en,
    'Hoida liittymä- ja laskutusasiat nopeasti silloin kun se sinulle sopii. Voit esimerkiksi seurata laskujesi tilannetta ja tarkistaa PUK-koodin veloituksetta.',
    ...val),

  M57F: (en: string, ...val: string[]) => translate(en,
    'Kiitos!',
    ...val),

  M59G: (en: string, ...val: string[]) => translate(en,
    'Liittymän avaamisessa tapahtui virhe',
    ...val),

  M64T: (en: string, ...val: string[]) => translate(en,
    'Elisa Yritystietoturvan tietojen palautus',
    ...val),

  M6CL: (en: string, ...val: string[]) => translate(en,
    'Netti plus ja Netti pro',
    ...val),

  M6TP: (en: string, ...val: string[]) => translate(en,
    'Listan nimi',
    ...val),

  M6V5: (en: string, ...val: string[]) => translate(en,
    'Sopimus on voimassa toistaiseksi',
    ...val),

  M76W: (en: string, ...val: string[]) => translate(en,
    'Kirjaudu Elisa Tunnuksella',
    ...val),

  M8C7: (en: string, ...val: string[]) => translate(en,
    'Ei tekstiviestipakettia',
    ...val),

  M9H0: (en: string, ...val: string[]) => translate(en,
    'Liittymän ja käyttäjän tiedot',
    ...val),

  M9HN: (en: string, ...val: string[]) => translate(en,
    'Muutoksen voimaantulo',
    ...val),

  M9Y9: (en: string, ...val: string[]) => translate(en,
    'Ota e-lasku käyttöön omassa verkkopankissasi.',
    ...val),

  MA8D: (en: string, ...val: string[]) => translate(en,
    'Halvin ensin',
    ...val),

  MADI: (en: string, ...val: string[]) => translate(en,
    'Reilusti verkkokaupan varastossa',
    ...val),

  MAYV: (en: string, ...val: string[]) => translate(en,
    'KelloSIM-palvelun hallinnointi ei ole mahdollista puhelimesta.',
    ...val),

  MB11: (en: string, ...val: string[]) => translate(en,
    'Huomiothan, että sopimuksen päättäminen on sitova eikä muutos ole peruttavissa.',
    ...val),

  MB13: (en: string, ...val: string[]) => translate(en,
    '80-alkuiset viitenumerolaskut',
    ...val),

  MBG9: (en: string, ...val: string[]) => translate(en,
    'Palvelut',
    ...val),

  MBNB: (en: string, ...val: string[]) => translate(en,
    'Näytössä naarmuja tai kulumaa',
    ...val),

  MBUX: (en: string, ...val: string[]) => translate(en,
    'Täytä käyttötarkoitus',
    ...val),

  MBXP: (en: string, ...val: string[]) => translate(en,
    'Ohjeet Elisa Mobiilivarmenteesta yrityksille ja työntekijöille',
    ...val),

  MC5L: (en: string, ...val: string[]) => translate(en,
    'eSIMiä tukevat laitteet',
    ...val),

  MCW3: (en: string, ...val: string[]) => translate(en,
    'Tietokoneet',
    ...val),

  MD77: (en: string, ...val: string[]) => translate(en,
    'Jatkossa kirjaudut Yritysten OmaElisaan Elisa Tunnuksella',
    ...val),

  MDFW: (en: string, ...val: string[]) => translate(en,
    'Laitevalikoimaan valitut laitteet',
    ...val),

  ME73: (en: string, ...val: string[]) => translate(en,
    'Tämä henkilö on paikalla asennuskohteessa.',
    ...val),

  MEIL: (en: string, ...val: string[]) => translate(en,
    'Poista käyttäjä',
    ...val),

  MEMF: (en: string, ...val: string[]) => translate(en,
    'Vahvistamme irtisanomisen sähköpostitse. Huomioithan, että tulet saamaan loppulaskun irtisanotusta palvelusta, mikäli käyttö- tai kuukausimaskuja on vielä laskuttamatta.',
    ...val),

  MF9P: (en: string, ...val: string[]) => translate(en,
    'eSIM on kuin perinteinen SIM-kortti, mutta täysin sähköinen. Tällä hetkellä eSIM on saatavilla uusimmille iPhone-puhelimille, iPad-tableteille ja Samsung Galaxy Watch -kelloille.',
    ...val),

  MFED: (en: string, ...val: string[]) => translate(en,
    'Omaguru auttaa teknisissä ongelmissa',
    ...val),

  MGJQ: (en: string, ...val: string[]) => translate(en,
    'Katso alustava arvio hyvityksen suuruudesta.',
    ...val),

  MGPN: (en: string, ...val: string[]) => translate(en,
    'Vahvista laitteen lunastaminen yritykselle',
    ...val),

  MGWG: (en: string, ...val: string[]) => translate(en,
    'Liittymän päivitys',
    ...val),

  MH00: (en: string, ...val: string[]) => translate(en,
    '4K-videot ja pilvipalvelut',
    ...val),

  MH8K: (en: string, ...val: string[]) => translate(en,
    'Lunastushinta',
    ...val),

  MI9J: (en: string, ...val: string[]) => translate(en,
    'tunnukset',
    ...val),

  MIFJ: (en: string, ...val: string[]) => translate(en,
    'Minun tietoni',
    ...val),

  MIL5: (en: string, ...val: string[]) => translate(en,
    'Siirry palvelun tietoihin',
    ...val),

  MIQC: (en: string, ...val: string[]) => translate(en,
    'Vastausryhmä',
    ...val),

  MJ63: (en: string, ...val: string[]) => translate(en,
    'Tällä laskutussopimuksella on ajastettu muutospyyntö, joten muokkaus ei ole mahdollista. Voit poistaa muutospyynnön tai ajastaa sen uudestaan.',
    ...val),

  MKML: (en: string, ...val: string[]) => translate(en,
    'Matkapuhelinvastaaja, Mobiiliturva, Reissunetti 2 Gt',
    ...val),

  ML58: (en: string, ...val: string[]) => translate(en,
    'Laitteen kertamaksu',
    ...val),

  MLUL: (en: string, ...val: string[]) => translate(en,
    'Lähetä vahvistuslinkki',
    ...val),

  MM8Z: (en: string, ...val: string[]) => translate(en,
    'Aktiivinen tila',
    ...val),

  MMA5: (en: string, ...val: string[]) => translate(en,
    'painike lisäämällä oikea laskutussopimus',
    ...val),

  MMUE: (en: string, ...val: string[]) => translate(en,
    'asiakaspalveluumme',
    ...val),

  MN35: (en: string, ...val: string[]) => translate(en,
    'Irtisanominen',
    ...val),

  MN4H: (en: string, ...val: string[]) => translate(en,
    'Vanha kustannuspaikka',
    ...val),

  MNEQ: (en: string, ...val: string[]) => translate(en,
    'Liitä laitteet laiterekisteröintiohjelmaan',
    ...val),

  MNN3: (en: string, ...val: string[]) => translate(en,
    'Luovutettava liittymä',
    ...val),

  MNYU: (en: string, ...val: string[]) => translate(en,
    'Tarjouksen',
    ...val),

  MOAZ: (en: string, ...val: string[]) => translate(en,
    'Olet poistamassa alla olevan tietueen. Tätä toimenpidettä ei ole mahdollista perua. Haluatko varmasti poistaa tietueen?',
    ...val),

  MOF8: (en: string, ...val: string[]) => translate(en,
    'Tilauksen käsittely ei onnistunut. Soita asiakaspalveluumme {0} niin saat asian hoidettua. Asiakaspalvelumme auttaa {1}. Puhelun hinta on {2}.',
    ...val),

  MOR3: (en: string, ...val: string[]) => translate(en,
    'Hyväksy sopimusehdot',
    ...val),

  MOWN: (en: string, ...val: string[]) => translate(en,
    'Ei agentteja paikalla',
    ...val),

  MOYY: (en: string, ...val: string[]) => translate(en,
    'Aloita chat',
    ...val),

  MPA5: (en: string, ...val: string[]) => translate(en,
    'Y-tunnus',
    ...val),

  MPFC: (en: string, ...val: string[]) => translate(en,
    'Uusi laitelista',
    ...val),

  MPKA: (en: string, ...val: string[]) => translate(en,
    'Tilauksesi lähetetään vasta, kun kaikkia tuotteita on saatavilla varastossa.',
    ...val),

  MQ9Q: (en: string, ...val: string[]) => translate(en,
    'Ole hyvä ja odota hetki.',
    ...val),

  MQHO: (en: string, ...val: string[]) => translate(en,
    'Liittymälle on tilattu muutos, jonka aikana et voi tehdä muita muutoksia liittymälle.',
    ...val),

  MQQC: (en: string, ...val: string[]) => translate(en,
    'Huomaathan, että laskun tila päivittyy n. 3 arkipäivän aikana, joten maksettu lasku voi näkyä hetken avoimena. Myöhässä maksetusta laskusta ei tarvitse ilmoittaa asiakaspalveluumme.',
    ...val),

  MRD6: (en: string, ...val: string[]) => translate(en,
    'Soita numeroon *100#, niin saat tietää liittymäsi saldotilanteen. Saat paluuviestinä tiedot datan kulutuksestasi ulkomailla. Palvelu on maksuton. ',
    ...val),

  MRG5: (en: string, ...val: string[]) => translate(en,
    'Uusi kustannuspaikka',
    ...val),

  MRGG: (en: string, ...val: string[]) => translate(en,
    'Huomaathan, että xlsx-tiedostomuoto ei kelpaa.',
    ...val),

  MS5F: (en: string, ...val: string[]) => translate(en,
    'määräaikainen',
    ...val),

  MSD6: (en: string, ...val: string[]) => translate(en,
    'Huomioithan, että käyttäjällä, jota olet poistamassa on pääkäyttäjäoikeudet Yritysten OmaElisaan. Poistamisen jälkeen häneltä poistuu myös pääkäyttäjäoikeudet.',
    ...val),

  MSV2: (en: string, ...val: string[]) => translate(en,
    'Valittu yhteensä',
    ...val),

  MTK8: (en: string, ...val: string[]) => translate(en,
    'Jätä tarvittaessa lisätietoja (valinnainen)',
    ...val),

  MTNX: (en: string, ...val: string[]) => translate(en,
    'Käsittelemme irtisanomispyyntösi mahdollisimman pian. Saat vahvistuksen sähköpostilla, kun palvelu on irtisanottu.',
    ...val),

  MU1K: (en: string, ...val: string[]) => translate(en,
    'WiFi-yhteys',
    ...val),

  MUEL: (en: string, ...val: string[]) => translate(en,
    'Haluatko varmasti poistaa laitevalikoiman {0}?',
    ...val),

  MUF5: (en: string, ...val: string[]) => translate(en,
    'Ei käytössä',
    ...val),

  MV0P: (en: string, ...val: string[]) => translate(en,
    'Videopuhelut ja sujuvat pilvipalvelut',
    ...val),

  MV3J: (en: string, ...val: string[]) => translate(en,
    'Microsoft 365',
    ...val),

  MVTD: (en: string, ...val: string[]) => translate(en,
    'Rajaton',
    ...val),

  MW58: (en: string, ...val: string[]) => translate(en,
    'Vastaajan ollessa varattu',
    ...val),

  MWSW: (en: string, ...val: string[]) => translate(en,
    'Puhelut ja viestit asiointipalvelunumeroihin, kuten lahjoitukset hyväntekeväisyyteen, tavaroiden ja palveluiden maksaminen puheluilla tai tekstiviesteillä',
    ...val),

  MX5U: (en: string, ...val: string[]) => translate(en,
    'Katuosoite ja numero',
    ...val),

  MXPB: (en: string, ...val: string[]) => translate(en,
    'Pelkkä SIM-kortti',
    ...val),

  MXR5: (en: string, ...val: string[]) => translate(en,
    'Tekstiviestit',
    ...val),

  MYQX: (en: string, ...val: string[]) => translate(en,
    'Liittymälläsi on Elisa MultiSIM-palvelu, joka estää palvelun käyttöönoton.',
    ...val),

  MYT5: (en: string, ...val: string[]) => translate(en,
    'Löydät SIM-kortin numeron SIM-kortista.',
    ...val),

  MYX7: (en: string, ...val: string[]) => translate(en,
    'Täytä nykyinen puhelinnumero',
    ...val),

  MYX8: (en: string, ...val: string[]) => translate(en,
    'Täytä sähköpostiosoite',
    ...val),

  MYX9: (en: string, ...val: string[]) => translate(en,
    'Valitse päivä',
    ...val),

  MZ1U: (en: string, ...val: string[]) => translate(en,
    'Valitse noutopiste',
    ...val),

  MZ5C: (en: string, ...val: string[]) => translate(en,
    'Estää tekstiviestit ja mobiilimaksut esim. aikataulu- ja tiedotuspalveluihin sekä pankkipalveluihin. Estää myös taksin tilaamisen. Sisältää eston viihde-, ajanviete- ja asiointinumeroihin.',
    ...val),

  MZS3: (en: string, ...val: string[]) => translate(en,
    'Uusi laskutussopimus',
    ...val),

  N04E: (en: string, ...val: string[]) => translate(en,
    'Lankaliittymät',
    ...val),

  N0UD: (en: string, ...val: string[]) => translate(en,
    'Löydetty käyttäjä',
    ...val),

  N11H: (en: string, ...val: string[]) => translate(en,
    'Tarvitsetko apua?',
    ...val),

  N1J1: (en: string, ...val: string[]) => translate(en,
    'Irroita ensin kameran linssien päälle mahdollisesti asetettu suojalasi, tarkista onko linssi rikki myös sen alla tai jatkuuko ongelmat kameran kanssa.',
    ...val),

  N1QP: (en: string, ...val: string[]) => translate(en,
    'Elisan Aito 5G takaa vakaammat yhteydet ja pidemmän akunkeston – Elisan yritysliittymällä kaikki vaan toimii paremmin! Kätevät lisäpalvelumme tekevät arjestasi turvallisempaa ja tehokkaampaa.',
    ...val),

  N1WI: (en: string, ...val: string[]) => translate(en,
    'Lähetetään',
    ...val),

  N1X2: (en: string, ...val: string[]) => translate(en,
    'Elisa Kuka Soittaa yrityksille tai',
    ...val),

  N1X3: (en: string, ...val: string[]) => translate(en,
    'Nopeuden nosto {} Mbit/s \u2192 {} Mbit/s',
    ...val),

  N1X4: (en: string, ...val: string[]) => translate(en,
    'Liittymän hintaan sisältyy yksi valitsemasi lisäominaisuus',
    ...val),

  N1X5: (en: string, ...val: string[]) => translate(en,
    'Valitse yksi lisäominaisuus',
    ...val),

  N1X6: (en: string, ...val: string[]) => translate(en,
    'Paras mahdollinen yhteys vaativaankin käyttöön. Suurten tiedostojen huippunopeaan siirtoon.',
    ...val),

  N1X8: (en: string, ...val: string[]) => translate(en,
    'Suurten tiedostojen siirtoon, videopalavereihin ja tehokkaaseen pilvipalveluiden käyttöön.',
    ...val),

  N1Y1: (en: string, ...val: string[]) => translate(en,
    'Kevyeen netinkäyttöön, kuten viestittelyyn ja sähköpostien lukemiseen. Sopii esimerkiksi toimiston yhteiskäyttöpuhelimeen.',
    ...val),

  N1Y2: (en: string, ...val: string[]) => translate(en,
    'Puhelut käytön mukaan',
    ...val),

  N1Y3: (en: string, ...val: string[]) => translate(en,
    'Kevyeen arkikäyttöön, surffailuun ja viestittelyyn.',
    ...val),

  N1Y4: (en: string, ...val: string[]) => translate(en,
    'Tekstiviestit käytön mukaan',
    ...val),

  N1Y5: (en: string, ...val: string[]) => translate(en,
    'Puheaika {} min',
    ...val),

  N1Y6: (en: string, ...val: string[]) => translate(en,
    'Puheaika',
    ...val),

  N1Y7: (en: string, ...val: string[]) => translate(en,
    'Paketin ylittävät puhelut sekä puhelut lankanumeroihin 0,199 €/min tai kpl. Liittymään on saatavilla isompi puhepaketti lisämaksusta tilauksen yhteydessä.',
    ...val),

  N1Y8: (en: string, ...val: string[]) => translate(en,
    'Tekstiviestit {} kpl',
    ...val),

  N1Y9: (en: string, ...val: string[]) => translate(en,
    'Kotimaan normaalihintaiset tekstiviestit 0,199 €/kpl. Liittymään on saatavilla isompi tekstiviestipaketti lisämaksusta tilauksen yhteydessä.',
    ...val),

  N1Z1: (en: string, ...val: string[]) => translate(en,
    'Huolettomaan peruskäyttöön, surffailuun ja videopalavereihin.',
    ...val),

  N1Z2: (en: string, ...val: string[]) => translate(en,
    'Tekstiviestillä aktivoituva Reissunetti-palvelu. Kun matkaat Reissunetti-maissa, saat tilaustekstiviestin automaattisesti. Datapaketin hinta 20,90 €/tilaus.',
    ...val),

  N1Z3: (en: string, ...val: string[]) => translate(en,
    'Liittymän sisältö',
    ...val),

  N1Z4: (en: string, ...val: string[]) => translate(en,
    'Palvelu näyttää automaattisesti soittajan nimitiedon, vaikka sitä ei olisi tallennettuna osoitekirjaasi, ja ilman erillistä sovellusta. Nimitiedot haetaan luettelotietokannoista.',
    ...val),

  N1Z5: (en: string, ...val: string[]) => translate(en,
    'Lue lisää Kuka Soittaa -palvelusta.',
    ...val),

  N1Z6: (en: string, ...val: string[]) => translate(en,
    'Elisa Mobiilivarmenne',
    ...val),

  N1Z7: (en: string, ...val: string[]) => translate(en,
    'Elisa Mobiilivarmenne tarjoaa turvallisen tunnistautumisen digitaalisiin palveluihin Mobiilivarmenteen rekisteröinti yritysliittymiin on maksuton eikä sisällä kuukausikuluja.',
    ...val),

  N1Z8: (en: string, ...val: string[]) => translate(en,
    'Kotimaan normaalihintaiset puhelut, puhelut lankanumeroihin ja tekstiviestit 0,199 €/min tai kpl.',
    ...val),

  N1Z9: (en: string, ...val: string[]) => translate(en,
    'Puhe käytön mukaan',
    ...val),

  N2A1: (en: string, ...val: string[]) => translate(en,
    'Kotimaassa',
    ...val),

  N2A2: (en: string, ...val: string[]) => translate(en,
    'Tämä liittymä toimii vain kotimaassa. Valitse toinen liittymätyyppi, mikäli tarvitset liittymäa myös ulkomailla.',
    ...val),

  N2A3: (en: string, ...val: string[]) => translate(en,
    'Liittymään sisältyvät palvelut',
    ...val),

  N2A4: (en: string, ...val: string[]) => translate(en,
    'Sisältyvät palvelut',
    ...val),

  N2A5: (en: string, ...val: string[]) => translate(en,
    'Paketin ylittävät puhelut ja tekstiviestit sekä puhelut lankanumeroihin 0,199 €/min tai kpl.',
    ...val),

  N2A6: (en: string, ...val: string[]) => translate(en,
    'Elisan Mobiliturva yrityksille on uudenlainen tietoturvapalvelu mobiililiittymään. Palvelu tunnistaa haitalliset sivustot ja tuo digiturvaa käyttäessäsi mobililiittymää.',
    ...val),

  N2A7: (en: string, ...val: string[]) => translate(en,
    'Sujuvaan arkikäyttöön, surffailuun ja sähköposteihin.',
    ...val),

  N2CC: (en: string, ...val: string[]) => translate(en,
    'Laitteen huoltopyyntö',
    ...val),

  N2OE: (en: string, ...val: string[]) => translate(en,
    'Pääkäyttäjä saa F-Securelta sähköpostitse uudet kirjautumistunnukset, joilla hän voi kirjautua takaisin sisään.',
    ...val),

  N2RK: (en: string, ...val: string[]) => translate(en,
    'Ajasta uudelleen',
    ...val),

  N31T: (en: string, ...val: string[]) => translate(en,
    'Kuukausikohtainen erittely',
    ...val),

  N3A8: (en: string, ...val: string[]) => translate(en,
    'Ole hyvä ja valitse noutopiste.',
    ...val),

  N3V5: (en: string, ...val: string[]) => translate(en,
    'Voi harmi',
    ...val),

  N3XM: (en: string, ...val: string[]) => translate(en,
    'Sinun ei tarvitse muistaa tunnuksia ja salasanoja, vaan voit kirjautua myös helposti Mobiilivarmenteella tai pankkitunnuksilla',
    ...val),

  N3YX: (en: string, ...val: string[]) => translate(en,
    'lunastushinta',
    ...val),

  N41Q: (en: string, ...val: string[]) => translate(en,
    '+ Lisää uusi',
    ...val),

  N4DE: (en: string, ...val: string[]) => translate(en,
    'Ei avoimia laskuja',
    ...val),

  N4LE: (en: string, ...val: string[]) => translate(en,
    'Ajastettu muutos',
    ...val),

  N4QO: (en: string, ...val: string[]) => translate(en,
    'Valitse uusi laite palautettavan laitteen tilalle',
    ...val),

  N4TR: (en: string, ...val: string[]) => translate(en,
    'Katso puhelintuen numero ja missä asioissa voit hyödyntää puhelintukea',
    ...val),

  N4VX: (en: string, ...val: string[]) => translate(en,
    'Käytössä oleva tavoitettavuusketju',
    ...val),

  N5AF: (en: string, ...val: string[]) => translate(en,
    'Saanko hyvitystä myös naarmuisesta tai viallisesta laitteesta?',
    ...val),

  N689: (en: string, ...val: string[]) => translate(en,
    'Lisenssien hallinta',
    ...val),

  N68W: (en: string, ...val: string[]) => translate(en,
    'Listahinta',
    ...val),

  N69Y: (en: string, ...val: string[]) => translate(en,
    'Elisa Palvelupäätelaitesopimuksen päättyminen',
    ...val),

  N6BZ: (en: string, ...val: string[]) => translate(en,
    'Käynnistä laitteesi kortin aktivoinnin jälkeen uudelleen. Uuden SIM-kortin PIN-koodi on aluksi 1234. SIM-kortin vaihdosta veloitetaan {} (alv. 0 %). Vanha korttisi lakkaa toimimasta aktivoinnin jälkeen.',
    ...val),

  N6FA: (en: string, ...val: string[]) => translate(en,
    'Liittymältä poistuu lisäpalveluita',
    ...val),

  N6FO: (en: string, ...val: string[]) => translate(en,
    'Asennuksen yhteyshenkilö ',
    ...val),

  N7W5: (en: string, ...val: string[]) => translate(en,
    'Laskutussopimus on irtisanottu, joten sen tietoja ei voi enää muokata.',
    ...val),

  N7WM: (en: string, ...val: string[]) => translate(en,
    'Aina reilu hyvitys vanhasta laitteestasi',
    ...val),

  N834: (en: string, ...val: string[]) => translate(en,
    '{0} = Erittäin helppoa',
    ...val),

  N86G: (en: string, ...val: string[]) => translate(en,
    'Myyntiyhteyshenkilö',
    ...val),

  N88P: (en: string, ...val: string[]) => translate(en,
    'Lunastushinta käyttäjälle',
    ...val),

  N894: (en: string, ...val: string[]) => translate(en,
    'Voit silti vahvistaa tilauksen, jolloin liittymälle valikoituu seuraava vapaana oleva puhelinnumero. Mikäli haluat valita puhelinnumeron itse, aloita tilaus alusta.',
    ...val),

  N8JO: (en: string, ...val: string[]) => translate(en,
    'Tai jättää yhteydenottopyynnön yritysasiakasmyynnille',
    ...val),

  N8T5: (en: string, ...val: string[]) => translate(en,
    'Elisa Mobiilivarmenne Työntekijälle -palvelulla tarjoat työntekijöillesi [Elisa Mobiilivarmenteen], joka on vahva sähköinen tunnistautumisväline. Elisa Mobiilivarmenteella työntekijäsi pääsevät asioimaan sähköisissä palveluissa turvallisesti ja vaivattomasti. Mobiilivarmenne kuuluu puhelinedun piiriin, joten voit tarjota sen työntekijöillesi työsuhde-etuna.',
    ...val),

  N9Q3: (en: string, ...val: string[]) => translate(en,
    'Jätä yhteydenottopyyntö meille, otamme sinuun yhteyttä vaihtotarjouksen ja lisäohjeiden kanssa.',
    ...val),

  NAKQ: (en: string, ...val: string[]) => translate(en,
    '(entinen Saunalahden yritysasiakas)',
    ...val),

  NALH: (en: string, ...val: string[]) => translate(en,
    'Laskutussopimusta muokattu',
    ...val),

  NBNH: (en: string, ...val: string[]) => translate(en,
    'Sisältö',
    ...val),

  NBTN: (en: string, ...val: string[]) => translate(en,
    'Vahvista laitelistan poisto',
    ...val),

  NC0D: (en: string, ...val: string[]) => translate(en,
    'Avoimet tilaukset',
    ...val),

  NC59: (en: string, ...val: string[]) => translate(en,
    'Muokkaa laitelistaa',
    ...val),

  NC66: (en: string, ...val: string[]) => translate(en,
    'Lataa toimivalla laturilla vähintään 30 minuuttia, jonka jälkeen kokeile käynnistää se uudelleen. Joskus akun lataustaso pääsee niin alas, että lataus käynnistyy viiveellä.',
    ...val),

  NC6Y: (en: string, ...val: string[]) => translate(en,
    'Hylkää lunastuspyyntö',
    ...val),

  NC8H: (en: string, ...val: string[]) => translate(en,
    'Tallennetaan',
    ...val),

  NCDC: (en: string, ...val: string[]) => translate(en,
    'Samalla tunnuksella voit jatkossa kirjautua myös muihin Elisan palveluihin',
    ...val),

  NCIJ: (en: string, ...val: string[]) => translate(en,
    '+ Uusi laskutussopimus',
    ...val),

  NCME: (en: string, ...val: string[]) => translate(en,
    'Lue lisää palveluista',
    ...val),

  ND8W: (en: string, ...val: string[]) => translate(en,
    'Lue lisää yleisistä sopimusehdoista',
    ...val),

  NDAK: (en: string, ...val: string[]) => translate(en,
    'Täytä laitteesi tiedot, saat hinta-arvion',
    ...val),

  NDIM: (en: string, ...val: string[]) => translate(en,
    'Puhelimen käyttö (verkkovierailut ulkomailla)',
    ...val),

  NDRY: (en: string, ...val: string[]) => translate(en,
    'Valitse muutoksen voimaantulopäivä',
    ...val),

  NDWK: (en: string, ...val: string[]) => translate(en,
    'Postiosoite',
    ...val),

  NDXP: (en: string, ...val: string[]) => translate(en,
    'Yleinen vanhemmissa rakennuksissa ja lyhyen matkan yhteyksiss. Kytt useita valon aallonpituuksia.',
    ...val),

  NE0O: (en: string, ...val: string[]) => translate(en,
    'Käyttäjää tai käyttötarkoitusta ei asetettu',
    ...val),

  NENG: (en: string, ...val: string[]) => translate(en,
    'Lisää liittymä Ringiin',
    ...val),

  NERD: (en: string, ...val: string[]) => translate(en,
    'Valintasi vaikuttaa vain siihen, minkä yrityksen käyttäjälistalla tietosi näkyvät. Pääset hallinnoimaan yrityksiä käyttöoikeuksiesi mukaisesti.',
    ...val),

  NET2: (en: string, ...val: string[]) => translate(en,
    'Tarkasta PUK-koodit liittymän tiedoista',
    ...val),

  NF60: (en: string, ...val: string[]) => translate(en,
    'Tilaajan yhteystiedot',
    ...val),

  NF7W: (en: string, ...val: string[]) => translate(en,
    'Täydennä yrityksen tiedot',
    ...val),

  NFGH: (en: string, ...val: string[]) => translate(en,
    'laitevalikoimasta',
    ...val),

  NFRH: (en: string, ...val: string[]) => translate(en,
    '(ei pakollinen)',
    ...val),

  NFXG: (en: string, ...val: string[]) => translate(en,
    'Taatusti kotimainen',
    ...val),

  NG7X: (en: string, ...val: string[]) => translate(en,
    'Palauta',
    ...val),

  NG9B: (en: string, ...val: string[]) => translate(en,
    'Soittoaika',
    ...val),

  NH45: (en: string, ...val: string[]) => translate(en,
    'Ei verkkovierailun käyttöä!',
    ...val),

  NH72: (en: string, ...val: string[]) => translate(en,
    'Salasana on virheellinen.',
    ...val),

  NH88: (en: string, ...val: string[]) => translate(en,
    'Tietueen muokkaus kesken',
    ...val),

  NHMG: (en: string, ...val: string[]) => translate(en,
    'Laskun maksu keskeytyi, sinua ei veloitettu.',
    ...val),

  NI34: (en: string, ...val: string[]) => translate(en,
    'Syötä alennuskoodi',
    ...val),

  NI69: (en: string, ...val: string[]) => translate(en,
    'OmaElisa Henkilöasiakkaille',
    ...val),

  NID5: (en: string, ...val: string[]) => translate(en,
    'Sähköpostiosoitteen vahvistaminen onnistui',
    ...val),

  NIDB: (en: string, ...val: string[]) => translate(en,
    'Vanha asennusosoite',
    ...val),

  NIHS: (en: string, ...val: string[]) => translate(en,
    'MIN',
    ...val),

  NIJZ: (en: string, ...val: string[]) => translate(en,
    'Vaihda sähköpostiosoite',
    ...val),

  NIMY: (en: string, ...val: string[]) => translate(en,
    'Laitteen toimitus',
    ...val),

  NIWE: (en: string, ...val: string[]) => translate(en,
    'Tallenna',
    ...val),

  NIY2: (en: string, ...val: string[]) => translate(en,
    'Tee nykyinen tilaus loppuun ja tilaa sen jälkeen tuotteet eri laitelistalta. Jos jatkat toiseen laitelistaan, ostoskorisi tyhjennetään automaattisesti.',
    ...val),

  NJHG: (en: string, ...val: string[]) => translate(en,
    'Lunastuspyynnön tiedot',
    ...val),

  NJLM: (en: string, ...val: string[]) => translate(en,
    'Tarkista sähköpostiosoite. Syötä osoite muodossa nimi@esimerkki.fi',
    ...val),

  NK9P: (en: string, ...val: string[]) => translate(en,
    'Käyttäjän voimassa olevat laitesopimukset',
    ...val),

  NKFF: (en: string, ...val: string[]) => translate(en,
    'Valitse yritysnumeron aktviivinen tila työajalla, työajan ulkopuolella tai ajastettu. Ajastetulla tilalla voit määrittää työajan voimassaoloajan, jolloin käytetään työajan vastaajia. Muina aikoina käytetään työajan ulkopuolisia vastaajia. Jos haluat käyttää työajan ulkopuolisia vastaajia koko viikonlopulle, aseta ajaksi 00:00 - 00:00.',
    ...val),

  NKJ8: (en: string, ...val: string[]) => translate(en,
    'Käyttäjä tai käyttötarkoitus',
    ...val),

  NKY1: (en: string, ...val: string[]) => translate(en,
    'Kirjoita kysymyksesi tai kuvaile ongelmasi...',
    ...val),

  NLB0: (en: string, ...val: string[]) => translate(en,
    'Tekstiviestien hinta 0,079 €/kpl Pohjolassa ja Baltiassa',
    ...val),

  NLGJ: (en: string, ...val: string[]) => translate(en,
    'Tilaa nettiliittymä',
    ...val),

  NM4G: (en: string, ...val: string[]) => translate(en,
    'Luettelotiedot',
    ...val),

  NMHZ: (en: string, ...val: string[]) => translate(en,
    'Epäonnistui',
    ...val),

  NMNN: (en: string, ...val: string[]) => translate(en,
    'Oma Laitelaskun tiedot',
    ...val),

  NMRJ: (en: string, ...val: string[]) => translate(en,
    'Valitettavasti järjestelmässämme tapahtui virhe. Yritä hetken kuluttua uudelleen. Mikäli ongelma jatkuu, ota yhteyttä asiakaspalveluumme. Pahoittelemme häiriötä.',
    ...val),

  NMXU: (en: string, ...val: string[]) => translate(en,
    'Tarkista verkkolaskuosoitteen muoto. Oikea muoto on 0037-, TE0037- tai FI-alkuinen. Verkkolaskuosoite voi sisältää kirjaimia A-Z ja numeroita 0-9.',
    ...val),

  NN5S: (en: string, ...val: string[]) => translate(en,
    'Ei saatavilla',
    ...val),

  NNV9: (en: string, ...val: string[]) => translate(en,
    'Sähköpostilasku',
    ...val),

  NO66: (en: string, ...val: string[]) => translate(en,
    'Alanumero',
    ...val),

  NOM4: (en: string, ...val: string[]) => translate(en,
    '2 viikon aikana',
    ...val),

  NP53: (en: string, ...val: string[]) => translate(en,
    'Laitteeni',
    ...val),

  NP6Z: (en: string, ...val: string[]) => translate(en,
    'Yritä uudelleen',
    ...val),

  NPBA: (en: string, ...val: string[]) => translate(en,
    'Max. {} merkkiä.',
    ...val),

  NPCK: (en: string, ...val: string[]) => translate(en,
    'Tukipyynnöt ja viestit',
    ...val),

  NPKT: (en: string, ...val: string[]) => translate(en,
    'Anna käyttäjätunnuksesi, niin autamme sinua salasanasi palauttamisessa. Haluatko vastaanottaa salasanan sähköpostiin tai matkapuhelimeen?',
    ...val),

  NPSZ: (en: string, ...val: string[]) => translate(en,
    'Avoimet tukipyynnöt:',
    ...val),

  NQ09: (en: string, ...val: string[]) => translate(en,
    'Yritysnumeron työajan mukaan (ajastettu)',
    ...val),

  NQYM: (en: string, ...val: string[]) => translate(en,
    'kuuluvuuskartasta',
    ...val),

  NRMH: (en: string, ...val: string[]) => translate(en,
    'tarkista vielä työyhteystietosi',
    ...val),

  NRPK: (en: string, ...val: string[]) => translate(en,
    'Kaipaatko apua liittymän valinnassa?',
    ...val),

  NRRT: (en: string, ...val: string[]) => translate(en,
    'Lähetä viesti asiakaspalveluun',
    ...val),

  NSLH: (en: string, ...val: string[]) => translate(en,
    'Sisältää vaihtopalvelun',
    ...val),

  NT3S: (en: string, ...val: string[]) => translate(en,
    'Katso liittymän lisätiedot',
    ...val),

  NTUU: (en: string, ...val: string[]) => translate(en,
    'Tuotetta ei voida toimittaa postilokeroon. Muuta osoitetta ja yritä uudelleen.',
    ...val),

  NUCX: (en: string, ...val: string[]) => translate(en,
    'Liittymän sisältö',
    ...val),

  NUFF: (en: string, ...val: string[]) => translate(en,
    'Käytä vain sähköpostia, joka sinulla on käytössä. Mikäli olet uusi työntekijä, eikä sinulla ole pääsyä vielä työsähköpostiisi, voit päivittää työsähköpostin myöhemmin.',
    ...val),

  NV0F: (en: string, ...val: string[]) => translate(en,
    'Tuote loppunut',
    ...val),

  NV83: (en: string, ...val: string[]) => translate(en,
    'Ulkomailta tulevien puheluiden alkuperä ja suomalaiset puhelinnumerot varmennetaan Elisan verkossa. Epäilyttävät huijaussoitot estetään, ja puhelu yhdistetään vain, jos numero on luotettava.',
    ...val),

  NVGB: (en: string, ...val: string[]) => translate(en,
    'Ei laskutussopimuksia',
    ...val),

  NVPK: (en: string, ...val: string[]) => translate(en,
    'Muokkaa',
    ...val),

  NVVN: (en: string, ...val: string[]) => translate(en,
    'laitelistan kopiointi ei onnistunut',
    ...val),

  NW12: (en: string, ...val: string[]) => translate(en,
    'Vahvista liittymä ja käyttäjätietojen linkitys uudelle työnantajalle',
    ...val),

  NWDY: (en: string, ...val: string[]) => translate(en,
    'Lisää listalle tarvittaessa uusia tuotteita.',
    ...val),

  NWKB: (en: string, ...val: string[]) => translate(en,
    'Tallennetaanko seuraavat muutokset?',
    ...val),

  NX0T: (en: string, ...val: string[]) => translate(en,
    'Kaikki palvelut',
    ...val),

  NXC5: (en: string, ...val: string[]) => translate(en,
    'Sujuvat videopuhelut ja pilvipalvelut',
    ...val),

  NXGI: (en: string, ...val: string[]) => translate(en,
    'Vaihdettava laite',
    ...val),

  NXHY: (en: string, ...val: string[]) => translate(en,
    'Saat vastaukset aina myös sähköpostiisi. ',
    ...val),

  NXK9: (en: string, ...val: string[]) => translate(en,
    'Nopeaan yrityskäyttöön, videoneuvotteluihin ja 4K-leffoihin.',
    ...val),

  NXUJ: (en: string, ...val: string[]) => translate(en,
    'Kutsua lähetetään osoitteeseen: {}',
    ...val),

  NY4L: (en: string, ...val: string[]) => translate(en,
    'Elisa Oma Laitelaskun avulla voit valita työsuhdelaitteeksi työnantajasi normaalikäytäntöä paremman laitteen. Maksat hinnan erotuksen kuukausittain erillisellä laskulla.',
    ...val),

  NY9Q: (en: string, ...val: string[]) => translate(en,
    'Suoramaksu + paperilasku',
    ...val),

  NYPL: (en: string, ...val: string[]) => translate(en,
    'Linkin lähettäminen',
    ...val),

  NYU3: (en: string, ...val: string[]) => translate(en,
    'Ota yhteyttä',
    ...val),

  NZRG: (en: string, ...val: string[]) => translate(en,
    'Laitekauden pituus',
    ...val),

  O06Y: (en: string, ...val: string[]) => translate(en,
    'Kun olet ottanut Elisa Tunnuksen käyttöön, Yritysten OmaElisa -tunnus {} lakkaa toimimasta.',
    ...val),

  O0EZ: (en: string, ...val: string[]) => translate(en,
    'Lisätarvike',
    ...val),

  O0QI: (en: string, ...val: string[]) => translate(en,
    'Katuosoitteen lisätieto',
    ...val),

  O108: (en: string, ...val: string[]) => translate(en,
    '{} kk sopimus, kokonaishinta {}, alv. {} %',
    ...val),

  O1F2: (en: string, ...val: string[]) => translate(en,
    'Puuttuuko sinulta pääkäyttäjäoikeudet?',
    ...val),

  O1MZ: (en: string, ...val: string[]) => translate(en,
    'Näytettävän numeron muunnos',
    ...val),

  O1RJ: (en: string, ...val: string[]) => translate(en,
    'Pääkäyttäjän yhteystiedot',
    ...val),

  O1Y8: (en: string, ...val: string[]) => translate(en,
    'Tälle laitteelle ei löydy suositeltuja lisätarvikkeita. Koko lisätarvikevalikoiman löydät ',
    ...val),

  O21N: (en: string, ...val: string[]) => translate(en,
    'Olet poistamassa ajastetun muutospyynnön. Tätä toimenpidettä ei ole mahdollista perua.',
    ...val),

  O222: (en: string, ...val: string[]) => translate(en,
    'Uusi mobiililaajakaista',
    ...val),

  O3L6: (en: string, ...val: string[]) => translate(en,
    'Sinulla on vain lukuoikeus',
    ...val),

  O3ZI: (en: string, ...val: string[]) => translate(en,
    'Etsi Y-tunnuksella tai yrityksen nimellä',
    ...val),

  O4D7: (en: string, ...val: string[]) => translate(en,
    'Voit ottaa Mobiilivarmenteen käyttöön yritysliittymällesi omakustanteisesti.',
    ...val),

  O4DB: (en: string, ...val: string[]) => translate(en,
    'Lisää pääkäyttäjä',
    ...val),

  O4KU: (en: string, ...val: string[]) => translate(en,
    'Yhteystietojen päivitys epäonnistui',
    ...val),

  O4R1: (en: string, ...val: string[]) => translate(en,
    'Hakusanalla',
    ...val),

  O4R6: (en: string, ...val: string[]) => translate(en,
    'Kiitos tilauksestasi!',
    ...val),

  O5C5: (en: string, ...val: string[]) => translate(en,
    'Viestikeskus',
    ...val),

  O5CK: (en: string, ...val: string[]) => translate(en,
    'Sopimushinta, alv. 0 %',
    ...val),

  O5R1: (en: string, ...val: string[]) => translate(en,
    'Vastaanottajan puhelinnumero',
    ...val),

  O699: (en: string, ...val: string[]) => translate(en,
    'Raportointipäivä',
    ...val),

  O6Q1: (en: string, ...val: string[]) => translate(en,
    'Numeron nykyinen omistaja?',
    ...val),

  O6XH: (en: string, ...val: string[]) => translate(en,
    'Ei muutosmaksua, alv. 0 %',
    ...val),

  O6ZK: (en: string, ...val: string[]) => translate(en,
    'Valitse vähintään yksi yritys',
    ...val),

  O7AN: (en: string, ...val: string[]) => translate(en,
    'Kirjautuminen epäonnistui.',
    ...val),

  O7DE: (en: string, ...val: string[]) => translate(en,
    'Toiminto ei ole mahdollinen, sillä palvelulle on tilattu muutos, joka on tällä hetkellä käsittelyssä.',
    ...val),

  O7OC: (en: string, ...val: string[]) => translate(en,
    'Yritykselläsi ei ole aktiivista Vakio-ratkaisua.',
    ...val),

  O7PT: (en: string, ...val: string[]) => translate(en,
    'SIM-kortin muutostilaus kesken, jonka aikana et voi tehdä muita muutoksia liittymälle.',
    ...val),

  O83E: (en: string, ...val: string[]) => translate(en,
    'Laskulle tulostuva maksajan nimen lisätieto esim. ostoreskontra',
    ...val),

  O854: (en: string, ...val: string[]) => translate(en,
    'Kun saavut ulkomaille, saat tekstarin kohtuukäytön rajastasi. Saat myös tekstarin, kun datan käyttömääräsi on täyttymässä. Tämän jälkeen maksat tiedonsiirrosta 1,30 €/Gt (gigatavua).',
    ...val),

  O948: (en: string, ...val: string[]) => translate(en,
    'Kotimaan käyttö',
    ...val),

  O9AW: (en: string, ...val: string[]) => translate(en,
    'Laitteet, joiden tuoteryhmää ei ole saatavilla',
    ...val),

  O9N8: (en: string, ...val: string[]) => translate(en,
    'Elisa Kuka Soittaa -palvelulla näet, kuka sinulle soittaa. Palvelu näyttää puhelimessasi automaattisesti soittajan nimitiedon ilman erikseen ladattavia sovelluksia. Elisa Kuka Soittaa nyt toistaiseksi tutustumishintaan 2,99 € / kk / liittymä alv. 0 % (norm. 3,99 € / kk / liittymä alv. 0 %).\n\nVoit tilata Elisa Kuka Soittaa -palvelun vaivattomasti yhteen tai useampaan yritysliittymään suoraan Yritysten OmaElisassa!',
    ...val),

  O9WF: (en: string, ...val: string[]) => translate(en,
    'Työajalla (manuaalinen)',
    ...val),

  OA7G: (en: string, ...val: string[]) => translate(en,
    'Aidoilla Elisan 5G-yritysliittymillä kaikki vaan toimii paremmin! Tehokkaat ja huippunopeat puhelinliittymät yrityskäyttöön varmistavat sujuvan työnteon. Räätälöi yritysliittymä tarpeidesi mukaan: päätä nopeus, lisää kätevä Kuka Soittaa -palvelu tai valitse Premium-liittymä, johon on jo valmiiksi paketoitu kaikki huippuominaisuudet mukaan.',
    ...val),

  OA8P: (en: string, ...val: string[]) => translate(en,
    'Ladataan tilitietoja',
    ...val),

  OAGD: (en: string, ...val: string[]) => translate(en,
    'Varavastaajat työajalla',
    ...val),

  OAGG: (en: string, ...val: string[]) => translate(en,
    'Syöttämäsi tiedot',
    ...val),

  OB4C: (en: string, ...val: string[]) => translate(en,
    'Olet Elisa Yritystietoturvan pääkäyttäjä. Jos muutat nimeäsi, matkapuhelinnumeroasi tai sähköpostiosoitettasi, myös Elisa Yritystietoturvan kirjautumistunnuksesi muuttuvat.',
    ...val),

  OBHZ: (en: string, ...val: string[]) => translate(en,
    'Laskutussopimuksen nimen lisäosa, auttaa tunnistamaan laskutussopimuksen. Ei tulostu laskulle.',
    ...val),

  OBVW: (en: string, ...val: string[]) => translate(en,
    'Lisenssien hallintaportaaliin pääsy on estetty. Ota yhteyttä asiakaspalveluun tilanteen selvittämiseksi.',
    ...val),

  OCYV: (en: string, ...val: string[]) => translate(en,
    'Siirry OmaElisan etusivulle',
    ...val),

  OD0K: (en: string, ...val: string[]) => translate(en,
    'kertamaksut',
    ...val),

  OD1L: (en: string, ...val: string[]) => translate(en,
    'Alk.',
    ...val),

  OD1M: (en: string, ...val: string[]) => translate(en,
    'Tai alk. {} €/kk',
    ...val),

  OD1N: (en: string, ...val: string[]) => translate(en,
    'Mikä on Laitenetti?',
    ...val),

  OD1O: (en: string, ...val: string[]) => translate(en,
    'Laitenetti on nettiliittymä etäohjattavien laitteiden, kuten valvontakameroiden ja paikantimien hallintaan tai esimerkiksi etäohjattavien pistorasioiden tai lämpömittareiden ohjaukseen.',
    ...val),

  OD1P: (en: string, ...val: string[]) => translate(en,
    'Laitenetti toimii kuten tavallinenkin liittymä, eli sillä voi luoda yhteyden laitteeseen. Laiteliittymän avulla voit seurata ja etäohjata laitteiden toimintaa tai tarkastella kameran lähettämää kuvaa tai videota. Laitenetti on tarkoitettu laitteiden väliseen datayhteyteen.',
    ...val),

  OD1Q: (en: string, ...val: string[]) => translate(en,
    'Mihin laitteisiin Laitenetti-liittymä sopii?',
    ...val),

  OD1R: (en: string, ...val: string[]) => translate(en,
    'Laitenetti-liittymä sopii esimerkiksi hälyttimiin, ilmalämpöpumppuihin, GPS-paikantimiin, olosuhdesensoreihin, hälytyslaitteisiin, valvonta- ja riistakameroihin sekä mobiilireitittimiin ja verkkolaitteisiin.',
    ...val),

  OD1S: (en: string, ...val: string[]) => translate(en,
    'Mikä liittymä sopii valvonta- tai riistakameraan?',
    ...val),

  OD1T: (en: string, ...val: string[]) => translate(en,
    'Riista- ja valvontakameroihin tarvitaan hieman nopeampaa lähetys- ja latausnopeutta, joten suosittelemme Elisa Laitenetti M, Laitenetti L tai Laitenetti 5G -liittymää. Laitenetti L ja 5G sopivat kameraan, joka lähettää live-videota, mutta kuvien lähetykseen riittää Laitenetti M.',
    ...val),

  OD1U: (en: string, ...val: string[]) => translate(en,
    'Mikä liittymä sopii korkealaatuisen live-videon lähetykseen? ',
    ...val),

  OD1V: (en: string, ...val: string[]) => translate(en,
    'Kun tarve on lähettää korkealaatuista live-videota, suosittelemme Laitenetti 5G -liittymää.',
    ...val),

  OD1W: (en: string, ...val: string[]) => translate(en,
    'Miten paikannan laitteeni?',
    ...val),

  OD1X: (en: string, ...val: string[]) => translate(en,
    'Elisa Laitenetti-sovelluksen avulla voit esimerkiksi tarkastella paikantimiesi sijaintia kartalla ja tarkkailla ajoneuvojen nopeustietoja. Voit halutessasi jakaa sijaintitietoja myös muille.',
    ...val),

  OD1Y: (en: string, ...val: string[]) => translate(en,
    'Laitenetti-sovellus toimii yhdessä laiteliittymän ja paikannuslaitteen kanssa, ja voit ladata sovelluksen ilmaiseksi omasta sovelluskaupastasi. Huomioi, että sovellus toimii vain paikantimiin, joissa sinulla on Elisan Laitenetti-liittymä.',
    ...val),

  OD1Z: (en: string, ...val: string[]) => translate(en,
    'Miten otan Elisa Laitenetti -liittymän käyttöön?',
    ...val),

  OD20: (en: string, ...val: string[]) => translate(en,
    'Tilauksen jälkeen toimitamme sinulle postissa uuden SIM-kortin, jonka voit asentaa älylaitteeseesi. SIM-kortin toimituksessa kestää keskimäärin 2–4 arkipäivää.',
    ...val),

  OD21: (en: string, ...val: string[]) => translate(en,
    'Katso ',
    ...val),

  OD22: (en: string, ...val: string[]) => translate(en,
    'Laitenettiliittymän avulla voit käyttää ja hallita älylaitteitasi mistä tahansa nettiyhteydellä varustetusta laitteesta, kuten älypuhelimesta tai tietokoneesta. Voit tarkastella ja kerätä dataa netin kautta sekä ohjata ja hallita laitteitasi etäyhteyden avulla. Laitenetti yrityksille -liittymien Access Point Name (APN) on APN internet, Laitenettiin ei voi liittää muita APN:iä',
    ...val),

  OD23: (en: string, ...val: string[]) => translate(en,
    'Katso kaikki IoT-laitteet',
    ...val),

  OD27: (en: string, ...val: string[]) => translate(en,
    'Laitenetti yrityksille – netti etäohjattaviin älylaitteisiin',
    ...val),

  OD28: (en: string, ...val: string[]) => translate(en,
    'Elisa Laitenetti mahdollistaa tiedonkeruun ja etäohjauksen verkon yli. Sen avulla saat nettiyhteyden yrityksesi etäohjattaviin älylaitteisiin, kuten valvontakameroihin, hälytysjärjestelmään tai lämmityslaitteisiin ja saat kerättyä dataa etänä.',
    ...val),

  OD29: (en: string, ...val: string[]) => translate(en,
    'Haluatko saada videokuvaa valvontakameroista tai ohjata ilmalämpöpumppua etänä?',
    ...val),

  OD30: (en: string, ...val: string[]) => translate(en,
    'Elisa Laitenetti on nopea ja helppo ottaa käyttöön. Valitse sopiva liittymä yrityksellesi ja saat laitenetin nopealla toimituksella!',
    ...val),

  OD31: (en: string, ...val: string[]) => translate(en,
    'Tutustu myös IoT-laitteisiin',
    ...val),

  OD32: (en: string, ...val: string[]) => translate(en,
    'Maksuton Elisa Laitenetti -sovellus paikantaa autosi tai omaisuutesi',
    ...val),

  OD33: (en: string, ...val: string[]) => translate(en,
    'Laitenetti-sovellus toimii yhdessä Elisa Laitenetti -liittymän ja paikannuslaitteen kanssa.',
    ...val),

  OD34: (en: string, ...val: string[]) => translate(en,
    'Tarkastele paikantimiesi sijaintia kartalla – tieto päivittyy reaaliaikaisesti puhelimeesi välimatkasta riippumatta',
    ...val),

  OD35: (en: string, ...val: string[]) => translate(en,
    'Tarkastele sijaintihistoriaa tai esimerkiksi ajoneuvojen nopeustietoja',
    ...val),

  OD36: (en: string, ...val: string[]) => translate(en,
    'Jaa sijaintitiedot halutessasi myös muille',
    ...val),

  OD37: (en: string, ...val: string[]) => translate(en,
    'Valittavissasi on useita erilaisia karttapohjia, esimerkiksi maastokartta',
    ...val),

  OD38: (en: string, ...val: string[]) => translate(en,
    'Kaikki tiedot välitetään turvallisesti Elisalle',
    ...val),

  OD39: (en: string, ...val: string[]) => translate(en,
    'Lataa sovellus ilmaiseksi omasta sovelluskaupastasi!',
    ...val),

  OD40: (en: string, ...val: string[]) => translate(en,
    'Sovellus toimii vain paikantimiin, joissa sinulla on käytössäsi Elisan Laitenetti-liittymä.',
    ...val),

  OD41: (en: string, ...val: string[]) => translate(en,
    'Laitenetin 4G-liittymät yrityksille',
    ...val),

  OD42: (en: string, ...val: string[]) => translate(en,
    'Laitenetin 5G-liittymä yrityksille',
    ...val),

  ODIH: (en: string, ...val: string[]) => translate(en,
    'Ring-ratkaisu',
    ...val),

  ODWA: (en: string, ...val: string[]) => translate(en,
    'Voit itse valita, missä numeropalveluissa tietosi julkaistaan.',
    ...val),

  OE45: (en: string, ...val: string[]) => translate(en,
    'IMEI/sarjanumero',
    ...val),

  OEB7: (en: string, ...val: string[]) => translate(en,
    'Valitse toimitustapa',
    ...val),

  OEEF: (en: string, ...val: string[]) => translate(en,
    'Laskutustavan muutokset',
    ...val),

  OESQ: (en: string, ...val: string[]) => translate(en,
    'Joudumme perumaan laitevaihdon, mikäli toteamme vian korjaantuvan ohjeistetuilla toimilla.',
    ...val),

  OF6S: (en: string, ...val: string[]) => translate(en,
    'Tietueet',
    ...val),

  OF9U: (en: string, ...val: string[]) => translate(en,
    'Kk-maksulliset laitteet',
    ...val),

  OFAN: (en: string, ...val: string[]) => translate(en,
    'Voit palata kauppaan ja jatkaa ostoksia.',
    ...val),

  OFYZ: (en: string, ...val: string[]) => translate(en,
    'Lataa PDF-kopioita laskuista',
    ...val),

  OHZ1: (en: string, ...val: string[]) => translate(en,
    'Palveluni',
    ...val),

  OIG7: (en: string, ...val: string[]) => translate(en,
    'Kopioi laitelista',
    ...val),

  OIUB: (en: string, ...val: string[]) => translate(en,
    ' helposti itse, jos sinulla on yrityksesi nimenkirjoitusoikeus.',
    ...val),

  OIVZ: (en: string, ...val: string[]) => translate(en,
    'Ongelma',
    ...val),

  OJDL: (en: string, ...val: string[]) => translate(en,
    'Käyttäjää ei voida poistaa, koska käyttäjällä on pääkäyttäjäoikeudet Yritysten OmaElisaan. Poista pääkäyttäjäoikeudet ensin',
    ...val),

  OJPZ: (en: string, ...val: string[]) => translate(en,
    'Piilota',
    ...val),

  OK8J: (en: string, ...val: string[]) => translate(en,
    'Tilaa uusi liittymä',
    ...val),

  OKCS: (en: string, ...val: string[]) => translate(en,
    'Jos ongelma toistuu, ole yhteydessä asiakaspalveluumme.',
    ...val),

  OKGT: (en: string, ...val: string[]) => translate(en,
    'Uuden liittymätyypin tiedot',
    ...val),

  OKJR: (en: string, ...val: string[]) => translate(en,
    'Ei käyttöoikeuksia.',
    ...val),

  OKLP: (en: string, ...val: string[]) => translate(en,
    'Muutosmaksut yhteensä',
    ...val),

  OKYY: (en: string, ...val: string[]) => translate(en,
    'Sähköposti',
    ...val),

  OL3F: (en: string, ...val: string[]) => translate(en,
    'Tilalle',
    ...val),

  OL6X: (en: string, ...val: string[]) => translate(en,
    'Ei sisällä roaming ominaisuuksia, toimii vain kotimaassa. Neljä datapakettia valittavissa. Normaalihintaiset kotimaan puhelut 0,0565 €/min, tekstiviestit 0,0565 €/kpl, multimediaviestit 0,156 €/kpl.',
    ...val),

  OL7B: (en: string, ...val: string[]) => translate(en,
    'Verkkolaskuosoite',
    ...val),

  OLLP: (en: string, ...val: string[]) => translate(en,
    'Siirrytään takaisin laskun tietoihin',
    ...val),

  OLM4: (en: string, ...val: string[]) => translate(en,
    'Kehitämme Yritysten OmaElisaa ja tässä vaiheessa näet alla "Kysy laskusta" sekä "Luo uusi" -painikkeiden kautta avaamasi tukipyynnöt.',
    ...val),

  OLP0: (en: string, ...val: string[]) => translate(en,
    'SIM-kortin tyyppi',
    ...val),

  OLP6: (en: string, ...val: string[]) => translate(en,
    'Anna hylkäyksen syy',
    ...val),

  OLVS: (en: string, ...val: string[]) => translate(en,
    'Näytä liittymät',
    ...val),

  OLZS: (en: string, ...val: string[]) => translate(en,
    'Onko kyseessä laitevaihto vai uusi sopimus?',
    ...val),

  OM46: (en: string, ...val: string[]) => translate(en,
    'Haluatko hyödyntää Vaihtoedun?',
    ...val),

  OM8N: (en: string, ...val: string[]) => translate(en,
    'Näytä muut vaihtoehdot',
    ...val),

  OMJ2: (en: string, ...val: string[]) => translate(en,
    'Viihde-esto',
    ...val),

  OMMT: (en: string, ...val: string[]) => translate(en,
    'Laskutukseen liittyvät kirjeet',
    ...val),

  OMNZ: (en: string, ...val: string[]) => translate(en,
    'Palautan',
    ...val),

  OMO5: (en: string, ...val: string[]) => translate(en,
    'Hyötyesto P1',
    ...val),

  OMP6: (en: string, ...val: string[]) => translate(en,
    'Irtisanomisilmoitus on vastaanotettu. Saat vielä erillisen irtisanomisvahvistuksen sähköpostiisi.',
    ...val),

  OMY8: (en: string, ...val: string[]) => translate(en,
    'Kotimaassa, Pohjolassa ja Baltiassa',
    ...val),

  ON49: (en: string, ...val: string[]) => translate(en,
    'Uusi käyttäjä',
    ...val),

  ONM3: (en: string, ...val: string[]) => translate(en,
    '4K-leffojen ja -sarjojen suoratoisto',
    ...val),

  ONSX: (en: string, ...val: string[]) => translate(en,
    'Hylkää',
    ...val),

  ONU5: (en: string, ...val: string[]) => translate(en,
    'Tämä on Elisan kuluttajaliittymien yritysasiakkaan liittymä (entinen Saunalahden yritysasiakas). Pääset hallinnoimaan sitä ',
    ...val),

  ONUM: (en: string, ...val: string[]) => translate(en,
    'Kaikki kentät ovat pakollisia, ellei kenttää ole merkitty valinnaiseksi.',
    ...val),

  OOWX: (en: string, ...val: string[]) => translate(en,
    'Kun päätät Elisa Palvelupäätelaitteen sopimuksen kesken sopimuskauden, Elisa veloittaa laitteesta jäljelle jäävien kuukausimaksujen summan kertaveloituksena, tämän laitteen osalta summa on',
    ...val),

  OOXB: (en: string, ...val: string[]) => translate(en,
    'Tablettien ja iPadien lisätarvikkeet',
    ...val),

  OOXW: (en: string, ...val: string[]) => translate(en,
    'Valitse tuotteiden toimitus',
    ...val),

  OP1P: (en: string, ...val: string[]) => translate(en,
    'Jos et pysty tunnistautumaan Mobiilivarmenteella tai pankkitunnuksilla, voit jatkaa',
    ...val),

  OP1Q: (en: string, ...val: string[]) => translate(en,
    'tästä',
    ...val),

  OP4E: (en: string, ...val: string[]) => translate(en,
    'Sinun osuutesi alk. {}, yhteensä {}',
    ...val),

  OP5R: (en: string, ...val: string[]) => translate(en,
    'Huomioithan, jos laite on vahingoittunut, tuhoutunut tai kadonnut siitä on tehtävä erillinen ilmoitus.',
    ...val),

  OPH9: (en: string, ...val: string[]) => translate(en,
    'Poista muutokset',
    ...val),

  OPI0: (en: string, ...val: string[]) => translate(en,
    'Voit tarvittaessa muuttaa laitteen laskutussopimusta vahvistaessasi muutokset.',
    ...val),

  OPKW: (en: string, ...val: string[]) => translate(en,
    'Valitse yritys, johon haluat lisätä uuden laskutussopimuksen.',
    ...val),

  OQ8K: (en: string, ...val: string[]) => translate(en,
    'Siirrä käyttäjä toiseen yritykseen',
    ...val),

  OQBT: (en: string, ...val: string[]) => translate(en,
    'Ei tuloksia haulle',
    ...val),

  OQDT: (en: string, ...val: string[]) => translate(en,
    'Ei laitteita saatavilla tällä hetkellä.',
    ...val),

  OQEQ: (en: string, ...val: string[]) => translate(en,
    'Muutospyynnön lähetys epäonnistui. Yritä myöhemmin uudelleen.',
    ...val),

  OQJD: (en: string, ...val: string[]) => translate(en,
    'Tuotekategoria',
    ...val),

  OQUG: (en: string, ...val: string[]) => translate(en,
    'Siirrytään Työntekijän OmaElisaan',
    ...val),

  ORKT: (en: string, ...val: string[]) => translate(en,
    'Näytettävä soittajan nimi',
    ...val),

  ORN1: (en: string, ...val: string[]) => translate(en,
    'Puhelut',
    ...val),

  ORQE: (en: string, ...val: string[]) => translate(en,
    'Kausimaksut yhteensä, alv. 0 %',
    ...val),

  ORRM: (en: string, ...val: string[]) => translate(en,
    'Muutoksen lähetys epäonnistui',
    ...val),

  ORYE: (en: string, ...val: string[]) => translate(en,
    'Palaa etusivulle',
    ...val),

  OS99: (en: string, ...val: string[]) => translate(en,
    'Laskutussopimuksen luonti onnistui.',
    ...val),

  OSYL: (en: string, ...val: string[]) => translate(en,
    'Lisätietoja hinnoista',
    ...val),

  OT0Z: (en: string, ...val: string[]) => translate(en,
    'Mobiililaajakaistan vaihtoehdot',
    ...val),

  OT3E: (en: string, ...val: string[]) => translate(en,
    'Tilaamasi tuotteet',
    ...val),

  OTF5: (en: string, ...val: string[]) => translate(en,
    'Ongelmia yhteydessä?',
    ...val),

  OTPK: (en: string, ...val: string[]) => translate(en,
    'Vaatii verkon rakentamista',
    ...val),

  OTQ4: (en: string, ...val: string[]) => translate(en,
    'Valitse laitelista',
    ...val),

  OTX5: (en: string, ...val: string[]) => translate(en,
    'Anna salasana uudelleen',
    ...val),

  OU0R: (en: string, ...val: string[]) => translate(en,
    'Tee muutospyyntö',
    ...val),

  OUCH: (en: string, ...val: string[]) => translate(en,
    'Valittu Ring-palvelu',
    ...val),

  OVFJ: (en: string, ...val: string[]) => translate(en,
    '. Liittymäsi päivittyy arviolta yhden arkipäivän sisällä.',
    ...val),

  OVGH: (en: string, ...val: string[]) => translate(en,
    'Laitteen sarjanumero',
    ...val),

  OVO4: (en: string, ...val: string[]) => translate(en,
    ' asennusosoitteeseesi 5G-kuuluvuuden. Kirjoita osoitteesi kartan hakukenttään ja valitse 5G-saatavuus.',
    ...val),

  OW10: (en: string, ...val: string[]) => translate(en,
    'Ei laitevalikoimia',
    ...val),

  OW3C: (en: string, ...val: string[]) => translate(en,
    'Palaa asiakkaan näkymään',
    ...val),

  OW64: (en: string, ...val: string[]) => translate(en,
    'Valitse ainakin yksi tuote.',
    ...val),

  OWF1: (en: string, ...val: string[]) => translate(en,
    'Matkapuhelin',
    ...val),

  OWG1: (en: string, ...val: string[]) => translate(en,
    'Liittymän käyttö ajalta',
    ...val),

  OWUZ: (en: string, ...val: string[]) => translate(en,
    'Koontilasku ilman erittelyä',
    ...val),

  OXI7: (en: string, ...val: string[]) => translate(en,
    'Vahvista laitteen lunastaminen työntekijälle',
    ...val),

  OXWO: (en: string, ...val: string[]) => translate(en,
    'Tuki on avoinna klo 08.00–17.00. Voit saada palvelu suomeksi, ruotsiksi tai englanniksi. Halutessasi puhelintuki voi ottaa etäyhteyden laitteeseesi ratkaistaksesi asian.',
    ...val),

  OXXR: (en: string, ...val: string[]) => translate(en,
    'Elisa Tunnus on nyt käytössäsi',
    ...val),

  OZCC: (en: string, ...val: string[]) => translate(en,
    'Mobiililiittymät',
    ...val),

  OZCV: (en: string, ...val: string[]) => translate(en,
    'Sopii sinulle, jos työsi on liikkuvaa, eikä sähköä ole aina helposti saatavilla. Pienikokoinen ja kestävällä akulla varustettu mobiilireititin kulkee vaivattomasti mukana.',
    ...val),

  OZEV: (en: string, ...val: string[]) => translate(en,
    'Avaa chat',
    ...val),

  OZLC: (en: string, ...val: string[]) => translate(en,
    'Palauta vanha laite Elisalle 2 viikon kuluessa. Lähetämme sinulle pussin ja ohjeet palautusta varten. Palauttamattomasta laitteesta veloitetaan maksu.',
    ...val),

  P00G: (en: string, ...val: string[]) => translate(en,
    'Käyttöjärjestelmä',
    ...val),

  P04G: (en: string, ...val: string[]) => translate(en,
    'Määritä kuinka pitkään puhelu hälyttää yksittäisellä vastaajalla.',
    ...val),

  P0AZ: (en: string, ...val: string[]) => translate(en,
    'SIM-kortissa olevat 14 numeroa',
    ...val),

  P0CE: (en: string, ...val: string[]) => translate(en,
    'Viihde-esto P4',
    ...val),

  P0F9: (en: string, ...val: string[]) => translate(en,
    'Kuinka helppoa asiasi hoitaminen oli?',
    ...val),

  P0PS: (en: string, ...val: string[]) => translate(en,
    'Kuukausimaksu',
    ...val),

  P111: (en: string, ...val: string[]) => translate(en,
    'Ajanviete-esto P3',
    ...val),

  P11A: (en: string, ...val: string[]) => translate(en,
    'Luontipäivä',
    ...val),

  P1Y9: (en: string, ...val: string[]) => translate(en,
    'Ladataan...',
    ...val),

  P2E3: (en: string, ...val: string[]) => translate(en,
    'Toimitus toimitusosoitteeseen',
    ...val),

  P2VO: (en: string, ...val: string[]) => translate(en,
    ' mukaisesti',
    ...val),

  P35B: (en: string, ...val: string[]) => translate(en,
    'Lisää liittymäsi',
    ...val),

  P3C8: (en: string, ...val: string[]) => translate(en,
    'Valitse yritys',
    ...val),

  P3SF: (en: string, ...val: string[]) => translate(en,
    'MESH-laite',
    ...val),

  P44I: (en: string, ...val: string[]) => translate(en,
    'Pääkäyttäjä-oikeudet asetetaan Käyttäjät-sivulla. Valitse olemassa oleva käyttäjä ja muuta hänen rooliaan Käyttöoikeudet-osiossa. Jos käyttäjää ei vielä löydy listalta, luo ensin uusi käyttäjä.',
    ...val),

  P4CJ: (en: string, ...val: string[]) => translate(en,
    'Ota uusi yhteys käyttöösi vaivattomasti.',
    ...val),

  P4DI: (en: string, ...val: string[]) => translate(en,
    'Kutsun lähetys osoitteeseen {} epäonnistui. Tarkista sähköpostiosoite ja yritä uudelleen.',
    ...val),

  P4RQ: (en: string, ...val: string[]) => translate(en,
    'Summa',
    ...val),

  P4VL: (en: string, ...val: string[]) => translate(en,
    'rekisteröintisivulla',
    ...val),

  P5F7: (en: string, ...val: string[]) => translate(en,
    'Liittymää ei voi avata OmaElisan kautta.',
    ...val),

  P5H4: (en: string, ...val: string[]) => translate(en,
    'Annettuun osoitteeseen lähetetään vahvistuspyyntö. Käyttäjä hyväksyy numeronsiirron tunnistautumalla verkkopankkitunnuksillaan.',
    ...val),

  P5RQ: (en: string, ...val: string[]) => translate(en,
    'Hyväksy',
    ...val),

  P674: (en: string, ...val: string[]) => translate(en,
    'Liittymä',
    ...val),

  P6A0: (en: string, ...val: string[]) => translate(en,
    'OmaLaskun tietojen hakeminen epäonnistui. Yritä myöhemmin uudestaan.',
    ...val),

  P6BC: (en: string, ...val: string[]) => translate(en,
    'Kuukausimaksut',
    ...val),

  P6TX: (en: string, ...val: string[]) => translate(en,
    '/mobiiliturva',
    ...val),

  P7JV: (en: string, ...val: string[]) => translate(en,
    'Laitelista tallennettu luonnoksena. Muista julkaista laitelista erikseen.',
    ...val),

  P81H: (en: string, ...val: string[]) => translate(en,
    'Muokkaa laitevalikoimaa',
    ...val),

  P87N: (en: string, ...val: string[]) => translate(en,
    'Viitenumero',
    ...val),

  P8B2: (en: string, ...val: string[]) => translate(en,
    'Siirrettävä käyttäjä',
    ...val),

  P9D3: (en: string, ...val: string[]) => translate(en,
    'Oletko laskutusyhteyshenkilö',
    ...val),

  P9G3: (en: string, ...val: string[]) => translate(en,
    'Jos haluat hallinnoida omia työliittymä- tai laiteasioitasi, kirjaudu',
    ...val),

  P9L6: (en: string, ...val: string[]) => translate(en,
    'USB-kaapeli',
    ...val),

  P9S4: (en: string, ...val: string[]) => translate(en,
    'Järjestä valitut ensimmäiseksi',
    ...val),

  P9Z5: (en: string, ...val: string[]) => translate(en,
    'Irtisanomisilmoitus',
    ...val),

  PA2R: (en: string, ...val: string[]) => translate(en,
    'Tällä liittymällä on ajastettu muutospyyntö, joten muokkaus ei ole mahdollista.',
    ...val),

  PA84: (en: string, ...val: string[]) => translate(en,
    'Sisältää 5000 min/kk puhetta kotimaan liittymiin. Yhdeksän datapakettia valittavissa.',
    ...val),

  PAOF: (en: string, ...val: string[]) => translate(en,
    'Aktivoi kaksivaiheinen tunnistautuminen',
    ...val),

  PB2M: (en: string, ...val: string[]) => translate(en,
    'Norm. 3,99 € / kk / liittymä alv. 0 %',
    ...val),

  PB3G: (en: string, ...val: string[]) => translate(en,
    'Liittymän käyttö avoinna olevalta laskutuskaudelta',
    ...val),

  PB6S: (en: string, ...val: string[]) => translate(en,
    'Maksaja',
    ...val),

  PBQH: (en: string, ...val: string[]) => translate(en,
    'Kaikki laitteet käyvät läpi tietoturvakäsittelyn, jossa kaikki niihin tallennetut tiedot poistetaan luotettavasti ja turvallisesti.\nHyväkuntoiset laitteet kunnostetaan ja myydään eteenpäin kierrätyskumppanimme kautta. Elinkaarensa päässä olevat laitteet puretaan, ja niiden sisältämät arvokkaat raaka-aineet kierrätetään uusiokäyttöön.',
    ...val),

  PC3E: (en: string, ...val: string[]) => translate(en,
    'Tilapäisesti suljettu',
    ...val),

  PCB2: (en: string, ...val: string[]) => translate(en,
    'Henkilö',
    ...val),

  PCNO: (en: string, ...val: string[]) => translate(en,
    'Tiedosto sisältää yhden tai useamman virheellisen sähköpostiosoitteen.',
    ...val),

  PD2Y: (en: string, ...val: string[]) => translate(en,
    'Lasku lähetetään paperisena ilmoittamaasi osoitteeseen.',
    ...val),

  PDVP: (en: string, ...val: string[]) => translate(en,
    'Henkilökohtaisessa käytössä',
    ...val),

  PDYE: (en: string, ...val: string[]) => translate(en,
    'Liitä liittymäsi ',
    ...val),

  PE9O: (en: string, ...val: string[]) => translate(en,
    'Laskutusväli',
    ...val),

  PEKP: (en: string, ...val: string[]) => translate(en,
    'Peruutettu',
    ...val),

  PETH: (en: string, ...val: string[]) => translate(en,
    'Jos sinulla on jo verkkotunnus, kirjoita se tähän',
    ...val),

  PF1Y: (en: string, ...val: string[]) => translate(en,
    'Kutsun poisto onnistui.',
    ...val),

  PFDS: (en: string, ...val: string[]) => translate(en,
    'Toimituskulut',
    ...val),

  PFI5: (en: string, ...val: string[]) => translate(en,
    'Ring pääkäyttäjät',
    ...val),

  PFPP: (en: string, ...val: string[]) => translate(en,
    'Kuukausimaksullisten tuotteiden maksutapana on aina lasku.',
    ...val),

  PFSQ: (en: string, ...val: string[]) => translate(en,
    'Pakettiin kuuluva data',
    ...val),

  PG0L: (en: string, ...val: string[]) => translate(en,
    'Numero ei ole sallittu',
    ...val),

  PGEM: (en: string, ...val: string[]) => translate(en,
    'Tämä raportti sisältää tiedot päivältä',
    ...val),

  PGK9: (en: string, ...val: string[]) => translate(en,
    'Tämän tietuetyypin muokkaus ei ole mahdollista palvelussamme',
    ...val),

  PGL0: (en: string, ...val: string[]) => translate(en,
    'Huomioithan että voimassaoleva maksusopimus estää lisämyynnin.',
    ...val),

  PGZ4: (en: string, ...val: string[]) => translate(en,
    'Liittymälläsi on Elisa Ring -palvelu, joka estää palvelun käyttöönoton.',
    ...val),

  PH37: (en: string, ...val: string[]) => translate(en,
    'Yritysten OmaElisassa hallitset yrityksesi laitteita, liittymiä ja monia lisäpalveluita ilman palvelumaksua. Maksa laskut, tarkastele laskuhistoriaa, muokkaa laskutustietoja ja lataa laskukopioita. Chattaa tarvittaessa suoraan asiakaspalvelijan kanssa.',
    ...val),

  PH3D: (en: string, ...val: string[]) => translate(en,
    'Matkahuollon kuljetus toimitusosoitteeseen',
    ...val),

  PITO: (en: string, ...val: string[]) => translate(en,
    'Elisa Kuka soittaa -palvelun tiedot',
    ...val),

  PIZC: (en: string, ...val: string[]) => translate(en,
    'SIM-kortti',
    ...val),

  PJC3: (en: string, ...val: string[]) => translate(en,
    'Tietoa ei saatavilla...',
    ...val),

  PJIU: (en: string, ...val: string[]) => translate(en,
    'Mitä vanhalle laitteelle tehdään?',
    ...val),

  PJQL: (en: string, ...val: string[]) => translate(en,
    'Vanhentunut',
    ...val),

  PK01: (en: string, ...val: string[]) => translate(en,
    'Valitse ne liittymät, joihin haluat tilata Elisa Kuka Soittaa -palvelun:',
    ...val),

  PKER: (en: string, ...val: string[]) => translate(en,
    'Oletko Suomen Yrittäjien jäsen?',
    ...val),

  PKES: (en: string, ...val: string[]) => translate(en,
    'Puhelut hyötypalvelunumeroihin esim. taksin tilaus ja pankkipalvelut',
    ...val),

  PKEZ: (en: string, ...val: string[]) => translate(en,
    'Mobiilivarmenne',
    ...val),

  PKFX: (en: string, ...val: string[]) => translate(en,
    'EPP-sopimushinta varmistuu kun kirjaudut sisään',
    ...val),

  PKML: (en: string, ...val: string[]) => translate(en,
    'Kiinteän verkon Netti Lite -liittymät',
    ...val),

  PLAW: (en: string, ...val: string[]) => translate(en,
    'Palaa Kauppaan',
    ...val),

  PLAX: (en: string, ...val: string[]) => translate(en,
    'Palaa Kassalle',
    ...val),

  PLPN: (en: string, ...val: string[]) => translate(en,
    'Muutosmaksu lisätään seuraavalle laskulle',
    ...val),

  PLPS: (en: string, ...val: string[]) => translate(en,
    'Loppuerän viimeiset kappaleet, toimi nopeasti',
    ...val),

  PLQC: (en: string, ...val: string[]) => translate(en,
    'Matkahuolto Jakopaketti',
    ...val),

  PLW9: (en: string, ...val: string[]) => translate(en,
    'Laitetilaukseni',
    ...val),

  PM1H: (en: string, ...val: string[]) => translate(en,
    'Viimeksi muokattu',
    ...val),

  PMFC: (en: string, ...val: string[]) => translate(en,
    'Tilaa uusi',
    ...val),

  PN10: (en: string, ...val: string[]) => translate(en,
    'Kertamaksulliset ja kuukausimaksulliset laitteet ja lisätarvikkeet',
    ...val),

  PN6W: (en: string, ...val: string[]) => translate(en,
    '5G-liittymät',
    ...val),

  PNS1: (en: string, ...val: string[]) => translate(en,
    'Nimi',
    ...val),

  PO7A: (en: string, ...val: string[]) => translate(en,
    'Vahinkotapaus (laitteelle käynyt vahinko, näyttö rikki, runko vääntynyt, kastunut tms.)',
    ...val),

  PODN: (en: string, ...val: string[]) => translate(en,
    'DNS-tietueen lisääminen epäonnistui!',
    ...val),

  POX2: (en: string, ...val: string[]) => translate(en,
    'Tilausten hyväksyjä',
    ...val),

  PQGG: (en: string, ...val: string[]) => translate(en,
    'Toimitettu',
    ...val),

  PQLL: (en: string, ...val: string[]) => translate(en,
    'Suunniteltu',
    ...val),

  PR0A: (en: string, ...val: string[]) => translate(en,
    'Tarkista käyttäjän mukana siirtyvien sopimusten tiedot. Valitse uusi laskutussopimus uudesta yrityksestä ja määritä tarvittaessa tuotteille uudet kustannuspaikat.',
    ...val),

  PR0R: (en: string, ...val: string[]) => translate(en,
    'Raportti sisältää Elisa Palvelupäätelaitteet -palvelun matkapuhelimet, tabletit ja tietokoneet.',
    ...val),

  PRFW: (en: string, ...val: string[]) => translate(en,
    'Ostoskori on tyhjä',
    ...val),

  PRH3: (en: string, ...val: string[]) => translate(en,
    'Laitesopimuksen hylkääminen',
    ...val),

  PRK5: (en: string, ...val: string[]) => translate(en,
    'Raportti sisältää Elisa Palvelupäätelaite -palvelun palautetut ja palautusta odottavat laitteet, huoltotapahtumat, laitevaihdot, lunastetut laitteet ja palautusrikemaksutapahtumat.',
    ...val),

  PRLT: (en: string, ...val: string[]) => translate(en,
    'Työaikaketjuun vaaditaan ensimmäinen kohdenumero kun työaikaketju on valittuna',
    ...val),

  PRM5: (en: string, ...val: string[]) => translate(en,
    'Yritysten OmaElisa -tunnukset poistuvat käytöstä',
    ...val),

  PS1E: (en: string, ...val: string[]) => translate(en,
    'Korissa on {} tuotetta',
    ...val),

  PS5T: (en: string, ...val: string[]) => translate(en,
    'Laskutusosoite',
    ...val),

  PS8D: (en: string, ...val: string[]) => translate(en,
    'Tietojen päivitys onnistui.',
    ...val),

  PSDN: (en: string, ...val: string[]) => translate(en,
    'Käyttäjälle on lähetetty kutsulinkki sähköpostiin. Linkki on voimassa {} asti.',
    ...val),

  PSP0: (en: string, ...val: string[]) => translate(en,
    'Kuulokkeen tai mikrofonin aukkoon voi ajan myötä kerääntyä pölyä tai likaa, mikä saattaa heikentää äänen laatua tai tehdä siitä vaimean. Ennen ilmoituksen lähettämistä tarkistathan, että aukko on puhdas. Voit puhdistaa sen esimerkiksi kuivalla hammasharjalla.',
    ...val),

  PSP3: (en: string, ...val: string[]) => translate(en,
    'Korttimaksu on mahdollinen vain kertamaksullisille laitteille ja lisävarusteille.',
    ...val),

  PSY1: (en: string, ...val: string[]) => translate(en,
    'Lisenssien hallintaportaalin käyttö vaatii kaksivaiheisen tunnistautumisen. Saat aktivoitua kaksivaiheisen tunnistautumisen käyttöön Yrityksen tiedot ja asetukset -sivulla',
    ...val),

  PTGG: (en: string, ...val: string[]) => translate(en,
    'Ilmoita laskutussopimus',
    ...val),

  PTQ7: (en: string, ...val: string[]) => translate(en,
    'Uusi tilaus',
    ...val),

  PTWI: (en: string, ...val: string[]) => translate(en,
    'Muokkaa estopalveluita',
    ...val),

  PUHZ: (en: string, ...val: string[]) => translate(en,
    'Valitse malli',
    ...val),

  PUM6: (en: string, ...val: string[]) => translate(en,
    'Valitse laskutussopimus',
    ...val),

  PV8D: (en: string, ...val: string[]) => translate(en,
    'Puhe',
    ...val),

  PV9I: (en: string, ...val: string[]) => translate(en,
    'Lisäämällä käyttäjätiedon helpotat tuotteiden ja palveluiden hallintaa OmaElisan Käyttäjät-näkymässä. Valitse käyttötarkoitus vain silloin, kun kyseessä on esimerkiksi ryhmä käyttäjiä.',
    ...val),

  PVER: (en: string, ...val: string[]) => translate(en,
    'Matkahuollon automaatti tai noutopiste',
    ...val),

  PVYK: (en: string, ...val: string[]) => translate(en,
    'Jos matkapuhelinnumero luovutetaan työntekijälle, ',
    ...val),

  PW0U: (en: string, ...val: string[]) => translate(en,
    'Numeroasi ja yhteystietojasi ei julkaista numeropalveluissa.',
    ...val),

  PW2I: (en: string, ...val: string[]) => translate(en,
    'Varmistithan, että tilaus- ja laskutustiedot ovat oikein',
    ...val),

  PWLF: (en: string, ...val: string[]) => translate(en,
    'Käyttäjällä ei ole puhelinliittymiä.',
    ...val),

  PWWO: (en: string, ...val: string[]) => translate(en,
    'Vahvista ja jatka',
    ...val),

  PWYT: (en: string, ...val: string[]) => translate(en,
    'Haluatko varmasti poistaa käyttäjän?',
    ...val),

  PX2Z: (en: string, ...val: string[]) => translate(en,
    'Henkilöasiakkaan OmaElisa',
    ...val),

  PY03: (en: string, ...val: string[]) => translate(en,
    'Aikataulutettu',
    ...val),

  PY9Q: (en: string, ...val: string[]) => translate(en,
    'Kysyttävää laskutukseen tai maksamiseen liittyvistä asioista?',
    ...val),

  PZ9O: (en: string, ...val: string[]) => translate(en,
    'Muutostilaus',
    ...val),

  PZOF: (en: string, ...val: string[]) => translate(en,
    'Mt',
    ...val),

  PZV7: (en: string, ...val: string[]) => translate(en,
    'Rajaton netti kotimaassa, Pohjolassa ja Baltiassa, muualla EU:ssa {} Gt/kk.',
    ...val),

  Q03S: (en: string, ...val: string[]) => translate(en,
    'Laiterekisteröintiohjelma',
    ...val),

  Q05U: (en: string, ...val: string[]) => translate(en,
    'Käsittely keskeytetty',
    ...val),

  Q0O6: (en: string, ...val: string[]) => translate(en,
    'Lisää tiedosto raahaamalla tai',
    ...val),

  Q1DM: (en: string, ...val: string[]) => translate(en,
    'Muutosaika',
    ...val),

  Q1I0: (en: string, ...val: string[]) => translate(en,
    'Jos sinulla on Elisan yritysliittymä, voit esimerkiksi:',
    ...val),

  Q27O: (en: string, ...val: string[]) => translate(en,
    'Liittymän päivittäminen hyllyliittymäksi',
    ...val),

  Q2NF: (en: string, ...val: string[]) => translate(en,
    'jos sinulla on yrityksesi nimenkirjoitusoikeus.',
    ...val),

  Q2QT: (en: string, ...val: string[]) => translate(en,
    'Salli tuotteiden osatoimitus',
    ...val),

  Q4GQ: (en: string, ...val: string[]) => translate(en,
    'Työnantajasi maksaa seuraavat palvelut:',
    ...val),

  Q4V8: (en: string, ...val: string[]) => translate(en,
    'Maksettavaa jäljellä',
    ...val),

  Q4XS: (en: string, ...val: string[]) => translate(en,
    'Ei teknisiä tietoja saatavilla',
    ...val),

  Q53K: (en: string, ...val: string[]) => translate(en,
    'Tilaa KelloSIM-lisäpalvelu',
    ...val),

  Q57Q: (en: string, ...val: string[]) => translate(en,
    'Voit asettaa työntekijälle "kassalla" pakotetusti näytettävän popUp -viestin. Viestin otsikkona on "Huomioitavaa työnantajasi pääkäyttäjältä", jota ei voi muuttaa. Voit asettaa viestin päälle ja pois laitelistakohtaisesti.',
    ...val),

  Q5UU: (en: string, ...val: string[]) => translate(en,
    '{} MESH-laitetta',
    ...val),

  Q61D: (en: string, ...val: string[]) => translate(en,
    'Tukipyynnön lähetys onnistui. Päivitä sivu nähdäksesi uusimmat tukipyynnöt.',
    ...val),

  Q6TC: (en: string, ...val: string[]) => translate(en,
    'Haluttu verkkotunnus. Esim. kotisivut.fi',
    ...val),

  Q6TK: (en: string, ...val: string[]) => translate(en,
    'Turvallisuussyistä poistamme yli 12 kk käyttämättä olleet OmaElisa-tunnukset automaattisesti. Jos et ole käyttänyt tunnuksiasi pitkään aikaan, sinun on luotava uudet tunnukset',
    ...val),

  Q8B7: (en: string, ...val: string[]) => translate(en,
    'Työnantajayrityksesi',
    ...val),

  Q8W5: (en: string, ...val: string[]) => translate(en,
    'Takuukuitti ei ole saatavilla tälle tilaukselle',
    ...val),

  Q8ZW: (en: string, ...val: string[]) => translate(en,
    'Sisältää akullisen liikuteltavan mobiilireitittimen markkinoiden parhaalla akunkestolla.',
    ...val),

  Q9G5: (en: string, ...val: string[]) => translate(en,
    'Puhelintuki tietoturvaongelmissa',
    ...val),

  Q9YM: (en: string, ...val: string[]) => translate(en,
    'Yritä tunnistautua uudelleen.',
    ...val),

  QAKO: (en: string, ...val: string[]) => translate(en,
    'Muutosmaksut lisätään seuraavalle laskulle',
    ...val),

  QAMU: (en: string, ...val: string[]) => translate(en,
    'Elisan Mobiiliturva yrityksille on uudenlainen tietoturvapalvelu mobiililiittymään. Palvelu tunnistaa haitalliset sivustot ja tuo digiturvaa käyttäessäsi mobiililiittymää.',
    ...val),

  QAMW: (en: string, ...val: string[]) => translate(en,
    ' on uudenlainen tietoturvapalvelu, joka parantaa mobiililiittymän selainturvallisuutta. Palvelu tunnistaa haitalliset sivustot automaattisesti ja ilmoittaa niistä käyttäjälle.',
    ...val),

  QB1A: (en: string, ...val: string[]) => translate(en,
    'Tietoja tallennetaan...',
    ...val),

  QCAF: (en: string, ...val: string[]) => translate(en,
    'Tekstiviestipaketti',
    ...val),

  QCG8: (en: string, ...val: string[]) => translate(en,
    'Liittymätyypin muutos',
    ...val),

  QDKP: (en: string, ...val: string[]) => translate(en,
    'Tilauksen tyyppi',
    ...val),

  QDTC: (en: string, ...val: string[]) => translate(en,
    'Tarkista sivun osoite.',
    ...val),

  QDU2: (en: string, ...val: string[]) => translate(en,
    'Muutos astuu voimaan noin vuorokauden kuluessa. Saat sähköpostiisi ilmoituksen muutetuista sopimuksista.',
    ...val),

  QE2O: (en: string, ...val: string[]) => translate(en,
    'henkilöasiakkaan OmaElisassa',
    ...val),

  QEFQ: (en: string, ...val: string[]) => translate(en,
    'Vaihtoetu yrityksille',
    ...val),

  QENF: (en: string, ...val: string[]) => translate(en,
    'Tiedostomuoto ei kelpaa. Tallenna tiedosto joko .csv tai .txt -muotoisena.',
    ...val),

  QF0D: (en: string, ...val: string[]) => translate(en,
    'Supernopeaan yrityskäyttöön, videoneuvotteluihin ja 8K-leffoihin.',
    ...val),

  QF2O: (en: string, ...val: string[]) => translate(en,
    'Myyntilomakkeet',
    ...val),

  QF5T: (en: string, ...val: string[]) => translate(en,
    'Tilauksen yhteenveto',
    ...val),

  QFXU: (en: string, ...val: string[]) => translate(en,
    'Ei tilauksia',
    ...val),

  QG2G: (en: string, ...val: string[]) => translate(en,
    'Yritysten OmaElisaan, jolloin voimme antaa sinulle henkilökohtaisempaa palvelua.',
    ...val),

  QG50: (en: string, ...val: string[]) => translate(en,
    'Kaikki laitteet',
    ...val),

  QGCA: (en: string, ...val: string[]) => translate(en,
    'Tiliote',
    ...val),

  QGS0: (en: string, ...val: string[]) => translate(en,
    'Kaksivaiheinen tunnistautuminen parantaa yrityksesi tietoturvaa. Käytännössä se tarkoittaa, että tunnuksen ja salasanan lisäksi tarvitset kirjautumiseen tekstiviestillä saapuvan kertakäyttöisen tunnistautumiskoodin. Kaksivaiheinen tunnistautuminen vaaditaan jokaiselta Yritysten OmaElisa -pääkäyttäjältä. Muutos koskee myös OmaElisa Classicia.',
    ...val),

  QH8P: (en: string, ...val: string[]) => translate(en,
    'Liittymätyyppi',
    ...val),

  QHG2: (en: string, ...val: string[]) => translate(en,
    'Olen tarkistanut, että kaikkien pääkäyttäjien käyttäjätunnuksen tiedot ovat oikein ja ajan tasalla.',
    ...val),

  QIHT: (en: string, ...val: string[]) => translate(en,
    'Sisältää 5000 kpl viestiä Pohjolassa ja Baltiassa, ylimenevät viestit 0,079 €/kpl',
    ...val),

  QIK1: (en: string, ...val: string[]) => translate(en,
    'Tunnus',
    ...val),

  QIKB: (en: string, ...val: string[]) => translate(en,
    'Syötä puhelinnumerosi',
    ...val),

  QJ7O: (en: string, ...val: string[]) => translate(en,
    'Salasanan päivittämisen jälkeen sinut kirjataan ulos kaikista Elisan palveluista, ja sinun on kirjauduttava uudelleen sisään.',
    ...val),

  QJEF: (en: string, ...val: string[]) => translate(en,
    'Jos ongelma jatkuu, ota yhteyttä yritysasiakaspalveluumme.',
    ...val),

  QJG7: (en: string, ...val: string[]) => translate(en,
    'Laitelistan tuotevalikoiman kopiointi epäonnistui.',
    ...val),

  QJL0: (en: string, ...val: string[]) => translate(en,
    'Siirry Asennus- ja hallintapalveluun',
    ...val),

  QK7P: (en: string, ...val: string[]) => translate(en,
    'Alennuskoodi "{}" huomioitu.',
    ...val),

  QKAC: (en: string, ...val: string[]) => translate(en,
    'Sis. 10 Gt datan käyttöä kotimaassa. Paketin ylimenevä datankäyttö 6,50 € / alkava 10 Gt.',
    ...val),

  QKRX: (en: string, ...val: string[]) => translate(en,
    'Nopea tiedonsiirto, 8K-leffat ilman katkoksia',
    ...val),

  QL4P: (en: string, ...val: string[]) => translate(en,
    'Laskutussopimuksen avoinna olevien laskujen yhteissumma ja mahdolliset liikasuoritukset.',
    ...val),

  QL8F: (en: string, ...val: string[]) => translate(en,
    'Ostolaite',
    ...val),

  QLJY: (en: string, ...val: string[]) => translate(en,
    'Puheluestot',
    ...val),

  QLKN: (en: string, ...val: string[]) => translate(en,
    'Muistikortit',
    ...val),

  QM6C: (en: string, ...val: string[]) => translate(en,
    'Toimii myös ruuhkassa',
    ...val),

  QMMA: (en: string, ...val: string[]) => translate(en,
    'Tilaa uusi SIM',
    ...val),

  QMXU: (en: string, ...val: string[]) => translate(en,
    'Ostetut laitteet',
    ...val),

  QNC2: (en: string, ...val: string[]) => translate(en,
    ' Näytä julkaistu versio',
    ...val),

  QNUL: (en: string, ...val: string[]) => translate(en,
    'Rungossa naarmuja tai kulumaa',
    ...val),

  QNVB: (en: string, ...val: string[]) => translate(en,
    'Tämä ei ole Elisan yritysasiakkaan omistama matkapuhelinnumero.',
    ...val),

  QOTV: (en: string, ...val: string[]) => translate(en,
    'Lähetimme numeroon {} vahvistuskoodin tekstiviestillä.',
    ...val),

  QOWZ: (en: string, ...val: string[]) => translate(en,
    'Liittymän päivittäminen hyllyliittymäksi ei onnistu',
    ...val),

  QP30: (en: string, ...val: string[]) => translate(en,
    'Jos laskun viitenumero on 80-alkuinen, kyseessä on vakioviitteellinen lasku. Maksusuoritukset kohdistuvat aina vanhimpaan avoimeen laskuun.',
    ...val),

  QP4T: (en: string, ...val: string[]) => translate(en,
    'Tukipyynnön luonti epäonnistui. Ole hyvä ja ota yhteyttä asiakaspalveluun.',
    ...val),

  QPHB: (en: string, ...val: string[]) => translate(en,
    'Käyttäjän {} Ring-palvelu säilytetään. Jotta Ring-liittymää voi käyttää ilman matkapuhelinta, on silloin otettava lisäpalveluksi ohjelmisto- tai IP-puhelin.',
    ...val),

  QPYC: (en: string, ...val: string[]) => translate(en,
    'Huomioithan että seuraavat lisäpalvelut ovat epäyhteensopivia Elisa Ring -palvelun kanssa ja ne suljetaan automaattisesti. Ring -palveluun sisältyy korvaava lisäpalvelu.',
    ...val),

  QQ5W: (en: string, ...val: string[]) => translate(en,
    'Kaapelimodeemin MAC-osoite',
    ...val),

  QQ80: (en: string, ...val: string[]) => translate(en,
    'Liittymään sisältyy',
    ...val),

  QQFY: (en: string, ...val: string[]) => translate(en,
    'Kaksivaiheinen tunnistautuminen',
    ...val),

  QQGQ: (en: string, ...val: string[]) => translate(en,
    'SIM-kortin tilaus',
    ...val),

  QQGU: (en: string, ...val: string[]) => translate(en,
    'Virheellinen alennuskoodi',
    ...val),

  QQH4: (en: string, ...val: string[]) => translate(en,
    'Toimitus 1-3 arkipäivässä.',
    ...val),

  QQJX: (en: string, ...val: string[]) => translate(en,
    'Liitä Elisa KelloSIM liittymääsi kirjautumalla Työntekijöiden OmaElisaan',
    ...val),

  QQSJ: (en: string, ...val: string[]) => translate(en,
    'Lisää uusi käyttäjä',
    ...val),

  QRED: (en: string, ...val: string[]) => translate(en,
    'Lisätyt palvelut',
    ...val),

  QRH4: (en: string, ...val: string[]) => translate(en,
    'Esto ei käytössä',
    ...val),

  QRON: (en: string, ...val: string[]) => translate(en,
    'Rekisteröidy yritysasiakkaaksi',
    ...val),

  QRYV: (en: string, ...val: string[]) => translate(en,
    'Valitse',
    ...val),

  QS9H: (en: string, ...val: string[]) => translate(en,
    'Tutustu Suomen Yrittäjien jäsenetuihin',
    ...val),

  QSG9: (en: string, ...val: string[]) => translate(en,
    'Kaikille kodin netinkäyttäjille ja laitteille',
    ...val),

  QSXP: (en: string, ...val: string[]) => translate(en,
    'Vahinkopalvelu',
    ...val),

  QTLF: (en: string, ...val: string[]) => translate(en,
    'Palvelun hinta {0}/kk yritysnumeroille (010-, 020- jne.) ja muille numeroille {1}/kk.',
    ...val),

  QTYF: (en: string, ...val: string[]) => translate(en,
    'Numeron julkisuus vaihtoehdot',
    ...val),

  QU5H: (en: string, ...val: string[]) => translate(en,
    'Kutsu Yritysten OmaElisaan',
    ...val),

  QU5I: (en: string, ...val: string[]) => translate(en,
    'Kutsu Työntekijän OmaElisaan',
    ...val),

  QUBS: (en: string, ...val: string[]) => translate(en,
    'Liitä Elisa Tunnuksesi yritykseen, jotta voit hoitaa yrityksen asioita Yritysten OmaElisassa.',
    ...val),

  QUDL: (en: string, ...val: string[]) => translate(en,
    'Tilaus onnistui',
    ...val),

  QV5K: (en: string, ...val: string[]) => translate(en,
    'Avaa liittymä',
    ...val),

  QVCE: (en: string, ...val: string[]) => translate(en,
    'maksettuja',
    ...val),

  QVYK: (en: string, ...val: string[]) => translate(en,
    'Vahvista',
    ...val),

  QWC8: (en: string, ...val: string[]) => translate(en,
    'Tuntematon',
    ...val),

  QXQ7: (en: string, ...val: string[]) => translate(en,
    'Kiinteä laajakaista',
    ...val),

  QXUN: (en: string, ...val: string[]) => translate(en,
    'Sis. {} Gt datan käyttöä Pohjola & Baltia sekä muun EU:n alueella. Paketin ylimenevä datankäyttö 4,50 € / alkava 5 Gt.',
    ...val),

  QY8T: (en: string, ...val: string[]) => translate(en,
    'Elisan Aito 5G on teknologisesti edistynein verkkovaihtoehto, joka tuo yrityksellesi konkreettisia hyötyjä',
    ...val),

  QYQX: (en: string, ...val: string[]) => translate(en,
    'Ei kutsuja',
    ...val),

  QYSL: (en: string, ...val: string[]) => translate(en,
    'Kertamaksullinen',
    ...val),

  QYXA: (en: string, ...val: string[]) => translate(en,
    'Tilaa uusi SIM-kortti',
    ...val),

  QZ2C: (en: string, ...val: string[]) => translate(en,
    'Sunnuntai',
    ...val),

  QZM5: (en: string, ...val: string[]) => translate(en,
    'Nykyisessä liittymässäsi on määräaikainen sopimus vielä kesken, minkä vuoksi liittymän päivitys onnistuu vain myyntimme kautta. Soita numeroon 0800 04411 (ma-pe 8-16), niin katsotaan yhdessä liittymäasiasi kuntoon!',
    ...val),

  QZVD: (en: string, ...val: string[]) => translate(en,
    'Varattu numeroavaruus',
    ...val),

  QZZR: (en: string, ...val: string[]) => translate(en,
    'Jos teit juuri tilauksen, niin ei huolta. Osa tilauksista tulee näkyviin viiveellä.',
    ...val),

  R0EY: (en: string, ...val: string[]) => translate(en,
    'Käyttäjää ei voida siirtää toiseen yritykseen, koska:',
    ...val),

  R0LP: (en: string, ...val: string[]) => translate(en,
    'Aktivointikoodi',
    ...val),

  R0OK: (en: string, ...val: string[]) => translate(en,
    'Maksullinen data',
    ...val),

  R0YI: (en: string, ...val: string[]) => translate(en,
    'Tallennetaan keskeneräistä tilausta',
    ...val),

  R13J: (en: string, ...val: string[]) => translate(en,
    'Jatkamme asian käsittelyä mahdollisimman pian.',
    ...val),

  R1D7: (en: string, ...val: string[]) => translate(en,
    'Katso 4K-leffoja ja -sarjoja',
    ...val),

  R1PB: (en: string, ...val: string[]) => translate(en,
    'Englanti',
    ...val),

  R28M: (en: string, ...val: string[]) => translate(en,
    'Liittymän avaaminen ei onnistu',
    ...val),

  R28N: (en: string, ...val: string[]) => translate(en,
    'Laajakaistakorjaimen käynnistäminen epäonnistui',
    ...val),

  R2DK: (en: string, ...val: string[]) => translate(en,
    'Ei toimitettavaa.',
    ...val),

  R2MM: (en: string, ...val: string[]) => translate(en,
    'Vaihda salasana',
    ...val),

  R2NG: (en: string, ...val: string[]) => translate(en,
    'Lue lisää {} palvelusta',
    ...val),

  R37K: (en: string, ...val: string[]) => translate(en,
    'Palvelun tilaaminen onnistui',
    ...val),

  R39E: (en: string, ...val: string[]) => translate(en,
    'Yksikköhinta',
    ...val),

  R3RM: (en: string, ...val: string[]) => translate(en,
    'Anna domain muodossa kotisivut.fi',
    ...val),

  R3VE: (en: string, ...val: string[]) => translate(en,
    'Poista',
    ...val),

  R488: (en: string, ...val: string[]) => translate(en,
    'Kaapeli',
    ...val),

  R4EV: (en: string, ...val: string[]) => translate(en,
    'Tuotteiden tiedot',
    ...val),

  R4O4: (en: string, ...val: string[]) => translate(en,
    'Latausnopeus',
    ...val),

  R58C: (en: string, ...val: string[]) => translate(en,
    'Maksun palautus',
    ...val),

  R5U2: (en: string, ...val: string[]) => translate(en,
    'Ota yhteyttä asiakaspalveluun',
    ...val),

  R69E: (en: string, ...val: string[]) => translate(en,
    'Vahvistus',
    ...val),

  R6AR: (en: string, ...val: string[]) => translate(en,
    'Puhelinliittymä',
    ...val),

  R6HP: (en: string, ...val: string[]) => translate(en,
    'Tuotetyyppi',
    ...val),

  R6WZ: (en: string, ...val: string[]) => translate(en,
    'Hyvitys maksetaan laskutussopimuksellesi ja voit käyttää sen tuleviin laskuihin ja ostoihin.',
    ...val),

  R7AY: (en: string, ...val: string[]) => translate(en,
    'Parempi akunkesto',
    ...val),

  R7FZ: (en: string, ...val: string[]) => translate(en,
    'Työntekijä',
    ...val),

  R7VE: (en: string, ...val: string[]) => translate(en,
    'Asennus',
    ...val),

  R805: (en: string, ...val: string[]) => translate(en,
    'Käyttö ulkomailla',
    ...val),

  R8HE: (en: string, ...val: string[]) => translate(en,
    'Valitettavasti tilausta ei voida käsitellä luottopäätöksen vuoksi. Tiesithän, että kertamaksullisia laitteita ja lisävarusteita voit maksaa korttimaksulla.',
    ...val),

  R8IE: (en: string, ...val: string[]) => translate(en,
    'Poistetaan',
    ...val),

  R8ND: (en: string, ...val: string[]) => translate(en,
    'Datan käyttö (3G 21M) 0,20€/Mt',
    ...val),

  R9VH: (en: string, ...val: string[]) => translate(en,
    'Sähköpostiosoite (työ)',
    ...val),

  R9YZ: (en: string, ...val: string[]) => translate(en,
    'Tarjousnumero',
    ...val),

  RA43: (en: string, ...val: string[]) => translate(en,
    'Lisää puuttuva puhelin- tai nettiliittymäsi ',
    ...val),

  RA9V: (en: string, ...val: string[]) => translate(en,
    'Maksuaika {} kk',
    ...val),

  RAO4: (en: string, ...val: string[]) => translate(en,
    'Suoratoimituslaite. Emme voi taata toimitusta seuraavaksi arkipäiväksi.',
    ...val),

  RAS9: (en: string, ...val: string[]) => translate(en,
    '-välilehdeltä',
    ...val),

  RB6Z: (en: string, ...val: string[]) => translate(en,
    'Yritysrakenteessa ei ole muita yrityksiä, joille laitelistan voi kopioida.',
    ...val),

  RBCF: (en: string, ...val: string[]) => translate(en,
    'Siirrä suuria tiedostoja hetkessä',
    ...val),

  RCF3: (en: string, ...val: string[]) => translate(en,
    'Vahvista eSIM-tilaus',
    ...val),

  RCIG: (en: string, ...val: string[]) => translate(en,
    'Mikäli laitevaihtoa ei tehdä tai sopimusta päätetä jatkokauden aikana, laite siirtyy automaattisesti yrityksen omaisuudeksi.',
    ...val),

  RCPW: (en: string, ...val: string[]) => translate(en,
    'Ladataan laskutustilejä',
    ...val),

  RCQ9: (en: string, ...val: string[]) => translate(en,
    'Laitteen käyttäjä',
    ...val),

  RCVR: (en: string, ...val: string[]) => translate(en,
    'avulla',
    ...val),

  RD4R: (en: string, ...val: string[]) => translate(en,
    'Ohjeet',
    ...val),

  RD75: (en: string, ...val: string[]) => translate(en,
    'Sähköpostiosoite tai osoitteet',
    ...val),

  RDSM: (en: string, ...val: string[]) => translate(en,
    'Poissaoloaikana',
    ...val),

  RDZA: (en: string, ...val: string[]) => translate(en,
    'Hyväksy lunastuspyyntö',
    ...val),

  RE1O: (en: string, ...val: string[]) => translate(en,
    'Jopa 20 % parempi mobiililaitteen akun kesto.',
    ...val),

  REA8: (en: string, ...val: string[]) => translate(en,
    'Sopimusnumero',
    ...val),

  REM3: (en: string, ...val: string[]) => translate(en,
    'Kirjoita vähintään 3 merkkiä. Jatka kirjoittamista jos yrityksesi ei näy heti hakutuloksissa. Esim. Yritys Oy 1234567-8. ',
    ...val),

  RF14: (en: string, ...val: string[]) => translate(en,
    'Liittymän toivottu asennuspäivä',
    ...val),

  RFGN: (en: string, ...val: string[]) => translate(en,
    'Vakio-ratkaisu',
    ...val),

  RFH9: (en: string, ...val: string[]) => translate(en,
    'Yksi SIM-kortti voidaan kytkeä vain yhteen liittymään.',
    ...val),

  RFSE: (en: string, ...val: string[]) => translate(en,
    'Jätä viesti myynnille',
    ...val),

  RG74: (en: string, ...val: string[]) => translate(en,
    'Yhteyshenkilön luonti epäonnistui.',
    ...val),

  RH6T: (en: string, ...val: string[]) => translate(en,
    'Laskutussopimuksen nimi',
    ...val),

  RHLM: (en: string, ...val: string[]) => translate(en,
    'liittymän käyttö ulkomailla',
    ...val),

  RHLU: (en: string, ...val: string[]) => translate(en,
    'Liittymän Ring-asetukset',
    ...val),

  RHTI: (en: string, ...val: string[]) => translate(en,
    'Haku toimii vain tilaustyypin ja numeron sarakkeissa',
    ...val),

  RJ27: (en: string, ...val: string[]) => translate(en,
    'Maksettu',
    ...val),

  RJR0: (en: string, ...val: string[]) => translate(en,
    'Käyttöopas ja pikaopas',
    ...val),

  RJT5: (en: string, ...val: string[]) => translate(en,
    'Valitse listalta yhteyshenkilö tai luo uusi.',
    ...val),

  RKNP: (en: string, ...val: string[]) => translate(en,
    'Etsitkö henkilöasiakkaan asiointia?',
    ...val),

  RKRB: (en: string, ...val: string[]) => translate(en,
    'Valitse vähintään yksi liittymä.',
    ...val),

  RKUQ: (en: string, ...val: string[]) => translate(en,
    'Olen maksanut laskun',
    ...val),

  RKZC: (en: string, ...val: string[]) => translate(en,
    'Palvelussa tapahtui virhe',
    ...val),

  RL8F: (en: string, ...val: string[]) => translate(en,
    'Lisää liittymä Vakioon',
    ...val),

  RLFR: (en: string, ...val: string[]) => translate(en,
    'Kutsu työntekijöitä',
    ...val),

  RLGI: (en: string, ...val: string[]) => translate(en,
    'Mahdolliset lisätiedot',
    ...val),

  RLNC: (en: string, ...val: string[]) => translate(en,
    'Valitse minkä yrityksen Työntekijän OmaElisassa haluat asioida',
    ...val),

  RLXT: (en: string, ...val: string[]) => translate(en,
    'Luo uusi tukipyyntö tai viesti',
    ...val),

  RM4V: (en: string, ...val: string[]) => translate(en,
    'Käyttäjän siirto toiseen yritykseen onnistui',
    ...val),

  RMBH: (en: string, ...val: string[]) => translate(en,
    'Laskukopiot',
    ...val),

  RMXD: (en: string, ...val: string[]) => translate(en,
    'Osta lisäpalveluna',
    ...val),

  RMXE: (en: string, ...val: string[]) => translate(en,
    'Saatavilla OmaElisassa',
    ...val),

  RN1O: (en: string, ...val: string[]) => translate(en,
    'Helpompi arki',
    ...val),

  RN44: (en: string, ...val: string[]) => translate(en,
    'Tukipyynnöt-sivulta',
    ...val),

  ROBH: (en: string, ...val: string[]) => translate(en,
    'Tee tukipyyntö',
    ...val),

  ROMH: (en: string, ...val: string[]) => translate(en,
    'Tarkista sähköpostisoite. Sähköpostiosoitteessa ei voi olla ääkkösiä.',
    ...val),

  RP0S: (en: string, ...val: string[]) => translate(en,
    'Rajattu laskutussopimuslista',
    ...val),

  RP6P: (en: string, ...val: string[]) => translate(en,
    'Yhteiskäyttölaitteet',
    ...val),

  RPL9: (en: string, ...val: string[]) => translate(en,
    'Arvo',
    ...val),

  RPMR: (en: string, ...val: string[]) => translate(en,
    'Laskutustiedot',
    ...val),

  RPVC: (en: string, ...val: string[]) => translate(en,
    'Valitse SIM-kortin tyyppi',
    ...val),

  RQ67: (en: string, ...val: string[]) => translate(en,
    'Liittymällä on määräaikaisuus joka estää sen päivittämisen hyllyliittymäksi.',
    ...val),

  RQA1: (en: string, ...val: string[]) => translate(en,
    'Tietojen tallentaminen epäonnistui. Yritä uudelleen',
    ...val),

  RQMS: (en: string, ...val: string[]) => translate(en,
    'Tietojen muokkaus ei onnistu',
    ...val),

  RR0O: (en: string, ...val: string[]) => translate(en,
    'OmaElisa Classicissa.',
    ...val),

  RREM: (en: string, ...val: string[]) => translate(en,
    'työ',
    ...val),

  RSDJ: (en: string, ...val: string[]) => translate(en,
    'Seuraavassa vaiheessa voit esikatsella ja tarkastaa, että lomake on täytetty oikein. Tämän jälkeen voit lähettää lomakkeen käsiteltäväksi.',
    ...val),

  RSW7: (en: string, ...val: string[]) => translate(en,
    'Toimitus seuraavana työpäivänä klo 16.00 mennessä kattavasti lähes koko Suomen alueella.',
    ...val),

  RTJW: (en: string, ...val: string[]) => translate(en,
    'Muokattu',
    ...val),

  RTLQ: (en: string, ...val: string[]) => translate(en,
    'Tarkista ja täydennä käyttäjän tiedot. Muista käyttää uuden yrityksen tietoja.',
    ...val),

  RTNX: (en: string, ...val: string[]) => translate(en,
    'Tilauksen lähetys onnistui',
    ...val),

  RTZM: (en: string, ...val: string[]) => translate(en,
    'Toimitus 1-2 arkipäivässä valitsemaasi pakettiautomaattiin tai noutopisteeseen.',
    ...val),

  RUAW: (en: string, ...val: string[]) => translate(en,
    'Postinumero',
    ...val),

  RUU7: (en: string, ...val: string[]) => translate(en,
    'Kuukausimaksusi',
    ...val),

  RV74: (en: string, ...val: string[]) => translate(en,
    'Etuliitteet soittaessa',
    ...val),

  RVSV: (en: string, ...val: string[]) => translate(en,
    'Tuntematon virhe.',
    ...val),

  RVSW: (en: string, ...val: string[]) => translate(en,
    'Lähettäjä',
    ...val),

  RW6O: (en: string, ...val: string[]) => translate(en,
    'Odota hetki, tietoja tarkastetaan...',
    ...val),

  RW9V: (en: string, ...val: string[]) => translate(en,
    'Päivitä liittymää',
    ...val),

  RWE3: (en: string, ...val: string[]) => translate(en,
    'Lisää laite tai liittymä',
    ...val),

  RWLD: (en: string, ...val: string[]) => translate(en,
    'Päivitä liittymätyyppiä',
    ...val),

  RWP3: (en: string, ...val: string[]) => translate(en,
    'Liittymä on jo liitetty Ring-ratkaisuun.',
    ...val),

  RX8Z: (en: string, ...val: string[]) => translate(en,
    'Tunnuksen luonti epäonnistui',
    ...val),

  RXBO: (en: string, ...val: string[]) => translate(en,
    'Laskutussopimus valitaan erikseen joka tilaukselle',
    ...val),

  RXQO: (en: string, ...val: string[]) => translate(en,
    'Vahvista sähköpostiosoitteesi.',
    ...val),

  RXRO: (en: string, ...val: string[]) => translate(en,
    'Tämä on Elisa Tunnuksen testiympäristö.',
    ...val),

  RXWZ: (en: string, ...val: string[]) => translate(en,
    'Anna postinumero valitaksesi noutopisteen',
    ...val),

  RY1J: (en: string, ...val: string[]) => translate(en,
    'Suosittelemme käyttämään yksilöllistä sähköpostia ja puhelinnumeroa tai valitsemaan sopivan yhteyshenkilön yrityksesi käyttäjälistalta.',
    ...val),

  RYGM: (en: string, ...val: string[]) => translate(en,
    'Minuuttihintaiset liittymät',
    ...val),

  RYLC: (en: string, ...val: string[]) => translate(en,
    'Lähetämme tiedon laitesopimuksen hylkäämisestä osoitteeseen',
    ...val),

  RYY6: (en: string, ...val: string[]) => translate(en,
    'Estä puhelut ulkomaille',
    ...val),

  RZIU: (en: string, ...val: string[]) => translate(en,
    'Kutsun lähetys työntekijälle epäonnistui',
    ...val),

  RZQ4: (en: string, ...val: string[]) => translate(en,
    'Kuitutyyppi',
    ...val),

  RZU4: (en: string, ...val: string[]) => translate(en,
    'Vahvista tilaus',
    ...val),

  RZXL: (en: string, ...val: string[]) => translate(en,
    'Tuotevalinta puuttuu',
    ...val),

  S06E: (en: string, ...val: string[]) => translate(en,
    'Jos linkki vanhenee, olethan yhteydessä työnantajasi yhteyshenkilöön',
    ...val),

  S07L: (en: string, ...val: string[]) => translate(en,
    'Oletko varma, että haluat irtisanoa Elisa Mobiilivarmenne Työntekijälle -palvelun',
    ...val),

  S0FN: (en: string, ...val: string[]) => translate(en,
    'Työntekijän OmaElisa',
    ...val),

  S0H2: (en: string, ...val: string[]) => translate(en,
    'Liittymällä on käytössä lisäpalveluita, jotka estävät sen muuttamisen hyllyliittymäksi.',
    ...val),

  S0IN: (en: string, ...val: string[]) => translate(en,
    'On tärkeää, että työsähköpostisi ja -puhelinnumerosi ovat ajan tasalla Työntekijän OmaElisassa. Hyödynnämme näitä yhteystietojasi, kun laitamme sinulle viestiä yrityksesi käyttämistä Elisan palveluista. Ilmoitamme sinulle esimerkiksi tilaamiesi tuotteiden toimituksesta.\nYrityksesi pääkäyttäjä näkee antamasi työyhteystiedot Yritysten OmaElisassa, jossa hän pääsee niitä tarvittaessa myös muokkaamaan. Jos puhelinnumerosi on julkinen, se näkyy lisäksi luettelotiedoissa.',
    ...val),

  S0PU: (en: string, ...val: string[]) => translate(en,
    'Elisa Yritystietoturva',
    ...val),

  S0V2: (en: string, ...val: string[]) => translate(en,
    'Elisa veloittaa tuhoutuneesta tai kadonneesta laitteesta jäljelle jäävien kuukausimaksujen summan kertaveloituksena.',
    ...val),

  S1F0: (en: string, ...val: string[]) => translate(en,
    'Puhelut numero- ja yhdistämispalvelunumeroihin sekä hyötypalveluihin, esim. soittaminen ja tekstiviestit numeropalveluun, taksin tilaus ja pankkipalvelut',
    ...val),

  S3DX: (en: string, ...val: string[]) => translate(en,
    'Laskutussopimuksen vaihto epäonnistui',
    ...val),

  S4FM: (en: string, ...val: string[]) => translate(en,
    'Piilota salasana',
    ...val),

  S4HQ: (en: string, ...val: string[]) => translate(en,
    'Voit muokata e-laskua omassa verkkopankissasi.',
    ...val),

  S4ME: (en: string, ...val: string[]) => translate(en,
    'Tarjous {0} ({1})  on hylätty onnistuneesti.',
    ...val),

  S5JH: (en: string, ...val: string[]) => translate(en,
    'Elisan yritysverkkokaupasta löydät kaiken tarvittavan sujuvaan arkeen, työntekoon ja toimistoon. Tilaa laitteet helposti netistä!',
    ...val),

  S5PK: (en: string, ...val: string[]) => translate(en,
    'Yhteyssähköpostiosoite',
    ...val),

  S5QX: (en: string, ...val: string[]) => translate(en,
    'Kotiosoite',
    ...val),

  S5RO: (en: string, ...val: string[]) => translate(en,
    'Käyttäjä on siirretty yritykseen {}. Huomaa, että käyttäjän tuotteet näkyvät tällä sivulla vasta, kun niiden siirto on käsitelty.',
    ...val),

  S6EV: (en: string, ...val: string[]) => translate(en,
    'Arvo voi sisältää vain numeroita 0-9, kirjaimia a-f ja kaksoispisteitä.',
    ...val),

  S6PJ: (en: string, ...val: string[]) => translate(en,
    'Kiitos yhteydenotosta!',
    ...val),

  S6U5: (en: string, ...val: string[]) => translate(en,
    ':n käyttäjät',
    ...val),

  S74X: (en: string, ...val: string[]) => translate(en,
    'Jos haluat voit seurata datan käyttöäsi älypuhelimesi asetuksista. Joissain puhelimissa on myös netin käyttöä seuraavat laskurit.',
    ...val),

  S81T: (en: string, ...val: string[]) => translate(en,
    'Matkapuhelinnumeroa ei löydy tai se ei ole aktiivinen',
    ...val),

  S86I: (en: string, ...val: string[]) => translate(en,
    'Kierrätä vanha laitteesi ja hyödynnä hyvitys tuleviin ostoihisi.',
    ...val),

  S8K2: (en: string, ...val: string[]) => translate(en,
    'Tietojen päivityksessä saattaa kestää muutama minuutti, jonka jälkeen voit käyttää liittymää kellollasi.',
    ...val),

  S8N1: (en: string, ...val: string[]) => translate(en,
    ' Laskulle tulostuva laskun maksajan y-tunnus.',
    ...val),

  S8ON: (en: string, ...val: string[]) => translate(en,
    'laitteen, joka tukee 5G SA -teknologiaa.',
    ...val),

  S8TX: (en: string, ...val: string[]) => translate(en,
    'alv. 0 %',
    ...val),

  SBCJ: (en: string, ...val: string[]) => translate(en,
    'Estä datasiirto EU:n ja ETA:n ulkopuolella',
    ...val),

  SBUB: (en: string, ...val: string[]) => translate(en,
    'Saatavuustietojen haussa oli ongelma, tee vikailmoitus tai pyydä apua YA Päivittäistuesta',
    ...val),

  SC8P: (en: string, ...val: string[]) => translate(en,
    'Aika-asetukset',
    ...val),

  SCDP: (en: string, ...val: string[]) => translate(en,
    'Nauhoitamme kaikki puhelut palvelun laadun varmistamiseksi. Lisätietoja tietosuojasta saat osoitteesta',
    ...val),

  SCL4: (en: string, ...val: string[]) => translate(en,
    'Julkinen',
    ...val),

  SCQO: (en: string, ...val: string[]) => translate(en,
    'Käyttöraja',
    ...val),

  SCZB: (en: string, ...val: string[]) => translate(en,
    'Unohtunut tai vanhentunut käyttäjätunnus',
    ...val),

  SD0B: (en: string, ...val: string[]) => translate(en,
    'Eikö sinulla ole tunnuksia? Voit lähettää viestin meille myös kirjautumatta.',
    ...val),

  SDO3: (en: string, ...val: string[]) => translate(en,
    'Muokkaa käyttöoikeuksia',
    ...val),

  SDQA: (en: string, ...val: string[]) => translate(en,
    ' näyttää puhelimessa soittajan nimitiedon, vaikka numeroa ei olisi tallennettuna puhelimen osoitekirjaan.',
    ...val),

  SDTI: (en: string, ...val: string[]) => translate(en,
    'Rajaton data kotimaassa, Pohjolassa ja Baltiassa',
    ...val),

  SDTJ: (en: string, ...val: string[]) => translate(en,
    'Sujuva arki ja työnteko',
    ...val),

  SDTK: (en: string, ...val: string[]) => translate(en,
    'Palaverit ja leffojen katselu',
    ...val),

  SDTL: (en: string, ...val: string[]) => translate(en,
    'Suositus {0} henkilöä ({1} laitetta)',
    ...val),

  SDTM: (en: string, ...val: string[]) => translate(en,
    'Sujuvaan arkikäyttöön',
    ...val),

  SDTN: (en: string, ...val: string[]) => translate(en,
    'Aktiivinen työnteko',
    ...val),

  SDTO: (en: string, ...val: string[]) => translate(en,
    'Videopalaverit ja sarjojen katselu',
    ...val),

  SDTP: (en: string, ...val: string[]) => translate(en,
    'Nopea yrityskäyttö',
    ...val),

  SDTQ: (en: string, ...val: string[]) => translate(en,
    'Videoneuvottelut ja 4K-leffat',
    ...val),

  SDTR: (en: string, ...val: string[]) => translate(en,
    'Aktiiviseen surffailuun',
    ...val),

  SDTS: (en: string, ...val: string[]) => translate(en,
    'Nopeaan yrityskäyttöön',
    ...val),

  SDTT: (en: string, ...val: string[]) => translate(en,
    'Supernopea yrityskäyttö',
    ...val),

  SDTU: (en: string, ...val: string[]) => translate(en,
    'Videoneuvottelut ja 8K-leffat',
    ...val),

  SDTV: (en: string, ...val: string[]) => translate(en,
    'Kaikki netinkäyttäjät ja laitteet',
    ...val),

  SDTW: (en: string, ...val: string[]) => translate(en,
    'Supernopeaan yrityskäyttöön',
    ...val),

  SDU1: (en: string, ...val: string[]) => translate(en,
    'Reitittimellä jaat verkon usealle eri laitteelle',
    ...val),

  SDU2: (en: string, ...val: string[]) => translate(en,
    'Saat parhaimman tehon irti mobiililaajakaistasta, kun hankit reitittimen. Reitittimellä voit jakaa verkon langattomalla WiFi-verkolla eri laitteille, kuten tietokoneille, tableteille ja televisioon. Valitse 4G-liittymään 4G-reititin ja 5G-liittymään 5G-reititin.',
    ...val),

  SDU3: (en: string, ...val: string[]) => translate(en,
    'Katso kaikki reitittimet',
    ...val),

  SDU4: (en: string, ...val: string[]) => translate(en,
    'Nettiliittymä pieneen toimistoon tai etätöihin',
    ...val),

  SDU5: (en: string, ...val: string[]) => translate(en,
    ' on täyden palvelun nettiliittymä pienelle yrityksellesi tai kotitoimistoon. Katsomme sinulle parhaimman vaihtoehdon sijaintisi ja tarpeesi mukaan.',
    ...val),

  SDU7: (en: string, ...val: string[]) => translate(en,
    'Ota liikkuva laajakaista yrityksessäsi sujuvasti käyttöön',
    ...val),

  SDU8: (en: string, ...val: string[]) => translate(en,
    'Lue ohjeet ja vinkit',
    ...val),

  SDU9: (en: string, ...val: string[]) => translate(en,
    'Kiinnostuitko?',
    ...val),

  SDUA: (en: string, ...val: string[]) => translate(en,
    'Jätä yhteystietosi',
    ...val),

  SDUB: (en: string, ...val: string[]) => translate(en,
    'Ma-Pe 8-16 | Maksuton numero',
    ...val),

  SDUD: (en: string, ...val: string[]) => translate(en,
    'Ma-Pe 8-20, La 9-17 | 3,04 €/puhelu + 3,04 € / alkava min alv. 25,5 % + pvm/mpm.',
    ...val),

  SDUF: (en: string, ...val: string[]) => translate(en,
    'Netti suuremmalle toimipaikalle',
    ...val),

  SDUG: (en: string, ...val: string[]) => translate(en,
    ' -liittymät tuovat vakaan nettiyhteyden toimipaikallesi. Voit myös hyödyntää niitä liiketilan monipuolisena nettiyhteytenä.',
    ...val),

  SDUI: (en: string, ...val: string[]) => translate(en,
    'Elisa Laitenetti – ketterä mobiililiittymä laitteisiin',
    ...val),

  SDUJ: (en: string, ...val: string[]) => translate(en,
    ' sopii esimerkiksi valvontakameroihin, hälytysjärjestelmiin tai GPS-paikantimiin. Tutustu ja tilaa Laitenetti-liittymä etäohjattaviin laitteisiin!',
    ...val),

  SDUV: (en: string, ...val: string[]) => translate(en,
    'Salasana vaihdettu onnistuneesti.',
    ...val),

  SDV0: (en: string, ...val: string[]) => translate(en,
    'Mobiililaajakaista - liikkuva laajakaista yrityksille',
    ...val),

  SDV1: (en: string, ...val: string[]) => translate(en,
    'Liikkuva netti kulkee mukana etätöissä ja reissussa. Liikkuva laajakaista on SIM-kortilla toimiva mobiililaajakaistaliittymä, jolla saat nettiyhteyden esimerkiksi tablettiin tai reitittimeen.',
    ...val),

  SDV2: (en: string, ...val: string[]) => translate(en,
    'Toimiva netti missä vain',
    ...val),

  SDV3: (en: string, ...val: string[]) => translate(en,
    'Aito 5G',
    ...val),

  SDV4: (en: string, ...val: string[]) => translate(en,
    'Kattavat datapaketit',
    ...val),

  SDV5: (en: string, ...val: string[]) => translate(en,
    'Mobiililaajakaista sopii hyvin liikkuvaan työhön. Hoida työt joustavasti eri paikoissa - etätöissä, työmatkoilla ja myyntitapaamisissa.',
    ...val),

  SDV6: (en: string, ...val: string[]) => translate(en,
    'Itsenäisesti toimiva Aito 5G on teknologisesti edistynein verkkovaihtoehto.',
    ...val),

  SDV7: (en: string, ...val: string[]) => translate(en,
    'Kaikissa liittymissä on rajaton netti kotimaassa. Lisäksi saat hyvin dataa EU- ja ETA-maihin, niin pääset surffaamaan turvallisesti reissussa.',
    ...val),

  SDV8: (en: string, ...val: string[]) => translate(en,
    'Kaipaatko apua mobiililaajakaistan valinnassa?',
    ...val),

  SDV9: (en: string, ...val: string[]) => translate(en,
    'Autamme sinua valitsemaan sopivan liikkuvan laajakaistan yrityksellesi. Jätä yhteystietosi, niin myyjämme vastaa kysymyksiisi:',
    ...val),

  SDVA: (en: string, ...val: string[]) => translate(en,
    'Mikä on liikkuva laajakaista?',
    ...val),

  SDVB: (en: string, ...val: string[]) => translate(en,
    'Miten saan mobiililaajakaistan käyttöön?',
    ...val),

  SDVC: (en: string, ...val: string[]) => translate(en,
    'Miksi kannattaa valita Elisan mobiililaajakaista?',
    ...val),

  SDVD: (en: string, ...val: string[]) => translate(en,
    'Miten nopea Elisan mobiililaajakaista on?',
    ...val),

  SDVE: (en: string, ...val: string[]) => translate(en,
    'Toimivatko 5G-liittymät alueellani?',
    ...val),

  SDVF: (en: string, ...val: string[]) => translate(en,
    'Voiko liikkuvaa laajakaistaa käyttää ulkomailla?',
    ...val),

  SDVG: (en: string, ...val: string[]) => translate(en,
    'Onko mobiililaajakaistan sopimus määräaikainen?',
    ...val),

  SDVH: (en: string, ...val: string[]) => translate(en,
    'Tarvitsenko erillisen reitittimen?',
    ...val),

  SDVI: (en: string, ...val: string[]) => translate(en,
    'Liikkuva laajakaista yrityksille - usein kysyttyä',
    ...val),

  SDVJ: (en: string, ...val: string[]) => translate(en,
    'Liikkuva laajakaista on SIM-kortilla toimiva ',
    ...val),

  SDVK: (en: string, ...val: string[]) => translate(en,
    'mobiililaajakaistaliittymä',
    ...val),

  SDVL: (en: string, ...val: string[]) => translate(en,
    ', jolla saat nettiyhteyden liikkuvaan työhön. Elisa Yritysdata -mobiililaajakaistan mukana tulee SIM-kortti, jonka voit asentaa esimerkiksi tablettiin tai reitittimeen. Voit jatkaa töitäsi joustavasti myös reissussa.',
    ...val),

  SDVM: (en: string, ...val: string[]) => translate(en,
    'Katso myös ',
    ...val),

  SDVN: (en: string, ...val: string[]) => translate(en,
    'puhelinliittymät yrityksille.',
    ...val),

  SDVO: (en: string, ...val: string[]) => translate(en,
    'Mobiililaajakaistan mukana tulee oma SIM-kortti, jonka voit asentaa esimerkiksi tablettiin tai reitittimeen.',
    ...val),

  SDVP: (en: string, ...val: string[]) => translate(en,
    'Voit hankkia SIM-kortin nykyisin myös eSIM-korttina. Tällöin voit kytkeä SIM-kortin päälle digitaalisesti. Huomaa, että päätelaitteesi tulee tukea eSIM-toiminnallisuutta.',
    ...val),

  SDVQ: (en: string, ...val: string[]) => translate(en,
    'Lue, miten otat eSIM-kortin käyttöön.',
    ...val),

  SDVR: (en: string, ...val: string[]) => translate(en,
    'Elisan mobiililaajakaistaliittymä on luotettava, kotimainen valinta yrityksellesi. Kattavassa ja laadukkaassa 5G- ja 5G+ -verkossa työskentelet joustavasti myös tien päällä.',
    ...val),

  SDVS: (en: string, ...val: string[]) => translate(en,
    'Elisa panostaa aktiivisesti tuotekehitykseen ja laajennamme nopeita 5G-verkkojamme jatkuvasti.',
    ...val),

  SDVT: (en: string, ...val: string[]) => translate(en,
    'Elisan mobiililaajakaistaan on saatavilla erilaisia nopeusluokkia, jotka ilmoitetaan aina maksiminopeuksina.',
    ...val),

  SDVU: (en: string, ...val: string[]) => translate(en,
    'Nopeus riippuu mm. sijainnista, käytettävissä olevasta verkkotekniikasta, kuuluvuuden voimakkuudesta, häiriötasosta, päätelaitteen ominaisuuksista ja verkon kuormituksesta.',
    ...val),

  SDVV: (en: string, ...val: string[]) => translate(en,
    'Katso kuuluvuuskartasta alueesi kuuluvuus.',
    ...val),

  SDVW: (en: string, ...val: string[]) => translate(en,
    'Elisa laajentaa ja parantaa 5G- ja 5G+ -verkkojaan jatkuvasti ympäri Suomen. Elisan 5G-verkon alueella asuu jo yli 4 miljoonaa suomalaista ja se on yli 200 paikkakunnalla.',
    ...val),

  SDVX: (en: string, ...val: string[]) => translate(en,
    'Katso tarkemmat kuuluvuusalueet.',
    ...val),

  SDVY: (en: string, ...val: string[]) => translate(en,
    'Jos käytät 5G-mobiililaajakaistaa 5G-alueen ulkopuolella, käytössäsi on nopea 4G-yhteys.',
    ...val),

  SDVZ: (en: string, ...val: string[]) => translate(en,
    'Kaikkiin liittymiin kuuluu tietty määrä dataa EU- ja ETA-maihin. ',
    ...val),

  SDW0: (en: string, ...val: string[]) => translate(en,
    'Lue lisää liittymän käytöstä ulkomailla.',
    ...val),

  SDW1: (en: string, ...val: string[]) => translate(en,
    'Mobiililaajakaistaan on mahdollista tilata ',
    ...val),

  SDW2: (en: string, ...val: string[]) => translate(en,
    'Elisa Reissunetti -palvelu',
    ...val),

  SDW3: (en: string, ...val: string[]) => translate(en,
    ', mikäli päätelaite tukee tekstiviestien lähetystä ja vastaanottoa. Yleensä reitittimiä varten on olemassa puhelimeen asennettava sovellus, jonka kautta tekstiviestejä voi hallinnoida (esim. Huawei HiLink).',
    ...val),

  SDW4: (en: string, ...val: string[]) => translate(en,
    'Mobiililaajakaistaliittymämme ovat toistaiseksi voimassa olevia lukuunottamatta Suomen Yrittäjät -jäsenetua ja tarjouksia.',
    ...val),

  SDW5: (en: string, ...val: string[]) => translate(en,
    'Toistaiseksi voimassa olevan liittymän voi irtisanoa milloin vain ',
    ...val),

  SDW8: (en: string, ...val: string[]) => translate(en,
    'asiakaspalvelun',
    ...val),

  SDW9: (en: string, ...val: string[]) => translate(en,
    ' kautta.',
    ...val),

  SDWA: (en: string, ...val: string[]) => translate(en,
    'Reitittimellä saat jaettua nettiyhteyden useaan eri laitteeseen eli saat muodostettua WiFi-verkon. Näin voit yhdistää samaan verkkoon esimerkiksi tablettisi, tietokoneesi ja televisiosi. ',
    ...val),

  SDWB: (en: string, ...val: string[]) => translate(en,
    'Reititin ei tule automaattisesti mobiililaajakaistaliittymän mukana, mutta voit ostaa sen erikseen ',
    ...val),

  SDWC: (en: string, ...val: string[]) => translate(en,
    'yritysverkkokaupastamme.',
    ...val),

  SDWD: (en: string, ...val: string[]) => translate(en,
    'Kaikissa liittymissä on rajaton data kotimaassa, Pohjolassa ja Baltiassa.',
    ...val),

  SDWE: (en: string, ...val: string[]) => translate(en,
    'Usein kysytyt kysymykset & vastaukset',
    ...val),

  SDWF: (en: string, ...val: string[]) => translate(en,
    'Tutustu ja tilaa',
    ...val),

  SDWG: (en: string, ...val: string[]) => translate(en,
    'Usein kysytyt kysymykset',
    ...val),

  SDWH: (en: string, ...val: string[]) => translate(en,
    'Heräsikö kysymyksiä yritysten puhelinliittymistä?',
    ...val),

  SDWL: (en: string, ...val: string[]) => translate(en,
    ' käytät nettiä huoletta myös EU/ETA-maiden ulkopuolella. Valmiit datapakettimme mahdollistavat edullisemman roamingin ulkomailla ja vältät yllättävät kustannukset.',
    ...val),

  SDWP: (en: string, ...val: string[]) => translate(en,
    'Liittymiin kuuluvat datapaketit aktivoituvat automaattisesti saavuttuasi kohdemaahan ja ne veloitetaan erikseen.',
    ...val),

  SDWV: (en: string, ...val: string[]) => translate(en,
    'Roaming ulkomailla',
    ...val),

  SDX3: (en: string, ...val: string[]) => translate(en,
    'Vastaaja matkapuhelimeen',
    ...val),

  SDX4: (en: string, ...val: string[]) => translate(en,
    'Elisa Matkapuhelinvastaajalla',
    ...val),

  SDX5: (en: string, ...val: string[]) => translate(en,
    ' saat liittymääsi vastaajan, lomavastaajan sekä ilmoituksen vastaamattomista puheluista. Tekstiviesti tuo tiedon vastaamattomista puheluista.',
    ...val),

  SDX6: (en: string, ...val: string[]) => translate(en,
    'Lomavastaajalla voit erotella myös työ- ja yksityispuhelut toisistaan ja varmistaa, että työpuhelut ohjautuvat haluamallesi henkilölle lomasi aikana.',
    ...val),

  SDXB: (en: string, ...val: string[]) => translate(en,
    'Virheellinen SIM-kortin numero.',
    ...val),

  SDXO: (en: string, ...val: string[]) => translate(en,
    'Tiedonsiirtonopeus vaihtelee päätelaitteen ominaisuuksien, sijainnin ja verkon kuormituksen mukaan. Tarkista kuuluvuus alueellasi ',
    ...val),

  SDXQ: (en: string, ...val: string[]) => translate(en,
    '. Pohjola ja Baltian maat: Ruotsi, Norja, Tanska, Viro, Latvia ja Liettua. Yritysliittymä 5G+ ja 5G liittymissä käyttörajan ylittävä data hinnoitellaan ',
    ...val),

  SDXR: (en: string, ...val: string[]) => translate(en,
    'roaming-hinnaston mukaisesti',
    ...val),

  SDXS: (en: string, ...val: string[]) => translate(en,
    '. Puheaika ei sisällä puheluita ulkomaille tai puheluita lisämaksullisiin palvelunumeroihin, kuten 0700 ja 0600-alkuisiin numeroihin. Soitettaessa ulkomaille tai lisämaksullisiin numeroihin veloitetaan lisäksi matkapuhelumaksu (mpm), jonka hinta määräytyy kyseessä olevan liittymän voimassa olevan hinnaston mukaisesti. Hinnat eivät koske erityishinnoiteltuja verkkoja (laivat/satelliitit/lentokoneet).',
    ...val),

  SDXT: (en: string, ...val: string[]) => translate(en,
    'Takaisin sivun alkuun',
    ...val),

  SDXU: (en: string, ...val: string[]) => translate(en,
    'Nettiliittymät yrityksille',
    ...val),

  SE00: (en: string, ...val: string[]) => translate(en,
    ' parantaa mobiililiittymän selainturvallisuutta. Se tunnistaa haitalliset sivut ja ilmoittaa niistä käyttäjille.',
    ...val),

  SE01: (en: string, ...val: string[]) => translate(en,
    'Saat turvaa yleisintä tietoturvauhkaa eli tietojen kalastelua (phishing) vastaan, kun käytät nettiä 4G- tai 5G-verkossa.',
    ...val),

  SE13: (en: string, ...val: string[]) => translate(en,
    'Reissunetti- ja Reissaaja-datapaketeilla',
    ...val),

  SE27: (en: string, ...val: string[]) => translate(en,
    'Näytettävä numero puheluille',
    ...val),

  SEB2: (en: string, ...val: string[]) => translate(en,
    'Valitse itsellesi sopivat laitteet työntekoon. Osallistumalla itse kustannuksiin saat aina parhaan mahdollisen puhelimen ja lisätarvikkeet.',
    ...val),

  SEBD: (en: string, ...val: string[]) => translate(en,
    'Omat tiedot',
    ...val),

  SEER: (en: string, ...val: string[]) => translate(en,
    'Vaihda',
    ...val),

  SEYV: (en: string, ...val: string[]) => translate(en,
    'Nettiliittymät',
    ...val),

  SEYW: (en: string, ...val: string[]) => translate(en,
    'Nettiliittymät toimistolle sekä etäohjattaviin laitteisiin',
    ...val),

  SEZ9: (en: string, ...val: string[]) => translate(en,
    'Laskulle tulostuva laskun maksajan nimi',
    ...val),

  SF03: (en: string, ...val: string[]) => translate(en,
    'Aito 5G tarjoaa vakaamman, sujuvamman ja luotettavamman yhteyden – ja vieläpä paremman akunkeston.',
    ...val),

  SF04: (en: string, ...val: string[]) => translate(en,
    '5G+ on Elisan paras 5G-yhteys ja se on myös ekologisempi ja energiatehokkaampi, kuin aiemmat teknologiat.',
    ...val),

  SF05: (en: string, ...val: string[]) => translate(en,
    'Elisan 5G-verkko on ',
    ...val),

  SF07: (en: string, ...val: string[]) => translate(en,
    'Mitkä ovat itsenäisen 5G:n hyödyt?',
    ...val),

  SF08: (en: string, ...val: string[]) => translate(en,
    'Itsenäinen 5G-verkko tarjoaa viimeisintä teknologiaa edustavan parhaan mahdollisen ja tasalaatuisemman yhteyden. Koska verkko on myös energiatehokkaampi, se kuluttaa vähemmän puhelimen akkua. Se mahdollistaa myös 5G-puhelut (Voice over New Radio, VoNR-puhelut), joiden laatu on entistä parempi.',
    ...val),

  SF09: (en: string, ...val: string[]) => translate(en,
    'Mitkä kaikki puhelimet toimivat itsenäisessä verkossa?',
    ...val),

  SF10: (en: string, ...val: string[]) => translate(en,
    'Itsenäinen 5G-verkko toimii toistaiseksi rajatussa joukossa älypuhelimia, mutta valikoima kasvaa säännöllisesti. Tutustu listaukseemme ',
    ...val),

  SF11: (en: string, ...val: string[]) => translate(en,
    '5G+ tuen omaavista laitteista',
    ...val),

  SF12: (en: string, ...val: string[]) => translate(en,
    'Puhelimen vaihtaminen ei ole aina tarpeen, sillä monien uudempien laitteiden osalta riittää, että ohjelmistopäivitykset ovat ajan tasalla.',
    ...val),

  SF13: (en: string, ...val: string[]) => translate(en,
    'Yritysliittymäni on ilman + -ominaisuutta. Päivittyykö nykyinen liittymäni automaattisesti?',
    ...val),

  SF14: (en: string, ...val: string[]) => translate(en,
    'Liittymä ei päivity automaattisesti. Saat päivitettyä puhelinliittymäsi kirjautumalla ',
    ...val),

  SF15: (en: string, ...val: string[]) => translate(en,
    'Yritysten OmaElisaan',
    ...val),

  SF16: (en: string, ...val: string[]) => translate(en,
    'Jos kaipaat lisätietoja, ',
    ...val),

  SF17: (en: string, ...val: string[]) => translate(en,
    'asiakaspalvelumme auttaa mielellään',
    ...val),

  SF18: (en: string, ...val: string[]) => translate(en,
    'Voiko 5G+ -liittymää käyttää puhelimella, joka ei tue itsenäistä verkkoa?',
    ...val),

  SF19: (en: string, ...val: string[]) => translate(en,
    'Kyllä. Jos puhelimesi ei tue itsenäistä verkkoa, se käyttää silloin tavallista 5G- tai 4G -yhteyttä aivan vastaavasti, kuin ennenkin.',
    ...val),

  SF20: (en: string, ...val: string[]) => translate(en,
    'ohjeet Elisa Laitenetti -liittymän käytöstä',
    ...val),

  SF4C: (en: string, ...val: string[]) => translate(en,
    'Näytä kaikki',
    ...val),

  SF6S: (en: string, ...val: string[]) => translate(en,
    'Haluatko sulkea liittymän väliaikaisesti vai muuttaa sen hyllyliittymäksi?',
    ...val),

  SF9W: (en: string, ...val: string[]) => translate(en,
    'Voit hakea mm. nimellä, puhelinnumerolla, tunnistenumerolla tai laskutussopimusnumerolla. Voit hakea useammalla hakusanalla erottelemalla sanat välilyönnillä. Kirjoita vähintään kaksi merkkiä.',
    ...val),

  SFI7: (en: string, ...val: string[]) => translate(en,
    'Hylätty',
    ...val),

  SFRK: (en: string, ...val: string[]) => translate(en,
    'Aktiivinen',
    ...val),

  SG00: (en: string, ...val: string[]) => translate(en,
    'Elisan Aito 5G – aidosti parempi mobiililaajakaistayhteys',
    ...val),

  SG01: (en: string, ...val: string[]) => translate(en,
    'Aito 5G:n hyödyt mobiililaajakaistayhteydelle:',
    ...val),

  SG02: (en: string, ...val: string[]) => translate(en,
    'Laitteidesi parempi akunkesto – Aito 5G kuluttaa laitteesi akkua jopa 20 % vähemmän kuin muut 4G- tai 5G-liittymät',
    ...val),

  SG03: (en: string, ...val: string[]) => translate(en,
    'Vakaampi yhteys – netti toimii saumattomammin ja etäpalaverit voi hoitaa luotettavammin ilman että video katkeilee tai yhteys pätkii',
    ...val),

  SG04: (en: string, ...val: string[]) => translate(en,
    ' tarvitset laitteen, joka tukee 5G SA -teknologiaa',
    ...val),

  SG05: (en: string, ...val: string[]) => translate(en,
    'Miksi Aito 5G-verkko eli 5G+ on aiempaa parempi?',
    ...val),

  SG06: (en: string, ...val: string[]) => translate(en,
    'Aito 5G-verkko tarjoaa viimeisintä teknologiaa edustavan parhaan mahdollisen ja tasalaatuisemman yhteyden. Tämä tarkoittaa käytännössä esimerkiksi viiveettömämpää nettiä. 5G+ on myös energiatehokkaampi sekä ekologisempi kuin edeltäjänsä.',
    ...val),

  SG07: (en: string, ...val: string[]) => translate(en,
    'Mitkä kaikki reitittimet toimivat itsenäisessä verkossa?',
    ...val),

  SG08: (en: string, ...val: string[]) => translate(en,
    'Itsenäinen 5G-verkko toimii toistaiseksi rajatussa joukossa reitittimiä, mutta valikoima kasvaa säännöllisesti. Tutustu listaukseemme ',
    ...val),

  SG09: (en: string, ...val: string[]) => translate(en,
    ' Voit tilata uuden reitittimen niin netistä, kuin ',
    ...val),

  SG10: (en: string, ...val: string[]) => translate(en,
    'asioimalla myymälässämme',
    ...val),

  SG11: (en: string, ...val: string[]) => translate(en,
    'Nykyinen 5G-nettiliittymäni on ilman + -ominaisuutta. Päivittyykö se automaattisesti?',
    ...val),

  SG12: (en: string, ...val: string[]) => translate(en,
    'Liittymä ei päivity automaattisesti. Saat päivitettyä sen kirjautumalla Yritysten OmaElisaan. Jos kaipaat lisätietoja, ',
    ...val),

  SG14: (en: string, ...val: string[]) => translate(en,
    'Voiko 5G+ -liittymää käyttää reitittimellä, joka ei tue itsenäistä verkkoa?',
    ...val),

  SG15: (en: string, ...val: string[]) => translate(en,
    'Kyllä. Jos reititin ei tue itsenäistä verkkoa, se käyttää silloin tavallista 5G- tai 4G -yhteyttä aivan vastaavasti, kuin ennenkin.',
    ...val),

  SG16: (en: string, ...val: string[]) => translate(en,
    'Mobiililaajakaista sopii liikkuvaan työhön',
    ...val),

  SG17: (en: string, ...val: string[]) => translate(en,
    'Avainlippu-tunnuksen',
    ...val),

  SG1R: (en: string, ...val: string[]) => translate(en,
    ', joten otathan Elisa Tunnuksen käyttöön ennen sitä.',
    ...val),

  SG3Q: (en: string, ...val: string[]) => translate(en,
    'Elisan Mobiiliturva yrityksille on uudenlainen tietoturvapalvelu mobiililiittymään. Palvelu tunnistaa haitalliset sivustot ja tuo turvaa mobiililiittymän käyttöön.',
    ...val),

  SGLK: (en: string, ...val: string[]) => translate(en,
    'Liittymäsi tietoja ei löydy.',
    ...val),

  SGNM: (en: string, ...val: string[]) => translate(en,
    'Mikli osoitteessa on olemassa oleva tilaus, se tulee irtisanoa ennen toimituspiv',
    ...val),

  SH61: (en: string, ...val: string[]) => translate(en,
    'alk.',
    ...val),

  SHYE: (en: string, ...val: string[]) => translate(en,
    'Valitse kaikki laitteet',
    ...val),

  SI9A: (en: string, ...val: string[]) => translate(en,
    'Asennuspäivä',
    ...val),

  SIEL: (en: string, ...val: string[]) => translate(en,
    'Ei valittavilta asiakkailta puuttuu olemassa oleva EPP sopimus. Ole yhteydessä Elisa kontaktihenkilöösi uuden EPP sopimuksen luonnin osalta.',
    ...val),

  SIPZ: (en: string, ...val: string[]) => translate(en,
    'Täytä maksajan tiedot',
    ...val),

  SJ3Y: (en: string, ...val: string[]) => translate(en,
    'Vanha SIM-korttisi lakkaa nyt toimimasta',
    ...val),

  SJ7E: (en: string, ...val: string[]) => translate(en,
    'Osittain toimitettu',
    ...val),

  SJBG: (en: string, ...val: string[]) => translate(en,
    'eSIMin toimituksessa kestää hetki, jonka jälkeen voit aktivoida sen.',
    ...val),

  SJKT: (en: string, ...val: string[]) => translate(en,
    'Ei liittymiä',
    ...val),

  SK41: (en: string, ...val: string[]) => translate(en,
    'Vanha liittymätyyppi',
    ...val),

  SKA0: (en: string, ...val: string[]) => translate(en,
    'Tarkasta, että käyttäjällä on ajan tasalla olevat työsähköposti ja -puhelinnumero.',
    ...val),

  SKCE: (en: string, ...val: string[]) => translate(en,
    'Malli',
    ...val),

  SKDZ: (en: string, ...val: string[]) => translate(en,
    'Vakio-ohjauksien päivityksessä tapahtui virhe',
    ...val),

  SKP7: (en: string, ...val: string[]) => translate(en,
    'Muu liittymä',
    ...val),

  SL51: (en: string, ...val: string[]) => translate(en,
    'Laitteeseen sisäänrakennettu eSIM toimii perinteisen SIM-kortin tavoin. Voit ottaa eSIMin käyttöön sähköisesti heti tilauksen jälkeen. eSIMin käyttöönotto vaatii, että laitteesi on yhteydessä langattomaan verkkoon (wifi). Huomioithan, että eSIM toimii vain laitteella, johon se on ensimmäisellä kerralla ladattu.',
    ...val),

  SLBP: (en: string, ...val: string[]) => translate(en,
    'OmaElisa Classic',
    ...val),

  SLOC: (en: string, ...val: string[]) => translate(en,
    'Palvelutaso',
    ...val),

  SLOI: (en: string, ...val: string[]) => translate(en,
    'Rajaton netti kotimaassa, Pohjolassa ja Baltiassa',
    ...val),

  SLPO: (en: string, ...val: string[]) => translate(en,
    'Omat edut',
    ...val),

  SMAR: (en: string, ...val: string[]) => translate(en,
    'Ohjeet tietojen palauttamiseen',
    ...val),

  SMI6: (en: string, ...val: string[]) => translate(en,
    'Käyttäjätunnus on pakollinen',
    ...val),

  SMM7: (en: string, ...val: string[]) => translate(en,
    'Nykyinen SIM-kortti lakkaa toimimasta heti tilauksen jälkeen.',
    ...val),

  SMPX: (en: string, ...val: string[]) => translate(en,
    'Tarkista ennen tilausta, että käytössäsi on ',
    ...val),

  SMSV: (en: string, ...val: string[]) => translate(en,
    'Sinulla on jo käytössä Yritysten OmaElisa-tunnus.',
    ...val),

  SMZW: (en: string, ...val: string[]) => translate(en,
    'Varavastaajat työajan ulkopuolella',
    ...val),

  SNOO: (en: string, ...val: string[]) => translate(en,
    'Voit muokata vain yhtä tietuetta kerrallaan. Tallenna tai peruuta nykyiset muutokset.',
    ...val),

  SNSD: (en: string, ...val: string[]) => translate(en,
    'Kirjaudu tai luo yrityksellesi OmaElisa-tunnukset',
    ...val),

  SOC0: (en: string, ...val: string[]) => translate(en,
    'Haluatko varmasti hylätä tarjouksen?',
    ...val),

  SOJT: (en: string, ...val: string[]) => translate(en,
    'Valittua laskutussopimusta käytetään oletuksena kaikille tilauksille, joita tältä laitelistalta tehdään. Tarvittaessa tilauksen hyväksyjä voi vaihtaa laskutussopimuksen toiseen.',
    ...val),

  SONR: (en: string, ...val: string[]) => translate(en,
    'Laite tulee palauttaa Elisalle viikon kuluessa. Palauttamattomasta laitteesta veloitetaan palautusrikemaksu.',
    ...val),

  SOQ1: (en: string, ...val: string[]) => translate(en,
    'Tilaus on välitetty onnistuneesti tilauskäsittelyyn',
    ...val),

  SOXH: (en: string, ...val: string[]) => translate(en,
    'Ei sisällä roaming ominaisuuksia, toimii vain kotimaassa. Normaalihintaiset kotimaan puhelut 0,0565 €/min, tekstiviestit 0,0565 €/kpl, multimediaviestit 0,156 €/kpl.',
    ...val),

  SQW6: (en: string, ...val: string[]) => translate(en,
    'Lisää laite',
    ...val),

  SQYY: (en: string, ...val: string[]) => translate(en,
    'Ilmoituksen aihe',
    ...val),

  SSBV: (en: string, ...val: string[]) => translate(en,
    'Elisan myymälät',
    ...val),

  SSJ9: (en: string, ...val: string[]) => translate(en,
    'Istuntosi on vanhentunut. Kirjaudu uudelleen jatkaaksesi.',
    ...val),

  SSQQ: (en: string, ...val: string[]) => translate(en,
    'KelloSIM palvelu ei ole käytettävissä',
    ...val),

  SST5: (en: string, ...val: string[]) => translate(en,
    'Varattu',
    ...val),

  STA2: (en: string, ...val: string[]) => translate(en,
    'Käyttäjän {} Ring-palvelut, alanumero {} ja yritysnumero {} säilytetään. Jotta voit käyttää Ring-liittymää ilman matkapuhelinta, sinun on otettava siihen ohjelmisto- tai IP-puhelin.',
    ...val),

  STLY: (en: string, ...val: string[]) => translate(en,
    'Sopimuksen alkupvm',
    ...val),

  STSD: (en: string, ...val: string[]) => translate(en,
    'Käyttäjällä on avoin kutsu käyttöoikeuksiin liittyen',
    ...val),

  STWG: (en: string, ...val: string[]) => translate(en,
    'Tilauksen käsittelyssä tapahtui ongelma. Soita asiakaspalveluumme {0} ({1}). Asiakaspalvelumme on avoinna {2}.',
    ...val),

  SU49: (en: string, ...val: string[]) => translate(en,
    'Siirry vanhaan OmaElisaan',
    ...val),

  SUZL: (en: string, ...val: string[]) => translate(en,
    'Luo tunnus tai palauta unohtunut salasana',
    ...val),

  SW0J: (en: string, ...val: string[]) => translate(en,
    'Sopimukset',
    ...val),

  SX1L: (en: string, ...val: string[]) => translate(en,
    'Uusi',
    ...val),

  SX7R: (en: string, ...val: string[]) => translate(en,
    'Sopijayritystä ei voida vaihtaa, koska liittymällä oleva lisäpalvelu estää siirron. Jätä tarvittaessa [tukipyyntö].',
    ...val),

  SX92: (en: string, ...val: string[]) => translate(en,
    'Mobiilivarmenteella voi tunnistautua turvallisesti puhelimella ilman pankkitunnuksia. Elisan yritysliittymiin mobiilivarmenteen käyttöönotto on helppoa ja nopeaa – käyttöönotto sujuu verkkopalvelussa parissa minuutissa omien pankkitunnusten avulla.',
    ...val),

  SXJ5: (en: string, ...val: string[]) => translate(en,
    'Ei lunastuspyyntöjä',
    ...val),

  SXTT: (en: string, ...val: string[]) => translate(en,
    'Ring-liittymä',
    ...val),

  SY1D: (en: string, ...val: string[]) => translate(en,
    'Vastaanottaja',
    ...val),

  SYLL: (en: string, ...val: string[]) => translate(en,
    'Kun hyväksyt tarjouksen, allekirjoitusprosessi käynnistyy ja sopimus aktivoidaan sen jälkeen.',
    ...val),

  SYWR: (en: string, ...val: string[]) => translate(en,
    'Kampanjahinta',
    ...val),

  SYWS: (en: string, ...val: string[]) => translate(en,
    'Normaalihinta',
    ...val),

  SZ6N: (en: string, ...val: string[]) => translate(en,
    'Siirretty',
    ...val),

  SZBW: (en: string, ...val: string[]) => translate(en,
    'Virheellinen aika',
    ...val),

  SZY8: (en: string, ...val: string[]) => translate(en,
    'Takuukuitit',
    ...val),

  T0FF: (en: string, ...val: string[]) => translate(en,
    'SIM-kortin numeroiden sijainnit',
    ...val),

  T0HO: (en: string, ...val: string[]) => translate(en,
    'Irtisanomisaika',
    ...val),

  T0KV: (en: string, ...val: string[]) => translate(en,
    'Aktivoinnin loppuvaiheessa puhelin voi mennä nukkumistilaan, jonka jälkeen puhelin kysyy uutta PIN-koodia 1234 (ei ole sama asia kuin puhelimen suojakoodi).',
    ...val),

  T197: (en: string, ...val: string[]) => translate(en,
    'Kun asetus on käytössä, työntekijät näkevät ostolaitteiden (kertamaksulla maksettavat tarvikkeet ja muut laitteet) kustannuksen yritykselle.',
    ...val),

  T1H4: (en: string, ...val: string[]) => translate(en,
    'Jos laitteesi on vahingoittunut, tee siitä vahinko- ja huoltoilmoitus. Toimitamme nopeasti korvaavan laitteen rikkoutuneen tilalle. Valitse ensin huollettava laite.',
    ...val),

  T1WX: (en: string, ...val: string[]) => translate(en,
    'Käyttäjätiedot',
    ...val),

  T29V: (en: string, ...val: string[]) => translate(en,
    'Muutostilauksen tekeminen onnistui',
    ...val),

  T2AE: (en: string, ...val: string[]) => translate(en,
    'Elisa Mobiilivarmenne yrityksille',
    ...val),

  T2IH: (en: string, ...val: string[]) => translate(en,
    'Data',
    ...val),

  T3BS: (en: string, ...val: string[]) => translate(en,
    'Elisa Palvelupäätelaitteen siirtyminen jatkokaudelle',
    ...val),

  T3CO: (en: string, ...val: string[]) => translate(en,
    'Tuote on poistunut valikoimasta',
    ...val),

  T3N9: (en: string, ...val: string[]) => translate(en,
    'Päiväys',
    ...val),

  T425: (en: string, ...val: string[]) => translate(en,
    'Palvelun aktivoituminen voi kestää muutaman minuutin.',
    ...val),

  T4CE: (en: string, ...val: string[]) => translate(en,
    'Päivämäärä ei voi olla menneisyydessä',
    ...val),

  T4MT: (en: string, ...val: string[]) => translate(en,
    'Laskun SMS-muistutuksen esto',
    ...val),

  T4OU: (en: string, ...val: string[]) => translate(en,
    'Tekninen virhe, yritä myöhemmin uudelleen.',
    ...val),

  T51P: (en: string, ...val: string[]) => translate(en,
    'Valitse tämä käyttäjä',
    ...val),

  T56E: (en: string, ...val: string[]) => translate(en,
    'Veloitetaan erikseen',
    ...val),

  T57I: (en: string, ...val: string[]) => translate(en,
    'Raportti',
    ...val),

  T57J: (en: string, ...val: string[]) => translate(en,
    'Luo uusi raportti',
    ...val),

  T57K: (en: string, ...val: string[]) => translate(en,
    'Luo raportti',
    ...val),

  T57L: (en: string, ...val: string[]) => translate(en,
    'Yritykset',
    ...val),

  T57M: (en: string, ...val: string[]) => translate(en,
    'Valmiit raportit',
    ...val),

  T57N: (en: string, ...val: string[]) => translate(en,
    'Ladattavissa 24 h',
    ...val),

  T57O: (en: string, ...val: string[]) => translate(en,
    'Raportin luonti onnistui',
    ...val),

  T57P: (en: string, ...val: string[]) => translate(en,
    'Raportin luonti epäonnistui',
    ...val),

  T57S: (en: string, ...val: string[]) => translate(en,
    'Raporttia luodaan...',
    ...val),

  T58Y: (en: string, ...val: string[]) => translate(en,
    'Sinua ei ole vielä yhdistetty mihinkään yritykseen. ',
    ...val),

  T6BJ: (en: string, ...val: string[]) => translate(en,
    'Käyttäjä saa kutsulinkin sähköpostilla. Käyttäjän on hyväksyttävä kutsu 14 päivän sisällä.',
    ...val),

  T6EF: (en: string, ...val: string[]) => translate(en,
    'Huomioithan, että muuttaessasi valintaa OmaElisasta, päivitetyt tiedot välitetään tämän jälkeen erikseen numeropalveluihin. Tietojen päivittyminen numeropalveluihin kestää joitakin arkipäiviä ja ne muuttuvat viiveellä.',
    ...val),

  T78Y: (en: string, ...val: string[]) => translate(en,
    'Toimitustiedot',
    ...val),

  T88E: (en: string, ...val: string[]) => translate(en,
    'Vaihtoetu maksetaan laskutussopimukselle sen jälkeen, kun laitteesi on käynyt läpi kuntotarkastuksen. Saat tarkastuksesta vahvistuksen sähköpostiisi. Mikäli arvioitu hyvitysarvo muuttuu, saat uuden tarjouksen sähköpostiin, ja voit hyväksyä tai hylätä sen. Jos hylkäät tarjouksen, laite palautetaan sinulle. \nKoko prosessin kesto alusta loppuun on tyypillisesti 2–4 viikkoa.',
    ...val),

  T8FJ: (en: string, ...val: string[]) => translate(en,
    'Lisää valitsemasi liittymä ostoskoriin ja siirry kassalle. Jotta pääset tilaamaan liittymän, sinun täytyy kirjautua OmaElisa-tunnuksillasi tai luoda itsellesi uudet tunnukset.',
    ...val),

  T9V1: (en: string, ...val: string[]) => translate(en,
    'Olen tarkistanut toimitusosoitteen',
    ...val),

  T9WD: (en: string, ...val: string[]) => translate(en,
    'Omakiasta Netti Lite offers',
    ...val),

  TA3J: (en: string, ...val: string[]) => translate(en,
    'Tunnistaudutaan',
    ...val),

  TA9S: (en: string, ...val: string[]) => translate(en,
    'Käyttöoikeuksien myöntäminen vaatii puhelinnumeron ja sähköpostiosoitteen.',
    ...val),

  TAXY: (en: string, ...val: string[]) => translate(en,
    'Kaikki liittymät',
    ...val),

  TBCM: (en: string, ...val: string[]) => translate(en,
    'Tietosuoja',
    ...val),

  TBES: (en: string, ...val: string[]) => translate(en,
    'Tilauksen tuotteet',
    ...val),

  TC0J: (en: string, ...val: string[]) => translate(en,
    'selvittää puheluiden ja nettiyhteyden ongelmia vianselvitystyökalulla',
    ...val),

  TC3W: (en: string, ...val: string[]) => translate(en,
    'Vaihda puhelinnumero',
    ...val),

  TCDE: (en: string, ...val: string[]) => translate(en,
    'Voit tilata Elisa Kuka Soittaa -palvelun helposti Yritysten OmaElisasta, jos yritykselläsi on käytössä Elisan yritysliittymät.',
    ...val),

  TCGR: (en: string, ...val: string[]) => translate(en,
    'Huomioithan, että myös käyttäjän linkitys yritykseen poistetaan ja tämän jälkeen hän ei voi nähdä kyseisen yrityksen yritysliittymiään tai laitteitaan Työntekijän OmaElisassa.',
    ...val),

  TCZK: (en: string, ...val: string[]) => translate(en,
    'Huomioithan, että sopimus näkyy aktiviisena sopimuslistalla kunnes olemme käsitelleet sen.',
    ...val),

  TDXL: (en: string, ...val: string[]) => translate(en,
    'Elisa Kuka Soittaa -palvelun tilaus',
    ...val),

  TE0F: (en: string, ...val: string[]) => translate(en,
    'Tilaa SIM-kortti',
    ...val),

  TE4L: (en: string, ...val: string[]) => translate(en,
    'Kertamaksut yhteensä',
    ...val),

  TEA3: (en: string, ...val: string[]) => translate(en,
    'Kaikki hinnat alv. 0 %',
    ...val),

  TER4: (en: string, ...val: string[]) => translate(en,
    'Paperilasku',
    ...val),

  TETZ: (en: string, ...val: string[]) => translate(en,
    'Elisa Puheratkaisu Vakio tuo matkapuhelimet luontevasti osaksi yrityksen puhelinjärjestelmää.',
    ...val),

  TEVT: (en: string, ...val: string[]) => translate(en,
    'Palvelu sisältää modeemin ja yhteyden asennuksen sekä toimivuuden testauksen.',
    ...val),

  TEXW: (en: string, ...val: string[]) => translate(en,
    'Liittymän käyttäjältä puuttuu henkilötietoja.',
    ...val),

  TEYY: (en: string, ...val: string[]) => translate(en,
    'Kustannuspaikka ja viitenumero',
    ...val),

  TF3M: (en: string, ...val: string[]) => translate(en,
    'Puhelinnumero luovutetaan liittymän käyttäjälle',
    ...val),

  TF4R: (en: string, ...val: string[]) => translate(en,
    'Muutos astuu voimaan noin vuorokauden kuluessa. Tukipyynnön tila on nähtävillä viestikeskuksessa. Ilmoitus muutetuista sopimuksista tulee sekä viestikeskukseen että yhteyshenkilön sähköpostiin.',
    ...val),

  TF8Q: (en: string, ...val: string[]) => translate(en,
    'Näytä lisää vaihtoehtoja mobiiliverkon Netti Lite -liittymille',
    ...val),

  TFDQ: (en: string, ...val: string[]) => translate(en,
    'Luo uusi',
    ...val),

  TFMQ: (en: string, ...val: string[]) => translate(en,
    'Lisätietoja Oma Laitelaskusta',
    ...val),

  TFV4: (en: string, ...val: string[]) => translate(en,
    'Sähköpostiosoite tai tunnus',
    ...val),

  TFX1: (en: string, ...val: string[]) => translate(en,
    'Ei laitelistoja',
    ...val),

  TG07: (en: string, ...val: string[]) => translate(en,
    'Muutos',
    ...val),

  TGFE: (en: string, ...val: string[]) => translate(en,
    'OmaLasku Palvelunumerot -ominaisuudella voit poistaa työnantajan asettamat palveluestot, jolloin maksat itse palvelunumeroihin tehdyistä puheluista ja viesteistä.',
    ...val),

  TGK3: (en: string, ...val: string[]) => translate(en,
    'Aktiivinen Applen Etsi -toiminto estää kaikki huoltotoimenpiteet laitteelle.',
    ...val),

  TGPX: (en: string, ...val: string[]) => translate(en,
    'Jos kuitenkin jo näet liittymäsi työntekijäportaalissa, ota yhteyttä Elisan asiakaspalveluun.',
    ...val),

  TH83: (en: string, ...val: string[]) => translate(en,
    'Yrityksen maksuosuus',
    ...val),

  THKA: (en: string, ...val: string[]) => translate(en,
    'Laitteen lisääminen ei ole mahdollista',
    ...val),

  THL9: (en: string, ...val: string[]) => translate(en,
    'Tilauksella voi olla tuotteita vain yhdeltä laitelistalta.',
    ...val),

  THX7: (en: string, ...val: string[]) => translate(en,
    'Jos asiasi on kiireellinen, voit ottaa yhteyttä chatin kautta tai soittaa asiakaspalveluun. Kaikki yhteystiedot löydät ',
    ...val),

  TIK0: (en: string, ...val: string[]) => translate(en,
    'Liittymässä on 24 kk määräaikainen sopimus.',
    ...val),

  TIK1: (en: string, ...val: string[]) => translate(en,
    'Toimi pian - etu voimassa {} asti.',
    ...val),

  TIWU: (en: string, ...val: string[]) => translate(en,
    'Hallinnoi palvelua',
    ...val),

  TIZ1: (en: string, ...val: string[]) => translate(en,
    '500 Mt aktivoituu automaattisesti kohdemaissa ja mahdollistaa mobiilipäätelaitteella tai kannettavalla tietokoneella käytettävän nopean tiedonsiirtoyhteyden edulliseen hintaan EU/ETA-alueen ulkopuolisissa maissa. Palvelussa ei ole kuukausimaksua, vaan hinnoittelu aktivoituu käytön mukaan 10,90 € / 1 vrk.',
    ...val),

  TJ3Q: (en: string, ...val: string[]) => translate(en,
    'Yhteensä verollinen',
    ...val),

  TJ54: (en: string, ...val: string[]) => translate(en,
    'Avoin',
    ...val),

  TJ9N: (en: string, ...val: string[]) => translate(en,
    'Laitesopimus päättyy ',
    ...val),

  TJKD: (en: string, ...val: string[]) => translate(en,
    'Tallenna luonnos',
    ...val),

  TJOE: (en: string, ...val: string[]) => translate(en,
    'Kertamaksu lisätään seuraavalle laskulle.',
    ...val),

  TJPP: (en: string, ...val: string[]) => translate(en,
    'Suositus',
    ...val),

  TJPQ: (en: string, ...val: string[]) => translate(en,
    'Tarjous',
    ...val),

  TJPR: (en: string, ...val: string[]) => translate(en,
    'Tarjoustuotteet',
    ...val),

  TK81: (en: string, ...val: string[]) => translate(en,
    'Ota yhteyttä työnantajanne yhteyshenkilöön.',
    ...val),

  TLA6: (en: string, ...val: string[]) => translate(en,
    'Häiriötilanteessa voit tehdä nopeasti vianmäärityksen käytössäsi olevalle liittymälle.',
    ...val),

  TLCA: (en: string, ...val: string[]) => translate(en,
    'Uusi laite',
    ...val),

  TLCF: (en: string, ...val: string[]) => translate(en,
    'Hups… hakemaasi sivua ei löytynyt.',
    ...val),

  TLT9: (en: string, ...val: string[]) => translate(en,
    'Latausliittimen pohjaan voi pakkaantua likaa ja sen vuoksi lataus ei toimi. Puhdista ensin lautausliitin esimerkiksi nuppineulalla, hakaneulalla tai teräväkärkisillä pinseteillä (latausliitin kestää hyvin käsittelyn).',
    ...val),

  TM4Y: (en: string, ...val: string[]) => translate(en,
    'Pääkäyttäjät, joilla on vanhat kirjautumistiedot',
    ...val),

  TM4Z: (en: string, ...val: string[]) => translate(en,
    'Jos olet pääkäyttäjä ja sinulla on vielä käytössäsi Yritysten OmaElisan käyttäjätunnus, kirjaudu sisään sillä. Voit ottaa henkilökohtaisen Elisa Tunnuksen käyttöön kirjautumisen jälkeen.',
    ...val),

  TMK7: (en: string, ...val: string[]) => translate(en,
    'Jatka asiointia',
    ...val),

  TMN1: (en: string, ...val: string[]) => translate(en,
    'Käyttöehdot',
    ...val),

  TOL1: (en: string, ...val: string[]) => translate(en,
    'Säilytetään numero',
    ...val),

  TPI4: (en: string, ...val: string[]) => translate(en,
    'Viestisi',
    ...val),

  TPQ5: (en: string, ...val: string[]) => translate(en,
    'Viimeinen mahdollinen irtisanomispäivä on 3 kk kuluttua nykyhetkestä',
    ...val),

  TPTZ: (en: string, ...val: string[]) => translate(en,
    'Tarkista tilaamasi tuotteet. Tämän jälkeen sinut siirretään takaisin työnantajasi järjestelmään, jossa voit viimeistellä ja vahvistaa tilauksen.',
    ...val),

  TPVQ: (en: string, ...val: string[]) => translate(en,
    'Laite',
    ...val),

  TQ6Z: (en: string, ...val: string[]) => translate(en,
    'Lisätiedot viasta',
    ...val),

  TQFU: (en: string, ...val: string[]) => translate(en,
    'tai pyydä pääkäyttäjältäsi linkki päästäksesi kiinni palveluihinne.',
    ...val),

  TQLE: (en: string, ...val: string[]) => translate(en,
    'Kirjoita viesti',
    ...val),

  TQNV: (en: string, ...val: string[]) => translate(en,
    'Piilota erittely',
    ...val),

  TR6I: (en: string, ...val: string[]) => translate(en,
    'Ei laitteita tässä kategoriassa.',
    ...val),

  TRE5: (en: string, ...val: string[]) => translate(en,
    'Elisa Palvelupäätelaite',
    ...val),

  TRS1: (en: string, ...val: string[]) => translate(en,
    'on helppo ja toimiva nettiliittymä kotikonttoriin tai pieneen toimistoon. Netti Liten laadukas nettiyhteys tekee työarjestasi tehokasta ja sujuvaa. Palvelun mukana saat reitittimen, jolla yhdistät langattoman verkon tietokoneeseen, puhelimeen ja muihin kodin älylaitteisiin. Voit jakaa verkon usealle käyttäjälle ja mobiiliyhteydellä teet etätöitä missä haluat.',
    ...val),

  TS0L: (en: string, ...val: string[]) => translate(en,
    'Kenelle laite lunastetaan?',
    ...val),

  TSLW: (en: string, ...val: string[]) => translate(en,
    'Palveluun sovelletaan pääliittymää koskevia sopimusehtoja.',
    ...val),

  TSNL: (en: string, ...val: string[]) => translate(en,
    'Sähköpostiosoite on jo vahvistettu. Jatka vahvistamalla puhelinnumerosi.',
    ...val),

  TT09: (en: string, ...val: string[]) => translate(en,
    'Nykyinen liittymäsi:',
    ...val),

  TTBU: (en: string, ...val: string[]) => translate(en,
    'Käyttäjällä on päättymässä oleva Elisa palvelupäätelaite sopimus. Valitse laite jolle haluat tehdä laitevaihdon tai valitse uusi sopimus.',
    ...val),

  TTFH: (en: string, ...val: string[]) => translate(en,
    'Liittymän nimi ja numero',
    ...val),

  TTKS: (en: string, ...val: string[]) => translate(en,
    'Haluan irtisanoa myös Ring-liittymän',
    ...val),

  TTM6: (en: string, ...val: string[]) => translate(en,
    'Jos sinulla on kysyttävää, voit [lähettää viestin]. Jos asiasi on kiireinen, niin chatista saat nopeimman avun.',
    ...val),

  TTO8: (en: string, ...val: string[]) => translate(en,
    'Haluatko jatkaa asiointia Yritysten OmaElisassa?',
    ...val),

  TTZ4: (en: string, ...val: string[]) => translate(en,
    'Esim. Varaston yhteiskäytössä oleva puhelin',
    ...val),

  TUZU: (en: string, ...val: string[]) => translate(en,
    'Asiakkaan laiterekisteröinnin alias',
    ...val),

  TVKW: (en: string, ...val: string[]) => translate(en,
    'Voit lisätä korkeintaan {} liitetiedostoa. (max. {} MB/liite)',
    ...val),

  TVWC: (en: string, ...val: string[]) => translate(en,
    'Sähköpostin voi lisätä ja sitä voi muokata myös myöhemmin OmaRing-palvelussa.',
    ...val),

  TW24: (en: string, ...val: string[]) => translate(en,
    'Ole yhteydessä työnantajasi yhteyshenkilöön ja pyydä heitä tarkistamaan Yritysten OmaElisassa olevat henkilö- ja yhteystietosi tai tarvittaessa lisäämään sinut käyttäjäksi.',
    ...val),

  TWB3: (en: string, ...val: string[]) => translate(en,
    '{} hinta ennen muutosta',
    ...val),

  TWHW: (en: string, ...val: string[]) => translate(en,
    'Nouda noutopisteestä',
    ...val),

  TX9O: (en: string, ...val: string[]) => translate(en,
    'Aloita käyttöönotto tunnistautumalla.',
    ...val),

  TXT7: (en: string, ...val: string[]) => translate(en,
    'Luo Elisa Tunnus',
    ...val),

  TXTH: (en: string, ...val: string[]) => translate(en,
    'Tämä käyttäjä on Elisa Yritystietoturvan pääkäyttäjä. Jos muutat käyttäjän nimeä, matkapuhelinnumeroa tai sähköpostiosoitetta, myös Elisa Yritystietoturvan kirjautumistunnukset muuttuvat.',
    ...val),

  TXXM: (en: string, ...val: string[]) => translate(en,
    'eSIMiä tukeva laite',
    ...val),

  TYJR: (en: string, ...val: string[]) => translate(en,
    'Huolettomaan peruskäyttöön ja aktiiviseen netin selaukseen.',
    ...val),

  TYKY: (en: string, ...val: string[]) => translate(en,
    'Tietosuojan vuoksi on tärkeää, että henkilötiedot ovat oikein.',
    ...val),

  TYQZ: (en: string, ...val: string[]) => translate(en,
    'Olet aktivoimassa kaksivaiheisen tunnistautumisen, mikä vaatii jatkossa kirjautumisen yhteydessä tunnuksen ja salasanan lisäksi matkapuhelimeen tulevan kertakäyttöisen tunnistautumiskoodin.',
    ...val),

  TYVC: (en: string, ...val: string[]) => translate(en,
    'Sopijayritystä ei voida vaihtaa, koska:',
    ...val),

  TZBP: (en: string, ...val: string[]) => translate(en,
    'Käsitellään',
    ...val),

  TZPN: (en: string, ...val: string[]) => translate(en,
    'Ota paperilasku (21,32 €/lasku) tai sähköpostilasku käyttöön asiakaspalvelun kautta.',
    ...val),

  TZS0: (en: string, ...val: string[]) => translate(en,
    'Laskutussopimus puuttuu',
    ...val),

  TZWB: (en: string, ...val: string[]) => translate(en,
    'Sisältyvät tuotteet',
    ...val),

  TZYQ: (en: string, ...val: string[]) => translate(en,
    'Verkkolaskutustietojen päivitys',
    ...val),

  U09E: (en: string, ...val: string[]) => translate(en,
    'Tutustu myös kattaviin asiakaspalveluratkaisuihimme',
    ...val),

  U0N3: (en: string, ...val: string[]) => translate(en,
    'Lasku laitteesta lähetetään työntekijälle',
    ...val),

  U17V: (en: string, ...val: string[]) => translate(en,
    'Matkapuhelimet',
    ...val),

  U1IQ: (en: string, ...val: string[]) => translate(en,
    'Uudenveroinen',
    ...val),

  U1QE: (en: string, ...val: string[]) => translate(en,
    'Tarkista saatavuus',
    ...val),

  U1WD: (en: string, ...val: string[]) => translate(en,
    'Kuvaile lyhyesti laitteen vikaa ja miten se ilmeni',
    ...val),

  U2A0: (en: string, ...val: string[]) => translate(en,
    'Hyötyesto',
    ...val),

  U2AK: (en: string, ...val: string[]) => translate(en,
    'Yhteysvirhe',
    ...val),

  U2PF: (en: string, ...val: string[]) => translate(en,
    'Vaiheet',
    ...val),

  U3B8: (en: string, ...val: string[]) => translate(en,
    'Oletko varma, että haluat poistaa OmaLasku Palvelunumerot -ominaisuuden käytöstä? Huomaa, että jos maksuja on laskuttamatta, saat niistä vielä laskun.',
    ...val),

  U3BJ: (en: string, ...val: string[]) => translate(en,
    'Irtisanomis-, keskeytys- tai jatkamistilaus',
    ...val),

  U3PR: (en: string, ...val: string[]) => translate(en,
    'Netti toimii saumattomammin ja etäpalaverit voi hoitaa luotettavammin ilman että video katkeilee tai yhteys pätkii',
    ...val),

  U3UL: (en: string, ...val: string[]) => translate(en,
    'Tietojen lähteet: Yhteyshenkilötiedot muodostuvat palveluiden käyttäjätiedoista, asiakaskohtaamisista (myynti, markkinointi, asiakaspalvelu), sekä Alma Media Finland Oy:n päättäjärekisterin tiedoista.',
    ...val),

  U4WE: (en: string, ...val: string[]) => translate(en,
    'Kuinka tyytyväinen olet saamaasi palveluun?',
    ...val),

  U54O: (en: string, ...val: string[]) => translate(en,
    'Gt/kk',
    ...val),

  U57Z: (en: string, ...val: string[]) => translate(en,
    'Mobiiliturva estää haitallisia sivuja',
    ...val),

  U5GY: (en: string, ...val: string[]) => translate(en,
    'Näin ostat liittymän',
    ...val),

  U5N7: (en: string, ...val: string[]) => translate(en,
    'Koontilasku erittelyllä',
    ...val),

  U5SS: (en: string, ...val: string[]) => translate(en,
    'Vahvista päivitys',
    ...val),

  U63I: (en: string, ...val: string[]) => translate(en,
    '.',
    ...val),

  U65A: (en: string, ...val: string[]) => translate(en,
    'Datavartija ei vaikuta paikallisten WiFi-yhteyksien kuten hotellien wlan-verkkojen käyttöön.',
    ...val),

  U6SB: (en: string, ...val: string[]) => translate(en,
    'Aito 5G -liittymä toimii parhaiten kaikissa tilanteissa, myös esimerkiksi massatapahtumissa, kun verkossa on ruuhkaa',
    ...val),

  U781: (en: string, ...val: string[]) => translate(en,
    '5G+ verkon hyödyt',
    ...val),

  U7F2: (en: string, ...val: string[]) => translate(en,
    'Työntekijän OmaElisa on palvelu, jossa voit hallinnoida omia työsuhdeliittymiäsi ja -laitteitasi. Voit muun muassa tilata työvälineet helposti työntekijän laitekaupasta, tarkastaa työliittymäsi PUK-koodin ja seurata liittymän käyttöä reaaliajassa.',
    ...val),

  U7HJ: (en: string, ...val: string[]) => translate(en,
    'Maksun vahvistaminen epäonnistui',
    ...val),

  U7X7: (en: string, ...val: string[]) => translate(en,
    'Valitse {}',
    ...val),

  U84N: (en: string, ...val: string[]) => translate(en,
    'Voit hoitaa asennuksen itse tai tilata asennuspalvelun Netti Lite tilauksen yhteydessä.',
    ...val),

  U85D: (en: string, ...val: string[]) => translate(en,
    'Saat hyvitystä laitteen kunnon ja mallin perusteella',
    ...val),

  U88X: (en: string, ...val: string[]) => translate(en,
    'Poistetut palvelut',
    ...val),

  U8AN: (en: string, ...val: string[]) => translate(en,
    'sis.',
    ...val),

  U8IP: (en: string, ...val: string[]) => translate(en,
    'En lunasta tai palauta laitetta. Haluan uuden sopimuksen aikaisempien sopimusten lisäksi. Aikaisemmat sopimukset jatkuvat ennallaan sopimuskauden mukaisesti.',
    ...val),

  U8O2: (en: string, ...val: string[]) => translate(en,
    'Tässä osiossa näytetään vanhassa tilausjärjestelmässä luodut tilaukset.',
    ...val),

  U992: (en: string, ...val: string[]) => translate(en,
    'Postin kuljetus toimitusosoitteeseen',
    ...val),

  U9EI: (en: string, ...val: string[]) => translate(en,
    'Tilauksen vastaanottaja',
    ...val),

  U9GR: (en: string, ...val: string[]) => translate(en,
    'Poista Etsi –toiminto käytöstä',
    ...val),

  U9V3: (en: string, ...val: string[]) => translate(en,
    'Ei avoimia lunastuspyyntöjä',
    ...val),

  UA9T: (en: string, ...val: string[]) => translate(en,
    'Muutospyynnön lähetys onnistui.',
    ...val),

  UAAP: (en: string, ...val: string[]) => translate(en,
    'Kassalle',
    ...val),

  UAD1: (en: string, ...val: string[]) => translate(en,
    'Estä puhelimen paikannus',
    ...val),

  UAMB: (en: string, ...val: string[]) => translate(en,
    'Toiminnot',
    ...val),

  UAPN: (en: string, ...val: string[]) => translate(en,
    'Mrit yhteytesi',
    ...val),

  UB77: (en: string, ...val: string[]) => translate(en,
    'Lisenssien hallintaportaaliin pääsy on estetty',
    ...val),

  UBBK: (en: string, ...val: string[]) => translate(en,
    'OmaElisa Työntekijöille',
    ...val),

  UC34: (en: string, ...val: string[]) => translate(en,
    'Hei',
    ...val),

  UC8X: (en: string, ...val: string[]) => translate(en,
    'Yritä uudelleen ja jos virhe toistuu, ota yhteyttä Elisan asiakaspalveluun.',
    ...val),

  UCAJ: (en: string, ...val: string[]) => translate(en,
    'Lähetä kertakäyttösalasana uudelleen',
    ...val),

  UCPM: (en: string, ...val: string[]) => translate(en,
    'Jos liittymälläsi on Mobiilivarmenne käytössä, se poistetaan eSIM-tilauksen yhteydessä.',
    ...val),

  UCRF: (en: string, ...val: string[]) => translate(en,
    'Tilauksen hyväksyjällä on oikeus hyväksyä ja hylätä tilauksia sekä lunastuspyyntöjä Työntekijän OmaElisassa. Tilauksen hyväksyjä ei saa pääsyä Yritysten OmaElisaan.',
    ...val),

  UDSQ: (en: string, ...val: string[]) => translate(en,
    'Lunastettava laite',
    ...val),

  UE2G: (en: string, ...val: string[]) => translate(en,
    'Ostoskorissa on nyt {} tuotetta',
    ...val),

  UE8R: (en: string, ...val: string[]) => translate(en,
    'Kustannuspaikka ei päivity automaattisesti käyttäjän palveluille. Tarkastathan kustannuspaikan tuotteen tai palvelun tiedoista.',
    ...val),

  UEHC: (en: string, ...val: string[]) => translate(en,
    'Tunnistautumisessa tapahtui virhe',
    ...val),

  UEMQ: (en: string, ...val: string[]) => translate(en,
    'Kustannuspaikkalasku erittelyillä',
    ...val),

  UEOZ: (en: string, ...val: string[]) => translate(en,
    'Kopioi',
    ...val),

  UF2D: (en: string, ...val: string[]) => translate(en,
    'Ei nettiliittymiä',
    ...val),

  UFGV: (en: string, ...val: string[]) => translate(en,
    'Suljettu',
    ...val),

  UFR3: (en: string, ...val: string[]) => translate(en,
    'Valitettavasti maksun vahvistaminen ei onnistunut. Yritä uudelleen tai käytä jotain muuta maksutapaa.',
    ...val),

  UG9B: (en: string, ...val: string[]) => translate(en,
    'Ring pääkäyttöoikeuden poistaminen epäonnistui',
    ...val),

  UGFH: (en: string, ...val: string[]) => translate(en,
    'Jätä yhteystietosi, niin asiakaspalvelumme on sinuun yhteydessä 24 tunnin kuluessa.',
    ...val),

  UGH3: (en: string, ...val: string[]) => translate(en,
    'Siirry vahvistamaan',
    ...val),

  UGPA: (en: string, ...val: string[]) => translate(en,
    'kk. Ilmoitetut hinnat alv. 0 %',
    ...val),

  UIV1: (en: string, ...val: string[]) => translate(en,
    'Onko laskusi loppusumma erilainen kuin yleensä?',
    ...val),

  UJ7S: (en: string, ...val: string[]) => translate(en,
    'Voit lisätä vain yhden alennuskoodin tilaukselle.',
    ...val),

  UJ8H: (en: string, ...val: string[]) => translate(en,
    'Jätä tarvittaessa [tukipyyntö].',
    ...val),

  UJGD: (en: string, ...val: string[]) => translate(en,
    'Tilausvahvistus ei ole saatavilla tälle tilaukselle',
    ...val),

  UJRH: (en: string, ...val: string[]) => translate(en,
    'Toimi nopeasti, tuotetta jäljellä rajoitetusti verkkokaupan varastossa',
    ...val),

  UJRP: (en: string, ...val: string[]) => translate(en,
    'tuotetta',
    ...val),

  UK6U: (en: string, ...val: string[]) => translate(en,
    'Tilaa OmaElisasta',
    ...val),

  UK9J: (en: string, ...val: string[]) => translate(en,
    'Vahvista asiakkaan numeron näkyvyystiedot jatkaaksesi.',
    ...val),

  UKMC: (en: string, ...val: string[]) => translate(en,
    'Pankki- tai luottokortti',
    ...val),

  ULHB: (en: string, ...val: string[]) => translate(en,
    'Jos haluat keskustella asiantuntijamme kanssa ennen tilaamista, jätä meille yhteydenottopyyntö. Olemme sinuun yhteydessä yhden työpäivän sisällä.',
    ...val),

  ULI0: (en: string, ...val: string[]) => translate(en,
    'Sopimusaika',
    ...val),

  ULM3: (en: string, ...val: string[]) => translate(en,
    'Täytä laskutusyhteyshenkilön tiedot',
    ...val),

  ULM4: (en: string, ...val: string[]) => translate(en,
    'Muista liittymän käyttäjän vaihtuessa irtisanoa myös liittymässä oleva käyttäjän henkilökohtainen vastaajapalvelu. Uudelle käyttäjälle tulee aktivoida oma henkilökohtainen vastaajapalvelu.',
    ...val),

  ULMQ: (en: string, ...val: string[]) => translate(en,
    'Päivämäärä ei ole kelvollinen',
    ...val),

  UM14: (en: string, ...val: string[]) => translate(en,
    'Käyttäjä on siirretty toiseen yritykseen. Huomaa, että käyttäjätiedot poistuvat yrityksestä {}, kun siirto on käsitelty.',
    ...val),

  UM4L: (en: string, ...val: string[]) => translate(en,
    'Laitteella on ajastettu muutos. Muutos käsitellään sovittuna ajankohtana.',
    ...val),

  UM9T: (en: string, ...val: string[]) => translate(en,
    'Alanumerot',
    ...val),

  UMEE: (en: string, ...val: string[]) => translate(en,
    'Ei käyttäjiä',
    ...val),

  UMWH: (en: string, ...val: string[]) => translate(en,
    'Tuetut verkot',
    ...val),

  UNYV: (en: string, ...val: string[]) => translate(en,
    'Huomiothan, että laitteen lunastaminen on sitova eikä muutos ole peruttavissa.',
    ...val),

  UO3T: (en: string, ...val: string[]) => translate(en,
    'Täältä voit tarkistaa liittymiesi tiedot ja PUK-koodit. PUK2-koodin näet klikkaamalla liittymää.',
    ...val),

  UOFI: (en: string, ...val: string[]) => translate(en,
    'Mikäli sinulla ei vielä ole henkilökohtaista Elisa Tunnusta pääset luomaan sen tunnistautumisen jälkeen. Jos et pysty tunnistautumaan Mobiilivarmenteella tai pankkitunnuksilla, voit jatkaa ',
    ...val),

  UORO: (en: string, ...val: string[]) => translate(en,
    'Valitse haluatko laitteet osatoimituksena vai kerralla.',
    ...val),

  UOYP: (en: string, ...val: string[]) => translate(en,
    'Estää puhelut esim. erilaisille keskustelulinjoille ja markkinointikampanjoihin sekä osallistumisen puhelinäänestyksiin ja TV-visailuihin. Sisältää eston viihdenumeroihin.',
    ...val),

  UP0J: (en: string, ...val: string[]) => translate(en,
    'Mobiililaajakaista (SIM-kortti)',
    ...val),

  UPE3: (en: string, ...val: string[]) => translate(en,
    'Ei rajoituksia',
    ...val),

  UPUX: (en: string, ...val: string[]) => translate(en,
    'Luo itsellesi OmaElisa-tunnukset',
    ...val),

  UPZV: (en: string, ...val: string[]) => translate(en,
    'Liittymä, jota muutos koskee',
    ...val),

  UQ4L: (en: string, ...val: string[]) => translate(en,
    'Yrityksesi on estänyt tämän maksullisen toiminnon. Tarvittaessa ota yhteyttä yrityksesi pääkäyttäjään.',
    ...val),

  UQHZ: (en: string, ...val: string[]) => translate(en,
    'Maksetut',
    ...val),

  UQMA: (en: string, ...val: string[]) => translate(en,
    'Yritysten omat laitelistat löydät omalta laitelista-sivulta. Kopiointi ei ylikirjoita olemassa olevia listoja, joten poista tarvittaessa vanhat listat.',
    ...val),

  UQPC: (en: string, ...val: string[]) => translate(en,
    'Tilauksesi sisältää tuotteita, joita ei juuri nyt ole saatavilla. Valitse haluatko laitteet osatoimituksena vai kerralla.',
    ...val),

  UQVM: (en: string, ...val: string[]) => translate(en,
    'Vastaaja',
    ...val),

  UR0I: (en: string, ...val: string[]) => translate(en,
    'Ladataan saatavuustietoja',
    ...val),

  UR1U: (en: string, ...val: string[]) => translate(en,
    'Yritysnumero tai alanumero ei ole saatavilla',
    ...val),

  URAB: (en: string, ...val: string[]) => translate(en,
    'Varmistamme henkilöllisyytesi tunnistautumisella.',
    ...val),

  URAQ: (en: string, ...val: string[]) => translate(en,
    'Valinta vaikuttaa millä kielellä saat mm. tilausvahvistukset sekä laskut',
    ...val),

  URFP: (en: string, ...val: string[]) => translate(en,
    'Valokuitu',
    ...val),

  US8M: (en: string, ...val: string[]) => translate(en,
    'Laskutussopimuksella on ajastettu muutospyyntö',
    ...val),

  USAF: (en: string, ...val: string[]) => translate(en,
    'Tee jokaisesta laitteesta oma hinta-arvio',
    ...val),

  USHS: (en: string, ...val: string[]) => translate(en,
    'Käyttäjä on jo olemassa',
    ...val),

  USTU: (en: string, ...val: string[]) => translate(en,
    'Valitse asennuspäivä ennen jatkamista.',
    ...val),

  UT0C: (en: string, ...val: string[]) => translate(en,
    'Laturi ei sisälly pakkaukseen',
    ...val),

  UT0X: (en: string, ...val: string[]) => translate(en,
    'Lähetä kutsu työntekijälle',
    ...val),

  UT8Z: (en: string, ...val: string[]) => translate(en,
    'Anna työsuhdepuhelinnumerosi, niin lähetämme sinulle vahvistuskoodin tekstiviestillä. Tällä varmistamme, mitä työsuhdeliittymiä tai -laitteita sinulla on käytössäsi.',
    ...val),

  UTC5: (en: string, ...val: string[]) => translate(en,
    'Valitse datapaketti',
    ...val),

  UTIR: (en: string, ...val: string[]) => translate(en,
    'Sopimus päättyy',
    ...val),

  UTNT: (en: string, ...val: string[]) => translate(en,
    'Nollahintaisuuden perusteet',
    ...val),

  UU5G: (en: string, ...val: string[]) => translate(en,
    'Valitse lisäpalvelut',
    ...val),

  UU5X: (en: string, ...val: string[]) => translate(en,
    'Olemme ratkaisseet tukipyynnön ja ratkaisu on nähtävillä tällä sivulla. Olemme myös lähettäneet kuittauksen tukipyynnön avanneen käyttäjän sähköpostiin.',
    ...val),

  UUO7: (en: string, ...val: string[]) => translate(en,
    'Paino',
    ...val),

  UV57: (en: string, ...val: string[]) => translate(en,
    'Sopimus ja lisäpalvelut',
    ...val),

  UV5C: (en: string, ...val: string[]) => translate(en,
    'Yhteystietoja puuttuu',
    ...val),

  UVCL: (en: string, ...val: string[]) => translate(en,
    'Ei tuotteita luettelossa.',
    ...val),

  UVFA: (en: string, ...val: string[]) => translate(en,
    'Käyttäjältä {} poistetaan Ring-palvelut. Alanumero {} ja yritysnumero {} vapautetaan.',
    ...val),

  UW4H: (en: string, ...val: string[]) => translate(en,
    'Laskun tyyppi',
    ...val),

  UWU6: (en: string, ...val: string[]) => translate(en,
    'Palvelu näyttää automaattisesti soittajan nimitiedon, vaikka sitä ei olisi tallennettuna osoitekirjaasi, ja ilman erillistä sovellusta. Nimitiedot haetaan luettelotietokannoista. Lue lisää Kuka Soittaa -palvelusta.',
    ...val),

  UWU7: (en: string, ...val: string[]) => translate(en,
    'Nopeuden nosto {} Mbit/s',
    ...val),

  UWU8: (en: string, ...val: string[]) => translate(en,
    'Nosta liittymäsi nopeutta vieläkin tehokkaampaan ja sujuvampaan työntekoon.',
    ...val),

  UWZ8: (en: string, ...val: string[]) => translate(en,
    'E-lasku',
    ...val),

  UX5G: (en: string, ...val: string[]) => translate(en,
    '2,99 € / kk / liittymä alv. 0 %',
    ...val),

  UXAH: (en: string, ...val: string[]) => translate(en,
    'Laitevalikoima on käytössä',
    ...val),

  UXSJ: (en: string, ...val: string[]) => translate(en,
    'Nettiliittymän asennus',
    ...val),

  UYCL: (en: string, ...val: string[]) => translate(en,
    'siirron uudelle omistajalle.',
    ...val),

  UZ2G: (en: string, ...val: string[]) => translate(en,
    'Laitelistaa ei voitu kopioida kaikille yrityksille. Ole hyvä ja yritä uudelleen.',
    ...val),

  UZ3K: (en: string, ...val: string[]) => translate(en,
    'Muu vastaanottaja',
    ...val),

  UZ6X: (en: string, ...val: string[]) => translate(en,
    'alv.',
    ...val),

  UZFU: (en: string, ...val: string[]) => translate(en,
    ', mm. Saunalahden yritysasiakkaiden palvelut löytyvät sieltä.',
    ...val),

  V02H: (en: string, ...val: string[]) => translate(en,
    'Päivitys muuttaa käyttäjän kirjautumistunnuksen',
    ...val),

  V05V: (en: string, ...val: string[]) => translate(en,
    'Ring-käyttäjän vaihtaminen',
    ...val),

  V07Q: (en: string, ...val: string[]) => translate(en,
    'Oma Ring',
    ...val),

  V082: (en: string, ...val: string[]) => translate(en,
    'Kutsulinkki odottaa vahvistusta käyttäjältä',
    ...val),

  V09Q: (en: string, ...val: string[]) => translate(en,
    'Voit ajastaa muutoksen, jos kyseessä on käyttäjän muutos tai laskutussopimuksen muutos.',
    ...val),

  V09R: (en: string, ...val: string[]) => translate(en,
    'Muutospyyntö kesken',
    ...val),

  V0VJ: (en: string, ...val: string[]) => translate(en,
    'Hupsis, jotain meni pieleen',
    ...val),

  V0XR: (en: string, ...val: string[]) => translate(en,
    'Elisa Yrityksille',
    ...val),

  V15A: (en: string, ...val: string[]) => translate(en,
    'Elisa',
    ...val),

  V16Q: (en: string, ...val: string[]) => translate(en,
    'Valitse liittymä',
    ...val),

  V19M: (en: string, ...val: string[]) => translate(en,
    'Siirry laskutussopimukseen',
    ...val),

  V1HP: (en: string, ...val: string[]) => translate(en,
    'Tilausaika',
    ...val),

  V1VL: (en: string, ...val: string[]) => translate(en,
    'Osoitetiedot puuttuvat',
    ...val),

  V2E6: (en: string, ...val: string[]) => translate(en,
    'Liittymän siirto toiseen laskutussopimukseen',
    ...val),

  V2IT: (en: string, ...val: string[]) => translate(en,
    'Poista Ring-palvelu liittymältä',
    ...val),

  V2PM: (en: string, ...val: string[]) => translate(en,
    'Jotta saat Aito 5G -liittymästäsi parhaan hyödyn irti,',
    ...val),

  V2S1: (en: string, ...val: string[]) => translate(en,
    'tulosta.',
    ...val),

  V2YZ: (en: string, ...val: string[]) => translate(en,
    'Tuotetta varastossa',
    ...val),

  V34H: (en: string, ...val: string[]) => translate(en,
    'Käytössä',
    ...val),

  V3UP: (en: string, ...val: string[]) => translate(en,
    'Laitteiden sopimuskausi',
    ...val),

  V4GK: (en: string, ...val: string[]) => translate(en,
    'Haku',
    ...val),

  V549: (en: string, ...val: string[]) => translate(en,
    'Listaa ei ole julkaistu. Lista on käytettävissä vasta julkaisun jälkeen.',
    ...val),

  V59H: (en: string, ...val: string[]) => translate(en,
    'Lähetämme tähän numeroon SMS-ilmoituksen erääntyneestä laskusta.',
    ...val),

  V5EW: (en: string, ...val: string[]) => translate(en,
    'Koskeeko muutos kaikkia tämän Y-tunnuksen laskutussopimuksia',
    ...val),

  V5HK: (en: string, ...val: string[]) => translate(en,
    'Olethan yhteydessä asiakaspalveluun {0} ({1})',
    ...val),

  V62H: (en: string, ...val: string[]) => translate(en,
    'Listassa näet laskutussopimukset, joissa käyttäjä on laskun yhteyshenkilö tai sähköpostilaskun vastaanottaja.',
    ...val),

  V6RV: (en: string, ...val: string[]) => translate(en,
    'Valikoimasta poistuneet tuotteet eivät ole enää myynnissä, eikä niitä näytetä työntekijöiden laitelistoilla.',
    ...val),

  V6WM: (en: string, ...val: string[]) => translate(en,
    'Laskun tilan päivittyminen',
    ...val),

  V72N: (en: string, ...val: string[]) => translate(en,
    'Hinta',
    ...val),

  V7EA: (en: string, ...val: string[]) => translate(en,
    'Tekninen neuvonta ja käytönopastus',
    ...val),

  V7HT: (en: string, ...val: string[]) => translate(en,
    'Langattoman MESH-verkon asennus',
    ...val),

  V7I7: (en: string, ...val: string[]) => translate(en,
    'Kertamaksu, alv. {} %',
    ...val),

  V7KF: (en: string, ...val: string[]) => translate(en,
    'Lisää käyttäjä',
    ...val),

  V837: (en: string, ...val: string[]) => translate(en,
    'Jos käyttäjällä on avoimia tilauksia tai hyväksyntäpyyntöjä, ne peruutetaan',
    ...val),

  V8YL: (en: string, ...val: string[]) => translate(en,
    'Lue lisää lisäpalveluista',
    ...val),

  V90E: (en: string, ...val: string[]) => translate(en,
    'Löysimme tuotteitasi useammasta yrityksestä.',
    ...val),

  V97L: (en: string, ...val: string[]) => translate(en,
    'numerosi on julkinen ja sen tiedot löytyvät numeropalveluista.',
    ...val),

  V996: (en: string, ...val: string[]) => translate(en,
    'Huomioithan, että jos yhteys tilataan muualle kuin kotiin, niin asennuspalvelu on suositeltava.',
    ...val),

  V9HK: (en: string, ...val: string[]) => translate(en,
    'Valitse tuote',
    ...val),

  V9K9: (en: string, ...val: string[]) => translate(en,
    'Matkapuhelinnumero (työ)',
    ...val),

  V9OQ: (en: string, ...val: string[]) => translate(en,
    'Tietolähde Patentti- ja rekisterihallitus / YTJ, tiedonvälittäjä Alma Media Finland Oy',
    ...val),

  V9XM: (en: string, ...val: string[]) => translate(en,
    'Älä peruuta',
    ...val),

  VA1O: (en: string, ...val: string[]) => translate(en,
    'Ei tietueita',
    ...val),

  VA44: (en: string, ...val: string[]) => translate(en,
    'Löytynyt käyttäjä',
    ...val),

  VAJN: (en: string, ...val: string[]) => translate(en,
    'Väliaikainen sulku kannattaa tehdä esimerkiksi silloin, jos laite on kadonnut ja haluat estää sen väärinkäyttöä.',
    ...val),

  VB8M: (en: string, ...val: string[]) => translate(en,
    'Säännölliseen työntekoon ja aktiiviseen vapaa-ajan surffailuun',
    ...val),

  VBQK: (en: string, ...val: string[]) => translate(en,
    'Elisa Oyj ei hallinnoi yrityksesi laitelistojen valikoimaa. Jos sinulla on kysyttävää laitevalikoimaan liittyen, ota yhteyttä työnantajasi OmaElisa-pääkäyttäjään.',
    ...val),

  VBS1: (en: string, ...val: string[]) => translate(en,
    'Ladataan tuotetietoja',
    ...val),

  VBUC: (en: string, ...val: string[]) => translate(en,
    'Uusi asennusosoite',
    ...val),

  VC3L: (en: string, ...val: string[]) => translate(en,
    'Saatavuus:',
    ...val),

  VCRE: (en: string, ...val: string[]) => translate(en,
    'Uusi vahvistuskoodi lähetettiin.',
    ...val),

  VCUZ: (en: string, ...val: string[]) => translate(en,
    'OmaElisa yrityksille',
    ...val),

  VCX1: (en: string, ...val: string[]) => translate(en,
    'Julkinen numero',
    ...val),

  VDB4: (en: string, ...val: string[]) => translate(en,
    'Yhteenveto',
    ...val),

  VDB5: (en: string, ...val: string[]) => translate(en,
    'Yhteenveto tilauksestasi',
    ...val),

  VDE4: (en: string, ...val: string[]) => translate(en,
    'Tunnuksena toimii sähköpostiosoitteesi.',
    ...val),

  VEGK: (en: string, ...val: string[]) => translate(en,
    'Määräaikaisuus päättyy',
    ...val),

  VF8X: (en: string, ...val: string[]) => translate(en,
    'Kyllä: uudet tiedot tulevat voimaan ensimmäisestä mahdollisesta laskusta alkaen. Huomioithan, että muutos ei vaikuta jo muodostuneisiin laskuihin.\n\nEi: voit ilmoittaa muuttuvat laskutustiedot etukäteen ja ne tulevat voimaan valitsemanasi päivänä.',
    ...val),

  VFVT: (en: string, ...val: string[]) => translate(en,
    'Kutsun poisto epäonnistui.',
    ...val),

  VFZ2: (en: string, ...val: string[]) => translate(en,
    'Muutokset tallennettu',
    ...val),

  VFZN: (en: string, ...val: string[]) => translate(en,
    'Muoto: AA:BB:CC:DD:EE:FF',
    ...val),

  VG7P: (en: string, ...val: string[]) => translate(en,
    'Puh. ',
    ...val),

  VH3U: (en: string, ...val: string[]) => translate(en,
    'Laskutussopimuksen yhteyshenkilö, jolle viestitään laskuihin liittyvistä asioista, myös maksamattomista laskuista. Ei tulostu laskulle.',
    ...val),

  VH59: (en: string, ...val: string[]) => translate(en,
    'Palaa',
    ...val),

  VH8G: (en: string, ...val: string[]) => translate(en,
    'Liittymä ei ole liitetty yrityksesi Vakio-ratkaisuun',
    ...val),

  VHFX: (en: string, ...val: string[]) => translate(en,
    'Avaaja',
    ...val),

  VHGX: (en: string, ...val: string[]) => translate(en,
    'Suojalaukut ja -kotelot',
    ...val),

  VI0P: (en: string, ...val: string[]) => translate(en,
    'Laajakaista',
    ...val),

  VJ0T: (en: string, ...val: string[]) => translate(en,
    'Laitevalikoiman nimi',
    ...val),

  VJBG: (en: string, ...val: string[]) => translate(en,
    'Liittymälläsi on Elisa Mobiiliturva yrityksille -palvelu, joka estää palvelun käyttöönoton.',
    ...val),

  VJCA: (en: string, ...val: string[]) => translate(en,
    'Työajan ulkopuolella (manuaalinen)',
    ...val),

  VJI9: (en: string, ...val: string[]) => translate(en,
    'Huomioithan että kaikki työntekijät, joilla on yrityksesi hankkima Elisan mobiililiittymä käytössä, voivat ottaa Elisa Mobiilivarmenne -palvelun käyttöönsä ilman erillistä hyväksymistä.',
    ...val),

  VJK6: (en: string, ...val: string[]) => translate(en,
    'Lisätty ostoskoriin',
    ...val),

  VJMT: (en: string, ...val: string[]) => translate(en,
    'Laitesopimuksesi päättyy {}',
    ...val),

  VJNB: (en: string, ...val: string[]) => translate(en,
    'Lunastetaanko laite yritykselle vai työntekijälle?',
    ...val),

  VJYS: (en: string, ...val: string[]) => translate(en,
    'Tiedostossa voi olla enintään 500 sähköpostiosoitetta.',
    ...val),

  VKFM: (en: string, ...val: string[]) => translate(en,
    'Lisää',
    ...val),

  VKJ4: (en: string, ...val: string[]) => translate(en,
    'Palauttamattomasta laitteesta veloitetaan palautusrikemaksu.',
    ...val),

  VKRZ: (en: string, ...val: string[]) => translate(en,
    'Vähintään 8 merkkiä pitkä',
    ...val),

  VL1R: (en: string, ...val: string[]) => translate(en,
    'Tilauksen hyväksyjän on valittava laskutussopimus joka kerta, kun hän hyväksyy tilauksen.',
    ...val),

  VLDA: (en: string, ...val: string[]) => translate(en,
    'Valmistajan mukaan',
    ...val),

  VLOS: (en: string, ...val: string[]) => translate(en,
    'Kirjautuminen on uudistunut.',
    ...val),

  VLQ3: (en: string, ...val: string[]) => translate(en,
    'SIM-kortin numero',
    ...val),

  VLT2: (en: string, ...val: string[]) => translate(en,
    'Kiitos, myyjämme on sinuun pian yhteydessä! Voit nyt täyttää toisen laitteen tiedot.',
    ...val),

  VLYG: (en: string, ...val: string[]) => translate(en,
    'Valitse jokin saatavilla olevista päivistä tai valitse toivottu asennuspäivä',
    ...val),

  VLZR: (en: string, ...val: string[]) => translate(en,
    'Jatka ostoksia',
    ...val),

  VM5M: (en: string, ...val: string[]) => translate(en,
    'Lähetys epäonnistui',
    ...val),

  VME0: (en: string, ...val: string[]) => translate(en,
    'laskuja',
    ...val),

  VMNS: (en: string, ...val: string[]) => translate(en,
    'Estää puhelut esim. lento- ja laivayhtiöiden asiakaspalvelunumeroihin sekä osallistumisen mielipidemittauksiin ja puhelinlahjoituksiin. Estää myös tilauspalveluiden käytön (esim. juoma- tai elintarvikeautomaatit) sekä pizza- ja matkalipputilaukset. Sisältää eston viihde- ja ajanvietenumeroihin.',
    ...val),

  VMT9: (en: string, ...val: string[]) => translate(en,
    'Liittymää ei voida avata maksamattomien laskujen vuoksi. Tarkistathan laskujen tilanteen.',
    ...val),

  VMZW: (en: string, ...val: string[]) => translate(en,
    'Sinun täytyy lähettää ensin kutsu Työntekijän OmaElisaan ',
    ...val),

  VNNL: (en: string, ...val: string[]) => translate(en,
    'Vahvista saatavilla oleva asennuspäivä ennen jatkamista.',
    ...val),

  VNWG: (en: string, ...val: string[]) => translate(en,
    'Estää mobiilidatan ja multimediaviestien käytön ulkomailla.',
    ...val),

  VO2Q: (en: string, ...val: string[]) => translate(en,
    'Palvelu asettaa matkapuhelinliittymälle 50 euron (alv. 0 %) saldorajan ulkomailla tapahtuvaan roaming-datasiirtoon. Palvelu ilmoittaa tekstiviestillä saldon täyttymisestä. Voit muuttaa rajaa (50–5000 €) tekstiviestillä milloin vain, ja tilattu raja on voimassa siitä eteenpäin.',
    ...val),

  VOF3: (en: string, ...val: string[]) => translate(en,
    'Toimitus yrityksen toimipisteeseen',
    ...val),

  VOMQ: (en: string, ...val: string[]) => translate(en,
    'Nollahintaisuuden käyttökategoria',
    ...val),

  VOR4: (en: string, ...val: string[]) => translate(en,
    'Liittymäsi on nyt suljettu väliaikaisesti.',
    ...val),

  VOV7: (en: string, ...val: string[]) => translate(en,
    'Evästeasetukset',
    ...val),

  VP3V: (en: string, ...val: string[]) => translate(en,
    'Lisää matkapuhelinnumero kontaktitietoihisi',
    ...val),

  VP3X: (en: string, ...val: string[]) => translate(en,
    'Yritykselläsi on kaksivaiheinen tunnistautuminen käytössä, mutta emme löytäneet yhteystiedoistasi puhelinnumeroa. Ole hyvä ja ota yhteyttä asiakaspalveluun puhelinnumeron lisäämiseksi yhteystietoihisi.',
    ...val),

  VP3Y: (en: string, ...val: string[]) => translate(en,
    'Yhteystiedoista puuttuu matkapuhelinnumero, ota yhteyttä asiakaspalveluun',
    ...val),

  VPJ3: (en: string, ...val: string[]) => translate(en,
    'Siirrä nykyinen puhelinnumero',
    ...val),

  VPVR: (en: string, ...val: string[]) => translate(en,
    'Kenttä tarvitsee arvon',
    ...val),

  VQE6: (en: string, ...val: string[]) => translate(en,
    'Hae',
    ...val),

  VQE7: (en: string, ...val: string[]) => translate(en,
    'Hae Vaihtoehdot',
    ...val),

  VQKT: (en: string, ...val: string[]) => translate(en,
    'Lunastuspyyntö on hyväksyttävä erikseen',
    ...val),

  VQOB: (en: string, ...val: string[]) => translate(en,
    'ei sopimushintaa',
    ...val),

  VQTF: (en: string, ...val: string[]) => translate(en,
    'Valittu päivä on saatavilla asennukseen',
    ...val),

  VQU7: (en: string, ...val: string[]) => translate(en,
    'Kirjoita muutostoiveesi tähän...',
    ...val),

  VQXC: (en: string, ...val: string[]) => translate(en,
    'Maksusopimuksen tilaus maksimissaan 30 päiväksi.\n\nOlemme ottaneet maksusopimuspyyntösi käsittelyyn. Tarkistamme tilanteesi ja saat päätöksen eräpäivän siirrosta ja uuden maksupäivän sähköpostiisi 5 arkipäivän kuluessa. Uusi maksupäivä ei näy Yritysten OmaElisassa. Jos et saa vahvistusviestiä 5 arkipäivän jälkeen, olethan yhteydessä Yritysasiakaspalveluumme.\n\nMaksusopimuksen tekemisestä veloitetaan hinnaston mukainen maksu seuraavassa laskussa.',
    ...val),

  VR6E: (en: string, ...val: string[]) => translate(en,
    'Käyttäjää ei voida poistaa, koska käyttäjällä on aktiivisia sopimuksia tai käyttäjä on laskutussopimuksella yhteyshenkilönä tai vastaanottajana.',
    ...val),

  VRG9: (en: string, ...val: string[]) => translate(en,
    'Etsi yrityksen nimellä tai Y-tunnuksella',
    ...val),

  VRGQ: (en: string, ...val: string[]) => translate(en,
    'Tarjouksen nimi',
    ...val),

  VRMK: (en: string, ...val: string[]) => translate(en,
    'Estää soittamisen esim. aikataulu-, tiedotus- ja pankkipalveluihin. Estää myös soittamisen taksikeskukseen ja numerotiedusteluihin sekä numerotiedustelujen yhdistämispalveluiden käytön. Sisältää eston viihde-, ajanviete- ja asiointinumeroihin.',
    ...val),

  VRVV: (en: string, ...val: string[]) => translate(en,
    'Tukipyyntösi on lähetetty',
    ...val),

  VS0Z: (en: string, ...val: string[]) => translate(en,
    'Yritykselle',
    ...val),

  VSE5: (en: string, ...val: string[]) => translate(en,
    'Datapaketti',
    ...val),

  VSRK: (en: string, ...val: string[]) => translate(en,
    'liittymän käyttö EU- ja ETA-maissa',
    ...val),

  VSWS: (en: string, ...val: string[]) => translate(en,
    'Tavoitettavuus matkapuhelinnumerolla',
    ...val),

  VT06: (en: string, ...val: string[]) => translate(en,
    'Poista muutospyyntö',
    ...val),

  VT5Z: (en: string, ...val: string[]) => translate(en,
    'Oletko käyttänyt puhelintasi ulkomailla?',
    ...val),

  VTE2: (en: string, ...val: string[]) => translate(en,
    'Elisa Reissaaja 500 Mt aktivoituu automaattisesti kohdemaissa. Reissaaja mahdollistaa nopean tiedonsiirron mobiilipäätelaitteella tai kannettavalla tietokoneella edulliseen hintaan EU/ETA-alueen ulkopuolisissa maissa. Palvelussa ei ole kuukausimaksua, vaan se hinnoitellaan käytön mukaan: 10,90 € / 1 vrk.',
    ...val),

  VU38: (en: string, ...val: string[]) => translate(en,
    'Muut palvelut',
    ...val),

  VUU0: (en: string, ...val: string[]) => translate(en,
    'Tuki',
    ...val),

  VV3T: (en: string, ...val: string[]) => translate(en,
    'Vastaajan kieli',
    ...val),

  VVC2: (en: string, ...val: string[]) => translate(en,
    'Ei valintaa',
    ...val),

  VVDT: (en: string, ...val: string[]) => translate(en,
    'Raportti sisältää yrityksen ostamat kertamaksulliset ja kuukausimaksulliset laitteet sekä lisätarvikkeet.',
    ...val),

  VVQP: (en: string, ...val: string[]) => translate(en,
    'Ostoskoriin',
    ...val),

  VWKR: (en: string, ...val: string[]) => translate(en,
    'Ilmoittaja',
    ...val),

  VWNX: (en: string, ...val: string[]) => translate(en,
    'Tuotteeni ja palveluni',
    ...val),

  VWSV: (en: string, ...val: string[]) => translate(en,
    'Omavastuu',
    ...val),

  VX6E: (en: string, ...val: string[]) => translate(en,
    'Siirtyvät sopimukset',
    ...val),

  VX8X: (en: string, ...val: string[]) => translate(en,
    'Linkki on henkilökohtainen ja sitä voi käyttää vain kerran',
    ...val),

  VXHX: (en: string, ...val: string[]) => translate(en,
    'Postin lähetystunnus',
    ...val),

  VXVC: (en: string, ...val: string[]) => translate(en,
    'OVT tunnus',
    ...val),

  VXXY: (en: string, ...val: string[]) => translate(en,
    'Ei oikeuksia',
    ...val),

  VY1K: (en: string, ...val: string[]) => translate(en,
    'Puhe ja tekstiviestit',
    ...val),

  VYFI: (en: string, ...val: string[]) => translate(en,
    'Yritysten OmaElisan pääkäyttäjien lisääminen ja poistaminen tapahtuu vielä toistaiseksi OmaElisa Classicissa. Yritysten OmaElisa -tunnuksilla voit kirjautua OmaElisa Classiciin, Yritysten OmaElisaan sekä joihinkin Elisa Ringin palveluihin, joihin kuuluvat mm. web-admin ja tallennearkisto.',
    ...val),

  VYGS: (en: string, ...val: string[]) => translate(en,
    'Laite on jatkokaudella. Laitekaupasta voit tilata uuden laitteen ja halutessasi myös lunastaa tämän vanhan laitteen. Mikäli laitevaihtoa ei tehdä tai sopimusta päätetä jatkokauden aikana, laite siirtyy automaattisesti yrityksen omaisuudeksi.',
    ...val),

  VYZS: (en: string, ...val: string[]) => translate(en,
    'Yhteyshenkilö',
    ...val),

  VZZW: (en: string, ...val: string[]) => translate(en,
    'Käsittelyssä',
    ...val),

  W0YU: (en: string, ...val: string[]) => translate(en,
    'Tilaus koskee liittymiä:',
    ...val),

  W0ZV: (en: string, ...val: string[]) => translate(en,
    'Päivitetään liittymään:',
    ...val),

  W1D4: (en: string, ...val: string[]) => translate(en,
    'Kortin tilaaminen on ilmainen. Kun SIM-kortti aktivoidaan käyttöön, veloitamme',
    ...val),

  W1M7: (en: string, ...val: string[]) => translate(en,
    'Suosittelemme',
    ...val),

  W1PP: (en: string, ...val: string[]) => translate(en,
    'Vastaanottajan sähköposti',
    ...val),

  W1RX: (en: string, ...val: string[]) => translate(en,
    'Kokonaishinta {}',
    ...val),

  W1ZW: (en: string, ...val: string[]) => translate(en,
    'Tilauksen tuotteiden laskutustiedot',
    ...val),

  W2NJ: (en: string, ...val: string[]) => translate(en,
    'Tilaa uusi laite',
    ...val),

  W2ZR: (en: string, ...val: string[]) => translate(en,
    'nettisivuiltamme',
    ...val),

  W3P0: (en: string, ...val: string[]) => translate(en,
    'Käyttäjällä ei ole nettiliittymiä.',
    ...val),

  W402: (en: string, ...val: string[]) => translate(en,
    ' vahvistuskoodin. Vahvista sähköpostisi täyttämällä koodi alla olevaan kenttään. Koodi on voimassa 10 minuuttia.',
    ...val),

  W43T: (en: string, ...val: string[]) => translate(en,
    'Numeron julkisuus',
    ...val),

  W447: (en: string, ...val: string[]) => translate(en,
    'Valittu yritys:',
    ...val),

  W45M: (en: string, ...val: string[]) => translate(en,
    'Lisää liittymä',
    ...val),

  W4CZ: (en: string, ...val: string[]) => translate(en,
    'Luo uusi laskutussopimus',
    ...val),

  W4JJ: (en: string, ...val: string[]) => translate(en,
    'Säännölliseen työntekoon ja vapaa-ajan viihteeseen.',
    ...val),

  W4NW: (en: string, ...val: string[]) => translate(en,
    'Aseta ajan mukaan',
    ...val),

  W4RA: (en: string, ...val: string[]) => translate(en,
    'ongelma liittymän lisäämisessä',
    ...val),

  W4RE: (en: string, ...val: string[]) => translate(en,
    'Huomioithan',
    ...val),

  W52I: (en: string, ...val: string[]) => translate(en,
    'Haluatko helpompaa asiointia?',
    ...val),

  W585: (en: string, ...val: string[]) => translate(en,
    'Lue lisää Elisa Mobiilivarmenteesta',
    ...val),

  W59S: (en: string, ...val: string[]) => translate(en,
    'Toimituksessa',
    ...val),

  W5JG: (en: string, ...val: string[]) => translate(en,
    'Lisää tai poista laitteita',
    ...val),

  W5Q6: (en: string, ...val: string[]) => translate(en,
    'Ennen laitevaihdon tilaamista Applen laitteista tulee poistaa käytöstä Etsi laitteita –toiminto. Aktiivinen toiminto estää kaikki huoltotoimenpiteet laitteelle.',
    ...val),

  W691: (en: string, ...val: string[]) => translate(en,
    'Tuotteet sopimuksella',
    ...val),

  W692: (en: string, ...val: string[]) => translate(en,
    'Vahvista laitteen lunastuspyynnön hylkääminen',
    ...val),

  W6DS: (en: string, ...val: string[]) => translate(en,
    'Huomioithan, että tämä laskutussopimus poistetaan {}, jos sitä ennen sille ei tilata palveluita tai tuotteita.',
    ...val),

  W6MP: (en: string, ...val: string[]) => translate(en,
    'Lisäinfoa OmaElisasta',
    ...val),

  W6SC: (en: string, ...val: string[]) => translate(en,
    'Huomioi, että lopullinen hinta vahvistuu vasta, kun olemme vastaanottaneet ja tarkistaneet puhelimen. Mikrovauriot lasiosissa, vaikeasti havaittavat virheet näytössä sekä laitteeseen tehdyt huollot saattavat vaikuttaa laitteen hyvitysarvoon.',
    ...val),

  W77N: (en: string, ...val: string[]) => translate(en,
    'Tilaa uutiskirjeemme ajankohtaisista asioista.',
    ...val),

  W7H8: (en: string, ...val: string[]) => translate(en,
    'Ota tarvittaessa yhteyttä [asiakaspalveluumme].',
    ...val),

  W885: (en: string, ...val: string[]) => translate(en,
    'Soittajan nimitieto näkyy saapuvan puhelun yhteydessä sekä puheluhistoriassa. Jatkossa siis tiedät aina, mihin puheluihin vastata.',
    ...val),

  W8I2: (en: string, ...val: string[]) => translate(en,
    'Lisätarvikkeidan haku epäonnistui',
    ...val),

  W8I6: (en: string, ...val: string[]) => translate(en,
    'Muualla EU:ssa',
    ...val),

  W9UE: (en: string, ...val: string[]) => translate(en,
    'Lisää nettiliittymä',
    ...val),

  WA19: (en: string, ...val: string[]) => translate(en,
    'Vakio-ratkaisu:',
    ...val),

  WA1M: (en: string, ...val: string[]) => translate(en,
    'Yhteyshenkilöt',
    ...val),

  WAEN: (en: string, ...val: string[]) => translate(en,
    'Laitteiden sopimuskaudet on määritelty ennalta. Ilmoitetuissa hinnoissa on mukana alv. {} %.',
    ...val),

  WAIL: (en: string, ...val: string[]) => translate(en,
    'Valitse pankki',
    ...val),

  WAMK: (en: string, ...val: string[]) => translate(en,
    'Käsittelemme irtisanomispyyntösi mahdollisimman pian. Saat vahvistuksen sähköpostilla, kun palvelu on irtisanottu. Huomaathan, että jos kuukausimaksuja on vielä laskuttamatta, ne lisätään kyseisen liittymän seuraavalle laskulle.',
    ...val),

  WAS5: (en: string, ...val: string[]) => translate(en,
    'Kiitos! Olemme sinuun yhteydessä yhden työpäivän sisällä.',
    ...val),

  WBKW: (en: string, ...val: string[]) => translate(en,
    'Tarkasta, että syöttämäsi tiedot ovat oikein ja valitse tarvittaessa oikeat yhteystiedot alapuolelta.',
    ...val),

  WBNM: (en: string, ...val: string[]) => translate(en,
    'Siirrä suuria tiedostoja ja jaa netti usealle hengelle',
    ...val),

  WBQT: (en: string, ...val: string[]) => translate(en,
    'Kortin aktivoinnissa tapahtui virhe',
    ...val),

  WBV9: (en: string, ...val: string[]) => translate(en,
    'Vaatii erillisen laitteen (tabletti, tietokone, reititin)',
    ...val),

  WBZV: (en: string, ...val: string[]) => translate(en,
    'Elisa Kuka Soittaa nyt toistaiseksi tutustumishintaan:',
    ...val),

  WD0I: (en: string, ...val: string[]) => translate(en,
    'Varmista että sinulla on oikea SIM -kortin numero ja mikäli ongelma toistuu, ole yhteydessä asiakaspalveluumme.',
    ...val),

  WDIX: (en: string, ...val: string[]) => translate(en,
    'Kirjaudu sisään Yritysten OmaElisa tunnuksellasi, jotta pääset siirtymään kassalle. Kirjautumalla saat myös käyttöösi sinulle räätälöityjä palveluja ja etuja. Jos et ole vielä luonut tunnuksia Yritysten OmaElisaan, tee se nyt.',
    ...val),

  WDX0: (en: string, ...val: string[]) => translate(en,
    '1 tuote lisättiin ostoskoriin',
    ...val),

  WE32: (en: string, ...val: string[]) => translate(en,
    'Seuraa laitteen antamia ohjeita.',
    ...val),

  WEWD: (en: string, ...val: string[]) => translate(en,
    'Käyttäjän sähköpostiin lähetetty kutsulinkki on vanhentunut.',
    ...val),

  WFEF: (en: string, ...val: string[]) => translate(en,
    'Tarkistetaan alennuskoodia {}',
    ...val),

  WFXG: (en: string, ...val: string[]) => translate(en,
    'Tilaa Elisa Mobiilivarmenne Työntekijälle -palvelu',
    ...val),

  WFZ0: (en: string, ...val: string[]) => translate(en,
    'Lisää liite',
    ...val),

  WG63: (en: string, ...val: string[]) => translate(en,
    'Odottaa huomiotasi',
    ...val),

  WG7P: (en: string, ...val: string[]) => translate(en,
    'Yritysten OmaElisa-tunnus luotu onnistuneesti.',
    ...val),

  WG8A: (en: string, ...val: string[]) => translate(en,
    'Laskutussopimus tai asiakasnumero on jo annettu',
    ...val),

  WGE3: (en: string, ...val: string[]) => translate(en,
    'Verkkotunnukset',
    ...val),

  WGGQ: (en: string, ...val: string[]) => translate(en,
    'Henkilönumero',
    ...val),

  WGM5: (en: string, ...val: string[]) => translate(en,
    'Vahvista laitelistan poistaminen',
    ...val),

  WGXF: (en: string, ...val: string[]) => translate(en,
    'Laskun tila päivittyy noin 3 arkipäivän kuluessa, joten maksun jälkeen lasku voi hetken näkyä avoimena. Myöhässä maksamisesta ei tarvitse ilmoittaa asiakaspalveluun. Jos lasku maksetaan OmaElisan maksunapilla, tila päivittyy laskujen listanäkymässä 15 minuutissa.',
    ...val),

  WHAA: (en: string, ...val: string[]) => translate(en,
    'Huomioitavaa työnantajasi pääkäyttäjältä.',
    ...val),

  WHE6: (en: string, ...val: string[]) => translate(en,
    'Uusi kortti aktivoituu välittömästi muutoksen jälkeen.',
    ...val),

  WHGU: (en: string, ...val: string[]) => translate(en,
    'Pohjola ja Baltian maat: Ruotsi, Norja, Tanska, Viro, Latvia ja Liettua. Yritysdata EU-liittymissä käyttörajan ylittävä data hinnoitellaan',
    ...val),

  WHH4: (en: string, ...val: string[]) => translate(en,
    'PUK2-koodi',
    ...val),

  WHHI: (en: string, ...val: string[]) => translate(en,
    'Valitse alta toimitusosoite johon toimitamme palautuspussin.',
    ...val),

  WHKI: (en: string, ...val: string[]) => translate(en,
    'Laskutussopimuksen numero puuttuu',
    ...val),

  WHMT: (en: string, ...val: string[]) => translate(en,
    'Ei vielä tukipyyntöjä tai viestejä',
    ...val),

  WI85: (en: string, ...val: string[]) => translate(en,
    'Saat luotua',
    ...val),

  WIMV: (en: string, ...val: string[]) => translate(en,
    'Valittu yhteyshenkilö ei kelpaa, tarkista valinta.',
    ...val),

  WIPE: (en: string, ...val: string[]) => translate(en,
    'Ma-Pe 8-16',
    ...val),

  WIZR: (en: string, ...val: string[]) => translate(en,
    'Jos olet työntekijä etkä pääkäyttäjä, voit hallinnoida omia työsuhdeliittymiäsi ja -laitteitasi ',
    ...val),

  WJIG: (en: string, ...val: string[]) => translate(en,
    'Vakion lisäpalvelut',
    ...val),

  WJN7: (en: string, ...val: string[]) => translate(en,
    'Näytettävä numero vaaditaan kun näytettävän numeron muunnos on käytössä.',
    ...val),

  WJUQ: (en: string, ...val: string[]) => translate(en,
    'Kutsu on vanhentunut',
    ...val),

  WK3U: (en: string, ...val: string[]) => translate(en,
    'Laitelistalla on valikoimasta poistuneita tuotteita, jotka eivät ole enää myynnissä',
    ...val),

  WKIN: (en: string, ...val: string[]) => translate(en,
    'Valitulla yrityksellä ei ole vastaavaa Elisa Palvelupäätelaite -sopimusta',
    ...val),

  WL1E: (en: string, ...val: string[]) => translate(en,
    'Kyllä: muutos tehdään kaikille Elisan laskutussopimuksille, joissa Y-tunnus on maksajana. Myös Elisan kuluttajapuolella Y-tunnuksella olevat sopimukset huomioidaan.\n\nEi: muutos koskee vain ilmoittamiasi laskutussopimuksia.',
    ...val),

  WLCJ: (en: string, ...val: string[]) => translate(en,
    'Näytä kaikki liittymät',
    ...val),

  WLQ1: (en: string, ...val: string[]) => translate(en,
    'Haluatko korvata asennusosoitteessa olevan kiinteän laajakaistan?',
    ...val),

  WLWK: (en: string, ...val: string[]) => translate(en,
    'Huomioithan, että liittymän luovutus käyttäjälle koskee vain siirtoa Elisan yritysliittymästä Elisan kuluttajaliittymään.',
    ...val),

  WM9Y: (en: string, ...val: string[]) => translate(en,
    'Kutsut-sivun',
    ...val),

  WMAS: (en: string, ...val: string[]) => translate(en,
    'Numeron',
    ...val),

  WMWY: (en: string, ...val: string[]) => translate(en,
    'Olet vaihtamassa käyttäjää laitteelle, jolla on käytössä työntekijän Oma Laitelasku. Työntekijän jäljellä olevat kuukausimaksut laskutetaan yritykseltä.',
    ...val),

  WN51: (en: string, ...val: string[]) => translate(en,
    'Jos sen sijaan olet yrityksesi pääkäyttäjä, kirjaudu ulos ja uudelleenkirjaudu yritysten OmaElisaan.',
    ...val),

  WN64: (en: string, ...val: string[]) => translate(en,
    'Poistetaan valitut',
    ...val),

  WNBL: (en: string, ...val: string[]) => translate(en,
    'Kaikki Elisan liittymät (mobiili ja kiinteä) ovat saaneet Avainlippu-tunnuksen merkiksi suomalaisesta työstä ja yrityksen kotimaisuudesta.',
    ...val),

  WNEF: (en: string, ...val: string[]) => translate(en,
    'Sis. 5 Gt datan käyttöä kotimaassa. Paketin ylimenevä datankäyttö 4,50 € / alkava 5 Gt.',
    ...val),

  WNUM: (en: string, ...val: string[]) => translate(en,
    'Käyttäjää ei voi poistaa',
    ...val),

  WO28: (en: string, ...val: string[]) => translate(en,
    'Olen tarkistanut että tilaus- ja laskutustiedot ovat oikein.',
    ...val),

  WOA2: (en: string, ...val: string[]) => translate(en,
    'Käyttöoikeuksia ei voi muokata, koska kutsuprosessi on kesken.',
    ...val),

  WOWC: (en: string, ...val: string[]) => translate(en,
    'Alkaa',
    ...val),

  WOYD: (en: string, ...val: string[]) => translate(en,
    'Sulje',
    ...val),

  WP25: (en: string, ...val: string[]) => translate(en,
    'Näytettävä yrityksen nimi',
    ...val),

  WP79: (en: string, ...val: string[]) => translate(en,
    'Liittymältäsi puuttuu Elisa WiFi puhelu -palvelu, mikä on edellytys palvelun käyttöönotolle.',
    ...val),

  WPBB: (en: string, ...val: string[]) => translate(en,
    'Räätälöi yritysliittymä tarpeidesi mukaan. Päätä nopeus ja valitse itsellesi kätevät lisäpalvelut:',
    ...val),

  WPEL: (en: string, ...val: string[]) => translate(en,
    'Hae verkkotunnusta',
    ...val),

  WPOQ: (en: string, ...val: string[]) => translate(en,
    'Valitse yritys jatkaaksesi',
    ...val),

  WPXQ: (en: string, ...val: string[]) => translate(en,
    'Valitse käyttäjä tai käyttötarkoitus',
    ...val),

  WPZI: (en: string, ...val: string[]) => translate(en,
    'Ostoskorissa on 1 tuote',
    ...val),

  WQ2D: (en: string, ...val: string[]) => translate(en,
    'Suosittelemme kiinteän verkon Netti Lite -liittymää ensisijaisena vaihtoehtona. Kiinteällä liittymällä saat mahdollisimman vakaan ja toimintavarman nettiyhteyden sujuvaan etätyöhön, videoneuvotteluihin ja suoratoistopalveluihin.',
    ...val),

  WQ2E: (en: string, ...val: string[]) => translate(en,
    'Suosittelemme Mobiililaajakaista Netti Lite 5G+ -liittymää, jos haluat nopean netin, mutta osoitteeseesi ei ole kiinteää yhteyttä saatavilla. Mobiililaajakaista kulkee mukanasi, jos teet töitä useammassa eri osoitteessa. Saat sen mukaasi vaikka mökille.',
    ...val),

  WQ7L: (en: string, ...val: string[]) => translate(en,
    'Vahvista laitteen lunastaminen',
    ...val),

  WQCL: (en: string, ...val: string[]) => translate(en,
    'Tämä kutsulinkki on vanhentunut tai väärä. Ole hyvä ja käytä oikeaa linkkiä.',
    ...val),

  WQM0: (en: string, ...val: string[]) => translate(en,
    'Voit asettaa käyttäjälle tilauksen hyväksyjä -roolin vain heidän työnantajayrityksessään.',
    ...val),

  WR9Q: (en: string, ...val: string[]) => translate(en,
    'Hei!',
    ...val),

  WRBN: (en: string, ...val: string[]) => translate(en,
    'Etkö löydä takuukuittia täältä? Kehitämme Yritysten OmaElisaa, ja tällä hetkellä takuukuitit näkyvät vain pankki- tai luottokortilla maksetuista ostoksista.',
    ...val),

  WSA8: (en: string, ...val: string[]) => translate(en,
    'Elisa Yritystietoturvan tietojen palautus ja puhelintuki',
    ...val),

  WSE5: (en: string, ...val: string[]) => translate(en,
    'Kiitos palautteestasi!',
    ...val),

  WT3N: (en: string, ...val: string[]) => translate(en,
    'Elisa YritysWiFi Lite -palvelu takaa nopean netin. Mesh-laitteet vahvistavat signaalia niin että netti toimii saumattomasti joka huoneessa - jopa paksujen seinien läpi. Palvelussa on vaivaton kuukausimaksusopimus.',
    ...val),

  WT42: (en: string, ...val: string[]) => translate(en,
    'Muuta sopimusten käyttäjätiedot ja/tai laskutussopimusten yhteyshenkilötiedot.',
    ...val),

  WTML: (en: string, ...val: string[]) => translate(en,
    'Emme pysty varmentamaan, että sinulla on yrityksen nimenkirjoitusoikeus. Tarkista, että Y-tunnus on rekisteröity kaupparekisteriin. Voit myös ottaa yhteyttä asiakaspalveluumme numeroon {0}.',
    ...val),

  WTN9: (en: string, ...val: string[]) => translate(en,
    'Tarkastele liittymiesi lisäpalveluita',
    ...val),

  WTWB: (en: string, ...val: string[]) => translate(en,
    'Ole hyvä ja vahvista tarkistaneesi osoitteen.',
    ...val),

  WURW: (en: string, ...val: string[]) => translate(en,
    'Avaa lasku',
    ...val),

  WVHG: (en: string, ...val: string[]) => translate(en,
    'Jätä viesti asiakaspalvelulle',
    ...val),

  WVLB: (en: string, ...val: string[]) => translate(en,
    'Verkkolaskuoperaattori',
    ...val),

  WVNV: (en: string, ...val: string[]) => translate(en,
    'Jätä viesti',
    ...val),

  WW2M: (en: string, ...val: string[]) => translate(en,
    'Turvaa laitteesi rikkoutumisen varalta - yllättävän vahingon sattuessa saat uutta vastaavan laitteen rikkoutuneen tilalle yhdellä soitolla.',
    ...val),

  WW6V: (en: string, ...val: string[]) => translate(en,
    'Kaikki yritykset',
    ...val),

  WWC5: (en: string, ...val: string[]) => translate(en,
    'Liittymän irtisanominen',
    ...val),

  WWEG: (en: string, ...val: string[]) => translate(en,
    'Laitelistan tuotevalikoiman kopioiminen ei ole mahdollista kk-maksullisille laitelistoille. Päivitä laitelistat yksitellen tai käytä Kopioi laitelista -toiminnetta.',
    ...val),

  WWSI: (en: string, ...val: string[]) => translate(en,
    'Laskutus ja asiakastiedot',
    ...val),

  WWTP: (en: string, ...val: string[]) => translate(en,
    'Nykyinen salasana',
    ...val),

  WWYF: (en: string, ...val: string[]) => translate(en,
    'Haluatko varmasti poistaa tietueen?',
    ...val),

  WX52: (en: string, ...val: string[]) => translate(en,
    'Käyttäjällä on päättymässä oleva Elisa palvelupäätelaite sopimus. Vain yksi laitevaihto on mahdollisesta tehdä yhdellä tilauksella.',
    ...val),

  WXB4: (en: string, ...val: string[]) => translate(en,
    'Käytä älykelloasi kuin puhelinta omalla tutulla numerollasi.',
    ...val),

  WXDM: (en: string, ...val: string[]) => translate(en,
    'Työaikaketju',
    ...val),

  WXU0: (en: string, ...val: string[]) => translate(en,
    'Nopeus {} Mbit/s',
    ...val),

  WXYJ: (en: string, ...val: string[]) => translate(en,
    'Matkapuhelimelle on mahdollista lisätä varavastaajia. Vakion puheluominaisuudet ovat jatkossa käytettävissä myös matkapuhelimeen saapuvissa puheluissa. ',
    ...val),

  WXZC: (en: string, ...val: string[]) => translate(en,
    'Valitettavasti tilausta ei voida käsitellä luottopäätöksen vuoksi.',
    ...val),

  WYE7: (en: string, ...val: string[]) => translate(en,
    'Nykyisestä laitteesta on avoin lunastuspyyntö',
    ...val),

  WYPE: (en: string, ...val: string[]) => translate(en,
    'Max. 65 merkkiä.',
    ...val),

  WYZ2: (en: string, ...val: string[]) => translate(en,
    'Hyväksy tarjous',
    ...val),

  WZ46: (en: string, ...val: string[]) => translate(en,
    'Toimitusmaksu',
    ...val),

  WZF5: (en: string, ...val: string[]) => translate(en,
    'Mihin voin käyttää Elisa Vaihtoetua yrityksille?',
    ...val),

  WZNT: (en: string, ...val: string[]) => translate(en,
    'Samalla Elisa Päätelaitteen sopimuskausi keskeytetään.',
    ...val),

  X04A: (en: string, ...val: string[]) => translate(en,
    'Valitse kuituyhteyden tyyppi. Ota yhteytt isnnitsijn, jos et ole varma kuitutyypist.',
    ...val),

  X05S: (en: string, ...val: string[]) => translate(en,
    'Poista listalta',
    ...val),

  X0II: (en: string, ...val: string[]) => translate(en,
    'Gt aktivoituu automaattisesti kohdemaissa ja mahdollistaa mobiilipäätelaitteella tai kannettavalla tietokoneella käytettävän nopean tiedonsiirtoyhteyden edulliseen hintaan EU/ETA-alueen ulkopuolisissa maissa. Palvelussa ei ole kuukausimaksua, vaan hinnoittelu aktivoituu käytön mukaan 21,90 € / 14 vrk.',
    ...val),

  X0LO: (en: string, ...val: string[]) => translate(en,
    'Liitä Ringiin',
    ...val),

  X0RT: (en: string, ...val: string[]) => translate(en,
    'Ei asetettua käyttötarkoitusta',
    ...val),

  X0V6: (en: string, ...val: string[]) => translate(en,
    'Huom. Käytäthän jatkossa kirjautumiseen valitsemaasi tunnusta.',
    ...val),

  X1DF: (en: string, ...val: string[]) => translate(en,
    ' -sivulta.',
    ...val),

  X1RF: (en: string, ...val: string[]) => translate(en,
    'Käyttäjä on yhteyshenkilönä palvelulla',
    ...val),

  X1TL: (en: string, ...val: string[]) => translate(en,
    'Siirry käyttäjän tietoihin',
    ...val),

  X2HQ: (en: string, ...val: string[]) => translate(en,
    'Valitse sopimus',
    ...val),

  X2UI: (en: string, ...val: string[]) => translate(en,
    'Lue lisää laiterekisteriohjelmista.',
    ...val),

  X2X6: (en: string, ...val: string[]) => translate(en,
    'pankkitunnuksilla',
    ...val),

  X32V: (en: string, ...val: string[]) => translate(en,
    'Listalle valittu laite sisältää kaikki saatavilla olevat muisti- sekä värivariaatiot.',
    ...val),

  X357: (en: string, ...val: string[]) => translate(en,
    'Valitse uusi vai nykyinen puhelinnumero:',
    ...val),

  X3A5: (en: string, ...val: string[]) => translate(en,
    'Mistä laitteista hyvitystä voi saada?',
    ...val),

  X49N: (en: string, ...val: string[]) => translate(en,
    'Näytä',
    ...val),

  X5NK: (en: string, ...val: string[]) => translate(en,
    'Vahvista päivämäärä',
    ...val),

  X6CL: (en: string, ...val: string[]) => translate(en,
    ' tarjoaa turvallisen tunnistautumisen digitaalisiin palveluihin.',
    ...val),

  X6LZ: (en: string, ...val: string[]) => translate(en,
    'Mobiilivarmenteella turvallista tunnistautumista',
    ...val),

  X7RU: (en: string, ...val: string[]) => translate(en,
    'Valitse laitelistat, joihin haluat kopioida tuotevalikoiman.',
    ...val),

  X7W5: (en: string, ...val: string[]) => translate(en,
    'Lankapuhelinnumero',
    ...val),

  X898: (en: string, ...val: string[]) => translate(en,
    'Laitteen nimi',
    ...val),

  X8GA: (en: string, ...val: string[]) => translate(en,
    'Postin automaatti tai noutopiste',
    ...val),

  X924: (en: string, ...val: string[]) => translate(en,
    'Tietosuojakäytäntö',
    ...val),

  X935: (en: string, ...val: string[]) => translate(en,
    'Kutsulinkki OmaElisaan on vanhentunut tai peruutettu.',
    ...val),

  X9W7: (en: string, ...val: string[]) => translate(en,
    'Maksulliset puhelut',
    ...val),

  XASK: (en: string, ...val: string[]) => translate(en,
    'Osoitetiedot puuttuvat. Valitse tai lisää osoitetiedot.',
    ...val),

  XAWP: (en: string, ...val: string[]) => translate(en,
    'Salesforcen knowledge-artikkelista',
    ...val),

  XBSA: (en: string, ...val: string[]) => translate(en,
    'Nopeus',
    ...val),

  XCDT: (en: string, ...val: string[]) => translate(en,
    'Käyttäjän siirto toiseen yritykseen',
    ...val),

  XCEN: (en: string, ...val: string[]) => translate(en,
    'Valitse liittymän tyyppi',
    ...val),

  XCF5: (en: string, ...val: string[]) => translate(en,
    'Laskutussopimuksen viite {}',
    ...val),

  XCJ3: (en: string, ...val: string[]) => translate(en,
    'Akku',
    ...val),

  XD7C: (en: string, ...val: string[]) => translate(en,
    'Yrityksille suunnatut Aito 5G -liittymät tunnistat yritysliittymien tuotekorteista löytyvästä 5G+-merkinnästä.',
    ...val),

  XDN7: (en: string, ...val: string[]) => translate(en,
    'Ota käyttöön myöhemmin',
    ...val),

  XE0P: (en: string, ...val: string[]) => translate(en,
    'Luo tunnukset',
    ...val),

  XE4X: (en: string, ...val: string[]) => translate(en,
    'Laitelistan tiedot',
    ...val),

  XED2: (en: string, ...val: string[]) => translate(en,
    'Kertamaksulliset laitteet',
    ...val),

  XEUL: (en: string, ...val: string[]) => translate(en,
    'Uusi liittymätyyppi',
    ...val),

  XF0E: (en: string, ...val: string[]) => translate(en,
    'Tuotevalikoima, hinnoittelu ja sopimuskaudet',
    ...val),

  XF2A: (en: string, ...val: string[]) => translate(en,
    'Päivitä',
    ...val),

  XFA9: (en: string, ...val: string[]) => translate(en,
    'Ota käyttöön',
    ...val),

  XFMF: (en: string, ...val: string[]) => translate(en,
    'Etkö näe etsimääsi yritystä tässä?',
    ...val),

  XFUZ: (en: string, ...val: string[]) => translate(en,
    'Päivämäärä',
    ...val),

  XGCD: (en: string, ...val: string[]) => translate(en,
    'Luoja',
    ...val),

  XGRM: (en: string, ...val: string[]) => translate(en,
    'Yritysnumerolla on käytössä kaksi ketjua (työajalla ja työajan ulkopuolella), joihin voit molempiin lisätä neljä vastaanottajaa.',
    ...val),

  XGWK: (en: string, ...val: string[]) => translate(en,
    'Poissaoloketju',
    ...val),

  XHN1: (en: string, ...val: string[]) => translate(en,
    'Virtalähde',
    ...val),

  XHYX: (en: string, ...val: string[]) => translate(en,
    'Lisätietoa puhelimen käytöstä ulkomailla',
    ...val),

  XI4V: (en: string, ...val: string[]) => translate(en,
    'Laitteen tyyppi',
    ...val),

  XI84: (en: string, ...val: string[]) => translate(en,
    'Työaikaketjuun vaaditaan ensimmäinen kohdenumero kun aikaohjaus on valittuna',
    ...val),

  XIFY: (en: string, ...val: string[]) => translate(en,
    'Valitse työnantajayrityksesi listalta',
    ...val),

  XIOZ: (en: string, ...val: string[]) => translate(en,
    'Elisa Palvelupäätelaitteiden elinkaari ja tapahtumat',
    ...val),

  XJKE: (en: string, ...val: string[]) => translate(en,
    '{0} = Täysin samaa mieltä',
    ...val),

  XJMC: (en: string, ...val: string[]) => translate(en,
    'Ei määräaikaisuutta.',
    ...val),

  XKFL: (en: string, ...val: string[]) => translate(en,
    'Tällä lomakkeella tehdyt laskutustietojen muutospyynnöt käsitellään maksutta. Asiakaspalvelun kautta tehdyistä muutospyynnöistä veloitamme ',
    ...val),

  XKKL: (en: string, ...val: string[]) => translate(en,
    'Tilauksen vahvistaminen onnistui.',
    ...val),

  XLP9: (en: string, ...val: string[]) => translate(en,
    'Voit hallita käyttöoikeuksia käyttäjän lisäämisen jälkeen',
    ...val),

  XLTQ: (en: string, ...val: string[]) => translate(en,
    'Valitettavasti järjestelmässämme tapahtui virhe. Yritä hetken kuluttua uudelleen. Jos asia on kiireellinen, ota yhteyttä asiakaspalveluun {0} ({1}). Pahoittelemme häiriötä.',
    ...val),

  XMCF: (en: string, ...val: string[]) => translate(en,
    'Laitesopimuksesi on jatkokaudella',
    ...val),

  XNEL: (en: string, ...val: string[]) => translate(en,
    'OmaLasku -palvelu ei ole käytettävissä',
    ...val),

  XOGB: (en: string, ...val: string[]) => translate(en,
    'Jatka palveluun',
    ...val),

  XONV: (en: string, ...val: string[]) => translate(en,
    'Aloita Työntekijän OmaElisan käyttöönotto vahvistamalla sähköpostioositteesi.',
    ...val),

  XOVM: (en: string, ...val: string[]) => translate(en,
    'Jatkokaudella olevat',
    ...val),

  XOYE: (en: string, ...val: string[]) => translate(en,
    'Arvo on liian pitkä, enintään {} merkkiä on sallittu',
    ...val),

  XP04: (en: string, ...val: string[]) => translate(en,
    'Puhelinnumero ei ole enää vapaana',
    ...val),

  XPAQ: (en: string, ...val: string[]) => translate(en,
    'Valittu lisäpalvelu',
    ...val),

  XPIK: (en: string, ...val: string[]) => translate(en,
    'Voit tilata uuden laitteen yrityksesi',
    ...val),

  XRDP: (en: string, ...val: string[]) => translate(en,
    'Käyttäjä',
    ...val),

  XRLY: (en: string, ...val: string[]) => translate(en,
    'Poista laitelista',
    ...val),

  XS42: (en: string, ...val: string[]) => translate(en,
    'Tabletit',
    ...val),

  XSEI: (en: string, ...val: string[]) => translate(en,
    'Kutsulinkin on voimassa:',
    ...val),

  XSQ0: (en: string, ...val: string[]) => translate(en,
    'Tuotteen nimi',
    ...val),

  XT3B: (en: string, ...val: string[]) => translate(en,
    'Alkaen',
    ...val),

  XTU4: (en: string, ...val: string[]) => translate(en,
    'Sinulla on käytössäsi Elisa Yritystietoturva -tilaus, joka tarjoaa käyttöösi erillisen puhelintuen tietoturvaongelmissa. Puhelintuesta vastaa yhteistyökumppanimme F-Secure.',
    ...val),

  XU1F: (en: string, ...val: string[]) => translate(en,
    'Yritykselle tilaaminen tai yritystietojen tarkastelu vaatii yrityksen nimenkirjoitusoikeuden tai pääkäyttäjäoikeudet Yritysten OmaElisaan. Pyydä tarvittaessa yrityksen pääkäyttäjää antamaan sinulle tarvittavat oikeudet Yritysten OmaElisassa.',
    ...val),

  XUDO: (en: string, ...val: string[]) => translate(en,
    'DNS-tietueen poistaminen epäonnistui!',
    ...val),

  XUE0: (en: string, ...val: string[]) => translate(en,
    'https://yrityksille.elisa.fi/yhteystiedot',
    ...val),

  XUFV: (en: string, ...val: string[]) => translate(en,
    'Suodata',
    ...val),

  XUME: (en: string, ...val: string[]) => translate(en,
    'SIM-kortin aktivointi',
    ...val),

  XUMF: (en: string, ...val: string[]) => translate(en,
    'SIM-kortin aktivointi onnistui.',
    ...val),

  XVAH: (en: string, ...val: string[]) => translate(en,
    'Voit aktivoida tai tilata liittymälle uuden SIM-kortin tai ottaa eSIM:n käyttöön.',
    ...val),

  XVCP: (en: string, ...val: string[]) => translate(en,
    'Eivätkö käytössäsi olevat palvelut näy listauksessa? Käy lisäämässä ne Laitteeni ja liittymäni -sivulla.',
    ...val),

  XVZ7: (en: string, ...val: string[]) => translate(en,
    'Laitteiden hinnat',
    ...val),

  XW4L: (en: string, ...val: string[]) => translate(en,
    'tukipyyntö-lomakkeen',
    ...val),

  XW5R: (en: string, ...val: string[]) => translate(en,
    'Voit seurata lähetettyjä kutsuja pääkäyttäjille ja työntekijöille. Kutsu on mahdollista peruuttaa ennen sen käyttöönottoa. Vanhentunut kutsu voidaan lähettää tarvittaessa uudelleen. Uuden pääkäyttäjän voit lisätä',
    ...val),

  XW97: (en: string, ...val: string[]) => translate(en,
    'Lisävarusteet ja muut laitteet',
    ...val),

  XWA9: (en: string, ...val: string[]) => translate(en,
    'Olet valinnut toimitukseen mukaan tuotteen, jolla rajoitettu toimitustapa. Rajoituksen perusteet mainittu tuotteen tiedoissa.',
    ...val),

  XWHX: (en: string, ...val: string[]) => translate(en,
    'Ylläpidetty palvelu',
    ...val),

  XX5A: (en: string, ...val: string[]) => translate(en,
    'Elisa Mobiilivarmenne Työntekijälle',
    ...val),

  XXVX: (en: string, ...val: string[]) => translate(en,
    'kk',
    ...val),

  XXXQ: (en: string, ...val: string[]) => translate(en,
    'Oletko päivittänyt liittymääsi?',
    ...val),

  XY1R: (en: string, ...val: string[]) => translate(en,
    'https://yrityksille.elisa.fi/ohjeet/laskut',
    ...val),

  XYAM: (en: string, ...val: string[]) => translate(en,
    'Vanha käyttötarkoitus',
    ...val),

  XYOP: (en: string, ...val: string[]) => translate(en,
    'Aloita Työntekijän OmaElisan käyttöönotto tarkistamalla ja vahvistamalla sähköpostiositteesi.',
    ...val),

  XZA8: (en: string, ...val: string[]) => translate(en,
    'Ei palveluita',
    ...val),

  XZH6: (en: string, ...val: string[]) => translate(en,
    'Laskutustapa',
    ...val),

  Y028: (en: string, ...val: string[]) => translate(en,
    'käytetty',
    ...val),

  Y02E: (en: string, ...val: string[]) => translate(en,
    'Ei palveluestoja',
    ...val),

  Y0HD: (en: string, ...val: string[]) => translate(en,
    'Muista lisätä tilaukselle näytönsuoja sekä suojakotelo. Voit myös hankkia ne haluamastasi paikasta omakustanteisesti. Vahinkopalvelu edellyttää, että laite on suojattu. Jatkamalla sitoudun suojaamaan laitteeni.',
    ...val),

  Y0IR: (en: string, ...val: string[]) => translate(en,
    'Valitse asennuspalvelu',
    ...val),

  Y1FD: (en: string, ...val: string[]) => translate(en,
    '5G-yhteensopivuus',
    ...val),

  Y1KA: (en: string, ...val: string[]) => translate(en,
    'En muista käyttäjätunnustani tai se on vanhentunut.',
    ...val),

  Y29L: (en: string, ...val: string[]) => translate(en,
    'Hyväksyntäpyynnöt',
    ...val),

  Y2QC: (en: string, ...val: string[]) => translate(en,
    'Satunnaiseen työskentelyyn ja asiointiin verkossa',
    ...val),

  Y2TH: (en: string, ...val: string[]) => translate(en,
    'Lisäominaisuudet',
    ...val),

  Y30S: (en: string, ...val: string[]) => translate(en,
    'Kun haluat vaihtaa Ring-liittymän käyttäjää, laita meille viestiä ja hoidamme asian puolestasi. Kiireellisissä tapauksissa suosittelemme soittamaan asiakaspalveluumme {0} ({1}).',
    ...val),

  Y30X: (en: string, ...val: string[]) => translate(en,
    'Uuden laskun PDF-lasku on saatavilla noin vuorokauden kuluttua.',
    ...val),

  Y36X: (en: string, ...val: string[]) => translate(en,
    'Raportit',
    ...val),

  Y37N: (en: string, ...val: string[]) => translate(en,
    'Muut yritykset',
    ...val),

  Y3R5: (en: string, ...val: string[]) => translate(en,
    'Emme valitettavasti pystyneet käsittelemään pyyntöäsi.',
    ...val),

  Y3YM: (en: string, ...val: string[]) => translate(en,
    'Tavoitettavuusketjut',
    ...val),

  Y41S: (en: string, ...val: string[]) => translate(en,
    'Sukunimi',
    ...val),

  Y62Y: (en: string, ...val: string[]) => translate(en,
    'Puhelimien lisätarvikkeet',
    ...val),

  Y6JY: (en: string, ...val: string[]) => translate(en,
    'Salasanan luominen epäonnistui. Yritä uudestaan',
    ...val),

  Y6ZI: (en: string, ...val: string[]) => translate(en,
    'Kattavat 5G+ -liittymät',
    ...val),

  Y7C0: (en: string, ...val: string[]) => translate(en,
    'Laskut',
    ...val),

  Y7WJ: (en: string, ...val: string[]) => translate(en,
    'Avausmaksut',
    ...val),

  Y821: (en: string, ...val: string[]) => translate(en,
    'Sujuvaan työntekoon, pilvipalveluihin ja vapaa-ajan viihteeseen',
    ...val),

  Y8KX: (en: string, ...val: string[]) => translate(en,
    'Käyttötarkoitus',
    ...val),

  Y8LP: (en: string, ...val: string[]) => translate(en,
    'Käyttöoikeudet',
    ...val),

  Y93H: (en: string, ...val: string[]) => translate(en,
    'Valitse oletuslaskutussopimus laitelistalle',
    ...val),

  Y9B3: (en: string, ...val: string[]) => translate(en,
    'Ohjeet ja tukisivut',
    ...val),

  Y9CE: (en: string, ...val: string[]) => translate(en,
    'Vaativaan työntekoon ja suoratoistopalveluiden aktiiviseen katsomiseen',
    ...val),

  Y9JE: (en: string, ...val: string[]) => translate(en,
    'Työnantajan kustantama',
    ...val),

  Y9S5: (en: string, ...val: string[]) => translate(en,
    'Tietueen tyyppi',
    ...val),

  YA79: (en: string, ...val: string[]) => translate(en,
    'Tarkista käyttäjän henkilötiedot',
    ...val),

  YA96: (en: string, ...val: string[]) => translate(en,
    'Viimeistele tilauksesi',
    ...val),

  YA97: (en: string, ...val: string[]) => translate(en,
    'Ostoskorissa on {} tuotetta',
    ...val),

  YAA5: (en: string, ...val: string[]) => translate(en,
    'Tekemäsi tukipyyntö tulee näkyviin OmaElisaan Tukipyynnöt-sivulle ja se näkyy kaikille yrityksenne OmaElisa-käyttäjille.',
    ...val),

  YAJE: (en: string, ...val: string[]) => translate(en,
    'Irtisanomispäivä ei saa osua viikonlopulle',
    ...val),

  YAKO: (en: string, ...val: string[]) => translate(en,
    'Siirrytään takaisin käyttäjän tietoihin',
    ...val),

  YAMO: (en: string, ...val: string[]) => translate(en,
    'Ohjeita laskutukseen?',
    ...val),

  YAVU: (en: string, ...val: string[]) => translate(en,
    'Lankanumerot',
    ...val),

  YB45: (en: string, ...val: string[]) => translate(en,
    'Tunnistaudu pankkitunnuksilla',
    ...val),

  YB6A: (en: string, ...val: string[]) => translate(en,
    'Saamani palvelu oli ystävällistä',
    ...val),

  YBF8: (en: string, ...val: string[]) => translate(en,
    'omistaa',
    ...val),

  YBFC: (en: string, ...val: string[]) => translate(en,
    'kt',
    ...val),

  YBJF: (en: string, ...val: string[]) => translate(en,
    'Muokkaa asetuksia',
    ...val),

  YBM6: (en: string, ...val: string[]) => translate(en,
    'Poista laitevalikoima',
    ...val),

  YC2H: (en: string, ...val: string[]) => translate(en,
    'Milloin Vaihtoetu maksetaan yritykseni laskutussopimukselle? Kuinka kauan prosessi kestää?',
    ...val),

  YD2N: (en: string, ...val: string[]) => translate(en,
    'Ei tukipyyntöjä',
    ...val),

  YDYY: (en: string, ...val: string[]) => translate(en,
    'Avoimet lunastuspyynnöt',
    ...val),

  YE3V: (en: string, ...val: string[]) => translate(en,
    'Laskun tila',
    ...val),

  YE85: (en: string, ...val: string[]) => translate(en,
    'Käyttäjää ei voida siirtää',
    ...val),

  YEX6: (en: string, ...val: string[]) => translate(en,
    'Käyttäjä poistetaan järjestelmästä lopullisesti. Poistoa ei voi peruuttaa.',
    ...val),

  YF1F: (en: string, ...val: string[]) => translate(en,
    'Haluatko jatkaa asiointia Työntekijän OmaElisassa?',
    ...val),

  YFT1: (en: string, ...val: string[]) => translate(en,
    'Siirry maksettuihin laskuihin',
    ...val),

  YFWU: (en: string, ...val: string[]) => translate(en,
    'Puhelut ja viestit aikuisviihdenumeroihin',
    ...val),

  YG0B: (en: string, ...val: string[]) => translate(en,
    'Liittymän uudelleenavaus',
    ...val),

  YHST: (en: string, ...val: string[]) => translate(en,
    'Mitä vanhoille laitteille tapahtuu?',
    ...val),

  YI0M: (en: string, ...val: string[]) => translate(en,
    'Vikatilanteissa saat korvaavan laitteen postitse 1-2 työpäivän aikana',
    ...val),

  YI9C: (en: string, ...val: string[]) => translate(en,
    'Avaa puhelimesi kamera ja kohdista se vieressä olevaan QR-koodiin.',
    ...val),

  YIDW: (en: string, ...val: string[]) => translate(en,
    'Liittymä näytetään Työntekijän OmaElisassa käyttäjän henkilötietojen perusteella.',
    ...val),

  YJIF: (en: string, ...val: string[]) => translate(en,
    'Yritysten OmaElisan käyttöönotto vaatii henkilökohtaisen Elisa Tunnuksen',
    ...val),

  YJIG: (en: string, ...val: string[]) => translate(en,
    'Työntekijän OmaElisan käyttöönotto vaatii henkilökohtaisen Elisa Tunnuksen',
    ...val),

  YK5V: (en: string, ...val: string[]) => translate(en,
    'Tervetuloa Yritysten OmaElisaan',
    ...val),

  YK9W: (en: string, ...val: string[]) => translate(en,
    'Sisältää sekä isoja että pieniä kirjaimia',
    ...val),

  YKJA: (en: string, ...val: string[]) => translate(en,
    'Laitesopimuksen hylkääminen onnistui.',
    ...val),

  YLAI: (en: string, ...val: string[]) => translate(en,
    'Maksajan lisätieto',
    ...val),

  YLCX: (en: string, ...val: string[]) => translate(en,
    'Virheellinen puhelinnumero',
    ...val),

  YLFT: (en: string, ...val: string[]) => translate(en,
    'Tekijänoikeudet © {} Elisa Oyj. Kaikki oikeudet pidätetään.',
    ...val),

  YLXB: (en: string, ...val: string[]) => translate(en,
    'Valitse yritys, johon käyttäjä siirretään.',
    ...val),

  YM3W: (en: string, ...val: string[]) => translate(en,
    'Näytetään laskutussopimuksen tämänhetkiset tiedot.',
    ...val),

  YMED: (en: string, ...val: string[]) => translate(en,
    'Käsitelty',
    ...val),

  YMF3: (en: string, ...val: string[]) => translate(en,
    'Voit seurata tukipyynnön etenemistä Yritysten OmaElisassa ',
    ...val),

  YMF4: (en: string, ...val: string[]) => translate(en,
    'Voit seurata tilausta OmaElisassa',
    ...val),

  YMF5: (en: string, ...val: string[]) => translate(en,
    '-sivulta. Tilauksen näkymisessä saattaa kestää hetki.',
    ...val),

  YMFA: (en: string, ...val: string[]) => translate(en,
    'Aidosti parempi 5G',
    ...val),

  YMJF: (en: string, ...val: string[]) => translate(en,
    'Seuraavien listojen kopiointi ei onnistunut. Tuotteita ei kopioitu. Tarkista ja muokkaa listat yksitellen:',
    ...val),

  YMLL: (en: string, ...val: string[]) => translate(en,
    'Kirjaudu sivustolle yrityksille.elisa.fi/työntekijä ja lisää se Liittymäni-sivulla.',
    ...val),

  YMMM: (en: string, ...val: string[]) => translate(en,
    'Hyväksy vielä sopimusehdot',
    ...val),

  YN14: (en: string, ...val: string[]) => translate(en,
    'Yritysnumeron tavoitettavuus',
    ...val),

  YNUS: (en: string, ...val: string[]) => translate(en,
    'Voit seurata tukipyynnön etenemistä',
    ...val),

  YO7F: (en: string, ...val: string[]) => translate(en,
    '{}/kk',
    ...val),

  YOU8: (en: string, ...val: string[]) => translate(en,
    'Soittajan numero',
    ...val),

  YOW5: (en: string, ...val: string[]) => translate(en,
    'Ratkaisu',
    ...val),

  YP6T: (en: string, ...val: string[]) => translate(en,
    'Asiakaspalvelijan viesti',
    ...val),

  YPI7: (en: string, ...val: string[]) => translate(en,
    'Asennusosoitteen vaihto',
    ...val),

  YPMQ: (en: string, ...val: string[]) => translate(en,
    'Laitteen voi vaihtaa uuteen kaksi viikkoa ennen sopimuskauden päättymistä. Mikäli laitevaihtoa ei tehdä tai sopimusta päätetä, laite siirtyy automaattisesti 6 kk jatkokaudelle.',
    ...val),

  YRN0: (en: string, ...val: string[]) => translate(en,
    'Ei tarjouksia',
    ...val),

  YRYX: (en: string, ...val: string[]) => translate(en,
    'Erääntynyt',
    ...val),

  YRZJ: (en: string, ...val: string[]) => translate(en,
    'Laitteeni ja liittymäni',
    ...val),

  YSPK: (en: string, ...val: string[]) => translate(en,
    'Vanhan järjestelmän tilaukset',
    ...val),

  YTDQ: (en: string, ...val: string[]) => translate(en,
    'Mobiilireitittimen avulla säästät puhelimesi akkua, kun sinun ei tarvitse jakaa nettiä puhelimesta. 5G+-tekniikan ansiosta mobiilireitittimen akun kulutusta on saatu vähennettyä 15–25 % verrattuna 4G/5G -verkossa toimivaan vaihtoehtoon.',
    ...val),

  YTH3: (en: string, ...val: string[]) => translate(en,
    'Tunnistenumero',
    ...val),

  YTNE: (en: string, ...val: string[]) => translate(en,
    'Lunastan',
    ...val),

  YU2R: (en: string, ...val: string[]) => translate(en,
    'Palaa OmaElisaan',
    ...val),

  YU6F: (en: string, ...val: string[]) => translate(en,
    'Kopioi laitelistan tuotevalikoima muihin Elisa Palvelupäätelaite -listoihin',
    ...val),

  YULI: (en: string, ...val: string[]) => translate(en,
    'Muokkaaja',
    ...val),

  YV0D: (en: string, ...val: string[]) => translate(en,
    'Sinulla ei ole oikeuksia hallinnoida tuotteita uudessa OmaElisassa.',
    ...val),

  YV0E: (en: string, ...val: string[]) => translate(en,
    'Yritysten OmaElisassa voit hallinnoida nykyisiä liittymiäsi, tarkastella laskujasi ja tilata uusia liittymiä.',
    ...val),

  YW61: (en: string, ...val: string[]) => translate(en,
    'Kiinteät laajakaistat',
    ...val),

  YW9I: (en: string, ...val: string[]) => translate(en,
    'Lisää maksuaikaa',
    ...val),

  YWE4: (en: string, ...val: string[]) => translate(en,
    'Julkaise muutokset heti valittuihin listoihin',
    ...val),

  YX3Y: (en: string, ...val: string[]) => translate(en,
    'Asiointiesto P2',
    ...val),

  YX9H: (en: string, ...val: string[]) => translate(en,
    'Käyttäjälle lähetetään kutsu sähköpostitse',
    ...val),

  YXMI: (en: string, ...val: string[]) => translate(en,
    'Hinta veroineen',
    ...val),

  YXNW: (en: string, ...val: string[]) => translate(en,
    'Voit halutessasi jättää myös avointa palautetta:',
    ...val),

  YY7Z: (en: string, ...val: string[]) => translate(en,
    'Katalogin julkaisu epäonnistui',
    ...val),

  YYCY: (en: string, ...val: string[]) => translate(en,
    'Työaika',
    ...val),

  YYZC: (en: string, ...val: string[]) => translate(en,
    'Haluatko jatkaa tallentamatta tietoja?',
    ...val),

  YZ8Q: (en: string, ...val: string[]) => translate(en,
    'Liittymän päivitys onnistui',
    ...val),

  YZJ3: (en: string, ...val: string[]) => translate(en,
    'Liittymän kuukausimaksut tilauksen jälkeen ',
    ...val),

  YZQH: (en: string, ...val: string[]) => translate(en,
    'Palaa kauppaan',
    ...val),

  Z0HF: (en: string, ...val: string[]) => translate(en,
    'Laitelista',
    ...val),

  Z0MM: (en: string, ...val: string[]) => translate(en,
    'Asennuksen saatavuutta ei voitu tarkistaa. Yritä uudelleen.',
    ...val),

  Z0OY: (en: string, ...val: string[]) => translate(en,
    'Nouto postin pakettiautomaatista',
    ...val),

  Z0U9: (en: string, ...val: string[]) => translate(en,
    'Palaa Työntekijän OmaElisaan',
    ...val),

  Z13H: (en: string, ...val: string[]) => translate(en,
    'Siirry OmaElisaan',
    ...val),

  Z16I: (en: string, ...val: string[]) => translate(en,
    'Kirjaudu',
    ...val),

  Z1M1: (en: string, ...val: string[]) => translate(en,
    'Lunastuspyynnöt',
    ...val),

  Z1U2: (en: string, ...val: string[]) => translate(en,
    'Tilaa Elisa Kuka Soittaa',
    ...val),

  Z20L: (en: string, ...val: string[]) => translate(en,
    'Laiterekisteriohjelmilla voit varmistaa, että jokaiselle uudelle laitteelle otetaan automaattisesti käyttöön yrityksen päätelaitteiden hallinta. Näin laitteet pysyvät yrityksen hallinnassa käyttöönotosta elinkaarensa loppuun asti.',
    ...val),

  Z223: (en: string, ...val: string[]) => translate(en,
    'Laskutuskoodi',
    ...val),

  Z2Y8: (en: string, ...val: string[]) => translate(en,
    'Tutustu myös ratkaisuihimme isommalle toimistolle',
    ...val),

  Z3L0: (en: string, ...val: string[]) => translate(en,
    'Lisätietoa aiheesta',
    ...val),

  Z3W8: (en: string, ...val: string[]) => translate(en,
    'Palauta salasanasi',
    ...val),

  Z3ZW: (en: string, ...val: string[]) => translate(en,
    'Kirkas ja selkeä, aiempaa parempi äänenlaatu',
    ...val),

  Z40V: (en: string, ...val: string[]) => translate(en,
    'Yritysnumeron ajastettu työaika',
    ...val),

  Z44Y: (en: string, ...val: string[]) => translate(en,
    'Asiointiesto',
    ...val),

  Z4KH: (en: string, ...val: string[]) => translate(en,
    'Kiitos päivityksestä!',
    ...val),

  Z5E1: (en: string, ...val: string[]) => translate(en,
    'Tutustu valikoimaan',
    ...val),

  Z64W: (en: string, ...val: string[]) => translate(en,
    'Vastausryhmät',
    ...val),

  Z6E1: (en: string, ...val: string[]) => translate(en,
    'Jos työnantajasi on tilannut laitteen puolestasi, ei laite näy listassa. Laite tulle silloin lisätä erikseen, jotta voimme merkata sinut käyttäjäksi.',
    ...val),

  Z6R6: (en: string, ...val: string[]) => translate(en,
    'Mobiilireititin ZTE MU5120',
    ...val),

  Z6SX: (en: string, ...val: string[]) => translate(en,
    'Uusin ensin',
    ...val),

  Z6YC: (en: string, ...val: string[]) => translate(en,
    'Maksukehotus',
    ...val),

  Z71F: (en: string, ...val: string[]) => translate(en,
    'Sinulla on jo avoin tilaus',
    ...val),

  Z72R: (en: string, ...val: string[]) => translate(en,
    'ohjeisiin',
    ...val),

  Z7CU: (en: string, ...val: string[]) => translate(en,
    ' nimenkorjaukseen liittyen.',
    ...val),

  Z7FX: (en: string, ...val: string[]) => translate(en,
    'Ikävä kyllä, palvelu ei vielä toistaiseksi ole saatavilla käytössäsi olevalle liittymätyypille.',
    ...val),

  Z7IG: (en: string, ...val: string[]) => translate(en,
    'Kadonnut tai tuhoutunut laite',
    ...val),

  Z7K0: (en: string, ...val: string[]) => translate(en,
    'Löydät SIM-kortin numeron kuvan osoittamista kohdista. Käynnistä laitteesi uudelleen kortin aktivoimisen jälkeen. Uuden SIM-kortin PIN-koodi on aluksi 1234.',
    ...val),

  Z7NS: (en: string, ...val: string[]) => translate(en,
    'Tässä liittymässä on seuraavat estot:',
    ...val),

  Z7S5: (en: string, ...val: string[]) => translate(en,
    'Postitoimipaikka',
    ...val),

  Z7TJ: (en: string, ...val: string[]) => translate(en,
    'Näytä lisää vaihtoehtoja kiinteän verkon Netti Lite -liittymille',
    ...val),

  Z7ZV: (en: string, ...val: string[]) => translate(en,
    'Yritysliittymien lisäpalvelut tuovat sujuvuutta arkeen',
    ...val),

  Z85X: (en: string, ...val: string[]) => translate(en,
    'SquareTrade ei ole saatavissa tässä yhteydessä ja se pitää poistaa ostoskorista.',
    ...val),

  Z875: (en: string, ...val: string[]) => translate(en,
    'Valittu yhteensä',
    ...val),

  Z8CO: (en: string, ...val: string[]) => translate(en,
    'Mikäli liittymä korvaa olemassa olevan liittymän, niin laita tähän korvattavan liittymän irtisanomispäivämäärä.',
    ...val),

  Z8FX: (en: string, ...val: string[]) => translate(en,
    ', jos olet edustajamyyjä',
    ...val),

  Z8MP: (en: string, ...val: string[]) => translate(en,
    'Laitteen voi vaihtaa uuteen kaksi viikkoa ennen peruskauden päättymistä. Mikäli laitevaihtoa ei tehdä tai sopimusta päätetä, laite siirtyy automaattisesti 6 kk jatkokaudelle.',
    ...val),

  Z8VV: (en: string, ...val: string[]) => translate(en,
    'Emme löytäneet yhtään yritystä tiedoillasi',
    ...val),

  Z96J: (en: string, ...val: string[]) => translate(en,
    'Arvo ei voi sisältää ääkkösiä tai erikoismerkkejä.',
    ...val),

  Z9BX: (en: string, ...val: string[]) => translate(en,
    'Laskuun liittyvä reklamaatio',
    ...val),

  Z9HQ: (en: string, ...val: string[]) => translate(en,
    'Liittymän näyttötiedot päivitettiin onnistuneesti.',
    ...val),

  Z9IW: (en: string, ...val: string[]) => translate(en,
    'Lataa App Storesta',
    ...val),

  Z9IX: (en: string, ...val: string[]) => translate(en,
    'Lataa se Google Playsta',
    ...val),

  Z9X2: (en: string, ...val: string[]) => translate(en,
    'Ongelma kuulokkeissa/mikrofonissa',
    ...val),

  ZB19: (en: string, ...val: string[]) => translate(en,
    'csv- tai tekstitiedoston.',
    ...val),

  ZB3L: (en: string, ...val: string[]) => translate(en,
    'Lunastuspyyntöni',
    ...val),

  ZB5M: (en: string, ...val: string[]) => translate(en,
    'Me laskemme hyvitykset yhteen ja siirrämme koko summan yrityksesi laskutussopimukselle',
    ...val),

  ZBEP: (en: string, ...val: string[]) => translate(en,
    'Lue vähemmän',
    ...val),

  ZBPW: (en: string, ...val: string[]) => translate(en,
    'Etätyöt, videopuhelut ja pilvipalvelut',
    ...val),

  ZBTH: (en: string, ...val: string[]) => translate(en,
    'Tarkasta ja muokkaa estoluokitukset liittymän tiedoista',
    ...val),

  ZCA8: (en: string, ...val: string[]) => translate(en,
    'Saat mobiililaajakaistaliittymän jopa 67% alennuksella ilman määräaikaa Netti Lite -tilauksesi yhteydessä. Hyödynnä etu ja katso kaikki etuhintaiset nopeusvaihtoehdot.',
    ...val),

  ZCS1: (en: string, ...val: string[]) => translate(en,
    'Jos laitteelle on tilattu asennuspalvelu, niin asentaja on yhteydessä asennusajasta.',
    ...val),

  ZCX7: (en: string, ...val: string[]) => translate(en,
    'Sama kuin yhteyshenkilö',
    ...val),

  ZCXQ: (en: string, ...val: string[]) => translate(en,
    'Vakio-palvelun asetukset',
    ...val),

  ZD17: (en: string, ...val: string[]) => translate(en,
    'Palvelun irtisanomisen jälkeen Elisa Mobiilivarmenne toimii vielä kaksi viikkoa työntekijöillä, jotka ovat ottaneet sen käyttöönsä. Ilmoitamme tekstiviestillä kaikille palvelun käyttöönottaneille mahdollisuudesta tilata palvelu jatkossa omakustanteisesti.',
    ...val),

  ZDQ2: (en: string, ...val: string[]) => translate(en,
    'Olemme lähettäneet tilausvahvistuksen sähkopostiisi {}.',
    ...val),

  ZE11: (en: string, ...val: string[]) => translate(en,
    'Valitettavasti kielteisen luottopäätöksen vuoksi valitsemasi laitteen tilaus ei onnistu. Valitsethan laitteen, jonka kuukausimaksun osuus on 0 euroa.',
    ...val),

  ZE18: (en: string, ...val: string[]) => translate(en,
    'Mihin osoitteeseen tarvitset netin?',
    ...val),

  ZE2K: (en: string, ...val: string[]) => translate(en,
    'Löysimme kohdeyrityksestä käyttäjän, jolla on samoja yhteystietoja',
    ...val),

  ZE9V: (en: string, ...val: string[]) => translate(en,
    'Ostoskorissa yhteensä {} tuotetta',
    ...val),

  ZEU1: (en: string, ...val: string[]) => translate(en,
    'Liittäminen ei ole tällä hetkellä mahdollista Lankanumero-lisäpalvelun vuoksi',
    ...val),

  ZEX1: (en: string, ...val: string[]) => translate(en,
    'Arvo ei voi sisältää kirjaimia. Esimerkki arvosta: [1-255].[0-255].[0-255].[0-255]',
    ...val),

  ZF4E: (en: string, ...val: string[]) => translate(en,
    'Ole hyvä ja viimeistele muutokset osoitetietoihin ennen jatkamista.',
    ...val),

  ZF77: (en: string, ...val: string[]) => translate(en,
    'Sopimusta ei voida päättää kesken sopimuskauden työntekijän toimesta. Ota tarvittaessa yhteyttä tilaajayhteyshenkilöösi.',
    ...val),

  ZF7B: (en: string, ...val: string[]) => translate(en,
    'Mistä aiheesta olet kiinnostunut?',
    ...val),

  ZFAS: (en: string, ...val: string[]) => translate(en,
    'Tabletti',
    ...val),

  ZFMI: (en: string, ...val: string[]) => translate(en,
    'EU-maissa',
    ...val),

  ZG2D: (en: string, ...val: string[]) => translate(en,
    'Hyvitämme Vaihtoetua puhelimista, tableteista ja älykelloista. Voit saada hyvitystä myös vanhemmasta laitteesta, vaikka ne olisivat jo elinkaarensa loppuvaiheessa.',
    ...val),

  ZGKE: (en: string, ...val: string[]) => translate(en,
    'Salainen',
    ...val),

  ZGSV: (en: string, ...val: string[]) => translate(en,
    'Avausmaksu lisätään seuraavalle laskulle.',
    ...val),

  ZGX7: (en: string, ...val: string[]) => translate(en,
    'Palvelu sisältää modeemin ja yhteyden asennuksen, sekä WIFI Mesh-laitteiden ({}) asennuksen optimaalisesti sijoiteltuna, jotta WIFI-verkko kattaa koko kodin/toimiston. Palveluun kuuluu myös asennetun kokonaisuuden toimivuuden testaus.',
    ...val),

  ZHBT: (en: string, ...val: string[]) => translate(en,
    'Laitevaihto',
    ...val),

  ZHSZ: (en: string, ...val: string[]) => translate(en,
    'Tämä ei vaikuta asiakkuuden sopijatietoon, vaan päivittää laskun saajan ja postiosoitteen. Nämä tiedot näkyvät laskulla.',
    ...val),

  ZIH3: (en: string, ...val: string[]) => translate(en,
    'Toimitettavat laitteet voi liittää yrityksen käyttämään, Elisalle aktivoituun laiterekisteriohjelmaan. Niitä ovat Apple DEP, Samsung KME, Android Zero-Touch ja Windows Autopilot. Laiterekisteriohjelmien avulla laitteet ohjataan automaattisesti yrityksen käytössä olevaan laitehallintajärjestelmään.',
    ...val),

  ZJE9: (en: string, ...val: string[]) => translate(en,
    'Mobile broadband Netti Lite offers',
    ...val),

  ZJQG: (en: string, ...val: string[]) => translate(en,
    'Luonnos',
    ...val),

  ZJRN: (en: string, ...val: string[]) => translate(en,
    'Sopimuskausi päättynyt',
    ...val),

  ZK2S: (en: string, ...val: string[]) => translate(en,
    'Tarkista salasana, kiitos',
    ...val),

  ZK30: (en: string, ...val: string[]) => translate(en,
    'Tilauksen vahvistaminen epäonnistui.',
    ...val),

  ZKGI: (en: string, ...val: string[]) => translate(en,
    'Tarkista käyttäjän yhteystiedot',
    ...val),

  ZKZZ: (en: string, ...val: string[]) => translate(en,
    'Elisa Kuka Soittaa',
    ...val),

  ZL7F: (en: string, ...val: string[]) => translate(en,
    'Lisää liittymä ostoskoriin',
    ...val),

  ZLQO: (en: string, ...val: string[]) => translate(en,
    'Hinta (alv. 0 %)',
    ...val),

  ZMA5: (en: string, ...val: string[]) => translate(en,
    'Liittymän päivitys epäonnistui. Voit päivittää liittymän myös ',
    ...val),

  ZML8: (en: string, ...val: string[]) => translate(en,
    'Poissaoloketjuun vaaditaan ensimmäinen kohdenumero kun poissaoloketju on valittuna',
    ...val),

  ZMRO: (en: string, ...val: string[]) => translate(en,
    'Tukipyyntö on peruutettu. Olemme lähettäneet lisätietoa tukipyynnön avanneen käyttäjän sähköpostiin.',
    ...val),

  ZN5B: (en: string, ...val: string[]) => translate(en,
    'Ladataan lomakelistaa',
    ...val),

  ZNGS: (en: string, ...val: string[]) => translate(en,
    'Vanhan laitteen lunastushinta',
    ...val),

  ZNS1: (en: string, ...val: string[]) => translate(en,
    'SIM-kortti on jo käytössä toisella liittymällä.',
    ...val),

  ZO3A: (en: string, ...val: string[]) => translate(en,
    'Android Zero-touch laiterekisteröintiohjelma',
    ...val),

  ZOES: (en: string, ...val: string[]) => translate(en,
    'Lue lisää palvelusta',
    ...val),

  ZPN3: (en: string, ...val: string[]) => translate(en,
    'Ennen kuin tilaat mobiililaajakaistaliittymän, tarkistathan ',
    ...val),

  ZPXZ: (en: string, ...val: string[]) => translate(en,
    'Lunastaja',
    ...val),

  ZPZR: (en: string, ...val: string[]) => translate(en,
    'Työntekijän OmaElisassa',
    ...val),

  ZQ1A: (en: string, ...val: string[]) => translate(en,
    'Tilaa IoT-laitteet helposti netistä',
    ...val),

  ZQ1B: (en: string, ...val: string[]) => translate(en,
    'Tutustu verkkokaupan IoT-laitteisiin, kuten valvontakameroihin ja riistakameroihin, hälytysjärjestelmiin ja etäluettaviin lämpömittareihin.',
    ...val),

  ZQ4R: (en: string, ...val: string[]) => translate(en,
    'Kuljetus toimitusosoitteeseen',
    ...val),

  ZRKX: (en: string, ...val: string[]) => translate(en,
    'Muutosmaksu',
    ...val),

  ZRR4: (en: string, ...val: string[]) => translate(en,
    'Tarkista, ettei yrityksesi palveluita ole',
    ...val),

  ZRXP: (en: string, ...val: string[]) => translate(en,
    'Samsung KME laiterekisteröintiohjelma',
    ...val),

  ZS4S: (en: string, ...val: string[]) => translate(en,
    'Prioriteetti',
    ...val),

  ZSRZ: (en: string, ...val: string[]) => translate(en,
    'Kun valitset laitteelle palautuksen, läheteämme palautuspussin tilauksen yhteydessä, jolla käyttäjän tulee palauttaa laite viipymättä',
    ...val),

  ZT0K: (en: string, ...val: string[]) => translate(en,
    'Tämä kutsulinkki on jo käytetty tai se on vanhentunut. Ole hyvä ja pyydä uusi kutsulinkki pääkäyttäjältäsi.',
    ...val),

  ZTNQ: (en: string, ...val: string[]) => translate(en,
    'Työntekijän OmaElisaan',
    ...val),

  ZTPC: (en: string, ...val: string[]) => translate(en,
    'Tilauspäivä',
    ...val),

  ZU4Z: (en: string, ...val: string[]) => translate(en,
    'Toimitus seuraavana työpäivänä klo 9 mennessä kattavasti lähes koko Suomen alueella.',
    ...val),

  ZU62: (en: string, ...val: string[]) => translate(en,
    'Näytä esimerkkiviesti',
    ...val),

  ZUCA: (en: string, ...val: string[]) => translate(en,
    'Estopalvelut',
    ...val),

  ZUFX: (en: string, ...val: string[]) => translate(en,
    'Siirry tunnistautumaan',
    ...val),

  ZUWC: (en: string, ...val: string[]) => translate(en,
    'yritysasiakkaiden palveluhinnaston',
    ...val),

  ZUZG: (en: string, ...val: string[]) => translate(en,
    'Salasanan on oltava vähintään 8 merkkiä pitkä, vähintään yksi numero, yksi iso kirjain ja yksi pieni kirjain.',
    ...val),

  ZV9E: (en: string, ...val: string[]) => translate(en,
    'Pysy ajan tasalla!',
    ...val),

  ZVDQ: (en: string, ...val: string[]) => translate(en,
    'Salasanan uusiminen onnistui',
    ...val),

  ZVMK: (en: string, ...val: string[]) => translate(en,
    'Laskutussopimukset',
    ...val),

  ZVP0: (en: string, ...val: string[]) => translate(en,
    'Pakettiin kuuluvat viestit',
    ...val),

  ZVQ5: (en: string, ...val: string[]) => translate(en,
    'Sähköpostiosoite',
    ...val),

  ZVQ6: (en: string, ...val: string[]) => translate(en,
    'Työsähköpostiosoite',
    ...val),

  ZVU5: (en: string, ...val: string[]) => translate(en,
    'Suositus {0} käyttäjää, ({1} laitetta)',
    ...val),

  ZW5Q: (en: string, ...val: string[]) => translate(en,
    'eSIM-kortti kytketään päälle QR-koodilla, joka luetaan puhelimen kameralla tai siihen erikseen tarkoitetulla sovelluksella. Voit syöttää tiedot myös käsin lisäämällä eSIMin laitteen asetuksista.',
    ...val),

  ZW5W: (en: string, ...val: string[]) => translate(en,
    'Ei valintaa',
    ...val),

  ZX0L: (en: string, ...val: string[]) => translate(en,
    'Valitse käyttäjätunnus',
    ...val),

  ZXA6: (en: string, ...val: string[]) => translate(en,
    'Odottaa hyväksyntää',
    ...val),

  ZXBT: (en: string, ...val: string[]) => translate(en,
    ', että työyhteystietosi ovat oikein. Ota tarvittaessa yhteyttä yrityksesi OmaElisa-pääkäyttäjään, joka voi varmistaa, että liittymiesi käyttäjätiedot ovat ajan tasalla.',
    ...val),

  ZYAW: (en: string, ...val: string[]) => translate(en,
    'Kirjautumiseen tarvitset',
    ...val),

  ZYID: (en: string, ...val: string[]) => translate(en,
    'Arvioi laitteesi kunto',
    ...val),

  ZYIU: (en: string, ...val: string[]) => translate(en,
    'Elisa Ring -ratkaisu liittymälle',
    ...val),

  ZYP7: (en: string, ...val: string[]) => translate(en,
    'Latausvaatimukset: {} W, USB PD',
    ...val),

  ZZ8N: (en: string, ...val: string[]) => translate(en,
    '5G-liittymät käyttävät aina parasta saatavilla olevaa yhteyttä ja vaihtavat sujuvasti myös 4G-verkkoon, jos liikut alueella, jolla ei ole 5G-yhteyttä. 5G+-liittymän myötä netin viive voi jopa puolittua nykyisestä. Uusi 5G+ kuluttaa myös vähemmän akkua ja on siis entistä energiatehokkaampi vaihtoehto.',
    ...val),

  ZZK7: (en: string, ...val: string[]) => translate(en,
    'Viikonloppuisin',
    ...val),

  ZZWM: (en: string, ...val: string[]) => translate(en,
    'Puhelinliittymiä ei voida tällä hetkellä näyttää. Yritä uudelleen hetken kuluttua. Tarvittaessa, ota yhteyttä asiakaspalveluun.',
    ...val),

  ZZWN: (en: string, ...val: string[]) => translate(en,
    'Valitse tekstiviestipaketti',
    ...val),

  ZZWO: (en: string, ...val: string[]) => translate(en,
    'Puhelinliittymät yritykselle',
    ...val),

  ZZWP: (en: string, ...val: string[]) => translate(en,
    'Liitä tunnukseen',
    ...val),

  ZZWQ: (en: string, ...val: string[]) => translate(en,
    'Liitetty',
    ...val),

  ZZWR: (en: string, ...val: string[]) => translate(en,
    'Kaikki artikkelit',
    ...val),

  ZZWS: (en: string, ...val: string[]) => translate(en,
    'Kaikki aihetunnisteet',
    ...val),

  ZZWT: (en: string, ...val: string[]) => translate(en,
    'Lue juttu',
    ...val),

  ZZWU: (en: string, ...val: string[]) => translate(en,
    'Uusimmat artikkelit',
    ...val),

  ZZWV: (en: string, ...val: string[]) => translate(en,
    'Avainsanat',
    ...val),

  ZZWW: (en: string, ...val: string[]) => translate(en,
    'Ideat',
    ...val),

  ZZWX: (en: string, ...val: string[]) => translate(en,
    'Elisan Ideat-artikkelit yrityksille.',
    ...val),

  ZZWY: (en: string, ...val: string[]) => translate(en,
    'Ideat aihetunnisteet',
    ...val),

  ZZWZ: (en: string, ...val: string[]) => translate(en,
    'Ideat-artikkelit kategoriassa {}.',
    ...val),

  ZZX0: (en: string, ...val: string[]) => translate(en,
    'Ideat-artikkelit avainsanalla {}.',
    ...val),

  ZZX1: (en: string, ...val: string[]) => translate(en,
    '{} arkistot',
    ...val),

  ZZX2: (en: string, ...val: string[]) => translate(en,
    'Kaikki avainsanat',
    ...val),

  ZZX3: (en: string, ...val: string[]) => translate(en,
    'Tälle sivulle on koottuna Ideat-osiomme avainsanat. Klikkaa haluamaasi avainsanaa lukeaksesi kaikki sen alla olevat artikkelit.',
    ...val),

});
